/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  DateTime: { input: any; output: any; }
  /** The `Void` scalar type represents no value being returned. */
  Void: { input: any; output: any; }
};

export type AiGenInput = {
  data: Scalars['String']['input'];
};

export type AcceptQuoteInput = {
  fileIds?: Array<Scalars['ID']['input']>;
  quoteId: Scalars['ID']['input'];
};

/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUser = {
  __typename?: 'ActAsUser';
  /**
   * sortable=false
   * groupable=false
   */
  allPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  allScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=true
   */
  assignedRoles: Array<RoleUser>;
  /**
   * sortable=true
   * groupable=false
   */
  authProvider: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  authProviderUid: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  branch: Maybe<Branch>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  email: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  firebaseAuthId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  fullName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  hasPin: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  identities: Array<UserIdentity>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedScreens: Array<Screen>;
  /**
   * sortable=true
   * groupable=false
   */
  initials: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  ownPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  ownScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=false
   */
  roles: Array<Role>;
  /**
   * sortable=false
   * groupable=true
   */
  timers: Array<ProcessTimer>;
  /**
   * sortable=true
   * groupable=false
   */
  username: Maybe<Scalars['String']['output']>;
};


/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUserAllPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUserAssignedRolesArgs = {
  filter?: InputMaybe<RoleUserFilterInput>;
};


/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUserCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUserIdentitiesArgs = {
  filter?: InputMaybe<UserIdentityFilterInput>;
};


/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUserInheritedPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUserOwnPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export type ActAsUserTimersArgs = {
  filter?: InputMaybe<ProcessTimerFilterInput>;
};

export type ActAsUserAggregate = {
  __typename?: 'ActAsUserAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type ActAsUserAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type ActAsUserAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ActAsUserFilterInput = {
  and?: InputMaybe<Array<ActAsUserFilterInput>>;
  assignedRoles?: InputMaybe<RoleUserFilterInput>;
  authProvider?: InputMaybe<StringFilterInput>;
  authProviderUid?: InputMaybe<StringFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  fullName?: InputMaybe<StringFilterInput>;
  hasPersonIdentity?: InputMaybe<BooleanFilterInput>;
  hasPin?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  identities?: InputMaybe<UserIdentityFilterInput>;
  includeSystem?: InputMaybe<BooleanFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isCurrent?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  oldRoles?: InputMaybe<UserRoleFilterInput>;
  or?: InputMaybe<Array<ActAsUserFilterInput>>;
  reviewedSuppliers?: InputMaybe<SupplierFilterInput>;
  timers?: InputMaybe<ProcessTimerFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type AmendPurchaseOrderInput = {
  lines: Array<PurchaseOrderLineInput>;
  purchaseOrderId: Scalars['ID']['input'];
};

/**
 * description=An asset, such as a machine, that can be assigned to a manufacturing process.
 * displayName=Asset
 * module=Manufacturing
 * defaultQuery=assets
 * iconName=cog
 * colour=#A96500
 * aggregateQuery=assetsAggregate
 * grouping=true
 * queryPermission=Query_Assets
 */
export type Asset = {
  __typename?: 'Asset';
  /**
   * sortable=true
   * groupable=false
   */
  assetType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=An asset, such as a machine, that can be assigned to a manufacturing process.
 * displayName=Asset
 * module=Manufacturing
 * defaultQuery=assets
 * iconName=cog
 * colour=#A96500
 * aggregateQuery=assetsAggregate
 * grouping=true
 * queryPermission=Query_Assets
 */
export type AssetCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An asset, such as a machine, that can be assigned to a manufacturing process. */
export type AssetAggregate = {
  __typename?: 'AssetAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An asset, such as a machine, that can be assigned to a manufacturing process. */
export type AssetAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An asset, such as a machine, that can be assigned to a manufacturing process. */
export type AssetAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetFilterInput = {
  and?: InputMaybe<Array<AssetFilterInput>>;
  assetType?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<AssetFilterInput>>;
};

export type AssignBusinessRolesToBatchScheduleInput = {
  batchScheduleId: Scalars['ID']['input'];
  personBusinessRoleIds: Array<Scalars['String']['input']>;
  roleType: Scalars['String']['input'];
};

export type AssignBusinessRolesToPersonInput = {
  businessRoleIds: Array<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
};

export type AssignInheritanceToRoleInput = {
  parentRoleIds: Array<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
};

export type AssignLeadsToSalespersonInput = {
  leadIds: Array<Scalars['ID']['input']>;
  salespersonId: Scalars['String']['input'];
};

export type AssignPermissionsToRoleInput = {
  permissions: Array<PermissionInput>;
  roleId: Scalars['ID']['input'];
};

export type AssignPermissionsToUserInput = {
  permissions: Array<PermissionInput>;
  userId: Scalars['ID']['input'];
};

export type AssignRolesToUserInput = {
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type AssignScreensToRoleInput = {
  roleId: Scalars['ID']['input'];
  screenIds: Array<Scalars['String']['input']>;
};

export type AssignScreensToUserInput = {
  screenIds: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type AssignUsersToRoleInput = {
  roleId: Scalars['ID']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type AssignedPermission = {
  __typename?: 'AssignedPermission';
  conditions: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * Useful for getting the underlying UserPermission or RolePermission ID,
   * eg when wanting to unassign it.
   */
  originalId: Scalars['String']['output'];
  /** sortable=true */
  permission: Permission;
  /** sortable=true */
  policy: Policy;
  /** TODO: Use batching */
  role: Maybe<Role>;
  subjectId: Scalars['String']['output'];
  /** sortable=true */
  subjectName: Scalars['String']['output'];
  user: Maybe<User>;
};

export type AssignedPermissionFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

/**
 * description=The status and result of a background task.
 * displayName=Async Task
 * module=Admin
 * defaultQuery=asyncTasks
 * iconName=time
 * colour=#5D35A6
 * aggregateQuery=asyncTasksAggregate
 * grouping=true
 * queryPermission=Query_Async_Tasks
 */
export type AsyncTask = {
  __typename?: 'AsyncTask';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['DateTime']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  payload: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  status: Maybe<Scalars['String']['output']>;
};


/**
 * description=The status and result of a background task.
 * displayName=Async Task
 * module=Admin
 * defaultQuery=asyncTasks
 * iconName=time
 * colour=#5D35A6
 * aggregateQuery=asyncTasksAggregate
 * grouping=true
 * queryPermission=Query_Async_Tasks
 */
export type AsyncTaskCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=The status and result of a background task. */
export type AsyncTaskAggregate = {
  __typename?: 'AsyncTaskAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=The status and result of a background task. */
export type AsyncTaskAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=The status and result of a background task. */
export type AsyncTaskAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AsyncTaskFilterInput = {
  and?: InputMaybe<Array<AsyncTaskFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<AsyncTaskFilterInput>>;
  payload?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
};

/**
 * description=An attachment configuration belonging to a subscription notification template.
 * displayName=Attachment Template
 * module=Admin
 * defaultQuery=attachmentTemplates
 * iconName=paperclip
 * colour=#5D35A6
 * aggregateQuery=attachmentTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Attachment_Templates
 */
export type AttachmentTemplate = {
  __typename?: 'AttachmentTemplate';
  /**
   * sortable=true
   * groupable=false
   */
  bodyTemplateId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  fileName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  notificationTemplate: Maybe<NotificationTemplate>;
  /**
   * sortable=true
   * groupable=true
   */
  type: Scalars['String']['output'];
};


/**
 * description=An attachment configuration belonging to a subscription notification template.
 * displayName=Attachment Template
 * module=Admin
 * defaultQuery=attachmentTemplates
 * iconName=paperclip
 * colour=#5D35A6
 * aggregateQuery=attachmentTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Attachment_Templates
 */
export type AttachmentTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An attachment configuration belonging to a subscription notification template. */
export type AttachmentTemplateAggregate = {
  __typename?: 'AttachmentTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An attachment configuration belonging to a subscription notification template. */
export type AttachmentTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An attachment configuration belonging to a subscription notification template. */
export type AttachmentTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AttachmentTemplateFilterInput = {
  and?: InputMaybe<Array<AttachmentTemplateFilterInput>>;
  bodyTemplateId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  fileName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  notificationTemplate?: InputMaybe<NotificationTemplateFilterInput>;
  or?: InputMaybe<Array<AttachmentTemplateFilterInput>>;
  type?: InputMaybe<StringFilterInput>;
};

/**
 * description=A recorded domain event linked to the user and record that triggered it.
 * displayName=Audit Log
 * module=Admin
 * defaultQuery=auditLogs
 * iconName=history
 * colour=#5D35A6
 * aggregateQuery=auditLogsAggregate
 * grouping=true
 * queryPermission=Query_Audit_Logs
 */
export type AuditLog = {
  __typename?: 'AuditLog';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['DateTime']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  event: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
};


/**
 * description=A recorded domain event linked to the user and record that triggered it.
 * displayName=Audit Log
 * module=Admin
 * defaultQuery=auditLogs
 * iconName=history
 * colour=#5D35A6
 * aggregateQuery=auditLogsAggregate
 * grouping=true
 * queryPermission=Query_Audit_Logs
 */
export type AuditLogCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type AuditLogFilterInput = {
  and?: InputMaybe<Array<AuditLogFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  event?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<AuditLogFilterInput>>;
  recordId?: InputMaybe<IdFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userIdentity?: InputMaybe<UserIdentityFilterInput>;
};

export enum AuthProviderType {
  EmailPassword = 'emailPassword',
  Legacy = 'legacy',
  Microsoft = 'microsoft'
}

/**
 * description=A manufacturing batch grouping work to be scheduled and produced together.
 * displayName=Batch
 * module=Manufacturing
 * defaultQuery=batches
 * iconName=layers
 * colour=#A96500
 * aggregateQuery=batchesAggregate
 * grouping=true
 * queryPermission=Query_Batches
 */
export type Batch = {
  __typename?: 'Batch';
  /**
   * sortable=true
   * groupable=false
   */
  batchNumber: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  benchtopSupplier: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  branch: Branch;
  /**
   * sortable=true
   * groupable=false
   */
  cubicMetres: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  installationHours: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  lineItemAggregate: Maybe<LineItemAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  lineItems: Array<LineItem>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=true
   */
  schedules: Array<BatchSchedule>;
  /**
   * sortable=true
   * groupable=false
   */
  sheets: Maybe<Scalars['Int']['output']>;
};


/**
 * description=A manufacturing batch grouping work to be scheduled and produced together.
 * displayName=Batch
 * module=Manufacturing
 * defaultQuery=batches
 * iconName=layers
 * colour=#A96500
 * aggregateQuery=batchesAggregate
 * grouping=true
 * queryPermission=Query_Batches
 */
export type BatchCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A manufacturing batch grouping work to be scheduled and produced together.
 * displayName=Batch
 * module=Manufacturing
 * defaultQuery=batches
 * iconName=layers
 * colour=#A96500
 * aggregateQuery=batchesAggregate
 * grouping=true
 * queryPermission=Query_Batches
 */
export type BatchLineItemAggregateArgs = {
  filter?: InputMaybe<LineItemFilterInput>;
};


/**
 * description=A manufacturing batch grouping work to be scheduled and produced together.
 * displayName=Batch
 * module=Manufacturing
 * defaultQuery=batches
 * iconName=layers
 * colour=#A96500
 * aggregateQuery=batchesAggregate
 * grouping=true
 * queryPermission=Query_Batches
 */
export type BatchLineItemsArgs = {
  filter?: InputMaybe<LineItemFilterInput>;
};


/**
 * description=A manufacturing batch grouping work to be scheduled and produced together.
 * displayName=Batch
 * module=Manufacturing
 * defaultQuery=batches
 * iconName=layers
 * colour=#A96500
 * aggregateQuery=batchesAggregate
 * grouping=true
 * queryPermission=Query_Batches
 */
export type BatchSchedulesArgs = {
  filter?: InputMaybe<BatchScheduleFilterInput>;
};

/** description=A manufacturing batch grouping work to be scheduled and produced together. */
export type BatchAggregate = {
  __typename?: 'BatchAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  sheetCount: Scalars['Int']['output'];
};


/** description=A manufacturing batch grouping work to be scheduled and produced together. */
export type BatchAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A manufacturing batch grouping work to be scheduled and produced together. */
export type BatchAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Batch */
export type BatchCreatedEvent = {
  __typename?: 'BatchCreatedEvent';
  batchId: Scalars['String']['output'];
  batchName: Scalars['String']['output'];
};

/** Batch */
export type BatchDeletedEvent = {
  __typename?: 'BatchDeletedEvent';
  batchId: Scalars['String']['output'];
  batchName: Scalars['String']['output'];
};

export type BatchFilterInput = {
  and?: InputMaybe<Array<BatchFilterInput>>;
  batchNumber?: InputMaybe<NumberFilterInput>;
  benchtopSupplier?: InputMaybe<StringFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  cubicMetres?: InputMaybe<NumberFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  installationHours?: InputMaybe<NumberFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItems?: InputMaybe<LineItemFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BatchFilterInput>>;
  schedules?: InputMaybe<BatchScheduleFilterInput>;
  sheets?: InputMaybe<NumberFilterInput>;
};

export type BatchRecalculateDueDateEvent = {
  __typename?: 'BatchRecalculateDueDateEvent';
  batchId: Scalars['String']['output'];
};

/** A Batch identity or a typed nested report dimension. */
export type BatchReportDimensionValue = {
  __typename?: 'BatchReportDimensionValue';
  branch: Maybe<BranchReportDimensionValue>;
  job: Maybe<JobReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Select exactly one typed Batch report dimension. */
export type BatchReportGroupByInput =
  /** Group by Branch or one of its dimensions. */
  { branch: BranchReportRelationDimensionInput; job?: never; }
  |  /** Group by Job or one of its dimensions. */
  { branch?: never; job: JobReportRelationDimensionInput; };

/** Groups by Batch identity, or traverses to one of its typed dimensions. */
export type BatchReportRelationDimensionInput = {
  filter?: InputMaybe<BatchFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<BatchReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * description=A scheduled manufacturing batch for a specific process type.
 * displayName=Batch Schedule
 * module=Manufacturing
 * defaultQuery=batchSchedules
 * iconName=calendar-days
 * colour=#A96500
 * aggregateQuery=batchSchedulesAggregate
 * reportQuery=batchScheduleReport
 * grouping=true
 * queryPermission=Query_Batch_Schedules
 */
export type BatchSchedule = {
  __typename?: 'BatchSchedule';
  /**
   * sortable=true
   * groupable=true
   */
  batch: Maybe<Batch>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  dueDate: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  processInstances: Array<ProcessInstance>;
  /**
   * sortable=true
   * groupable=true
   */
  processType: Maybe<ProcessType>;
  /**
   * sortable=true
   * groupable=true
   */
  scheduled: Maybe<Scalars['String']['output']>;
};


/**
 * description=A scheduled manufacturing batch for a specific process type.
 * displayName=Batch Schedule
 * module=Manufacturing
 * defaultQuery=batchSchedules
 * iconName=calendar-days
 * colour=#A96500
 * aggregateQuery=batchSchedulesAggregate
 * reportQuery=batchScheduleReport
 * grouping=true
 * queryPermission=Query_Batch_Schedules
 */
export type BatchScheduleCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A scheduled manufacturing batch for a specific process type.
 * displayName=Batch Schedule
 * module=Manufacturing
 * defaultQuery=batchSchedules
 * iconName=calendar-days
 * colour=#A96500
 * aggregateQuery=batchSchedulesAggregate
 * reportQuery=batchScheduleReport
 * grouping=true
 * queryPermission=Query_Batch_Schedules
 */
export type BatchScheduleProcessInstancesArgs = {
  filter?: InputMaybe<ProcessInstanceFilterInput>;
};

/** description=A scheduled manufacturing batch for a specific process type. */
export type BatchScheduleAggregate = {
  __typename?: 'BatchScheduleAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * description=Total batch sheets across matching schedules. Filter by process type to count that process workload.
   * sortable=true
   * groupable=false
   */
  sheetCount: Scalars['Int']['output'];
  /**
   * description=Confirmed line-item sale value across matching schedules, grouped by schedule date rather than confirmation date. Each process schedule contributes its batch value.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  totalConfirmedSale: Maybe<Scalars['Float']['output']>;
};


/** description=A scheduled manufacturing batch for a specific process type. */
export type BatchScheduleAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A scheduled manufacturing batch for a specific process type. */
export type BatchScheduleAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BatchScheduleFilterInput = {
  and?: InputMaybe<Array<BatchScheduleFilterInput>>;
  batch?: InputMaybe<BatchFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  dueDate?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BatchScheduleFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  scheduled?: InputMaybe<DateTimeFilterInput>;
};

/** Typed Batch Schedule report dimension values. */
export type BatchScheduleReportDimensions = {
  __typename?: 'BatchScheduleReportDimensions';
  batch: Maybe<BatchReportDimensionValue>;
  dueDate: Maybe<ReportDimensionValue>;
  processType: Maybe<ProcessTypeReportDimensionValue>;
  scheduled: Maybe<ReportDimensionValue>;
};

/** Select exactly one typed Batch Schedule report dimension. */
export type BatchScheduleReportGroupByInput =
  /** Group by Batch or one of its dimensions. */
  { batch: BatchReportRelationDimensionInput; dueDate?: never; processType?: never; scheduled?: never; }
  |  { batch?: never; dueDate: DateTimeReportDimensionInput; processType?: never; scheduled?: never; }
  |  /** Group by Process Type or one of its dimensions. */
  { batch?: never; dueDate?: never; processType: ProcessTypeReportRelationDimensionInput; scheduled?: never; }
  |  { batch?: never; dueDate?: never; processType?: never; scheduled: DateTimeReportDimensionInput; };

/** One grouped Batch Schedule report row. */
export type BatchScheduleReportRow = {
  __typename?: 'BatchScheduleReportRow';
  /** The generated BatchSchedule aggregate, constrained to this dimension row. */
  aggregate: BatchScheduleAggregate;
  /** Typed values for every selected report dimension. */
  dimensions: BatchScheduleReportDimensions;
  /** The first dimension key, retained for single-dimension report compatibility. */
  key: Scalars['String']['output'];
  /** The first dimension label, retained for single-dimension report compatibility. */
  label: Scalars['String']['output'];
};


/** One grouped Batch Schedule report row. */
export type BatchScheduleReportRowAggregateArgs = {
  filter?: InputMaybe<BatchScheduleFilterInput>;
};

export type BatchStatusCheckEvent = {
  __typename?: 'BatchStatusCheckEvent';
  batchId: Scalars['String']['output'];
};

/** Batch */
export type BatchUpdatedEvent = {
  __typename?: 'BatchUpdatedEvent';
  batchId: Scalars['String']['output'];
  batchName: Scalars['String']['output'];
};

export type BillOfMaterialsImport = {
  __typename?: 'BillOfMaterialsImport';
  externalStorageConnection: ExternalStorageConnection;
  matchedItems: Array<BillOfMaterialsLine>;
  rawItems: Scalars['String']['output'];
};

export type BillOfMaterialsLine = {
  __typename?: 'BillOfMaterialsLine';
  description: Scalars['String']['output'];
  group: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  product: Maybe<Product>;
  quantity: Scalars['String']['output'];
  room: Maybe<Scalars['String']['output']>;
};

export type BooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * description=A company branch or location used to organise jobs, users, and operations.
 * displayName=Branch
 * module=Admin
 * defaultQuery=branches
 * iconName=office
 * colour=#5D35A6
 * aggregateQuery=branchesAggregate
 * grouping=true
 * queryPermission=Query_Branches
 */
export type Branch = {
  __typename?: 'Branch';
  /**
   * sortable=true
   * groupable=false
   */
  code: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  colour: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  darkColour: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  jobAggregate: Maybe<JobAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * description=The number of people assigned to this branch.
   * sortable=false
   * groupable=false
   */
  personAggregate: Maybe<PersonAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  users: Array<User>;
};


/**
 * description=A company branch or location used to organise jobs, users, and operations.
 * displayName=Branch
 * module=Admin
 * defaultQuery=branches
 * iconName=office
 * colour=#5D35A6
 * aggregateQuery=branchesAggregate
 * grouping=true
 * queryPermission=Query_Branches
 */
export type BranchCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A company branch or location used to organise jobs, users, and operations.
 * displayName=Branch
 * module=Admin
 * defaultQuery=branches
 * iconName=office
 * colour=#5D35A6
 * aggregateQuery=branchesAggregate
 * grouping=true
 * queryPermission=Query_Branches
 */
export type BranchJobAggregateArgs = {
  filter?: InputMaybe<JobFilterInput>;
};


/**
 * description=A company branch or location used to organise jobs, users, and operations.
 * displayName=Branch
 * module=Admin
 * defaultQuery=branches
 * iconName=office
 * colour=#5D35A6
 * aggregateQuery=branchesAggregate
 * grouping=true
 * queryPermission=Query_Branches
 */
export type BranchPersonAggregateArgs = {
  filter?: InputMaybe<PersonFilterInput>;
};


/**
 * description=A company branch or location used to organise jobs, users, and operations.
 * displayName=Branch
 * module=Admin
 * defaultQuery=branches
 * iconName=office
 * colour=#5D35A6
 * aggregateQuery=branchesAggregate
 * grouping=true
 * queryPermission=Query_Branches
 */
export type BranchUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
};

/** description=A company branch or location used to organise jobs, users, and operations. */
export type BranchAggregate = {
  __typename?: 'BranchAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A company branch or location used to organise jobs, users, and operations. */
export type BranchAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A company branch or location used to organise jobs, users, and operations. */
export type BranchAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Branch */
export type BranchCreatedEvent = {
  __typename?: 'BranchCreatedEvent';
  branchId: Scalars['Int']['output'];
  branchName: Scalars['String']['output'];
};

/** Branch */
export type BranchDeletedEvent = {
  __typename?: 'BranchDeletedEvent';
  branchId: Scalars['Int']['output'];
  branchName: Scalars['String']['output'];
};

export type BranchFilterInput = {
  and?: InputMaybe<Array<BranchFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  colour?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  darkColour?: InputMaybe<StringFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BranchFilterInput>>;
  users?: InputMaybe<UserFilterInput>;
};

/** A Branch identity or a typed nested report dimension. */
export type BranchReportDimensionValue = {
  __typename?: 'BranchReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Branch identity, or traverses to one of its typed dimensions. */
export type BranchReportRelationDimensionInput = {
  filter?: InputMaybe<BranchFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Branch */
export type BranchRestoredEvent = {
  __typename?: 'BranchRestoredEvent';
  branchId: Scalars['Int']['output'];
  branchName: Scalars['String']['output'];
};

/** Branch */
export type BranchUpdatedEvent = {
  __typename?: 'BranchUpdatedEvent';
  branchId: Scalars['Int']['output'];
  branchName: Scalars['String']['output'];
};

/**
 * description=A sales classification describing the type of build for a job.
 * displayName=Build Type
 * module=Sales
 * defaultQuery=buildTypes
 * colour=#A91F54
 * aggregateQuery=buildTypesAggregate
 * grouping=true
 * queryPermission=Query_Build_Types
 */
export type BuildType = {
  __typename?: 'BuildType';
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A sales classification describing the type of build for a job.
 * displayName=Build Type
 * module=Sales
 * defaultQuery=buildTypes
 * colour=#A91F54
 * aggregateQuery=buildTypesAggregate
 * grouping=true
 * queryPermission=Query_Build_Types
 */
export type BuildTypeCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A sales classification describing the type of build for a job. */
export type BuildTypeAggregate = {
  __typename?: 'BuildTypeAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A sales classification describing the type of build for a job. */
export type BuildTypeAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A sales classification describing the type of build for a job. */
export type BuildTypeAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildTypeFilterInput = {
  and?: InputMaybe<Array<BuildTypeFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BuildTypeFilterInput>>;
};

/** A Build Type identity or a typed nested report dimension. */
export type BuildTypeReportDimensionValue = {
  __typename?: 'BuildTypeReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Build Type identity, or traverses to one of its typed dimensions. */
export type BuildTypeReportRelationDimensionInput = {
  filter?: InputMaybe<BuildTypeFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * description=A building company or builder associated with sales jobs.
 * displayName=Builder
 * module=Sales
 * defaultQuery=builders
 * iconName=inbox
 * colour=#A91F54
 * aggregateQuery=buildersAggregate
 * grouping=true
 * queryPermission=Query_Builders
 */
export type Builder = {
  __typename?: 'Builder';
  /**
   * sortable=true
   * groupable=false
   */
  address: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  code: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A building company or builder associated with sales jobs.
 * displayName=Builder
 * module=Sales
 * defaultQuery=builders
 * iconName=inbox
 * colour=#A91F54
 * aggregateQuery=buildersAggregate
 * grouping=true
 * queryPermission=Query_Builders
 */
export type BuilderCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A building company or builder associated with sales jobs. */
export type BuilderAggregate = {
  __typename?: 'BuilderAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A building company or builder associated with sales jobs. */
export type BuilderAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A building company or builder associated with sales jobs. */
export type BuilderAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BuilderFilterInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<BuilderFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BuilderFilterInput>>;
};

/** A Builder identity or a typed nested report dimension. */
export type BuilderReportDimensionValue = {
  __typename?: 'BuilderReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Builder identity, or traverses to one of its typed dimensions. */
export type BuilderReportRelationDimensionInput = {
  filter?: InputMaybe<BuilderFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * description=A business role that describes how a person can be assigned to work.
 * displayName=Business Role
 * module=Admin
 * defaultQuery=businessRoles
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=businessRolesAggregate
 * grouping=true
 * queryPermission=Query_Business_Roles
 */
export type BusinessRole = {
  __typename?: 'BusinessRole';
  /**
   * description=The number of active people assigned this business role.
   * sortable=true
   * groupable=false
   */
  activePersonBusinessRoleCount: Scalars['Int']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * description=The number of current and historical assignments for this business role.
   * sortable=false
   * groupable=false
   */
  personBusinessRoleAggregate: Maybe<PersonBusinessRoleAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  personBusinessRoles: Array<PersonBusinessRole>;
};


/**
 * description=A business role that describes how a person can be assigned to work.
 * displayName=Business Role
 * module=Admin
 * defaultQuery=businessRoles
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=businessRolesAggregate
 * grouping=true
 * queryPermission=Query_Business_Roles
 */
export type BusinessRoleCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A business role that describes how a person can be assigned to work.
 * displayName=Business Role
 * module=Admin
 * defaultQuery=businessRoles
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=businessRolesAggregate
 * grouping=true
 * queryPermission=Query_Business_Roles
 */
export type BusinessRolePersonBusinessRoleAggregateArgs = {
  filter?: InputMaybe<PersonBusinessRoleFilterInput>;
};


/**
 * description=A business role that describes how a person can be assigned to work.
 * displayName=Business Role
 * module=Admin
 * defaultQuery=businessRoles
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=businessRolesAggregate
 * grouping=true
 * queryPermission=Query_Business_Roles
 */
export type BusinessRolePersonBusinessRolesArgs = {
  filter?: InputMaybe<PersonBusinessRoleFilterInput>;
};

/** description=A business role that describes how a person can be assigned to work. */
export type BusinessRoleAggregate = {
  __typename?: 'BusinessRoleAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A business role that describes how a person can be assigned to work. */
export type BusinessRoleAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A business role that describes how a person can be assigned to work. */
export type BusinessRoleAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessRoleFilterInput = {
  and?: InputMaybe<Array<BusinessRoleFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BusinessRoleFilterInput>>;
  personBusinessRoles?: InputMaybe<PersonBusinessRoleFilterInput>;
};

/** A Business Role identity or a typed nested report dimension. */
export type BusinessRoleReportDimensionValue = {
  __typename?: 'BusinessRoleReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Business Role identity, or traverses to one of its typed dimensions. */
export type BusinessRoleReportRelationDimensionInput = {
  filter?: InputMaybe<BusinessRoleFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalculateQuoteInput = {
  expressions?: Array<ExpressionInput>;
  lineTemplates: Array<QuoteLineTemplateInput>;
  lines: Array<QuoteLineInput>;
};

export type CancelPurchaseOrdersInput = {
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};

export type CancelSalesOrderInput = {
  salesOrderId: Scalars['ID']['input'];
};

export type CancelSupplierQuoteRequestInput = {
  supplierQuoteRequestId: Scalars['ID']['input'];
};

/**
 * description=An AI-generated draft record awaiting review and approval.
 * displayName=Candidate
 * module=Sales
 * defaultQuery=candidates
 * colour=#A91F54
 * aggregateQuery=candidatesAggregate
 * grouping=true
 * queryPermission=Query_Candidates
 */
export type Candidate = {
  __typename?: 'Candidate';
  /**
   * sortable=true
   * groupable=false
   */
  candidateTypeName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  conversionErrors: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  generatedData: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  shortSummary: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  source: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  status: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  targetRecordId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  targetRecordType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  type: Scalars['String']['output'];
};


/**
 * description=An AI-generated draft record awaiting review and approval.
 * displayName=Candidate
 * module=Sales
 * defaultQuery=candidates
 * colour=#A91F54
 * aggregateQuery=candidatesAggregate
 * grouping=true
 * queryPermission=Query_Candidates
 */
export type CandidateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An AI-generated draft record awaiting review and approval. */
export type CandidateAggregate = {
  __typename?: 'CandidateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An AI-generated draft record awaiting review and approval. */
export type CandidateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An AI-generated draft record awaiting review and approval. */
export type CandidateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Candidate */
export type CandidateCreatedEvent = {
  __typename?: 'CandidateCreatedEvent';
  candidateId: Scalars['Int']['output'];
  shortSummary: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CandidateFilterInput = {
  and?: InputMaybe<Array<CandidateFilterInput>>;
  conversionErrors?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  generatedData?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CandidateFilterInput>>;
  shortSummary?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  targetRecordId?: InputMaybe<IdFilterInput>;
  targetRecordType?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export enum CandidateIngestionMode {
  AutoConvert = 'autoConvert',
  Disabled = 'disabled',
  ManualReview = 'manualReview'
}

/**
 * description=Controls whether messages from an identified sender can create or automatically convert Candidates.
 * displayName=CandidateIngestionPolicy
 * module=Admin
 * defaultQuery=candidateIngestionPolicies
 * colour=#5D35A6
 * aggregateQuery=candidateIngestionPoliciesAggregate
 * grouping=true
 * queryPermission=Query_Candidate_Ingestion_Policies
 */
export type CandidateIngestionPolicy = {
  __typename?: 'CandidateIngestionPolicy';
  /**
   * sortable=true
   * groupable=false
   */
  candidateType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  emailAddresses: Array<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  mode: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modified: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  senderRecordId: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  senderRecordType: Scalars['String']['output'];
};


/**
 * description=Controls whether messages from an identified sender can create or automatically convert Candidates.
 * displayName=CandidateIngestionPolicy
 * module=Admin
 * defaultQuery=candidateIngestionPolicies
 * colour=#5D35A6
 * aggregateQuery=candidateIngestionPoliciesAggregate
 * grouping=true
 * queryPermission=Query_Candidate_Ingestion_Policies
 */
export type CandidateIngestionPolicyCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=Controls whether messages from an identified sender can create or automatically convert Candidates. */
export type CandidateIngestionPolicyAggregate = {
  __typename?: 'CandidateIngestionPolicyAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=Controls whether messages from an identified sender can create or automatically convert Candidates. */
export type CandidateIngestionPolicyAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=Controls whether messages from an identified sender can create or automatically convert Candidates. */
export type CandidateIngestionPolicyAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidateIngestionPolicyFilterInput = {
  and?: InputMaybe<Array<CandidateIngestionPolicyFilterInput>>;
  candidateType?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  mode?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<CandidateIngestionPolicyFilterInput>>;
  senderRecordId?: InputMaybe<IdFilterInput>;
  senderRecordType?: InputMaybe<StringFilterInput>;
};

/**
 * description=A customer or household contact associated with sales work.
 * displayName=Client
 * module=Sales
 * defaultQuery=clients
 * iconName=people
 * colour=#A91F54
 * aggregateQuery=clientsAggregate
 * grouping=true
 * queryPermission=Query_Clients
 */
export type Client = {
  __typename?: 'Client';
  /**
   * sortable=true
   * groupable=false
   */
  address: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  email: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  faxHome: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  faxWork: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  firstName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  fullName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  jobs: Maybe<Array<Job>>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  lastName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  notes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  phoneCell: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  phoneHome: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  phoneWork: Maybe<Scalars['String']['output']>;
};


/**
 * description=A customer or household contact associated with sales work.
 * displayName=Client
 * module=Sales
 * defaultQuery=clients
 * iconName=people
 * colour=#A91F54
 * aggregateQuery=clientsAggregate
 * grouping=true
 * queryPermission=Query_Clients
 */
export type ClientCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A customer or household contact associated with sales work.
 * displayName=Client
 * module=Sales
 * defaultQuery=clients
 * iconName=people
 * colour=#A91F54
 * aggregateQuery=clientsAggregate
 * grouping=true
 * queryPermission=Query_Clients
 */
export type ClientJobsArgs = {
  filter?: InputMaybe<JobFilterInput>;
};

/** description=A customer or household contact associated with sales work. */
export type ClientAggregate = {
  __typename?: 'ClientAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A customer or household contact associated with sales work. */
export type ClientAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A customer or household contact associated with sales work. */
export type ClientAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientFilterInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<ClientFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  faxHome?: InputMaybe<StringFilterInput>;
  faxWork?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  fullName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobs?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ClientFilterInput>>;
  phoneCell?: InputMaybe<StringFilterInput>;
  phoneHome?: InputMaybe<StringFilterInput>;
  phoneWork?: InputMaybe<StringFilterInput>;
};

/** A Client identity or a typed nested report dimension. */
export type ClientReportDimensionValue = {
  __typename?: 'ClientReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Client identity, or traverses to one of its typed dimensions. */
export type ClientReportRelationDimensionInput = {
  filter?: InputMaybe<ClientFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommitPendingFilesInput = {
  defaultFolderId?: InputMaybe<Scalars['ID']['input']>;
  files: Array<FileInput>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  uploadToken?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAction = {
  __typename?: 'ComponentAction';
  action: Scalars['String']['output'];
  colour: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ComponentGridColumn = {
  __typename?: 'ComponentGridColumn';
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['String']['output'];
};

/**
 * displayName=Shortcut
 * module=Admin
 * defaultQuery=configuredLinkedActions
 * colour=#5D35A6
 * aggregateQuery=configuredLinkedActionsAggregate
 * grouping=true
 * queryPermission=Query_Configured_Linked_Actions
 */
export type ConfiguredLinkedAction = {
  __typename?: 'ConfiguredLinkedAction';
  /**
   * sortable=true
   * groupable=false
   */
  actionId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  bindings: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  displayOrder: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isGlobal: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordPath: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  roleIds: Array<Scalars['ID']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  seedRoleIds: Array<Scalars['ID']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  seedUserIds: Array<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  source: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  userIds: Array<Scalars['ID']['output']>;
};


/**
 * displayName=Shortcut
 * module=Admin
 * defaultQuery=configuredLinkedActions
 * colour=#5D35A6
 * aggregateQuery=configuredLinkedActionsAggregate
 * grouping=true
 * queryPermission=Query_Configured_Linked_Actions
 */
export type ConfiguredLinkedActionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type ConfiguredLinkedActionAggregate = {
  __typename?: 'ConfiguredLinkedActionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type ConfiguredLinkedActionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type ConfiguredLinkedActionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfiguredLinkedActionFilterInput = {
  actionId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<ConfiguredLinkedActionFilterInput>>;
  bindings?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  displayOrder?: InputMaybe<NumberFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isGlobal?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ConfiguredLinkedActionFilterInput>>;
  recordPath?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
};

export type ConfirmSalesOrderInput = {
  salesOrderId: Scalars['ID']['input'];
};

export type ConvertLeadToJobInput = {
  jobId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};

/**
 * description=A note, email, phone call, or other correspondence item linked to a record.
 * displayName=Correspondence
 * module=Sales
 * defaultQuery=correspondence
 * iconName=comment
 * colour=#A91F54
 * aggregateQuery=correspondenceAggregate
 * grouping=true
 * queryPermission=Query_Correspondence
 */
export type Correspondence = {
  __typename?: 'Correspondence';
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  createdBy: Maybe<User>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  date: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  text: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  type: Maybe<Scalars['String']['output']>;
};


/**
 * description=A note, email, phone call, or other correspondence item linked to a record.
 * displayName=Correspondence
 * module=Sales
 * defaultQuery=correspondence
 * iconName=comment
 * colour=#A91F54
 * aggregateQuery=correspondenceAggregate
 * grouping=true
 * queryPermission=Query_Correspondence
 */
export type CorrespondenceCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A note, email, phone call, or other correspondence item linked to a record. */
export type CorrespondenceAggregate = {
  __typename?: 'CorrespondenceAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A note, email, phone call, or other correspondence item linked to a record. */
export type CorrespondenceAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A note, email, phone call, or other correspondence item linked to a record. */
export type CorrespondenceAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CorrespondenceFilterInput = {
  and?: InputMaybe<Array<CorrespondenceFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<CorrespondenceFilterInput>>;
  recordId?: InputMaybe<IdFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

/**
 * displayName=Costing
 * defaultQuery=costings
 * aggregateQuery=costingsAggregate
 * grouping=true
 * queryPermission=Query_Costings
 */
export type Costing = {
  __typename?: 'Costing';
  /**
   * sortable=true
   * groupable=false
   */
  costTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision: Maybe<CostingRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=true
   */
  jobComponent: Maybe<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  marginPercent: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  markupTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  revisions: Array<CostingRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  sellTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['String']['output'];
};


/**
 * displayName=Costing
 * defaultQuery=costings
 * aggregateQuery=costingsAggregate
 * grouping=true
 * queryPermission=Query_Costings
 */
export type CostingCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * displayName=Costing
 * defaultQuery=costings
 * aggregateQuery=costingsAggregate
 * grouping=true
 * queryPermission=Query_Costings
 */
export type CostingLinesArgs = {
  filter?: InputMaybe<CostingLineFilterInput>;
};


/**
 * displayName=Costing
 * defaultQuery=costings
 * aggregateQuery=costingsAggregate
 * grouping=true
 * queryPermission=Query_Costings
 */
export type CostingRevisionsArgs = {
  filter?: InputMaybe<CostingRevisionFilterInput>;
};

export type CostingAggregate = {
  __typename?: 'CostingAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type CostingAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type CostingAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CostingFilterInput = {
  and?: InputMaybe<Array<CostingFilterInput>>;
  costTotal?: InputMaybe<StringFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<CostingRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  jobComponent?: InputMaybe<JobComponentFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<CostingLineFilterInput>;
  marginPercent?: InputMaybe<StringFilterInput>;
  markupTotal?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingFilterInput>>;
  revisions?: InputMaybe<CostingRevisionFilterInput>;
  sellTotal?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
};

/**
 * displayName=CostingLine
 * defaultQuery=costingLines
 * aggregateQuery=costingLinesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Lines
 */
export type CostingLine = {
  __typename?: 'CostingLine';
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  costing: Maybe<Costing>;
  /**
   * sortable=true
   * groupable=true
   */
  costingRevision: Maybe<CostingRevision>;
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision: Maybe<CostingTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  line: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  lineTemplateId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  markupAmount: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  parentLine: Maybe<CostingLine>;
  /**
   * sortable=true
   * groupable=true
   */
  product: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  productId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  supplierQuote: Maybe<SupplierQuote>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierQuoteId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  type: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitSellPrice: Scalars['String']['output'];
};


/**
 * displayName=CostingLine
 * defaultQuery=costingLines
 * aggregateQuery=costingLinesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Lines
 */
export type CostingLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * displayName=CostingLine
 * defaultQuery=costingLines
 * aggregateQuery=costingLinesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Lines
 */
export type CostingLineLinesArgs = {
  filter?: InputMaybe<CostingLineFilterInput>;
};

export type CostingLineAggregate = {
  __typename?: 'CostingLineAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['Float']['output'];
};


export type CostingLineAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type CostingLineAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CostingLineFilterInput = {
  and?: InputMaybe<Array<CostingLineFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  costing?: InputMaybe<CostingFilterInput>;
  costingRevision?: InputMaybe<CostingRevisionFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  lineTemplateId?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<CostingLineFilterInput>;
  markupAmount?: InputMaybe<StringFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingLineFilterInput>>;
  parentLine?: InputMaybe<CostingLineFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<StringFilterInput>;
  quantity?: InputMaybe<StringFilterInput>;
  supplierQuote?: InputMaybe<SupplierQuoteFilterInput>;
  supplierQuoteId?: InputMaybe<IdFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitSellPrice?: InputMaybe<StringFilterInput>;
};

export type CostingLineInput = {
  costPrice?: InputMaybe<Scalars['String']['input']>;
  costing?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lineTemplateId?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<CostingLineInput>>;
  markupExpression?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  supplierQuoteId?: InputMaybe<Scalars['String']['input']>;
  type?: CostingLineType;
};

/**
 * displayName=CostingLineTemplate
 * defaultQuery=costingLineTemplates
 * aggregateQuery=costingLineTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Line_Templates
 */
export type CostingLineTemplate = {
  __typename?: 'CostingLineTemplate';
  /**
   * sortable=true
   * groupable=false
   */
  category: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision: Maybe<CostingTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  descriptionEditable: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  markupEditable: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  quantityEditable: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPriceEditable: Scalars['Boolean']['output'];
};


/**
 * displayName=CostingLineTemplate
 * defaultQuery=costingLineTemplates
 * aggregateQuery=costingLineTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Line_Templates
 */
export type CostingLineTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type CostingLineTemplateAggregate = {
  __typename?: 'CostingLineTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type CostingLineTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type CostingLineTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CostingLineTemplateFilterInput = {
  and?: InputMaybe<Array<CostingLineTemplateFilterInput>>;
  category?: InputMaybe<StringFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  descriptionEditable?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  markupEditable?: InputMaybe<BooleanFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingLineTemplateFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  quantityEditable?: InputMaybe<BooleanFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitCostPriceEditable?: InputMaybe<BooleanFilterInput>;
};

export type CostingLineTemplateInput = {
  category?: Scalars['String']['input'];
  costPriceEditable?: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  descriptionEditable?: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  markupEditable?: Scalars['Boolean']['input'];
  markupExpression?: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  quantityEditable?: Scalars['Boolean']['input'];
  type?: CostingLineType;
  unitCostPrice?: Scalars['String']['input'];
  unitCostPriceEditable?: Scalars['Boolean']['input'];
};

export enum CostingLineType {
  Composite = 'COMPOSITE',
  Normal = 'NORMAL'
}

/**
 * displayName=CostingRevision
 * defaultQuery=costingRevisions
 * aggregateQuery=costingRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Revisions
 */
export type CostingRevision = {
  __typename?: 'CostingRevision';
  /**
   * sortable=true
   * groupable=false
   */
  costTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  costing: Costing;
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  marginPercent: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  markupTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  sellTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  version: Scalars['Int']['output'];
};


/**
 * displayName=CostingRevision
 * defaultQuery=costingRevisions
 * aggregateQuery=costingRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Revisions
 */
export type CostingRevisionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * displayName=CostingRevision
 * defaultQuery=costingRevisions
 * aggregateQuery=costingRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Revisions
 */
export type CostingRevisionLinesArgs = {
  filter?: InputMaybe<CostingLineFilterInput>;
};

export type CostingRevisionAggregate = {
  __typename?: 'CostingRevisionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type CostingRevisionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type CostingRevisionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CostingRevisionFilterInput = {
  and?: InputMaybe<Array<CostingRevisionFilterInput>>;
  costTotal?: InputMaybe<StringFilterInput>;
  costing?: InputMaybe<CostingFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<CostingLineFilterInput>;
  marginPercent?: InputMaybe<StringFilterInput>;
  markupTotal?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingRevisionFilterInput>>;
  sellTotal?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
};

/**
 * displayName=CostingTemplate
 * defaultQuery=costingTemplates
 * aggregateQuery=costingTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Templates
 */
export type CostingTemplate = {
  __typename?: 'CostingTemplate';
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision: Maybe<CostingTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  draftRevision: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isDefault: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  version: Scalars['Int']['output'];
};


/**
 * displayName=CostingTemplate
 * defaultQuery=costingTemplates
 * aggregateQuery=costingTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Templates
 */
export type CostingTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type CostingTemplateAggregate = {
  __typename?: 'CostingTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type CostingTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type CostingTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * displayName=CostingTemplateExpression
 * defaultQuery=costingTemplateExpressions
 * aggregateQuery=costingTemplateExpressionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Expressions
 */
export type CostingTemplateExpression = {
  __typename?: 'CostingTemplateExpression';
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  costingTemplateRevisionId: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  value: Scalars['String']['output'];
};


/**
 * displayName=CostingTemplateExpression
 * defaultQuery=costingTemplateExpressions
 * aggregateQuery=costingTemplateExpressionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Expressions
 */
export type CostingTemplateExpressionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type CostingTemplateExpressionAggregate = {
  __typename?: 'CostingTemplateExpressionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type CostingTemplateExpressionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type CostingTemplateExpressionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CostingTemplateExpressionFilterInput = {
  and?: InputMaybe<Array<CostingTemplateExpressionFilterInput>>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  costingTemplateRevisionId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingTemplateExpressionFilterInput>>;
  value?: InputMaybe<StringFilterInput>;
};

export type CostingTemplateFilterInput = {
  and?: InputMaybe<Array<CostingTemplateFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isDefault?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingTemplateFilterInput>>;
  version?: InputMaybe<NumberFilterInput>;
};

/**
 * displayName=CostingTemplateRevision
 * defaultQuery=costingTemplateRevisions
 * aggregateQuery=costingTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Revisions
 */
export type CostingTemplateRevision = {
  __typename?: 'CostingTemplateRevision';
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplate: CostingTemplate;
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  defaultLines: Array<CostingLine>;
  /**
   * sortable=false
   * groupable=true
   */
  expressions: Array<CostingTemplateExpression>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lineTemplates: Array<CostingLineTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  status: CostingTemplateRevisionStatus;
  /**
   * sortable=true
   * groupable=false
   */
  version: Scalars['Int']['output'];
};


/**
 * displayName=CostingTemplateRevision
 * defaultQuery=costingTemplateRevisions
 * aggregateQuery=costingTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Revisions
 */
export type CostingTemplateRevisionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * displayName=CostingTemplateRevision
 * defaultQuery=costingTemplateRevisions
 * aggregateQuery=costingTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Revisions
 */
export type CostingTemplateRevisionExpressionsArgs = {
  filter?: InputMaybe<CostingTemplateExpressionFilterInput>;
};


/**
 * displayName=CostingTemplateRevision
 * defaultQuery=costingTemplateRevisions
 * aggregateQuery=costingTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Revisions
 */
export type CostingTemplateRevisionLineTemplatesArgs = {
  filter?: InputMaybe<CostingLineTemplateFilterInput>;
};

export type CostingTemplateRevisionAggregate = {
  __typename?: 'CostingTemplateRevisionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type CostingTemplateRevisionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type CostingTemplateRevisionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CostingTemplateRevisionFilterInput = {
  and?: InputMaybe<Array<CostingTemplateRevisionFilterInput>>;
  costingTemplate?: InputMaybe<CostingTemplateFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  expressions?: InputMaybe<CostingTemplateExpressionFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineTemplates?: InputMaybe<CostingLineTemplateFilterInput>;
  or?: InputMaybe<Array<CostingTemplateRevisionFilterInput>>;
  status?: InputMaybe<NumberFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
};

/** Costing template revision status. */
export enum CostingTemplateRevisionStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type CreateBatchInput = {
  jobId: Scalars['ID']['input'];
};

export type CreateBranchInput = {
  code: Scalars['String']['input'];
  colour: Scalars['String']['input'];
  darkColour: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateBuilderInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateBusinessRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCandidateInput = {
  files?: Array<Scalars['ID']['input']>;
  source: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateClientInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxHome?: InputMaybe<Scalars['String']['input']>;
  faxWork?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneCell?: InputMaybe<Scalars['String']['input']>;
  phoneHome?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCorrespondenceInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  type: Scalars['Int']['input'];
};

export type CreateCostingInput = {
  costingTemplateRevisionId?: InputMaybe<Scalars['ID']['input']>;
  jobComponentId?: InputMaybe<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines?: Array<CostingLineInput>;
  name: Scalars['String']['input'];
};

export type CreateCostingTemplateInput = {
  isDefault?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateCostingTemplateRevisionInput = {
  costingTemplateId: Scalars['String']['input'];
  costingTemplateRevisionId?: InputMaybe<Scalars['String']['input']>;
  defaultLines: Array<CostingLineInput>;
  expressions: Array<ExpressionInput>;
  lineTemplates: Array<CostingLineTemplateInput>;
  publish?: Scalars['Boolean']['input'];
};

export type CreateDocumentTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};

export type CreateFileInput = {
  hash: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  persistenceType?: InputMaybe<Scalars['Int']['input']>;
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFolderInput = {
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  recordId: Scalars['ID']['input'];
  recordType: Scalars['String']['input'];
};

export type CreateHousingCompanyImageInput = {
  hash: Scalars['String']['input'];
  housingCompanyId: Scalars['ID']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHousingCompanyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateIssueInput = {
  completed?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  requiredDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateJobComponentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  partTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateJobEmailInput = {
  body: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type CreateJobInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  benchtopOnly: Scalars['Boolean']['input'];
  branch: Scalars['ID']['input'];
  buildType: Scalars['ID']['input'];
  builder?: InputMaybe<Scalars['ID']['input']>;
  builderPhone?: InputMaybe<Scalars['String']['input']>;
  client: Scalars['ID']['input'];
  designer?: InputMaybe<Scalars['ID']['input']>;
  difficultAccess: Scalars['Boolean']['input'];
  estimatedDueDate: Scalars['DateTime']['input'];
  hcJobNumber?: InputMaybe<Scalars['String']['input']>;
  hcPmPhone?: InputMaybe<Scalars['String']['input']>;
  hcProjectManager?: InputMaybe<Scalars['String']['input']>;
  housingCompany?: InputMaybe<Scalars['ID']['input']>;
  jobName?: InputMaybe<Scalars['String']['input']>;
  jobQuantity: Scalars['Int']['input'];
  leadId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  projectManager?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['ID']['input']>;
  saleType: Scalars['ID']['input'];
  showHome: Scalars['Boolean']['input'];
  siteNotes?: InputMaybe<Scalars['String']['input']>;
  sssp: Scalars['Boolean']['input'];
  tristoneJoin: Scalars['Boolean']['input'];
  tristoneSpecified: Scalars['Boolean']['input'];
  unit: Scalars['Boolean']['input'];
};

export type CreateLeadInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  builderName?: InputMaybe<Scalars['String']['input']>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  joineryTypes?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priceRangeBottom?: InputMaybe<Scalars['Float']['input']>;
  priceRangeTop?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  projectType: Scalars['String']['input'];
  requiredBy?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLineItemInput = {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  jobId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  partTypeId: Scalars['ID']['input'];
};

export type CreateLostReasonInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreatePanelInput = {
  config: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreatePartTypeInput = {
  code: Scalars['String']['input'];
  colour: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePersonInput = {
  branchId?: InputMaybe<Scalars['ID']['input']>;
  businessRoleIds?: Array<Scalars['ID']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateProcessTimerInput = {
  processInstanceIds: Array<Scalars['String']['input']>;
};

export type CreateProcessTypeInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProcessTypeNoteInput = {
  assignedProcessIds: Array<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
};

export type CreateProcessTypeRoleInput = {
  processTypeId: Scalars['ID']['input'];
  roleType: Scalars['String']['input'];
};

export type CreateProductCategoryInput = {
  group: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateProductInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  deleted: Scalars['Boolean']['input'];
  indent: Scalars['Boolean']['input'];
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  qtyReviewThreshold: Scalars['Int']['input'];
  safetyStockDays: Scalars['Int']['input'];
  starred: Scalars['Boolean']['input'];
  stockItem: Scalars['Boolean']['input'];
  supplier: Scalars['ID']['input'];
  tags: Array<Scalars['ID']['input']>;
  template: Scalars['Boolean']['input'];
  unitOfMeasure: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateProductPriceInput = {
  effectiveDate: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  unitPrice: Scalars['String']['input'];
};

export type CreateProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreatePurchaseOrderFromSupplierQuoteInput = {
  supplierQuoteId: Scalars['ID']['input'];
};

export type CreatePurchaseOrderInput = {
  category?: InputMaybe<OrderCategory>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressId?: InputMaybe<Scalars['ID']['input']>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines?: InputMaybe<Array<PurchaseOrderLineInput>>;
  notifySupplierWhenPlaced?: Scalars['Boolean']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<OrderShippingMethods>;
  shippingTerms?: InputMaybe<OrderShippingTerms>;
  siteVisitRequired?: Scalars['Boolean']['input'];
  statusWhenPlaced?: InputMaybe<OrderStatus>;
  supplierComment?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  urgent?: Scalars['Boolean']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePurchaseOrderReceiptInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  orderLines: Array<PurchaseOrderReceiptLineInput>;
  purchaseOrderId: Scalars['ID']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type CreateQuoteApprovalRequestInput = {
  quoteId: Scalars['ID']['input'];
};

export type CreateQuoteInput = {
  clientAddress?: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<QuoteLineInput>;
  quoteRequestId?: InputMaybe<Scalars['ID']['input']>;
  quoteTemplateRevisionId?: InputMaybe<Scalars['ID']['input']>;
  reference: Scalars['String']['input'];
};

export type CreateQuoteTemplateInput = {
  isDefault?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateQuoteTemplateRevisionInput = {
  defaultLines: Array<QuoteLineInput>;
  expressions: Array<ExpressionInput>;
  lineTemplates: Array<QuoteLineTemplateInput>;
  publish?: Scalars['Boolean']['input'];
  quoteTemplateId: Scalars['String']['input'];
  quoteTemplateRevisionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRecordFileInput = {
  entity: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  recordId: Scalars['Int']['input'];
};

export type CreateRoleInput = {
  description: Scalars['String']['input'];
  inheritFrom?: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSalesOrderInput = {
  clientAddress?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientName: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  currency?: Scalars['String']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SalesOrderLineInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchemaInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};

export type CreateScreenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<ScreenGroup>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  screenCfg: Scalars['String']['input'];
};

export type CreateSignedUploadUrlInput = {
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type CreateStorageConnectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  deviceAccessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dropboxAuthToken?: InputMaybe<Scalars['String']['input']>;
  dropboxNamespaceId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  localRoot?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  root: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateStorageResourceMappingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalStorageConnectionId: Scalars['ID']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  resourceFilter?: InputMaybe<Scalars['String']['input']>;
  resourceType: Scalars['String']['input'];
};

export type CreateSubscriptionInput = {
  enabled?: Scalars['Boolean']['input'];
  event: Scalars['String']['input'];
  maxRecipients?: InputMaybe<Scalars['Int']['input']>;
  notifications?: Array<NotificationInput>;
  sourceFilter?: InputMaybe<Scalars['String']['input']>;
  targetFilter?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierImageInput = {
  hash: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  supplierId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierInput = {
  address: Scalars['String']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  cell: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  quoteEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  url: Scalars['String']['input'];
};

export type CreateSupplierQuoteInput = {
  files?: Array<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines?: Array<SupplierQuoteLineInput>;
  quoteRequestId?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  salesTax?: Scalars['String']['input'];
  saveAsDraft?: Scalars['Boolean']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierQuoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierQuoteRequestInput = {
  files?: Array<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SupplierQuoteRequestLineInput>;
  noteForSupplier: Scalars['String']['input'];
  place?: InputMaybe<Scalars['Boolean']['input']>;
  reference: Scalars['String']['input'];
  supplierIds: Array<Scalars['ID']['input']>;
};

export type CreateTagInput = {
  colour: Scalars['String']['input'];
  context: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateUserIdentityInput = {
  entity: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateUserInput = {
  authProvider: AuthProviderType;
  branchId?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  username: Scalars['String']['input'];
};

export type CreateWarehouseInput = {
  address: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateWebhookInput = {
  authType?: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  event: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sourceFilter?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateWorkflowTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  master: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/**
 * description=Custom form data associated with a record and schema version.
 * displayName=Custom Data
 * module=Admin
 * defaultQuery=customData
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=customDataAggregate
 * grouping=true
 * queryPermission=Query_Custom_Data
 */
export type CustomData = {
  __typename?: 'CustomData';
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  data: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  schema: Schema;
  /**
   * sortable=true
   * groupable=false
   */
  schemaId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  schemaVersion: Maybe<SchemaVersion>;
};


/**
 * description=Custom form data associated with a record and schema version.
 * displayName=Custom Data
 * module=Admin
 * defaultQuery=customData
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=customDataAggregate
 * grouping=true
 * queryPermission=Query_Custom_Data
 */
export type CustomDataCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=Custom form data associated with a record and schema version. */
export type CustomDataAggregate = {
  __typename?: 'CustomDataAggregate';
  /**
   * sortable=true
   * groupable=false
   */
  average: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  max: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  min: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  sum: Scalars['Float']['output'];
};


/** description=Custom form data associated with a record and schema version. */
export type CustomDataAggregateAverageArgs = {
  path: Scalars['String']['input'];
};


/** description=Custom form data associated with a record and schema version. */
export type CustomDataAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=Custom form data associated with a record and schema version. */
export type CustomDataAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** description=Custom form data associated with a record and schema version. */
export type CustomDataAggregateMaxArgs = {
  path: Scalars['String']['input'];
};


/** description=Custom form data associated with a record and schema version. */
export type CustomDataAggregateMinArgs = {
  path: Scalars['String']['input'];
};


/** description=Custom form data associated with a record and schema version. */
export type CustomDataAggregateSumArgs = {
  path: Scalars['String']['input'];
};

export type CustomDataFilterInput = {
  and?: InputMaybe<Array<CustomDataFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CustomDataFilterInput>>;
  recordId?: InputMaybe<IdFilterInput>;
  schema?: InputMaybe<SchemaFilterInput>;
  schemaId?: InputMaybe<StringFilterInput>;
  schemaVersion?: InputMaybe<SchemaVersionFilterInput>;
};

/** CustomData */
export type CustomDataSetEvent = {
  __typename?: 'CustomDataSetEvent';
  customDataId: Scalars['String']['output'];
  data: Scalars['String']['output'];
  description: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
  recordType: Scalars['String']['output'];
  schemaId: Scalars['String']['output'];
  schemaVersionId: Scalars['String']['output'];
};

/**
 * description=A reusable custom template for generating application content.
 * displayName=Custom Template
 * module=Admin
 * defaultQuery=customTemplates
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=customTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Custom_Templates
 */
export type CustomTemplate = {
  __typename?: 'CustomTemplate';
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  default: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  entity: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  query: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  sampleDataOverride: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  source: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  template: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  type: Scalars['Int']['output'];
};


/**
 * description=A reusable custom template for generating application content.
 * displayName=Custom Template
 * module=Admin
 * defaultQuery=customTemplates
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=customTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Custom_Templates
 */
export type CustomTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable custom template for generating application content. */
export type CustomTemplateAggregate = {
  __typename?: 'CustomTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable custom template for generating application content. */
export type CustomTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable custom template for generating application content. */
export type CustomTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomTemplateFilterInput = {
  and?: InputMaybe<Array<CustomTemplateFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  default?: InputMaybe<BooleanFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  entity?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CustomTemplateFilterInput>>;
  query?: InputMaybe<StringFilterInput>;
  sampleDataOverride?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  template?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
};

export type DataStore = {
  __typename?: 'DataStore';
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type DataStoreRecord = {
  __typename?: 'DataStoreRecord';
  data: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type DateTimeFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
};

/** Groups a DateTime field into calendar intervals within a typed date filter. */
export type DateTimeReportDimensionInput = {
  filter: DateTimeFilterInput;
  /** Include interval values for which the aggregate is zero. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  interval: ReportDateInterval;
  /** Restrict contributing values to the same relative date range within every interval. */
  withinEachInterval?: InputMaybe<DateTimeFilterInput>;
};

export type Day = {
  __typename?: 'Day';
  createdLeadAggregate: Maybe<LeadAggregate>;
  createdPurchaseOrderAggregate: Maybe<PurchaseOrderAggregate>;
  createdPurchaseOrderLineAggregate: Maybe<PurchaseOrderLineAggregate>;
  date: Scalars['String']['output'];
};


export type DayCreatedLeadAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};


export type DayCreatedPurchaseOrderAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
};


export type DayCreatedPurchaseOrderLineAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
};

export type DeactivatePersonInput = {
  personId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

/**
 * description=A default native folder shown for every record of its configured type.
 * displayName=Default Folder
 * defaultQuery=defaultFolders
 * iconName=folder-close
 * aggregateQuery=defaultFoldersAggregate
 * grouping=true
 * queryPermission=Query_Default_Folders
 */
export type DefaultFolder = {
  __typename?: 'DefaultFolder';
  /**
   * sortable=false
   * groupable=false
   */
  allowedMimeTypes: Maybe<Array<Scalars['String']['output']>>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Scalars['String']['output'];
};


/**
 * description=A default native folder shown for every record of its configured type.
 * displayName=Default Folder
 * defaultQuery=defaultFolders
 * iconName=folder-close
 * aggregateQuery=defaultFoldersAggregate
 * grouping=true
 * queryPermission=Query_Default_Folders
 */
export type DefaultFolderCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A default native folder shown for every record of its configured type. */
export type DefaultFolderAggregate = {
  __typename?: 'DefaultFolderAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A default native folder shown for every record of its configured type. */
export type DefaultFolderAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A default native folder shown for every record of its configured type. */
export type DefaultFolderAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DefaultFolderFilterInput = {
  and?: InputMaybe<Array<DefaultFolderFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<DefaultFolderFilterInput>>;
  recordType?: InputMaybe<StringFilterInput>;
};

export type DeleteBatchesInput = {
  batchIds: Array<Scalars['ID']['input']>;
};

export type DeleteBranchesInput = {
  branchIds: Array<Scalars['ID']['input']>;
};

export type DeleteBuildersInput = {
  builderIds: Array<Scalars['ID']['input']>;
};

export type DeleteClientsInput = {
  clientIds: Array<Scalars['ID']['input']>;
};

export type DeleteConfiguredLinkedActionsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteCorrespondenceInput = {
  correspondenceId: Scalars['ID']['input'];
};

export type DeleteCostingInput = {
  costingId: Scalars['ID']['input'];
};

export type DeleteDraftPurchaseOrdersInput = {
  purchaseOrderIds: Array<Scalars['String']['input']>;
};

export type DeleteExternalStorageItemsInput = {
  paths: Array<Scalars['String']['input']>;
};

export type DeleteHousingCompaniesInput = {
  housingCompanyIds: Array<Scalars['ID']['input']>;
};

export type DeleteHousingCompanyImageInput = {
  housingCompanyId: Scalars['ID']['input'];
};

export type DeleteJobComponentInput = {
  jobComponentId: Scalars['ID']['input'];
};

export type DeleteJobsInput = {
  jobIds: Array<Scalars['ID']['input']>;
};

export type DeleteLeadsInput = {
  leadIds: Array<Scalars['ID']['input']>;
};

export type DeleteLineItemsInput = {
  lineItemIds: Array<Scalars['ID']['input']>;
};

export type DeleteLostReasonsInput = {
  lostReasonIds: Array<Scalars['ID']['input']>;
};

export type DeletePanelsInput = {
  panelIds: Array<Scalars['ID']['input']>;
};

export type DeletePartTypesInput = {
  partTypeIds: Array<Scalars['ID']['input']>;
};

export type DeleteProcessTypeNoteInput = {
  processTypeNoteId: Scalars['ID']['input'];
};

export type DeleteProcessTypeRolesInput = {
  processTypeRoleIds: Array<Scalars['ID']['input']>;
};

export type DeleteProcessTypesInput = {
  processTypeIds: Array<Scalars['ID']['input']>;
};

export type DeleteProductCategoriesInput = {
  cascade: Scalars['Boolean']['input'];
  productCategoryIds: Array<Scalars['ID']['input']>;
};

export type DeleteProductPricesInput = {
  productPriceIds: Array<Scalars['ID']['input']>;
};

export type DeleteRecordFilesInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteSalesOrderInput = {
  salesOrderId: Scalars['ID']['input'];
};

export type DeleteScreensInput = {
  screenIds: Array<Scalars['ID']['input']>;
};

export type DeleteSupplierImageInput = {
  supplierId: Scalars['ID']['input'];
};

export type DeleteSupplierQuoteInput = {
  supplierQuoteId: Scalars['ID']['input'];
};

export type DeleteSupplierQuoteRequestInput = {
  supplierQuoteRequestId: Scalars['ID']['input'];
};

export type DeleteSuppliersInput = {
  supplierIds: Array<Scalars['ID']['input']>;
};

export type DeleteUserIdentitiesInput = {
  userIdentityIds: Array<Scalars['ID']['input']>;
};

export type DeleteWebhooksInput = {
  webhookIds: Array<Scalars['ID']['input']>;
};

export type DeleteWorkflowTypesInput = {
  workflowTypeIds: Array<Scalars['ID']['input']>;
};

/**
 * description=A reusable delivery address for purchase orders.
 * displayName=Delivery Address
 * module=Inventory
 * defaultQuery=deliveryAddresses
 * iconName=map-marker
 * colour=#596600
 * aggregateQuery=deliveryAddressesAggregate
 * grouping=true
 * queryPermission=Query_Delivery_Addresses
 */
export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  /**
   * sortable=true
   * groupable=false
   */
  address: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  color: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Maybe<Scalars['String']['output']>;
};


/**
 * description=A reusable delivery address for purchase orders.
 * displayName=Delivery Address
 * module=Inventory
 * defaultQuery=deliveryAddresses
 * iconName=map-marker
 * colour=#596600
 * aggregateQuery=deliveryAddressesAggregate
 * grouping=true
 * queryPermission=Query_Delivery_Addresses
 */
export type DeliveryAddressCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable delivery address for purchase orders. */
export type DeliveryAddressAggregate = {
  __typename?: 'DeliveryAddressAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable delivery address for purchase orders. */
export type DeliveryAddressAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable delivery address for purchase orders. */
export type DeliveryAddressAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryAddressFilterInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<DeliveryAddressFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<DeliveryAddressFilterInput>>;
};

export type Document = {
  __typename?: 'Document';
  /** TODO: Rename as might output formats other than HTML, eg plaintext, images etc */
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pdfBase64: Scalars['String']['output'];
  template: DocumentTemplate;
};

export type DocumentPreview = {
  __typename?: 'DocumentPreview';
  html: Scalars['String']['output'];
  pdfBase64: Scalars['String']['output'];
};

/**
 * description=A document template with its rendering query and default selection.
 * displayName=Document Template
 * module=Admin
 * defaultQuery=documentTemplates
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=documentTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Document_Templates
 */
export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  default: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  entity: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  html: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  query: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  sampleDataOverride: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  source: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  template: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  type: Scalars['String']['output'];
};


/**
 * description=A document template with its rendering query and default selection.
 * displayName=Document Template
 * module=Admin
 * defaultQuery=documentTemplates
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=documentTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Document_Templates
 */
export type DocumentTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A document template with its rendering query and default selection. */
export type DocumentTemplateAggregate = {
  __typename?: 'DocumentTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A document template with its rendering query and default selection. */
export type DocumentTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A document template with its rendering query and default selection. */
export type DocumentTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentTemplateFilterInput = {
  and?: InputMaybe<Array<DocumentTemplateFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  default?: InputMaybe<BooleanFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  entity?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<DocumentTemplateFilterInput>>;
  query?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  sampleDataOverride?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  template?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

/** All discovered domain event GraphQL type names. */
export enum DomainEventType {
  BatchCreatedEvent = 'BatchCreatedEvent',
  BatchDeletedEvent = 'BatchDeletedEvent',
  BatchRecalculateDueDateEvent = 'BatchRecalculateDueDateEvent',
  BatchStatusCheckEvent = 'BatchStatusCheckEvent',
  BatchUpdatedEvent = 'BatchUpdatedEvent',
  BranchCreatedEvent = 'BranchCreatedEvent',
  BranchDeletedEvent = 'BranchDeletedEvent',
  BranchRestoredEvent = 'BranchRestoredEvent',
  BranchUpdatedEvent = 'BranchUpdatedEvent',
  CandidateCreatedEvent = 'CandidateCreatedEvent',
  CustomDataSetEvent = 'CustomDataSetEvent',
  EmailCreatedEvent = 'EmailCreatedEvent',
  EmailStatusChangedEvent = 'EmailStatusChangedEvent',
  FileUploadedEvent = 'FileUploadedEvent',
  InternalCommentUpdatedEvent = 'InternalCommentUpdatedEvent',
  InvalidateCacheEvent = 'InvalidateCacheEvent',
  InvoiceCheckedEvent = 'InvoiceCheckedEvent',
  InvoiceUncheckedEvent = 'InvoiceUncheckedEvent',
  IssueCreatedEvent = 'IssueCreatedEvent',
  IssueUpdatedEvent = 'IssueUpdatedEvent',
  JobBuilderUpdatedEvent = 'JobBuilderUpdatedEvent',
  JobClientUpdatedEvent = 'JobClientUpdatedEvent',
  JobCreatedEvent = 'JobCreatedEvent',
  JobDetailsUpdatedEvent = 'JobDetailsUpdatedEvent',
  JobPartBatchChangedEvent = 'JobPartBatchChangedEvent',
  JobPartConfirmedEvent = 'JobPartConfirmedEvent',
  JobPartCreatedEvent = 'JobPartCreatedEvent',
  JobPartDeletedEvent = 'JobPartDeletedEvent',
  JobPartUpdatedEvent = 'JobPartUpdatedEvent',
  JobSiteUpdatedEvent = 'JobSiteUpdatedEvent',
  JobStatusChangedEvent = 'JobStatusChangedEvent',
  LeadAssignedEvent = 'LeadAssignedEvent',
  LeadBranchChangedEvent = 'LeadBranchChangedEvent',
  LeadConvertedToJobEvent = 'LeadConvertedToJobEvent',
  LeadCreatedEvent = 'LeadCreatedEvent',
  LeadDetailsUpdatedEvent = 'LeadDetailsUpdatedEvent',
  LeadOverrideStatusEvent = 'LeadOverrideStatusEvent',
  LeadStatusChangedEvent = 'LeadStatusChangedEvent',
  LineItemMasterWorkflowCompletedEvent = 'LineItemMasterWorkflowCompletedEvent',
  OrderEmailStatusUpdatedEvent = 'OrderEmailStatusUpdatedEvent',
  OrderOverrideStatusEvent = 'OrderOverrideStatusEvent',
  OrderReceiptCreatedEvent = 'OrderReceiptCreatedEvent',
  OrderRevisionCreatedEvent = 'OrderRevisionCreatedEvent',
  PartTypeCreatedEvent = 'PartTypeCreatedEvent',
  PartTypeDeletedEvent = 'PartTypeDeletedEvent',
  PartTypeRestoredEvent = 'PartTypeRestoredEvent',
  PartTypeUpdatedEvent = 'PartTypeUpdatedEvent',
  ProcessTypeCreatedEvent = 'ProcessTypeCreatedEvent',
  ProcessTypeDeletedEvent = 'ProcessTypeDeletedEvent',
  ProcessTypeRestoredEvent = 'ProcessTypeRestoredEvent',
  ProcessTypeUpdatedEvent = 'ProcessTypeUpdatedEvent',
  ProductCreatedEvent = 'ProductCreatedEvent',
  ProductDetailsUpdatedEvent = 'ProductDetailsUpdatedEvent',
  ProductPriceCreatedEvent = 'ProductPriceCreatedEvent',
  ProductPriceDeletedEvent = 'ProductPriceDeletedEvent',
  PurchaseOrderAmendedEvent = 'PurchaseOrderAmendedEvent',
  PurchaseOrderApprovedEvent = 'PurchaseOrderApprovedEvent',
  PurchaseOrderCancelledEvent = 'PurchaseOrderCancelledEvent',
  PurchaseOrderIncompleteEvent = 'PurchaseOrderIncompleteEvent',
  PurchaseOrderPendingReviewEvent = 'PurchaseOrderPendingReviewEvent',
  PurchaseOrderPlacedEvent = 'PurchaseOrderPlacedEvent',
  PurchaseOrderReceivedEvent = 'PurchaseOrderReceivedEvent',
  PurchaseOrderRejectedEvent = 'PurchaseOrderRejectedEvent',
  PurchaseOrderReleasedEvent = 'PurchaseOrderReleasedEvent',
  PurchaseOrderSupplierNotificationManuallySentEvent = 'PurchaseOrderSupplierNotificationManuallySentEvent',
  PurchaseOrderSupplierNotificationSentEvent = 'PurchaseOrderSupplierNotificationSentEvent',
  QuoteApprovalRequestedEvent = 'QuoteApprovalRequestedEvent',
  QuoteRequestAcceptedEvent = 'QuoteRequestAcceptedEvent',
  QuoteRequestPlacedEvent = 'QuoteRequestPlacedEvent',
  QuoteRequestQuotedEvent = 'QuoteRequestQuotedEvent',
  RecordFileDeletedEvent = 'RecordFileDeletedEvent',
  RecordFilesUploadedEvent = 'RecordFilesUploadedEvent',
  RoleCreatedEvent = 'RoleCreatedEvent',
  RoleDeletedEvent = 'RoleDeletedEvent',
  RoleDetailsUpdatedEvent = 'RoleDetailsUpdatedEvent',
  RoleInheritanceAssignmentUpdatedEvent = 'RoleInheritanceAssignmentUpdatedEvent',
  RolePermissionsAssignmentUpdatedEvent = 'RolePermissionsAssignmentUpdatedEvent',
  RoleScreensAssignmentUpdatedEvent = 'RoleScreensAssignmentUpdatedEvent',
  RoleUsersAssignmentUpdatedEvent = 'RoleUsersAssignmentUpdatedEvent',
  SchemaCreatedEvent = 'SchemaCreatedEvent',
  SchemaDeletedEvent = 'SchemaDeletedEvent',
  SchemaUpdatedEvent = 'SchemaUpdatedEvent',
  SchemaVersionActiveEvent = 'SchemaVersionActiveEvent',
  SchemaVersionCreatedEvent = 'SchemaVersionCreatedEvent',
  SchemaVersionDeletedEvent = 'SchemaVersionDeletedEvent',
  SchemaVersionUpdatedEvent = 'SchemaVersionUpdatedEvent',
  ScreenCreatedEvent = 'ScreenCreatedEvent',
  ScreenDeletedEvent = 'ScreenDeletedEvent',
  ScreenUpdatedEvent = 'ScreenUpdatedEvent',
  StatusChangedEvent = 'StatusChangedEvent',
  StatusUpdatedEvent = 'StatusUpdatedEvent',
  StockTakeCreatedEvent = 'StockTakeCreatedEvent',
  StockTransactionCreatedEvent = 'StockTransactionCreatedEvent',
  SupplierCreatedEvent = 'SupplierCreatedEvent',
  SupplierDeletedEvent = 'SupplierDeletedEvent',
  SupplierDetailsUpdatedEvent = 'SupplierDetailsUpdatedEvent',
  SupplierReviewersUpdatedEvent = 'SupplierReviewersUpdatedEvent',
  SupplierStatusUpdatedEvent = 'SupplierStatusUpdatedEvent',
  TemplateCreatedEvent = 'TemplateCreatedEvent',
  TemplateDeletedEvent = 'TemplateDeletedEvent',
  TemplateUpdatedEvent = 'TemplateUpdatedEvent',
  UserCreatedEvent = 'UserCreatedEvent',
  UserDeletedEvent = 'UserDeletedEvent',
  UserDisabledEvent = 'UserDisabledEvent',
  UserEnabledEvent = 'UserEnabledEvent',
  UserPermissionsUpdatedEvent = 'UserPermissionsUpdatedEvent',
  UserRestoredEvent = 'UserRestoredEvent',
  UserRolesUpdatedEvent = 'UserRolesUpdatedEvent',
  UserScreensUpdatedEvent = 'UserScreensUpdatedEvent',
  UserUpdatedEvent = 'UserUpdatedEvent',
  WarehouseCreatedEvent = 'WarehouseCreatedEvent',
  WarehouseDeletedEvent = 'WarehouseDeletedEvent',
  WarehouseStockReceivedEvent = 'WarehouseStockReceivedEvent',
  WarehouseStockTakeEvent = 'WarehouseStockTakeEvent',
  WarehouseStockTransferReceivedEvent = 'WarehouseStockTransferReceivedEvent',
  WarehouseStockTransferWithdrawnEvent = 'WarehouseStockTransferWithdrawnEvent',
  WarehouseStockWithdrawnEvent = 'WarehouseStockWithdrawnEvent',
  WarehouseUpdatedEvent = 'WarehouseUpdatedEvent',
  WebhookCallFailedEvent = 'WebhookCallFailedEvent',
  WebhookCalledEvent = 'WebhookCalledEvent',
  WebhookCreatedEvent = 'WebhookCreatedEvent',
  WebhookDeletedEvent = 'WebhookDeletedEvent',
  WebhookUpdatedEvent = 'WebhookUpdatedEvent',
  WorkflowTypeCreatedEvent = 'WorkflowTypeCreatedEvent',
  WorkflowTypeDeletedEvent = 'WorkflowTypeDeletedEvent',
  WorkflowTypeRestoredEvent = 'WorkflowTypeRestoredEvent',
  WorkflowTypeUpdatedEvent = 'WorkflowTypeUpdatedEvent'
}

export type EffectivePermission = {
  __typename?: 'EffectivePermission';
  assigned: Scalars['Boolean']['output'];
  conditions: Maybe<Scalars['String']['output']>;
  permission: Permission;
  policy: Policy;
};

/**
 * description=A persisted transactional email and its delivery status.
 * displayName=Transactional Email
 * module=Admin
 * defaultQuery=emails
 * iconName=envelope
 * colour=#5D35A6
 * aggregateQuery=emailsAggregate
 * grouping=true
 * queryPermission=Query_Transactional_Emails
 */
export type Email = {
  __typename?: 'Email';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  messageId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  recipient: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  sender: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  sentAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  status: Maybe<EmailDeliveryStatus>;
  /**
   * sortable=true
   * groupable=false
   */
  subject: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  type: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  typeDisplayName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


/**
 * description=A persisted transactional email and its delivery status.
 * displayName=Transactional Email
 * module=Admin
 * defaultQuery=emails
 * iconName=envelope
 * colour=#5D35A6
 * aggregateQuery=emailsAggregate
 * grouping=true
 * queryPermission=Query_Transactional_Emails
 */
export type EmailCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A persisted transactional email and its delivery status. */
export type EmailAggregate = {
  __typename?: 'EmailAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A persisted transactional email and its delivery status. */
export type EmailAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A persisted transactional email and its delivery status. */
export type EmailAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailCreatedEvent = {
  __typename?: 'EmailCreatedEvent';
  entity: Scalars['String']['output'];
};

/** Transactional email delivery status. */
export enum EmailDeliveryStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  NotSent = 'NOT_SENT',
  Pending = 'PENDING'
}

export type EmailDeliveryStatusFilterInput = {
  eq?: InputMaybe<EmailDeliveryStatus>;
  in?: InputMaybe<Array<EmailDeliveryStatus>>;
};

export type EmailFilterInput = {
  and?: InputMaybe<Array<EmailFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  messageId?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  recipient?: InputMaybe<StringFilterInput>;
  sender?: InputMaybe<StringFilterInput>;
  sentAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<EmailDeliveryStatusFilterInput>;
  subject?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  typeDisplayName?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

/** Email */
export type EmailStatusChangedEvent = {
  __typename?: 'EmailStatusChangedEvent';
  description: Maybe<Scalars['String']['output']>;
  emailId: Scalars['String']['output'];
  previousStatus: Maybe<Scalars['Int']['output']>;
  recipient: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  subject: Maybe<Scalars['String']['output']>;
};

export type ExpressionInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 * description=A configured storage provider and its remote and device access settings.
 * displayName=External Storage Connection
 * module=Admin
 * defaultQuery=externalStorageConnections
 * iconName=cloud
 * colour=#5D35A6
 * aggregateQuery=externalStorageConnectionsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Connections
 */
export type ExternalStorageConnection = {
  __typename?: 'ExternalStorageConnection';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  deviceAccessEnabled: Scalars['Boolean']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  dropboxAuthToken: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  dropboxNamespaceId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  item: ExternalStorageItem;
  /**
   * sortable=false
   * groupable=false
   */
  items: Array<ExternalStorageItem>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  localPathSeparator: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  localRoot: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  root: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  storageMappings: Array<ExternalStorageResourceMapping>;
  /**
   * sortable=true
   * groupable=false
   */
  type: Scalars['String']['output'];
};


/**
 * description=A configured storage provider and its remote and device access settings.
 * displayName=External Storage Connection
 * module=Admin
 * defaultQuery=externalStorageConnections
 * iconName=cloud
 * colour=#5D35A6
 * aggregateQuery=externalStorageConnectionsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Connections
 */
export type ExternalStorageConnectionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A configured storage provider and its remote and device access settings.
 * displayName=External Storage Connection
 * module=Admin
 * defaultQuery=externalStorageConnections
 * iconName=cloud
 * colour=#5D35A6
 * aggregateQuery=externalStorageConnectionsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Connections
 */
export type ExternalStorageConnectionItemArgs = {
  path?: Scalars['String']['input'];
};


/**
 * description=A configured storage provider and its remote and device access settings.
 * displayName=External Storage Connection
 * module=Admin
 * defaultQuery=externalStorageConnections
 * iconName=cloud
 * colour=#5D35A6
 * aggregateQuery=externalStorageConnectionsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Connections
 */
export type ExternalStorageConnectionItemsArgs = {
  path?: Scalars['String']['input'];
  pathPrefix?: Scalars['String']['input'];
};


/**
 * description=A configured storage provider and its remote and device access settings.
 * displayName=External Storage Connection
 * module=Admin
 * defaultQuery=externalStorageConnections
 * iconName=cloud
 * colour=#5D35A6
 * aggregateQuery=externalStorageConnectionsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Connections
 */
export type ExternalStorageConnectionStorageMappingsArgs = {
  filter?: InputMaybe<ExternalStorageResourceMappingFilterInput>;
};

/** description=A configured storage provider and its remote and device access settings. */
export type ExternalStorageConnectionAggregate = {
  __typename?: 'ExternalStorageConnectionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A configured storage provider and its remote and device access settings. */
export type ExternalStorageConnectionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A configured storage provider and its remote and device access settings. */
export type ExternalStorageConnectionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalStorageConnectionFilterInput = {
  and?: InputMaybe<Array<ExternalStorageConnectionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  localRoot?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ExternalStorageConnectionFilterInput>>;
  root?: InputMaybe<StringFilterInput>;
  storageMappings?: InputMaybe<ExternalStorageResourceMappingFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ExternalStorageItem = {
  __typename?: 'ExternalStorageItem';
  canOpen: Maybe<Scalars['Boolean']['output']>;
  fileId: Maybe<Scalars['String']['output']>;
  folderBadgeIconColour: Maybe<Scalars['String']['output']>;
  folderBadgeIconName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFolder: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  largeThumbnailUrl: Maybe<Scalars['String']['output']>;
  /**
   * Returns the "local" path (if it exists) for this item
   * Eg you may have dropbox mounted locally on your PC,
   * this will let you access that file directly.
   */
  localPath: Maybe<Scalars['String']['output']>;
  /** Signed local-device URL consumed by the Windows jmfile protocol handler. */
  localUrl: Maybe<Scalars['String']['output']>;
  mediumThumbnailUrl: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** groupable=true */
  mimeType: Maybe<Scalars['String']['output']>;
  /** groupable=true */
  modified: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  previewUrl: Maybe<Scalars['String']['output']>;
  recordFileId: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  smallThumbnailUrl: Maybe<Scalars['String']['output']>;
  temporaryUrl: Maybe<Scalars['String']['output']>;
  /** groupable=true */
  type: Scalars['String']['output'];
  uploadMimeTypes: Maybe<Array<Scalars['String']['output']>>;
};

export type ExternalStorageItemFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  isFolder?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  mimeType?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  path?: InputMaybe<StringFilterInput>;
  recordFile?: InputMaybe<RecordFileFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

/**
 * description=A storage connection path made available to records matching a resource filter.
 * displayName=External Storage Resource Mapping
 * module=Admin
 * defaultQuery=externalStorageResourceMappings
 * iconName=folder-open
 * colour=#5D35A6
 * aggregateQuery=externalStorageResourceMappingsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Resource_Mappings
 */
export type ExternalStorageResourceMapping = {
  __typename?: 'ExternalStorageResourceMapping';
  /**
   * sortable=true
   * groupable=false
   */
  created: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  externalStorageConnection: ExternalStorageConnection;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  path: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceFilter: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceType: Maybe<Scalars['String']['output']>;
};


/**
 * description=A storage connection path made available to records matching a resource filter.
 * displayName=External Storage Resource Mapping
 * module=Admin
 * defaultQuery=externalStorageResourceMappings
 * iconName=folder-open
 * colour=#5D35A6
 * aggregateQuery=externalStorageResourceMappingsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Resource_Mappings
 */
export type ExternalStorageResourceMappingCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A storage connection path made available to records matching a resource filter. */
export type ExternalStorageResourceMappingAggregate = {
  __typename?: 'ExternalStorageResourceMappingAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A storage connection path made available to records matching a resource filter. */
export type ExternalStorageResourceMappingAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A storage connection path made available to records matching a resource filter. */
export type ExternalStorageResourceMappingAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalStorageResourceMappingFilterInput = {
  and?: InputMaybe<Array<ExternalStorageResourceMappingFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  externalStorageConnection?: InputMaybe<ExternalStorageConnectionFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ExternalStorageResourceMappingFilterInput>>;
  path?: InputMaybe<StringFilterInput>;
  resourceFilter?: InputMaybe<StringFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
  storageConnection?: InputMaybe<ExternalStorageConnectionFilterInput>;
};

/**
 * description=An uploaded file and its stored metadata and preview URLs.
 * displayName=File
 * module=Admin
 * defaultQuery=files
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=fileAggregates
 * grouping=true
 * queryPermission=Query_Files
 */
export type File = {
  __typename?: 'File';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['DateTime']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  hash: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  largeThumbnailUrl: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  mediumThumbnailUrl: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  mimeType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  modified: Scalars['DateTime']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  sizeBytes: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  smallThumbnailUrl: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  temporaryUrl: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
};


/**
 * description=An uploaded file and its stored metadata and preview URLs.
 * displayName=File
 * module=Admin
 * defaultQuery=files
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=fileAggregates
 * grouping=true
 * queryPermission=Query_Files
 */
export type FileCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An uploaded file and its stored metadata and preview URLs. */
export type FileAggregate = {
  __typename?: 'FileAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An uploaded file and its stored metadata and preview URLs. */
export type FileAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An uploaded file and its stored metadata and preview URLs. */
export type FileAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type FileFilterInput = {
  and?: InputMaybe<Array<FileFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  mimeType?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<FileFilterInput>>;
  size?: InputMaybe<NumberFilterInput>;
  sizeBytes?: InputMaybe<NumberFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UserIdentityFilterInput>;
};

export type FileInput = {
  fileId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  primaryImage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A File identity or a typed nested report dimension. */
export type FileReportDimensionValue = {
  __typename?: 'FileReportDimensionValue';
  created: Maybe<ReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  modified: Maybe<ReportDimensionValue>;
  user: Maybe<UserReportDimensionValue>;
};

/** Select exactly one typed File report dimension. */
export type FileReportGroupByInput =
  { created: DateTimeReportDimensionInput; modified?: never; user?: never; }
  |  { created?: never; modified: DateTimeReportDimensionInput; user?: never; }
  |  /** Group by User or one of its dimensions. */
  { created?: never; modified?: never; user: UserReportRelationDimensionInput; };

/** Groups by File identity, or traverses to one of its typed dimensions. */
export type FileReportRelationDimensionInput = {
  filter?: InputMaybe<FileFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<FileReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileUploadedEvent = {
  __typename?: 'FileUploadedEvent';
  file: Scalars['String']['output'];
};

export type GetDocumentPreviewInput = {
  /** Dummy data returned from query */
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  /** Eith pass id (above) or template (below) */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Dummy variables for either record or event */
  variables?: InputMaybe<Scalars['String']['input']>;
};

/**
 * description=A group within a running line-item manufacturing workflow.
 * displayName=Group Instance
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type GroupInstance = {
  __typename?: 'GroupInstance';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  workflow: Workflow;
};


/**
 * description=A group within a running line-item manufacturing workflow.
 * displayName=Group Instance
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type GroupInstanceCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type GroupInstanceFilterInput = {
  and?: InputMaybe<Array<GroupInstanceFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<GroupInstanceFilterInput>>;
  workflow?: InputMaybe<WorkflowFilterInput>;
};

/**
 * description=A reusable grouped workflow step inside a workflow template.
 * displayName=Group Template
 * module=Manufacturing
 * defaultQuery=groupTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=groupTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Group_Templates
 */
export type GroupTemplate = {
  __typename?: 'GroupTemplate';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  placeHolder: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  workflowTemplate: Maybe<WorkflowTemplate>;
};


/**
 * description=A reusable grouped workflow step inside a workflow template.
 * displayName=Group Template
 * module=Manufacturing
 * defaultQuery=groupTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=groupTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Group_Templates
 */
export type GroupTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable grouped workflow step inside a workflow template. */
export type GroupTemplateAggregate = {
  __typename?: 'GroupTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable grouped workflow step inside a workflow template. */
export type GroupTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable grouped workflow step inside a workflow template. */
export type GroupTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupTemplateFilterInput = {
  and?: InputMaybe<Array<GroupTemplateFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<GroupTemplateFilterInput>>;
  placeHolder?: InputMaybe<BooleanFilterInput>;
  workflowTemplate?: InputMaybe<WorkflowTemplateFilterInput>;
};

/**
 * description=A housing company associated with sales jobs.
 * displayName=Housing Company
 * module=Sales
 * defaultQuery=housingCompanies
 * iconName=office
 * colour=#A91F54
 * aggregateQuery=housingCompaniesAggregate
 * grouping=true
 * queryPermission=Query_Housing_Companies
 */
export type HousingCompany = {
  __typename?: 'HousingCompany';
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * description=Completed-month YTD confirmed sales minus the equivalent period in the previous year.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  confirmedSalesYtdChange: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  image: Maybe<File>;
  /**
   * sortable=false
   * groupable=false
   */
  jobAggregate: Maybe<JobAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  jobs: Array<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modified: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Maybe<Scalars['String']['output']>;
};


/**
 * description=A housing company associated with sales jobs.
 * displayName=Housing Company
 * module=Sales
 * defaultQuery=housingCompanies
 * iconName=office
 * colour=#A91F54
 * aggregateQuery=housingCompaniesAggregate
 * grouping=true
 * queryPermission=Query_Housing_Companies
 */
export type HousingCompanyCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A housing company associated with sales jobs.
 * displayName=Housing Company
 * module=Sales
 * defaultQuery=housingCompanies
 * iconName=office
 * colour=#A91F54
 * aggregateQuery=housingCompaniesAggregate
 * grouping=true
 * queryPermission=Query_Housing_Companies
 */
export type HousingCompanyJobAggregateArgs = {
  filter?: InputMaybe<JobFilterInput>;
};


/**
 * description=A housing company associated with sales jobs.
 * displayName=Housing Company
 * module=Sales
 * defaultQuery=housingCompanies
 * iconName=office
 * colour=#A91F54
 * aggregateQuery=housingCompaniesAggregate
 * grouping=true
 * queryPermission=Query_Housing_Companies
 */
export type HousingCompanyJobsArgs = {
  filter?: InputMaybe<JobFilterInput>;
};

/** description=A housing company associated with sales jobs. */
export type HousingCompanyAggregate = {
  __typename?: 'HousingCompanyAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A housing company associated with sales jobs. */
export type HousingCompanyAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A housing company associated with sales jobs. */
export type HousingCompanyAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type HousingCompanyFilterInput = {
  and?: InputMaybe<Array<HousingCompanyFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  /** Completed-month YTD confirmed sales minus the equivalent period in the previous year. */
  confirmedSalesYtdChange?: InputMaybe<NumberFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  image?: InputMaybe<FileFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobs?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<HousingCompanyFilterInput>>;
};

/** A Housing Company identity or a typed nested report dimension. */
export type HousingCompanyReportDimensionValue = {
  __typename?: 'HousingCompanyReportDimensionValue';
  created: Maybe<ReportDimensionValue>;
  image: Maybe<FileReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  modified: Maybe<ReportDimensionValue>;
};

/** Select exactly one typed Housing Company report dimension. */
export type HousingCompanyReportGroupByInput =
  { created: DateTimeReportDimensionInput; image?: never; modified?: never; }
  |  /** Group by File or one of its dimensions. */
  { created?: never; image: FileReportRelationDimensionInput; modified?: never; }
  |  { created?: never; image?: never; modified: DateTimeReportDimensionInput; };

/** Groups by Housing Company identity, or traverses to one of its typed dimensions. */
export type HousingCompanyReportRelationDimensionInput = {
  filter?: InputMaybe<HousingCompanyFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<HousingCompanyReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdFilterInput = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** PurchaseOrder */
export type InternalCommentUpdatedEvent = {
  __typename?: 'InternalCommentUpdatedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

export type InvalidateCacheEvent = {
  __typename?: 'InvalidateCacheEvent';
  shutdown: Scalars['String']['output'];
};

/** PurchaseOrder */
export type InvoiceCheckedEvent = {
  __typename?: 'InvoiceCheckedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/** PurchaseOrder */
export type InvoiceUncheckedEvent = {
  __typename?: 'InvoiceUncheckedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/**
 * description=A maintenance issue tracked against a record.
 * displayName=Issue
 * module=Sales
 * defaultQuery=issues
 * iconName=issue
 * colour=#A91F54
 * aggregateQuery=issuesAggregate
 * grouping=true
 * queryPermission=Query_Issues
 */
export type Issue = {
  __typename?: 'Issue';
  /**
   * sortable=true
   * groupable=false
   */
  completed: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=true
   */
  files: Array<RecordFile>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modifiedAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  notes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  recordId: Maybe<Scalars['ID']['output']>;
  /**
   * description=The Job linked through the issue record reference.
   * sortable=true
   * groupable=true
   */
  recordJob: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  reportedBy: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  requiredDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  scheduledDate: Maybe<Scalars['DateTime']['output']>;
};


/**
 * description=A maintenance issue tracked against a record.
 * displayName=Issue
 * module=Sales
 * defaultQuery=issues
 * iconName=issue
 * colour=#A91F54
 * aggregateQuery=issuesAggregate
 * grouping=true
 * queryPermission=Query_Issues
 */
export type IssueCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A maintenance issue tracked against a record.
 * displayName=Issue
 * module=Sales
 * defaultQuery=issues
 * iconName=issue
 * colour=#A91F54
 * aggregateQuery=issuesAggregate
 * grouping=true
 * queryPermission=Query_Issues
 */
export type IssueFilesArgs = {
  filter?: InputMaybe<RecordFileFilterInput>;
};

/** description=A maintenance issue tracked against a record. */
export type IssueAggregate = {
  __typename?: 'IssueAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A maintenance issue tracked against a record. */
export type IssueAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A maintenance issue tracked against a record. */
export type IssueAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type IssueCompletionStatus = {
  __typename?: 'IssueCompletionStatus';
  completed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  issueAggregate: Maybe<IssueAggregate>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type IssueCompletionStatusIssueAggregateArgs = {
  filter?: InputMaybe<IssueFilterInput>;
};

/** Issue */
export type IssueCreatedEvent = {
  __typename?: 'IssueCreatedEvent';
  description: Maybe<Scalars['String']['output']>;
  issueId: Scalars['Int']['output'];
};

export type IssueFilterInput = {
  and?: InputMaybe<Array<IssueFilterInput>>;
  completed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  files?: InputMaybe<RecordFileFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modifiedAt?: InputMaybe<DateTimeFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<IssueFilterInput>>;
  recordId?: InputMaybe<IdFilterInput>;
  /** The Job linked through the issue record reference. */
  recordJob?: InputMaybe<JobFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  reportedBy?: InputMaybe<StringFilterInput>;
  requiredDate?: InputMaybe<DateTimeFilterInput>;
  scheduledDate?: InputMaybe<DateTimeFilterInput>;
};

export type IssueQuoteInput = {
  quoteId: Scalars['ID']['input'];
};

/** Issue */
export type IssueUpdatedEvent = {
  __typename?: 'IssueUpdatedEvent';
  description: Maybe<Scalars['String']['output']>;
  issueId: Scalars['Int']['output'];
};

/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type Job = {
  __typename?: 'Job';
  /**
   * sortable=false
   * groupable=true
   */
  batches: Array<Batch>;
  /**
   * sortable=true
   * groupable=false
   */
  benchtopOnly: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  branch: Maybe<Branch>;
  /**
   * sortable=true
   * groupable=true
   */
  buildType: Maybe<BuildType>;
  /**
   * sortable=true
   * groupable=false
   */
  buildTypeId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  builder: Maybe<Builder>;
  /**
   * sortable=true
   * groupable=false
   */
  builderId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  builderPhone: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  client: Maybe<Client>;
  /**
   * sortable=false
   * groupable=true
   */
  costings: Array<Costing>;
  /**
   * sortable=true
   * groupable=true
   */
  createdDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  designer: Maybe<PersonBusinessRole>;
  /**
   * sortable=true
   * groupable=false
   */
  designerId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  difficultAccess: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  dueDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  externalStorageConnection: Maybe<ExternalStorageConnection>;
  /**
   * sortable=false
   * groupable=false
   */
  externalStorageItems: Maybe<Array<ExternalStorageItem>>;
  /**
   * description=We won't store this in the database, but will use centralised tenant-specific logic to map a job to the right external path
   * sortable=true
   * groupable=false
   */
  externalStoragePath: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  hcJobNumber: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  hcPmPhone: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  hcProjectManager: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  housingCompany: Maybe<HousingCompany>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  issues: Array<Issue>;
  /**
   * sortable=false
   * groupable=true
   */
  jobComponents: Array<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  jobFolderLink: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  jobName: Maybe<Scalars['String']['output']>;
  /**
   * description=A unique number for this job
   * sortable=true
   * groupable=false
   */
  jobNumber: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  lead: Maybe<Lead>;
  /**
   * sortable=false
   * groupable=false
   */
  lineItemAggregate: Maybe<LineItemAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  lineItems: Array<LineItem>;
  /**
   * sortable=true
   * groupable=true
   */
  lostReason: Maybe<LostReason>;
  /**
   * sortable=true
   * groupable=false
   */
  lostReasonNotes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  note: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  projectManager: Maybe<PersonBusinessRole>;
  /**
   * sortable=true
   * groupable=false
   */
  projectManagerId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  purchaseOrderAggregate: Maybe<PurchaseOrderAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  purchaseOrders: Array<PurchaseOrder>;
  /**
   * sortable=false
   * groupable=true
   */
  quotes: Array<Quote>;
  /**
   * sortable=true
   * groupable=true
   */
  region: Maybe<Region>;
  /**
   * sortable=true
   * groupable=false
   */
  regionId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  saleType: Maybe<SaleType>;
  /**
   * sortable=true
   * groupable=false
   */
  saleTypeId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=true
   */
  salesOrders: Array<SalesOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  showHome: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  siteAddress: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  siteNotes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  sssp: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['Int']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  supplierQuoteRequests: Array<SupplierQuoteRequest>;
  /**
   * sortable=false
   * groupable=true
   */
  supplierQuotes: Array<SupplierQuote>;
  /**
   * sortable=true
   * groupable=false
   */
  tristoneJoin: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  tristoneSpecified: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unit: Scalars['Boolean']['output'];
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobBatchesArgs = {
  filter?: InputMaybe<BatchFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobCostingsArgs = {
  filter?: InputMaybe<CostingFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobExternalStorageItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobIssuesArgs = {
  filter?: InputMaybe<IssueFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobJobComponentsArgs = {
  filter?: InputMaybe<JobComponentFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobLineItemAggregateArgs = {
  filter?: InputMaybe<LineItemFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobLineItemsArgs = {
  filter?: InputMaybe<LineItemFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobPurchaseOrdersArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobQuotesArgs = {
  filter?: InputMaybe<QuoteFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobSalesOrdersArgs = {
  filter?: InputMaybe<SalesOrderFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobSupplierQuoteRequestsArgs = {
  filter?: InputMaybe<SupplierQuoteRequestFilterInput>;
};


/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export type JobSupplierQuotesArgs = {
  filter?: InputMaybe<SupplierQuoteFilterInput>;
};

/** description=A customer job tracking sales, production, purchasing, and delivery work. */
export type JobAggregate = {
  __typename?: 'JobAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  /**
   * description=Estimated line-item sheets for matching jobs, grouped by job date.
   * sortable=true
   * groupable=false
   */
  estimatedSheets: Scalars['Float']['output'];
  groups: ResourceGroupPage;
  /**
   * description=Total confirmed line-item sales for matching jobs.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  totalConfirmedSale: Maybe<Scalars['Float']['output']>;
};


/** description=A customer job tracking sales, production, purchasing, and delivery work. */
export type JobAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A customer job tracking sales, production, purchasing, and delivery work. */
export type JobAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** description=A customer job tracking sales, production, purchasing, and delivery work. */
export type JobAggregateTotalConfirmedSaleArgs = {
  confirmedDate?: InputMaybe<DateTimeFilterInput>;
};

/** Job */
export type JobBuilderUpdatedEvent = {
  __typename?: 'JobBuilderUpdatedEvent';
  jobId: Scalars['String']['output'];
  jobNumber: Scalars['String']['output'];
};

/** Job */
export type JobClientUpdatedEvent = {
  __typename?: 'JobClientUpdatedEvent';
  clientName: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  jobNumber: Scalars['String']['output'];
};

/**
 * description=A stable unit of scope within a job.
 * displayName=Job Component
 * module=Sales
 * defaultQuery=jobComponents
 * iconName=cube
 * colour=#A91F54
 * aggregateQuery=jobComponentsAggregate
 * grouping=true
 * queryPermission=Query_Job_Components
 */
export type JobComponent = {
  __typename?: 'JobComponent';
  /**
   * sortable=true
   * groupable=false
   */
  code: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  costings: Array<Costing>;
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  estimatingSellTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Job;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  partType: Maybe<PartType>;
  /**
   * sortable=false
   * groupable=true
   */
  quoteLines: Array<QuoteLine>;
  /**
   * sortable=false
   * groupable=true
   */
  salesOrderLines: Array<SalesOrderLine>;
};


/**
 * description=A stable unit of scope within a job.
 * displayName=Job Component
 * module=Sales
 * defaultQuery=jobComponents
 * iconName=cube
 * colour=#A91F54
 * aggregateQuery=jobComponentsAggregate
 * grouping=true
 * queryPermission=Query_Job_Components
 */
export type JobComponentCostingsArgs = {
  filter?: InputMaybe<CostingFilterInput>;
};


/**
 * description=A stable unit of scope within a job.
 * displayName=Job Component
 * module=Sales
 * defaultQuery=jobComponents
 * iconName=cube
 * colour=#A91F54
 * aggregateQuery=jobComponentsAggregate
 * grouping=true
 * queryPermission=Query_Job_Components
 */
export type JobComponentCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A stable unit of scope within a job.
 * displayName=Job Component
 * module=Sales
 * defaultQuery=jobComponents
 * iconName=cube
 * colour=#A91F54
 * aggregateQuery=jobComponentsAggregate
 * grouping=true
 * queryPermission=Query_Job_Components
 */
export type JobComponentQuoteLinesArgs = {
  filter?: InputMaybe<QuoteLineFilterInput>;
};


/**
 * description=A stable unit of scope within a job.
 * displayName=Job Component
 * module=Sales
 * defaultQuery=jobComponents
 * iconName=cube
 * colour=#A91F54
 * aggregateQuery=jobComponentsAggregate
 * grouping=true
 * queryPermission=Query_Job_Components
 */
export type JobComponentSalesOrderLinesArgs = {
  filter?: InputMaybe<SalesOrderLineFilterInput>;
};

/** description=A stable unit of scope within a job. */
export type JobComponentAggregate = {
  __typename?: 'JobComponentAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A stable unit of scope within a job. */
export type JobComponentAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A stable unit of scope within a job. */
export type JobComponentAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type JobComponentFilterInput = {
  and?: InputMaybe<Array<JobComponentFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  costings?: InputMaybe<CostingFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  estimatingSellTotal?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<JobComponentFilterInput>>;
  partType?: InputMaybe<PartTypeFilterInput>;
  quoteLines?: InputMaybe<QuoteLineFilterInput>;
  salesOrderLines?: InputMaybe<SalesOrderLineFilterInput>;
};

/** Job */
export type JobCreatedEvent = {
  __typename?: 'JobCreatedEvent';
  jobId: Scalars['String']['output'];
  jobNumber: Scalars['String']['output'];
  leadId: Maybe<Scalars['String']['output']>;
};

/** Job */
export type JobDetailsUpdatedEvent = {
  __typename?: 'JobDetailsUpdatedEvent';
  jobId: Scalars['String']['output'];
  jobNumber: Scalars['String']['output'];
};

export type JobFilterInput = {
  and?: InputMaybe<Array<JobFilterInput>>;
  batches?: InputMaybe<BatchFilterInput>;
  benchtopOnly?: InputMaybe<BooleanFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  buildType?: InputMaybe<BuildTypeFilterInput>;
  buildTypeId?: InputMaybe<StringFilterInput>;
  builder?: InputMaybe<BuilderFilterInput>;
  builderId?: InputMaybe<StringFilterInput>;
  builderPhone?: InputMaybe<StringFilterInput>;
  client?: InputMaybe<ClientFilterInput>;
  costings?: InputMaybe<CostingFilterInput>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  designer?: InputMaybe<PersonBusinessRoleFilterInput>;
  designerId?: InputMaybe<StringFilterInput>;
  difficultAccess?: InputMaybe<BooleanFilterInput>;
  dueDate?: InputMaybe<DateTimeFilterInput>;
  hasAssociatedLead?: InputMaybe<BooleanFilterInput>;
  hcJobNumber?: InputMaybe<StringFilterInput>;
  hcPmPhone?: InputMaybe<StringFilterInput>;
  hcProjectManager?: InputMaybe<StringFilterInput>;
  housingCompany?: InputMaybe<HousingCompanyFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  issues?: InputMaybe<IssueFilterInput>;
  jobComponents?: InputMaybe<JobComponentFilterInput>;
  jobName?: InputMaybe<StringFilterInput>;
  /** A unique number for this job */
  jobNumber?: InputMaybe<StringFilterInput>;
  jobString?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lead?: InputMaybe<LeadFilterInput>;
  lineItems?: InputMaybe<LineItemFilterInput>;
  lostReason?: InputMaybe<LostReasonFilterInput>;
  lostReasonNotes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<JobFilterInput>>;
  projectManager?: InputMaybe<PersonBusinessRoleFilterInput>;
  projectManagerId?: InputMaybe<StringFilterInput>;
  purchaseOrders?: InputMaybe<PurchaseOrderFilterInput>;
  quotes?: InputMaybe<QuoteFilterInput>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<StringFilterInput>;
  saleType?: InputMaybe<SaleTypeFilterInput>;
  saleTypeId?: InputMaybe<StringFilterInput>;
  salesOrders?: InputMaybe<SalesOrderFilterInput>;
  showHome?: InputMaybe<BooleanFilterInput>;
  siteAddress?: InputMaybe<StringFilterInput>;
  siteNotes?: InputMaybe<StringFilterInput>;
  sssp?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<JobStatusFilterInput>;
  supplierQuoteRequests?: InputMaybe<SupplierQuoteRequestFilterInput>;
  supplierQuotes?: InputMaybe<SupplierQuoteFilterInput>;
  tristoneJoin?: InputMaybe<BooleanFilterInput>;
  tristoneSpecified?: InputMaybe<BooleanFilterInput>;
  unit?: InputMaybe<BooleanFilterInput>;
};

/** LineItem */
export type JobPartBatchChangedEvent = {
  __typename?: 'JobPartBatchChangedEvent';
  lineItemId: Scalars['String']['output'];
  lineItemName: Scalars['String']['output'];
  newBatchId: Scalars['String']['output'];
  newBatchName: Scalars['String']['output'];
  oldBatchId: Maybe<Scalars['String']['output']>;
};

/** LineItem */
export type JobPartConfirmedEvent = {
  __typename?: 'JobPartConfirmedEvent';
  lineItemId: Scalars['String']['output'];
  lineItemName: Scalars['String']['output'];
};

/** LineItem */
export type JobPartCreatedEvent = {
  __typename?: 'JobPartCreatedEvent';
  jobNumber: Scalars['String']['output'];
  lineItemId: Scalars['String']['output'];
  lineItemName: Scalars['String']['output'];
};

/** LineItem */
export type JobPartDeletedEvent = {
  __typename?: 'JobPartDeletedEvent';
  batchId: Maybe<Scalars['String']['output']>;
  lineItemId: Scalars['String']['output'];
  lineItemName: Scalars['String']['output'];
};

/** LineItem */
export type JobPartUpdatedEvent = {
  __typename?: 'JobPartUpdatedEvent';
  lineItemId: Scalars['String']['output'];
  lineItemName: Scalars['String']['output'];
};

/** A Job identity or a typed nested report dimension. */
export type JobReportDimensionValue = {
  __typename?: 'JobReportDimensionValue';
  branch: Maybe<BranchReportDimensionValue>;
  buildType: Maybe<BuildTypeReportDimensionValue>;
  builder: Maybe<BuilderReportDimensionValue>;
  client: Maybe<ClientReportDimensionValue>;
  createdDate: Maybe<ReportDimensionValue>;
  designer: Maybe<PersonBusinessRoleReportDimensionValue>;
  dueDate: Maybe<ReportDimensionValue>;
  housingCompany: Maybe<HousingCompanyReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  lead: Maybe<LeadReportDimensionValue>;
  lostReason: Maybe<LostReasonReportDimensionValue>;
  projectManager: Maybe<PersonBusinessRoleReportDimensionValue>;
  region: Maybe<RegionReportDimensionValue>;
  saleType: Maybe<SaleTypeReportDimensionValue>;
};

/** Typed Job report dimension values. */
export type JobReportDimensions = {
  __typename?: 'JobReportDimensions';
  branch: Maybe<BranchReportDimensionValue>;
  buildType: Maybe<BuildTypeReportDimensionValue>;
  builder: Maybe<BuilderReportDimensionValue>;
  client: Maybe<ClientReportDimensionValue>;
  createdDate: Maybe<ReportDimensionValue>;
  designer: Maybe<PersonBusinessRoleReportDimensionValue>;
  dueDate: Maybe<ReportDimensionValue>;
  housingCompany: Maybe<HousingCompanyReportDimensionValue>;
  lead: Maybe<LeadReportDimensionValue>;
  lostReason: Maybe<LostReasonReportDimensionValue>;
  projectManager: Maybe<PersonBusinessRoleReportDimensionValue>;
  region: Maybe<RegionReportDimensionValue>;
  saleType: Maybe<SaleTypeReportDimensionValue>;
};

/** Select exactly one typed Job report dimension. */
export type JobReportGroupByInput =
  /** Group by Branch or one of its dimensions. */
  { branch: BranchReportRelationDimensionInput; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Build Type or one of its dimensions. */
  { branch?: never; buildType: BuildTypeReportRelationDimensionInput; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Builder or one of its dimensions. */
  { branch?: never; buildType?: never; builder: BuilderReportRelationDimensionInput; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Client or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client: ClientReportRelationDimensionInput; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate: DateTimeReportDimensionInput; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Person Business Role or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer: PersonBusinessRoleReportRelationDimensionInput; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate: DateTimeReportDimensionInput; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Housing Company or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany: HousingCompanyReportRelationDimensionInput; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Lead or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead: LeadReportRelationDimensionInput; lostReason?: never; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Lost Reason or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason: LostReasonReportRelationDimensionInput; projectManager?: never; region?: never; saleType?: never; }
  |  /** Group by Person Business Role or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager: PersonBusinessRoleReportRelationDimensionInput; region?: never; saleType?: never; }
  |  /** Group by Region or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region: RegionReportRelationDimensionInput; saleType?: never; }
  |  /** Group by Sale Type or one of its dimensions. */
  { branch?: never; buildType?: never; builder?: never; client?: never; createdDate?: never; designer?: never; dueDate?: never; housingCompany?: never; lead?: never; lostReason?: never; projectManager?: never; region?: never; saleType: SaleTypeReportRelationDimensionInput; };

/** Groups by Job identity, or traverses to one of its typed dimensions. */
export type JobReportRelationDimensionInput = {
  filter?: InputMaybe<JobFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<JobReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One grouped Job report row. */
export type JobReportRow = {
  __typename?: 'JobReportRow';
  /** The generated Job aggregate, constrained to this dimension row. */
  aggregate: JobAggregate;
  /** Typed values for every selected report dimension. */
  dimensions: JobReportDimensions;
  /** The first dimension key, retained for single-dimension report compatibility. */
  key: Scalars['String']['output'];
  /** The first dimension label, retained for single-dimension report compatibility. */
  label: Scalars['String']['output'];
};


/** One grouped Job report row. */
export type JobReportRowAggregateArgs = {
  filter?: InputMaybe<JobFilterInput>;
};

/** Job */
export type JobSiteUpdatedEvent = {
  __typename?: 'JobSiteUpdatedEvent';
  jobId: Scalars['String']['output'];
  jobNumber: Scalars['String']['output'];
};

export type JobStatus = {
  __typename?: 'JobStatus';
  id: Scalars['ID']['output'];
  intent: Scalars['String']['output'];
  jobAggregate: Maybe<JobAggregate>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type JobStatusJobAggregateArgs = {
  filter?: InputMaybe<JobFilterInput>;
};

/** Job */
export type JobStatusChangedEvent = {
  __typename?: 'JobStatusChangedEvent';
  jobId: Scalars['String']['output'];
  jobNumber: Maybe<Scalars['String']['output']>;
  newStatus: Scalars['String']['output'];
  oldStatus: Maybe<Scalars['String']['output']>;
};

export type JobStatusFilterInput = {
  id?: InputMaybe<IdFilterInput>;
};

export type JsonFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * description=A sales enquiry or prospect before it is converted into a job.
 * displayName=Lead
 * module=Sales
 * defaultQuery=leads
 * iconName=filter-list
 * colour=#A91F54
 * aggregateQuery=leadsAggregate
 * reportQuery=leadReport
 * grouping=true
 * queryPermission=Query_Leads
 */
export type Lead = {
  __typename?: 'Lead';
  /**
   * sortable=true
   * groupable=false
   */
  address: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  assignedDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  assignedTo: Maybe<PersonBusinessRole>;
  /**
   * sortable=true
   * groupable=true
   */
  branch: Maybe<Branch>;
  /**
   * sortable=true
   * groupable=false
   */
  builderName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  builderType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  city: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  client: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  correspondence: Array<Correspondence>;
  /**
   * sortable=true
   * groupable=true
   */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  email: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  joineryTypes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  latestCorrespondence: Maybe<Correspondence>;
  /**
   * sortable=true
   * groupable=true
   */
  lostReason: Maybe<LostReason>;
  /**
   * sortable=true
   * groupable=false
   */
  lostReasonNotes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  notes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  phone: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  priceRangeBottom: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  priceRangeTop: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  priority: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  projectType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  requiredBy: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  source: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: LeadStatus;
  /**
   * sortable=true
   * groupable=false
   */
  suburb: Maybe<Scalars['String']['output']>;
};


/**
 * description=A sales enquiry or prospect before it is converted into a job.
 * displayName=Lead
 * module=Sales
 * defaultQuery=leads
 * iconName=filter-list
 * colour=#A91F54
 * aggregateQuery=leadsAggregate
 * reportQuery=leadReport
 * grouping=true
 * queryPermission=Query_Leads
 */
export type LeadCorrespondenceArgs = {
  filter?: InputMaybe<CorrespondenceFilterInput>;
};


/**
 * description=A sales enquiry or prospect before it is converted into a job.
 * displayName=Lead
 * module=Sales
 * defaultQuery=leads
 * iconName=filter-list
 * colour=#A91F54
 * aggregateQuery=leadsAggregate
 * reportQuery=leadReport
 * grouping=true
 * queryPermission=Query_Leads
 */
export type LeadCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A sales enquiry or prospect before it is converted into a job. */
export type LeadAggregate = {
  __typename?: 'LeadAggregate';
  /**
   * sortable=true
   * groupable=false
   */
  avgAssignTimeDays: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=false
   * groupable=false
   */
  ids: Array<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  newStatusCount: Scalars['Int']['output'];
};


/** description=A sales enquiry or prospect before it is converted into a job. */
export type LeadAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A sales enquiry or prospect before it is converted into a job. */
export type LeadAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Lead */
export type LeadAssignedEvent = {
  __typename?: 'LeadAssignedEvent';
  assignedToId: Scalars['Int']['output'];
  assignedToName: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  leadId: Scalars['Int']['output'];
};

/** Lead */
export type LeadBranchChangedEvent = {
  __typename?: 'LeadBranchChangedEvent';
  clientName: Scalars['String']['output'];
  leadId: Scalars['Int']['output'];
  newBranchId: Maybe<Scalars['String']['output']>;
  newBranchName: Maybe<Scalars['String']['output']>;
  oldBranchId: Maybe<Scalars['String']['output']>;
  oldBranchName: Maybe<Scalars['String']['output']>;
};

/** Lead */
export type LeadConvertedToJobEvent = {
  __typename?: 'LeadConvertedToJobEvent';
  jobNumber: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  leadLabel: Scalars['String']['output'];
};

/** Lead */
export type LeadCreatedEvent = {
  __typename?: 'LeadCreatedEvent';
  clientName: Scalars['String']['output'];
  leadId: Scalars['Int']['output'];
};

/** Lead */
export type LeadDetailsUpdatedEvent = {
  __typename?: 'LeadDetailsUpdatedEvent';
  clientName: Scalars['String']['output'];
  leadId: Scalars['Int']['output'];
};

export type LeadFilterInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<LeadFilterInput>>;
  assignedDate?: InputMaybe<DateTimeFilterInput>;
  assignedTo?: InputMaybe<PersonBusinessRoleFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  builderName?: InputMaybe<StringFilterInput>;
  builderType?: InputMaybe<StringFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  client?: InputMaybe<StringFilterInput>;
  correspondence?: InputMaybe<CorrespondenceFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  hasAssociatedJob?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  joineryTypes?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lostReason?: InputMaybe<LostReasonFilterInput>;
  lostReasonNotes?: InputMaybe<StringFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LeadFilterInput>>;
  phone?: InputMaybe<StringFilterInput>;
  priceRangeBottom?: InputMaybe<NumberFilterInput>;
  priceRangeTop?: InputMaybe<NumberFilterInput>;
  priority?: InputMaybe<NumberFilterInput>;
  projectType?: InputMaybe<StringFilterInput>;
  requiredBy?: InputMaybe<DateTimeFilterInput>;
  source?: InputMaybe<LeadSourceFilterInput>;
  status?: InputMaybe<LeadStatusFilterInput>;
  suburb?: InputMaybe<StringFilterInput>;
};

/** Lead */
export type LeadOverrideStatusEvent = {
  __typename?: 'LeadOverrideStatusEvent';
  clientName: Scalars['String']['output'];
  leadId: Scalars['Int']['output'];
  newStatus: Scalars['String']['output'];
  oldStatus: Scalars['String']['output'];
};

export type LeadProjectType = {
  __typename?: 'LeadProjectType';
  id: Scalars['ID']['output'];
  leadAggregate: Maybe<LeadAggregate>;
  name: Scalars['String']['output'];
};


export type LeadProjectTypeLeadAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};

/** A Lead identity or a typed nested report dimension. */
export type LeadReportDimensionValue = {
  __typename?: 'LeadReportDimensionValue';
  assignedDate: Maybe<ReportDimensionValue>;
  assignedTo: Maybe<PersonBusinessRoleReportDimensionValue>;
  branch: Maybe<BranchReportDimensionValue>;
  createdAt: Maybe<ReportDimensionValue>;
  job: Maybe<JobReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  lostReason: Maybe<LostReasonReportDimensionValue>;
  requiredBy: Maybe<ReportDimensionValue>;
};

/** Typed Lead report dimension values. */
export type LeadReportDimensions = {
  __typename?: 'LeadReportDimensions';
  assignedDate: Maybe<ReportDimensionValue>;
  assignedTo: Maybe<PersonBusinessRoleReportDimensionValue>;
  branch: Maybe<BranchReportDimensionValue>;
  createdAt: Maybe<ReportDimensionValue>;
  job: Maybe<JobReportDimensionValue>;
  lostReason: Maybe<LostReasonReportDimensionValue>;
  requiredBy: Maybe<ReportDimensionValue>;
};

/** Select exactly one typed Lead report dimension. */
export type LeadReportGroupByInput =
  { assignedDate: DateTimeReportDimensionInput; assignedTo?: never; branch?: never; createdAt?: never; job?: never; lostReason?: never; requiredBy?: never; }
  |  /** Group by Person Business Role or one of its dimensions. */
  { assignedDate?: never; assignedTo: PersonBusinessRoleReportRelationDimensionInput; branch?: never; createdAt?: never; job?: never; lostReason?: never; requiredBy?: never; }
  |  /** Group by Branch or one of its dimensions. */
  { assignedDate?: never; assignedTo?: never; branch: BranchReportRelationDimensionInput; createdAt?: never; job?: never; lostReason?: never; requiredBy?: never; }
  |  { assignedDate?: never; assignedTo?: never; branch?: never; createdAt: DateTimeReportDimensionInput; job?: never; lostReason?: never; requiredBy?: never; }
  |  /** Group by Job or one of its dimensions. */
  { assignedDate?: never; assignedTo?: never; branch?: never; createdAt?: never; job: JobReportRelationDimensionInput; lostReason?: never; requiredBy?: never; }
  |  /** Group by Lost Reason or one of its dimensions. */
  { assignedDate?: never; assignedTo?: never; branch?: never; createdAt?: never; job?: never; lostReason: LostReasonReportRelationDimensionInput; requiredBy?: never; }
  |  { assignedDate?: never; assignedTo?: never; branch?: never; createdAt?: never; job?: never; lostReason?: never; requiredBy: DateTimeReportDimensionInput; };

/** Groups by Lead identity, or traverses to one of its typed dimensions. */
export type LeadReportRelationDimensionInput = {
  filter?: InputMaybe<LeadFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<LeadReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One grouped Lead report row. */
export type LeadReportRow = {
  __typename?: 'LeadReportRow';
  /** The generated Lead aggregate, constrained to this dimension row. */
  aggregate: LeadAggregate;
  /** Typed values for every selected report dimension. */
  dimensions: LeadReportDimensions;
  /** The first dimension key, retained for single-dimension report compatibility. */
  key: Scalars['String']['output'];
  /** The first dimension label, retained for single-dimension report compatibility. */
  label: Scalars['String']['output'];
};


/** One grouped Lead report row. */
export type LeadReportRowAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};

export type LeadSource = {
  __typename?: 'LeadSource';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  leadAggregate: Maybe<LeadAggregate>;
  name: Scalars['String']['output'];
};


export type LeadSourceLeadAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};

export type LeadSourceFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  leads?: InputMaybe<LeadFilterInput>;
};

export type LeadStatus = {
  __typename?: 'LeadStatus';
  id: LeadStatusEnum;
  intent: Scalars['String']['output'];
  label: Scalars['String']['output'];
  leadAggregate: Maybe<LeadAggregate>;
  name: Scalars['String']['output'];
};


export type LeadStatusLeadAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};

/** Lead */
export type LeadStatusChangedEvent = {
  __typename?: 'LeadStatusChangedEvent';
  clientName: Scalars['String']['output'];
  leadId: Scalars['Int']['output'];
  newStatus: Scalars['String']['output'];
  oldStatus: Scalars['String']['output'];
};

export enum LeadStatusEnum {
  Assigned = 'assigned',
  Converted = 'converted',
  Lost = 'lost',
  New = 'new'
}

export type LeadStatusFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  leads?: InputMaybe<LeadFilterInput>;
};

/**
 * description=A manufactured or supplied part, unit, or work item within a job.
 * displayName=Work Order
 * module=Manufacturing
 * defaultQuery=lineItems
 * iconName=wrench
 * colour=#A96500
 * aggregateQuery=lineItemsAggregate
 * reportQuery=lineItemReport
 * grouping=true
 * queryPermission=Query_Job_Parts
 */
export type LineItem = {
  __typename?: 'LineItem';
  /**
   * sortable=true
   * groupable=true
   */
  batch: Maybe<Batch>;
  /**
   * sortable=true
   * groupable=false
   */
  batchId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  confirmed: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  confirmedDate: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  confirmedSale: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  masterWorkflow: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  oldSpecification: Maybe<Specification>;
  /**
   * sortable=true
   * groupable=false
   */
  partNumber: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  partType: Maybe<PartType>;
  /**
   * sortable=true
   * groupable=false
   */
  salePrice: Maybe<Scalars['Float']['output']>;
};


/**
 * description=A manufactured or supplied part, unit, or work item within a job.
 * displayName=Work Order
 * module=Manufacturing
 * defaultQuery=lineItems
 * iconName=wrench
 * colour=#A96500
 * aggregateQuery=lineItemsAggregate
 * reportQuery=lineItemReport
 * grouping=true
 * queryPermission=Query_Job_Parts
 */
export type LineItemCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A manufactured or supplied part, unit, or work item within a job. */
export type LineItemAggregate = {
  __typename?: 'LineItemAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * description=Total confirmed sale value.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  totalConfirmedSale: Maybe<Scalars['Float']['output']>;
};


/** description=A manufactured or supplied part, unit, or work item within a job. */
export type LineItemAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A manufactured or supplied part, unit, or work item within a job. */
export type LineItemAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LineItemFilterInput = {
  and?: InputMaybe<Array<LineItemFilterInput>>;
  batch?: InputMaybe<BatchFilterInput>;
  batchId?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  confirmedDate?: InputMaybe<DateTimeFilterInput>;
  confirmedSale?: InputMaybe<NumberFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  masterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LineItemFilterInput>>;
  partNumber?: InputMaybe<StringFilterInput>;
  partType?: InputMaybe<PartTypeFilterInput>;
  salePrice?: InputMaybe<NumberFilterInput>;
};

/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type LineItemMasterWorkflow = {
  __typename?: 'LineItemMasterWorkflow';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=true
   */
  groupInstances: Array<GroupInstance>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  items: Array<WorkflowNode>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  lineItem: Maybe<LineItem>;
  /**
   * sortable=true
   * groupable=false
   */
  lineItemId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  orderedItems: Array<WorkflowNode>;
  /**
   * sortable=false
   * groupable=false
   */
  orderedProcessInstances: Array<ProcessInstance>;
  /**
   * sortable=false
   * groupable=true
   */
  processAssets: Array<ProcessAsset>;
  /**
   * sortable=false
   * groupable=false
   */
  processInstanceAggregate: Maybe<ProcessInstanceAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  processInstances: Array<ProcessInstance>;
};


/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type LineItemMasterWorkflowCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type LineItemMasterWorkflowGroupInstancesArgs = {
  filter?: InputMaybe<GroupInstanceFilterInput>;
};


/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type LineItemMasterWorkflowItemsArgs = {
  filter?: InputMaybe<WorkflowNodeFilterInput>;
};


/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type LineItemMasterWorkflowProcessAssetsArgs = {
  filter?: InputMaybe<ProcessAssetFilterInput>;
};


/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type LineItemMasterWorkflowProcessInstanceAggregateArgs = {
  filter?: InputMaybe<ProcessInstanceFilterInput>;
};


/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type LineItemMasterWorkflowProcessInstancesArgs = {
  filter?: InputMaybe<ProcessInstanceFilterInput>;
};

/** description=The workflow subject that tracks manufacturing process instances for a line item. */
export type LineItemMasterWorkflowAggregate = {
  __typename?: 'LineItemMasterWorkflowAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=The workflow subject that tracks manufacturing process instances for a line item. */
export type LineItemMasterWorkflowAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=The workflow subject that tracks manufacturing process instances for a line item. */
export type LineItemMasterWorkflowAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LineItemMasterWorkflowCompletedEvent = {
  __typename?: 'LineItemMasterWorkflowCompletedEvent';
  lineItemMasterWorkflowId: Scalars['String']['output'];
};

export type LineItemMasterWorkflowFilterInput = {
  and?: InputMaybe<Array<LineItemMasterWorkflowFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  groupInstances?: InputMaybe<GroupInstanceFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  items?: InputMaybe<WorkflowNodeFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItem?: InputMaybe<LineItemFilterInput>;
  lineItemId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LineItemMasterWorkflowFilterInput>>;
  processAssets?: InputMaybe<ProcessAssetFilterInput>;
  processInstances?: InputMaybe<ProcessInstanceFilterInput>;
};

/** A Line Item Master Workflow identity or a typed nested report dimension. */
export type LineItemMasterWorkflowReportDimensionValue = {
  __typename?: 'LineItemMasterWorkflowReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  lineItem: Maybe<LineItemReportDimensionValue>;
};

/** Select exactly one typed Line Item Master Workflow report dimension. */
export type LineItemMasterWorkflowReportGroupByInput =
  /** Group by Work Order or one of its dimensions. */
  { lineItem: LineItemReportRelationDimensionInput; };

/** Groups by Line Item Master Workflow identity, or traverses to one of its typed dimensions. */
export type LineItemMasterWorkflowReportRelationDimensionInput = {
  filter?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<LineItemMasterWorkflowReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Work Order identity or a typed nested report dimension. */
export type LineItemReportDimensionValue = {
  __typename?: 'LineItemReportDimensionValue';
  batch: Maybe<BatchReportDimensionValue>;
  confirmedDate: Maybe<ReportDimensionValue>;
  job: Maybe<JobReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  masterWorkflow: Maybe<LineItemMasterWorkflowReportDimensionValue>;
  partType: Maybe<PartTypeReportDimensionValue>;
};

/** Typed Work Order report dimension values. */
export type LineItemReportDimensions = {
  __typename?: 'LineItemReportDimensions';
  batch: Maybe<BatchReportDimensionValue>;
  confirmedDate: Maybe<ReportDimensionValue>;
  job: Maybe<JobReportDimensionValue>;
  masterWorkflow: Maybe<LineItemMasterWorkflowReportDimensionValue>;
  partType: Maybe<PartTypeReportDimensionValue>;
};

/** Select exactly one typed Work Order report dimension. */
export type LineItemReportGroupByInput =
  /** Group by Batch or one of its dimensions. */
  { batch: BatchReportRelationDimensionInput; confirmedDate?: never; job?: never; masterWorkflow?: never; partType?: never; }
  |  { batch?: never; confirmedDate: DateTimeReportDimensionInput; job?: never; masterWorkflow?: never; partType?: never; }
  |  /** Group by Job or one of its dimensions. */
  { batch?: never; confirmedDate?: never; job: JobReportRelationDimensionInput; masterWorkflow?: never; partType?: never; }
  |  /** Group by Line Item Master Workflow or one of its dimensions. */
  { batch?: never; confirmedDate?: never; job?: never; masterWorkflow: LineItemMasterWorkflowReportRelationDimensionInput; partType?: never; }
  |  /** Group by Part Type or one of its dimensions. */
  { batch?: never; confirmedDate?: never; job?: never; masterWorkflow?: never; partType: PartTypeReportRelationDimensionInput; };

/** Groups by Work Order identity, or traverses to one of its typed dimensions. */
export type LineItemReportRelationDimensionInput = {
  filter?: InputMaybe<LineItemFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<LineItemReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One grouped Work Order report row. */
export type LineItemReportRow = {
  __typename?: 'LineItemReportRow';
  /** The generated LineItem aggregate, constrained to this dimension row. */
  aggregate: LineItemAggregate;
  /** Typed values for every selected report dimension. */
  dimensions: LineItemReportDimensions;
  /** The first dimension key, retained for single-dimension report compatibility. */
  key: Scalars['String']['output'];
  /** The first dimension label, retained for single-dimension report compatibility. */
  label: Scalars['String']['output'];
};


/** One grouped Work Order report row. */
export type LineItemReportRowAggregateArgs = {
  filter?: InputMaybe<LineItemFilterInput>;
};

export type LineItemWorkflowPlaceholderInput = {
  workflowTemplateId: Scalars['ID']['input'];
  workflowTypeId: Scalars['ID']['input'];
};

/**
 * description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record.
 * displayName=Shortcut
 * defaultQuery=linkedActions
 * aggregateQuery=linkedActionsAggregate
 * grouping=true
 * queryPermission=Query_Linked_Actions
 */
export type LinkedAction = {
  __typename?: 'LinkedAction';
  /**
   * sortable=true
   * groupable=false
   */
  actionId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  bindings: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  displayOrder: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  ownerUserId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  recordPath: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Scalars['String']['output'];
};


/**
 * description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record.
 * displayName=Shortcut
 * defaultQuery=linkedActions
 * aggregateQuery=linkedActionsAggregate
 * grouping=true
 * queryPermission=Query_Linked_Actions
 */
export type LinkedActionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record. */
export type LinkedActionAggregate = {
  __typename?: 'LinkedActionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record. */
export type LinkedActionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record. */
export type LinkedActionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkedActionFilterInput = {
  actionId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<LinkedActionFilterInput>>;
  bindings?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  displayOrder?: InputMaybe<NumberFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LinkedActionFilterInput>>;
  ownerUserId?: InputMaybe<IdFilterInput>;
  recordPath?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
};

/**
 * description=A list of reasons to choose from for lost jobs or leads.
 * displayName=Lost Reason
 * module=Admin
 * defaultQuery=lostReasons
 * colour=#5D35A6
 * aggregateQuery=lostReasonsAggregate
 * grouping=true
 * queryPermission=Query_Lost_Reasons
 */
export type LostReason = {
  __typename?: 'LostReason';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A list of reasons to choose from for lost jobs or leads.
 * displayName=Lost Reason
 * module=Admin
 * defaultQuery=lostReasons
 * colour=#5D35A6
 * aggregateQuery=lostReasonsAggregate
 * grouping=true
 * queryPermission=Query_Lost_Reasons
 */
export type LostReasonCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A list of reasons to choose from for lost jobs or leads. */
export type LostReasonAggregate = {
  __typename?: 'LostReasonAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A list of reasons to choose from for lost jobs or leads. */
export type LostReasonAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A list of reasons to choose from for lost jobs or leads. */
export type LostReasonAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LostReasonFilterInput = {
  and?: InputMaybe<Array<LostReasonFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LostReasonFilterInput>>;
};

/** A Lost Reason identity or a typed nested report dimension. */
export type LostReasonReportDimensionValue = {
  __typename?: 'LostReasonReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Lost Reason identity, or traverses to one of its typed dimensions. */
export type LostReasonReportRelationDimensionInput = {
  filter?: InputMaybe<LostReasonFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Machine = {
  __typename?: 'Machine';
  id: Scalars['ID']['output'];
  machineTypeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MachineFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  machineType?: InputMaybe<MachineTypeFilterInput>;
};

export type MachineType = {
  __typename?: 'MachineType';
  id: Scalars['ID']['output'];
  machines: Array<Machine>;
  name: Scalars['String']['output'];
};


export type MachineTypeMachinesArgs = {
  filter?: InputMaybe<MachineFilterInput>;
};

export type MachineTypeFilterInput = {
  id?: InputMaybe<IdFilterInput>;
};

export type MarkJobLostInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  lostReasonId: Scalars['ID']['input'];
};

export type MarkLeadLostInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  leadId: Scalars['ID']['input'];
  lostReasonId: Scalars['ID']['input'];
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export type Month = {
  __typename?: 'Month';
  createdLeadAggregate: Maybe<LeadAggregate>;
  createdPurchaseOrderAggregate: Maybe<PurchaseOrderAggregate>;
  createdPurchaseOrderLineAggregate: Maybe<PurchaseOrderLineAggregate>;
  monthNumber: Scalars['String']['output'];
  monthNumberAndYear: Scalars['String']['output'];
  quoteLineAggregateByJobEstDue: Maybe<QuoteLineAggregate>;
  year: Scalars['String']['output'];
};


export type MonthCreatedLeadAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};


export type MonthCreatedPurchaseOrderAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
};


export type MonthCreatedPurchaseOrderLineAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
};


export type MonthQuoteLineAggregateByJobEstDueArgs = {
  filter?: InputMaybe<QuoteLineFilterInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptQuote: Maybe<Scalars['ID']['output']>;
  activatePerson: Maybe<Scalars['ID']['output']>;
  amendPurchaseOrder: Maybe<Scalars['ID']['output']>;
  assignBusinessRolesToBatchSchedule: Maybe<Scalars['ID']['output']>;
  assignBusinessRolesToPerson: Maybe<Scalars['ID']['output']>;
  assignInheritanceToRole: Maybe<Scalars['ID']['output']>;
  assignLeadsToSalesperson: Maybe<Array<Scalars['ID']['output']>>;
  assignPermissionsToRole: Maybe<Scalars['ID']['output']>;
  assignPermissionsToUser: Maybe<Scalars['ID']['output']>;
  assignRolesToUser: Maybe<Scalars['ID']['output']>;
  assignScreensToRole: Maybe<Scalars['ID']['output']>;
  assignScreensToUser: Maybe<Scalars['ID']['output']>;
  assignUsersToProcessInstance: Scalars['String']['output'];
  assignUsersToRole: Maybe<Scalars['ID']['output']>;
  bulkCreatePurchaseOrder: Array<Scalars['ID']['output']>;
  bulkProductImport: Maybe<Scalars['String']['output']>;
  bulkProductPriceAdjustment: Scalars['ID']['output'];
  cancelPurchaseOrders: Maybe<Array<Scalars['ID']['output']>>;
  cancelSalesOrder: Maybe<Scalars['ID']['output']>;
  cancelSupplierQuoteRequest: Maybe<Scalars['ID']['output']>;
  cleanupFiles: Maybe<Scalars['Void']['output']>;
  clearPermissionCache: Maybe<Scalars['Boolean']['output']>;
  commitPendingFiles: Maybe<Scalars['String']['output']>;
  completeTimers: Maybe<Scalars['ID']['output']>;
  confirmSalesOrder: Maybe<Scalars['ID']['output']>;
  convertCandidate: Maybe<Scalars['ID']['output']>;
  convertLeadToJob: Maybe<Scalars['ID']['output']>;
  createAuthToken: Scalars['String']['output'];
  createBatch: Maybe<Scalars['ID']['output']>;
  createBranch: Maybe<Scalars['ID']['output']>;
  createBuilder: Scalars['ID']['output'];
  createBusinessRole: Maybe<Scalars['ID']['output']>;
  createCandidate: Maybe<AsyncTask>;
  createClient: Maybe<Scalars['ID']['output']>;
  createCorrespondence: Scalars['ID']['output'];
  createCosting: Maybe<Scalars['ID']['output']>;
  createCostingTemplate: Maybe<Scalars['ID']['output']>;
  createCostingTemplateRevision: Maybe<Scalars['ID']['output']>;
  createDocumentTemplate: Maybe<Scalars['ID']['output']>;
  createFiles: Maybe<Array<Scalars['ID']['output']>>;
  createFirebaseAuthToken: Maybe<Scalars['String']['output']>;
  createFolder: Maybe<Scalars['ID']['output']>;
  createHousingCompany: Maybe<Scalars['ID']['output']>;
  createHousingCompanyImage: Maybe<Scalars['ID']['output']>;
  createIssue: Maybe<Scalars['ID']['output']>;
  createJob: Maybe<Array<Scalars['ID']['output']>>;
  createJobComponent: Maybe<Scalars['ID']['output']>;
  createJobEmail: Scalars['ID']['output'];
  createJobFileUrl: Scalars['String']['output'];
  createLead: Maybe<Scalars['ID']['output']>;
  createLineItem: Maybe<Scalars['ID']['output']>;
  createLostReason: Maybe<Scalars['ID']['output']>;
  createPanel: Maybe<Scalars['ID']['output']>;
  createPartType: Maybe<Scalars['ID']['output']>;
  createPerson: Maybe<Scalars['ID']['output']>;
  createProcessAsset: Scalars['String']['output'];
  createProcessTimer: Maybe<Scalars['ID']['output']>;
  createProcessType: Maybe<Scalars['ID']['output']>;
  createProcessTypeNote: Maybe<Scalars['ID']['output']>;
  createProcessTypeRole: Maybe<Scalars['ID']['output']>;
  createProduct: Maybe<Scalars['ID']['output']>;
  createProductCategory: Maybe<Scalars['ID']['output']>;
  createProductPrice: Maybe<Scalars['ID']['output']>;
  createProject: Scalars['ID']['output'];
  createPurchaseOrder: Maybe<PurchaseOrderSavePayload>;
  createPurchaseOrderFromSupplierQuote: Maybe<Scalars['ID']['output']>;
  createPurchaseOrderReceipt: Maybe<Scalars['ID']['output']>;
  createQuote: Maybe<Scalars['ID']['output']>;
  createQuoteApprovalRequest: Scalars['ID']['output'];
  createQuoteTemplate: Maybe<Scalars['ID']['output']>;
  createQuoteTemplateRevision: Maybe<Scalars['ID']['output']>;
  createRecordFile: Scalars['ID']['output'];
  createRole: Maybe<Scalars['ID']['output']>;
  createSalesOrder: Maybe<Scalars['ID']['output']>;
  createSchema: Scalars['ID']['output'];
  createSchemaVersion: Scalars['ID']['output'];
  createScreen: Maybe<Scalars['ID']['output']>;
  createSignedUploadUrl: Maybe<SignedUploadUrlPayload>;
  createSpecification: Scalars['ID']['output'];
  createStorageConnection: Maybe<Scalars['ID']['output']>;
  createStorageResourceMapping: Maybe<Scalars['ID']['output']>;
  createSubscription: Maybe<Scalars['ID']['output']>;
  createSupplier: Maybe<Scalars['ID']['output']>;
  createSupplierImage: Maybe<Scalars['ID']['output']>;
  createSupplierQuote: Maybe<Scalars['ID']['output']>;
  createSupplierQuoteRequest: Maybe<Array<Scalars['ID']['output']>>;
  createTag: Maybe<Scalars['ID']['output']>;
  createUser: Maybe<Scalars['ID']['output']>;
  createUserIdentity: Maybe<Scalars['ID']['output']>;
  createWarehouse: Maybe<Scalars['ID']['output']>;
  createWebhook: Maybe<Scalars['ID']['output']>;
  createWorkflowType: Maybe<Scalars['ID']['output']>;
  deactivatePerson: Maybe<Scalars['ID']['output']>;
  deleteBatches: Maybe<Array<Scalars['ID']['output']>>;
  deleteBranches: Maybe<Array<Scalars['ID']['output']>>;
  deleteBuilders: Maybe<Array<Scalars['ID']['output']>>;
  deleteBusinessRole: Maybe<Scalars['ID']['output']>;
  deleteCandidate: Scalars['ID']['output'];
  deleteClients: Maybe<Array<Scalars['ID']['output']>>;
  deleteConfiguredLinkedActions: Maybe<Array<Scalars['ID']['output']>>;
  deleteCorrespondence: Maybe<Scalars['ID']['output']>;
  deleteCosting: Maybe<Scalars['ID']['output']>;
  deleteCustomData: Scalars['ID']['output'];
  deleteDocumentTemplate: Maybe<Scalars['ID']['output']>;
  deleteDraftPurchaseOrders: Maybe<Array<Scalars['ID']['output']>>;
  deleteExternalStorageItems: Maybe<Scalars['Boolean']['output']>;
  deleteFavouriteLinkedAction: Maybe<Scalars['ID']['output']>;
  deleteHousingCompanies: Maybe<Array<Scalars['ID']['output']>>;
  deleteHousingCompanyImage: Maybe<Scalars['ID']['output']>;
  deleteJobComponent: Maybe<Scalars['ID']['output']>;
  deleteJobs: Maybe<Array<Scalars['ID']['output']>>;
  deleteLeads: Maybe<Array<Scalars['ID']['output']>>;
  deleteLineItems: Maybe<Array<Scalars['ID']['output']>>;
  deleteLostReasons: Maybe<Array<Scalars['ID']['output']>>;
  deletePanels: Maybe<Array<Scalars['ID']['output']>>;
  deletePartTypes: Maybe<Array<Scalars['ID']['output']>>;
  deleteProcessTypeNote: Maybe<Scalars['ID']['output']>;
  deleteProcessTypeRoles: Maybe<Array<Scalars['ID']['output']>>;
  deleteProcessTypes: Maybe<Array<Scalars['ID']['output']>>;
  deleteProductCategories: Maybe<Array<Scalars['ID']['output']>>;
  deleteProductPrices: Maybe<Array<Scalars['ID']['output']>>;
  deleteQuote: Maybe<Scalars['ID']['output']>;
  deleteRecordFiles: Maybe<Scalars['Void']['output']>;
  deleteRole: Maybe<Scalars['ID']['output']>;
  deleteSalesOrder: Maybe<Scalars['ID']['output']>;
  deleteSchema: Scalars['ID']['output'];
  deleteSchemaVersion: Scalars['ID']['output'];
  deleteScreens: Maybe<Array<Scalars['ID']['output']>>;
  deleteStorageConnection: Scalars['ID']['output'];
  deleteStorageResourceMapping: Scalars['ID']['output'];
  deleteSubscription: Maybe<Scalars['ID']['output']>;
  deleteSupplierImage: Maybe<Scalars['ID']['output']>;
  deleteSupplierQuote: Maybe<Scalars['ID']['output']>;
  deleteSupplierQuoteRequest: Maybe<Scalars['ID']['output']>;
  deleteSuppliers: Maybe<Array<Scalars['ID']['output']>>;
  deleteTag: Maybe<Scalars['ID']['output']>;
  deleteUser: Maybe<Scalars['ID']['output']>;
  deleteUserIdentities: Maybe<Array<Scalars['ID']['output']>>;
  deleteWarehouse: Maybe<Scalars['ID']['output']>;
  deleteWebhooks: Maybe<Array<Scalars['ID']['output']>>;
  deleteWorkflowTypes: Maybe<Array<Scalars['ID']['output']>>;
  disableUser: Maybe<Scalars['ID']['output']>;
  enableUser: Maybe<Scalars['ID']['output']>;
  generateCurrentProductPricing: Maybe<Scalars['Boolean']['output']>;
  issueQuote: Maybe<Scalars['ID']['output']>;
  markJobLost: Maybe<Scalars['ID']['output']>;
  markLeadLost: Maybe<Scalars['ID']['output']>;
  markPurchaseOrderInvoiceAsChecked: Maybe<Scalars['ID']['output']>;
  markPurchaseOrderInvoiceAsUnchecked: Maybe<Scalars['ID']['output']>;
  notifyJobPhotoRecipients: Scalars['Boolean']['output'];
  overrideLeadStatus: Maybe<Scalars['ID']['output']>;
  overridePurchaseOrderStatus: Maybe<Scalars['ID']['output']>;
  pauseTimers: Maybe<Scalars['ID']['output']>;
  promoteSchemaVersion: Maybe<Scalars['ID']['output']>;
  publishDraftCostingRevision: Maybe<Scalars['ID']['output']>;
  publishDraftCostingTemplate: Maybe<Scalars['ID']['output']>;
  publishDraftQuoteTemplate: Maybe<Scalars['ID']['output']>;
  /**
   * Supported for ONLY receiving product stock to a warehouse,
   * if you want to bulk update (e.g adding/removing) then use the transferstock or
   * stocktake endpoints.
   */
  receiveWarehouseStock: Maybe<Scalars['ID']['output']>;
  releasePurchaseOrders: Maybe<Array<Scalars['ID']['output']>>;
  removeProcessAsset: Scalars['String']['output'];
  rescheduleBatches: Maybe<Array<Scalars['ID']['output']>>;
  rescheduleProcessTypeNote: Maybe<Scalars['ID']['output']>;
  resendPurchaseOrderSupplierNotification: Maybe<AsyncTask>;
  resetUserPassword: Maybe<Scalars['ID']['output']>;
  restorePartTypes: Maybe<Array<Scalars['ID']['output']>>;
  restoreProcessTypes: Maybe<Array<Scalars['ID']['output']>>;
  restoreWorkflowTypes: Maybe<Array<Scalars['ID']['output']>>;
  resumeTimers: Maybe<Scalars['ID']['output']>;
  reviseQuote: Maybe<Scalars['ID']['output']>;
  screenAssignment: Maybe<Scalars['ID']['output']>;
  screenUnassignment: Maybe<Scalars['ID']['output']>;
  setCandidateIngestionPolicy: Maybe<Scalars['ID']['output']>;
  setConfiguredLinkedAction: Maybe<Scalars['ID']['output']>;
  setCustomData: Scalars['ID']['output'];
  setDefaultCostingTemplate: Maybe<Scalars['ID']['output']>;
  setDefaultDocumentTemplate: Maybe<Scalars['ID']['output']>;
  setDefaultFolder: Maybe<Scalars['ID']['output']>;
  setDefaultQuoteTemplate: Maybe<Scalars['ID']['output']>;
  setFavouriteLinkedAction: Maybe<Scalars['ID']['output']>;
  setLinkedActionRecipient: Maybe<Scalars['ID']['output']>;
  setUserPin: Maybe<Scalars['ID']['output']>;
  submitPurchaseOrderReview: Scalars['ID']['output'];
  submitQuoteForApproval: Scalars['ID']['output'];
  transferWarehouseStock: Maybe<Scalars['ID']['output']>;
  triggerWebhook: Maybe<Scalars['ID']['output']>;
  unassignBusinessRolesFromPerson: Maybe<Array<Scalars['ID']['output']>>;
  unassignInheritanceFromRole: Maybe<Scalars['ID']['output']>;
  unassignLeadsFromSalesperson: Maybe<Array<Scalars['ID']['output']>>;
  unassignPermissionsFromRole: Maybe<Scalars['ID']['output']>;
  unassignPermissionsFromUser: Maybe<Scalars['ID']['output']>;
  unassignRolesFromUser: Maybe<Scalars['ID']['output']>;
  unassignScreensFromRole: Maybe<Scalars['ID']['output']>;
  unassignScreensFromUser: Maybe<Scalars['ID']['output']>;
  unassignUsersFromRole: Maybe<Scalars['ID']['output']>;
  unmarkJobLost: Maybe<Scalars['ID']['output']>;
  unmarkLeadLost: Maybe<Scalars['ID']['output']>;
  unsetUserPin: Maybe<Scalars['ID']['output']>;
  updateBatchDetails: Maybe<Scalars['ID']['output']>;
  updateBranch: Maybe<Scalars['ID']['output']>;
  updateBuilder: Maybe<Scalars['ID']['output']>;
  updateBusinessRole: Maybe<Scalars['ID']['output']>;
  updateClient: Maybe<Scalars['ID']['output']>;
  updateCorrespondence: Scalars['ID']['output'];
  updateCosting: Maybe<Scalars['ID']['output']>;
  updateCurrentUserNotifications: Scalars['Boolean']['output'];
  updateDocumentTemplate: Maybe<Scalars['ID']['output']>;
  updateDraftCostingTemplateRevision: Maybe<Scalars['ID']['output']>;
  updateDraftPurchaseOrder: Maybe<PurchaseOrderSavePayload>;
  updateDraftQuoteTemplateRevision: Maybe<Scalars['ID']['output']>;
  updateDraftSchemaVersion: Maybe<Scalars['ID']['output']>;
  updateHousingCompany: Maybe<Scalars['ID']['output']>;
  updateIssue: Maybe<Scalars['ID']['output']>;
  updateJobBuilder: Maybe<Scalars['ID']['output']>;
  updateJobClient: Maybe<Scalars['ID']['output']>;
  updateJobComponent: Maybe<Scalars['ID']['output']>;
  updateJobDetails: Maybe<Scalars['ID']['output']>;
  updateJobNote: Maybe<Scalars['ID']['output']>;
  updateJobSite: Maybe<Scalars['ID']['output']>;
  updateLead: Maybe<Scalars['ID']['output']>;
  updateLineItem: Maybe<Scalars['ID']['output']>;
  updateLineItemWorkflow: Maybe<Scalars['ID']['output']>;
  updateLostReason: Maybe<Scalars['ID']['output']>;
  updatePanelConfig: Maybe<Scalars['ID']['output']>;
  updatePanelDetails: Maybe<Scalars['ID']['output']>;
  updatePartType: Maybe<Scalars['ID']['output']>;
  updatePermissionForRole: Maybe<Scalars['ID']['output']>;
  updatePermissionForUser: Maybe<Scalars['ID']['output']>;
  updatePerson: Maybe<Scalars['ID']['output']>;
  updateProcessInstanceDetails: Maybe<Scalars['ID']['output']>;
  updateProcessInstanceStatus: Maybe<Scalars['ID']['output']>;
  updateProcessTypeDetails: Maybe<Scalars['ID']['output']>;
  updateProcessTypeNote: Maybe<Scalars['ID']['output']>;
  updateProcessTypeRole: Maybe<Scalars['ID']['output']>;
  updateProductCategory: Maybe<Scalars['ID']['output']>;
  updateProductDetails: Maybe<Array<Scalars['ID']['output']>>;
  updatePurchaseOrderInternalComment: Scalars['ID']['output'];
  updateQuote: Maybe<Scalars['ID']['output']>;
  updateRoleDetails: Maybe<Scalars['ID']['output']>;
  updateSalesOrder: Maybe<Scalars['ID']['output']>;
  updateSchemaDetails: Maybe<Scalars['ID']['output']>;
  updateScreenConfig: Maybe<Scalars['ID']['output']>;
  updateScreenDetails: Maybe<Scalars['ID']['output']>;
  updateSettings: Scalars['ID']['output'];
  updateStorageConnection: Maybe<Scalars['ID']['output']>;
  updateStorageResourceMapping: Maybe<Scalars['ID']['output']>;
  updateSubscription: Scalars['Boolean']['output'];
  updateSupplierDetails: Maybe<Scalars['ID']['output']>;
  updateSupplierQuote: Maybe<Scalars['ID']['output']>;
  updateSupplierQuoteRequest: Maybe<Scalars['ID']['output']>;
  updateSupplierReviewers: Maybe<Scalars['ID']['output']>;
  updateTag: Maybe<Scalars['ID']['output']>;
  updateUserDetails: Maybe<Scalars['ID']['output']>;
  updateUserSubscriptions: Scalars['Boolean']['output'];
  updateWarehouse: Maybe<Scalars['ID']['output']>;
  updateWebhook: Maybe<Scalars['ID']['output']>;
  updateWorkflowTypeDetails: Maybe<Scalars['ID']['output']>;
  warehouseStockTake: Maybe<Scalars['ID']['output']>;
  /**
   * Supported for withdrawing product stock from a warehouse,
   * if you want to bulk update then use the transferstock or
   * stocktake endpoints.
   */
  withdrawWarehouseStock: Maybe<Scalars['ID']['output']>;
};


export type MutationAcceptQuoteArgs = {
  input: AcceptQuoteInput;
};


export type MutationActivatePersonArgs = {
  personId: Scalars['ID']['input'];
};


export type MutationAmendPurchaseOrderArgs = {
  input: AmendPurchaseOrderInput;
};


export type MutationAssignBusinessRolesToBatchScheduleArgs = {
  input: AssignBusinessRolesToBatchScheduleInput;
};


export type MutationAssignBusinessRolesToPersonArgs = {
  input: AssignBusinessRolesToPersonInput;
};


export type MutationAssignInheritanceToRoleArgs = {
  input: AssignInheritanceToRoleInput;
};


export type MutationAssignLeadsToSalespersonArgs = {
  input: AssignLeadsToSalespersonInput;
};


export type MutationAssignPermissionsToRoleArgs = {
  input: AssignPermissionsToRoleInput;
};


export type MutationAssignPermissionsToUserArgs = {
  input: AssignPermissionsToUserInput;
};


export type MutationAssignRolesToUserArgs = {
  input: AssignRolesToUserInput;
};


export type MutationAssignScreensToRoleArgs = {
  input: AssignScreensToRoleInput;
};


export type MutationAssignScreensToUserArgs = {
  input: AssignScreensToUserInput;
};


export type MutationAssignUsersToProcessInstanceArgs = {
  processInstanceId: Scalars['ID']['input'];
  userRoles: Array<Scalars['ID']['input']>;
};


export type MutationAssignUsersToRoleArgs = {
  input: AssignUsersToRoleInput;
};


export type MutationBulkCreatePurchaseOrderArgs = {
  orders: Array<CreatePurchaseOrderInput>;
  place?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkProductImportArgs = {
  productsToImport: Array<ProductImportInput>;
  updateFields: Array<ProductImportUpdateField>;
};


export type MutationBulkProductPriceAdjustmentArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCancelPurchaseOrdersArgs = {
  input: CancelPurchaseOrdersInput;
};


export type MutationCancelSalesOrderArgs = {
  input: CancelSalesOrderInput;
};


export type MutationCancelSupplierQuoteRequestArgs = {
  input: CancelSupplierQuoteRequestInput;
};


export type MutationCommitPendingFilesArgs = {
  input: CommitPendingFilesInput;
};


export type MutationCompleteTimersArgs = {
  timerIds: Array<Scalars['ID']['input']>;
};


export type MutationConfirmSalesOrderArgs = {
  input: ConfirmSalesOrderInput;
};


export type MutationConvertCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConvertLeadToJobArgs = {
  input: ConvertLeadToJobInput;
};


export type MutationCreateAuthTokenArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCreateBatchArgs = {
  input: CreateBatchInput;
};


export type MutationCreateBranchArgs = {
  input: CreateBranchInput;
};


export type MutationCreateBuilderArgs = {
  input: CreateBuilderInput;
};


export type MutationCreateBusinessRoleArgs = {
  input: CreateBusinessRoleInput;
};


export type MutationCreateCandidateArgs = {
  input: CreateCandidateInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateCorrespondenceArgs = {
  input: CreateCorrespondenceInput;
};


export type MutationCreateCostingArgs = {
  input: CreateCostingInput;
};


export type MutationCreateCostingTemplateArgs = {
  input: CreateCostingTemplateInput;
};


export type MutationCreateCostingTemplateRevisionArgs = {
  input: CreateCostingTemplateRevisionInput;
};


export type MutationCreateDocumentTemplateArgs = {
  input: CreateDocumentTemplateInput;
};


export type MutationCreateFilesArgs = {
  files: Array<CreateFileInput>;
};


export type MutationCreateFirebaseAuthTokenArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateHousingCompanyArgs = {
  input: CreateHousingCompanyInput;
};


export type MutationCreateHousingCompanyImageArgs = {
  input: CreateHousingCompanyImageInput;
};


export type MutationCreateIssueArgs = {
  input: CreateIssueInput;
};


export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


export type MutationCreateJobComponentArgs = {
  input: CreateJobComponentInput;
};


export type MutationCreateJobEmailArgs = {
  input: CreateJobEmailInput;
};


export type MutationCreateJobFileUrlArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationCreateLineItemArgs = {
  input: CreateLineItemInput;
};


export type MutationCreateLostReasonArgs = {
  input: CreateLostReasonInput;
};


export type MutationCreatePanelArgs = {
  input: CreatePanelInput;
};


export type MutationCreatePartTypeArgs = {
  input: CreatePartTypeInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreateProcessAssetArgs = {
  assetId: Scalars['ID']['input'];
  processInstanceId: Scalars['ID']['input'];
};


export type MutationCreateProcessTimerArgs = {
  input: CreateProcessTimerInput;
};


export type MutationCreateProcessTypeArgs = {
  input: CreateProcessTypeInput;
};


export type MutationCreateProcessTypeNoteArgs = {
  input: CreateProcessTypeNoteInput;
};


export type MutationCreateProcessTypeRoleArgs = {
  input: CreateProcessTypeRoleInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductCategoryArgs = {
  input: CreateProductCategoryInput;
};


export type MutationCreateProductPriceArgs = {
  input: CreateProductPriceInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreatePurchaseOrderArgs = {
  place?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrder: CreatePurchaseOrderInput;
};


export type MutationCreatePurchaseOrderFromSupplierQuoteArgs = {
  input: CreatePurchaseOrderFromSupplierQuoteInput;
};


export type MutationCreatePurchaseOrderReceiptArgs = {
  input: CreatePurchaseOrderReceiptInput;
};


export type MutationCreateQuoteArgs = {
  input: CreateQuoteInput;
};


export type MutationCreateQuoteApprovalRequestArgs = {
  input: CreateQuoteApprovalRequestInput;
};


export type MutationCreateQuoteTemplateArgs = {
  input: CreateQuoteTemplateInput;
};


export type MutationCreateQuoteTemplateRevisionArgs = {
  input: CreateQuoteTemplateRevisionInput;
};


export type MutationCreateRecordFileArgs = {
  input: CreateRecordFileInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSalesOrderArgs = {
  input: CreateSalesOrderInput;
};


export type MutationCreateSchemaArgs = {
  input: CreateSchemaInput;
};


export type MutationCreateSchemaVersionArgs = {
  input: SchemaVersionInput;
};


export type MutationCreateScreenArgs = {
  input: CreateScreenInput;
};


export type MutationCreateSignedUploadUrlArgs = {
  input: CreateSignedUploadUrlInput;
};


export type MutationCreateSpecificationArgs = {
  lineItemId: Scalars['ID']['input'];
};


export type MutationCreateStorageConnectionArgs = {
  input: CreateStorageConnectionInput;
};


export type MutationCreateStorageResourceMappingArgs = {
  input: CreateStorageResourceMappingInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput;
};


export type MutationCreateSupplierImageArgs = {
  input: CreateSupplierImageInput;
};


export type MutationCreateSupplierQuoteArgs = {
  input: CreateSupplierQuoteInput;
};


export type MutationCreateSupplierQuoteRequestArgs = {
  input: CreateSupplierQuoteRequestInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserIdentityArgs = {
  input: CreateUserIdentityInput;
};


export type MutationCreateWarehouseArgs = {
  input: CreateWarehouseInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationCreateWorkflowTypeArgs = {
  input: CreateWorkflowTypeInput;
};


export type MutationDeactivatePersonArgs = {
  input: DeactivatePersonInput;
};


export type MutationDeleteBatchesArgs = {
  input: DeleteBatchesInput;
};


export type MutationDeleteBranchesArgs = {
  input: DeleteBranchesInput;
};


export type MutationDeleteBuildersArgs = {
  input: DeleteBuildersInput;
};


export type MutationDeleteBusinessRoleArgs = {
  businessRoleId: Scalars['ID']['input'];
};


export type MutationDeleteCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientsArgs = {
  input: DeleteClientsInput;
};


export type MutationDeleteConfiguredLinkedActionsArgs = {
  input: DeleteConfiguredLinkedActionsInput;
};


export type MutationDeleteCorrespondenceArgs = {
  input: DeleteCorrespondenceInput;
};


export type MutationDeleteCostingArgs = {
  input: DeleteCostingInput;
};


export type MutationDeleteCustomDataArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentTemplateArgs = {
  documentTemplateId: Scalars['ID']['input'];
};


export type MutationDeleteDraftPurchaseOrdersArgs = {
  input: DeleteDraftPurchaseOrdersInput;
};


export type MutationDeleteExternalStorageItemsArgs = {
  input: DeleteExternalStorageItemsInput;
};


export type MutationDeleteFavouriteLinkedActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHousingCompaniesArgs = {
  input: DeleteHousingCompaniesInput;
};


export type MutationDeleteHousingCompanyImageArgs = {
  input: DeleteHousingCompanyImageInput;
};


export type MutationDeleteJobComponentArgs = {
  input: DeleteJobComponentInput;
};


export type MutationDeleteJobsArgs = {
  input: DeleteJobsInput;
};


export type MutationDeleteLeadsArgs = {
  input: DeleteLeadsInput;
};


export type MutationDeleteLineItemsArgs = {
  input: DeleteLineItemsInput;
};


export type MutationDeleteLostReasonsArgs = {
  input: DeleteLostReasonsInput;
};


export type MutationDeletePanelsArgs = {
  input: DeletePanelsInput;
};


export type MutationDeletePartTypesArgs = {
  input: DeletePartTypesInput;
};


export type MutationDeleteProcessTypeNoteArgs = {
  input: DeleteProcessTypeNoteInput;
};


export type MutationDeleteProcessTypeRolesArgs = {
  input: DeleteProcessTypeRolesInput;
};


export type MutationDeleteProcessTypesArgs = {
  input: DeleteProcessTypesInput;
};


export type MutationDeleteProductCategoriesArgs = {
  input: DeleteProductCategoriesInput;
};


export type MutationDeleteProductPricesArgs = {
  input: DeleteProductPricesInput;
};


export type MutationDeleteQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRecordFilesArgs = {
  input: DeleteRecordFilesInput;
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSalesOrderArgs = {
  input: DeleteSalesOrderInput;
};


export type MutationDeleteSchemaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchemaVersionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScreensArgs = {
  input: DeleteScreensInput;
};


export type MutationDeleteStorageConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStorageResourceMappingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationDeleteSupplierImageArgs = {
  input: DeleteSupplierImageInput;
};


export type MutationDeleteSupplierQuoteArgs = {
  input: DeleteSupplierQuoteInput;
};


export type MutationDeleteSupplierQuoteRequestArgs = {
  input: DeleteSupplierQuoteRequestInput;
};


export type MutationDeleteSuppliersArgs = {
  input: DeleteSuppliersInput;
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteUserIdentitiesArgs = {
  input: DeleteUserIdentitiesInput;
};


export type MutationDeleteWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWebhooksArgs = {
  input: DeleteWebhooksInput;
};


export type MutationDeleteWorkflowTypesArgs = {
  input: DeleteWorkflowTypesInput;
};


export type MutationDisableUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationEnableUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationIssueQuoteArgs = {
  input: IssueQuoteInput;
};


export type MutationMarkJobLostArgs = {
  input: MarkJobLostInput;
};


export type MutationMarkLeadLostArgs = {
  input: MarkLeadLostInput;
};


export type MutationMarkPurchaseOrderInvoiceAsCheckedArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationMarkPurchaseOrderInvoiceAsUncheckedArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationNotifyJobPhotoRecipientsArgs = {
  area: Scalars['String']['input'];
  jobNumber: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOverrideLeadStatusArgs = {
  input: OverrideLeadStatusInput;
};


export type MutationOverridePurchaseOrderStatusArgs = {
  input: OverridePurchaseOrderStatusInput;
};


export type MutationPauseTimersArgs = {
  timerIds: Array<Scalars['ID']['input']>;
};


export type MutationPromoteSchemaVersionArgs = {
  input: PromoteSchemaVersionInput;
};


export type MutationPublishDraftCostingRevisionArgs = {
  costingId: Scalars['ID']['input'];
};


export type MutationPublishDraftCostingTemplateArgs = {
  costingTemplateId: Scalars['ID']['input'];
};


export type MutationPublishDraftQuoteTemplateArgs = {
  quoteTemplateId: Scalars['ID']['input'];
};


export type MutationReceiveWarehouseStockArgs = {
  input: ReceiveWarehouseStockInput;
};


export type MutationReleasePurchaseOrdersArgs = {
  input: ReleasePurchaseOrdersInput;
};


export type MutationRemoveProcessAssetArgs = {
  assetId: Scalars['ID']['input'];
  processInstanceId: Scalars['ID']['input'];
};


export type MutationRescheduleBatchesArgs = {
  input: RescheduleBatchesInput;
};


export type MutationRescheduleProcessTypeNoteArgs = {
  date: Scalars['String']['input'];
  processTypeNoteId: Scalars['ID']['input'];
};


export type MutationResendPurchaseOrderSupplierNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type MutationRestorePartTypesArgs = {
  input: RestorePartTypesInput;
};


export type MutationRestoreProcessTypesArgs = {
  input: RestoreProcessTypesInput;
};


export type MutationRestoreWorkflowTypesArgs = {
  input: RestoreWorkflowTypesInput;
};


export type MutationResumeTimersArgs = {
  timerIds: Array<Scalars['ID']['input']>;
};


export type MutationReviseQuoteArgs = {
  input: ReviseQuoteInput;
};


export type MutationScreenAssignmentArgs = {
  input: ScreenAssignmentInput;
};


export type MutationScreenUnassignmentArgs = {
  input: ScreenUnassignmentInput;
};


export type MutationSetCandidateIngestionPolicyArgs = {
  input: SetCandidateIngestionPolicyInput;
};


export type MutationSetConfiguredLinkedActionArgs = {
  input: SetConfiguredLinkedActionInput;
};


export type MutationSetCustomDataArgs = {
  input: SetCustomDataInput;
};


export type MutationSetDefaultCostingTemplateArgs = {
  costingTemplateId: Scalars['ID']['input'];
};


export type MutationSetDefaultDocumentTemplateArgs = {
  documentTemplateId: Scalars['ID']['input'];
};


export type MutationSetDefaultFolderArgs = {
  input: SetDefaultFolderInput;
};


export type MutationSetDefaultQuoteTemplateArgs = {
  quoteTemplateId: Scalars['ID']['input'];
};


export type MutationSetFavouriteLinkedActionArgs = {
  input: SetFavouriteLinkedActionInput;
};


export type MutationSetLinkedActionRecipientArgs = {
  input: SetLinkedActionRecipientInput;
};


export type MutationSetUserPinArgs = {
  input: SetUserPinInput;
};


export type MutationSubmitPurchaseOrderReviewArgs = {
  input: SubmitPurchaseOrderReviewInput;
};


export type MutationSubmitQuoteForApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransferWarehouseStockArgs = {
  input: TransferWarehouseStockInput;
};


export type MutationTriggerWebhookArgs = {
  input: TriggerWebhookInput;
};


export type MutationUnassignBusinessRolesFromPersonArgs = {
  input: UnassignBusinessRolesFromPersonInput;
};


export type MutationUnassignInheritanceFromRoleArgs = {
  input: UnassignInheritanceFromRoleInput;
};


export type MutationUnassignLeadsFromSalespersonArgs = {
  input: UnassignLeadsFromSalespersonInput;
};


export type MutationUnassignPermissionsFromRoleArgs = {
  input: UnassignPermissionsFromRoleInput;
};


export type MutationUnassignPermissionsFromUserArgs = {
  input: UnassignPermissionsFromUserInput;
};


export type MutationUnassignRolesFromUserArgs = {
  input: UnassignRolesFromUserInput;
};


export type MutationUnassignScreensFromRoleArgs = {
  input: UnassignScreensFromRoleInput;
};


export type MutationUnassignScreensFromUserArgs = {
  input: UnassignScreensFromUserInput;
};


export type MutationUnassignUsersFromRoleArgs = {
  input: UnassignUsersFromRoleInput;
};


export type MutationUnmarkJobLostArgs = {
  input: UnmarkJobLostInput;
};


export type MutationUnmarkLeadLostArgs = {
  input: UnmarkLeadLostInput;
};


export type MutationUnsetUserPinArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUpdateBatchDetailsArgs = {
  input: UpdateBatchDetailsInput;
};


export type MutationUpdateBranchArgs = {
  input: UpdateBranchInput;
};


export type MutationUpdateBuilderArgs = {
  input: UpdateBuilderInput;
};


export type MutationUpdateBusinessRoleArgs = {
  input: UpdateBusinessRoleInput;
};


export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationUpdateCorrespondenceArgs = {
  input: UpdateCorrespondenceInput;
};


export type MutationUpdateCostingArgs = {
  input: UpdateCostingInput;
};


export type MutationUpdateCurrentUserNotificationsArgs = {
  action: NotificationAction;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateDocumentTemplateArgs = {
  input: UpdateDocumentTemplateInput;
};


export type MutationUpdateDraftCostingTemplateRevisionArgs = {
  input: CreateCostingTemplateRevisionInput;
};


export type MutationUpdateDraftPurchaseOrderArgs = {
  place?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrder: UpdateDraftPurchaseOrderInput;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationUpdateDraftQuoteTemplateRevisionArgs = {
  input: CreateQuoteTemplateRevisionInput;
};


export type MutationUpdateDraftSchemaVersionArgs = {
  input: UpdateDraftSchemaVersionInput;
};


export type MutationUpdateHousingCompanyArgs = {
  input: UpdateHousingCompanyInput;
};


export type MutationUpdateIssueArgs = {
  input: UpdateIssueInput;
};


export type MutationUpdateJobBuilderArgs = {
  input: UpdateJobBuilderInput;
};


export type MutationUpdateJobClientArgs = {
  input: UpdateJobClientInput;
};


export type MutationUpdateJobComponentArgs = {
  input: UpdateJobComponentInput;
};


export type MutationUpdateJobDetailsArgs = {
  input: UpdateJobDetailsInput;
};


export type MutationUpdateJobNoteArgs = {
  input: UpdateJobNoteInput;
};


export type MutationUpdateJobSiteArgs = {
  input: UpdateJobSiteInput;
};


export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


export type MutationUpdateLineItemArgs = {
  input: UpdateLineItemInput;
};


export type MutationUpdateLineItemWorkflowArgs = {
  input: UpdateLineItemWorkflowInput;
};


export type MutationUpdateLostReasonArgs = {
  input: UpdateLostReasonInput;
};


export type MutationUpdatePanelConfigArgs = {
  input: UpdatePanelConfigInput;
};


export type MutationUpdatePanelDetailsArgs = {
  input: UpdatePanelDetailsInput;
};


export type MutationUpdatePartTypeArgs = {
  input: UpdatePartTypeInput;
};


export type MutationUpdatePermissionForRoleArgs = {
  input: UpdatePermissionForRoleInput;
};


export type MutationUpdatePermissionForUserArgs = {
  input: UpdatePermissionForUserInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdateProcessInstanceDetailsArgs = {
  input: UpdateProcessInstanceDetailsInput;
};


export type MutationUpdateProcessInstanceStatusArgs = {
  input: UpdateProcessInstanceStatusInput;
};


export type MutationUpdateProcessTypeDetailsArgs = {
  input: UpdateProcessTypeDetailsInput;
};


export type MutationUpdateProcessTypeNoteArgs = {
  input: UpdateProcessTypeNoteInput;
};


export type MutationUpdateProcessTypeRoleArgs = {
  input: UpdateProcessTypeRoleInput;
};


export type MutationUpdateProductCategoryArgs = {
  input: UpdateProductCategoryInput;
};


export type MutationUpdateProductDetailsArgs = {
  input: UpdateProductDetailsInput;
};


export type MutationUpdatePurchaseOrderInternalCommentArgs = {
  input: UpdatePurchaseOrderInternalCommentInput;
};


export type MutationUpdateQuoteArgs = {
  input: UpdateQuoteInput;
};


export type MutationUpdateRoleDetailsArgs = {
  input: UpdateRoleDetailsInput;
};


export type MutationUpdateSalesOrderArgs = {
  input: UpdateSalesOrderInput;
};


export type MutationUpdateSchemaDetailsArgs = {
  input: UpdateSchemaDetailsInput;
};


export type MutationUpdateScreenConfigArgs = {
  input: UpdateScreenConfigInput;
};


export type MutationUpdateScreenDetailsArgs = {
  input: UpdateScreenDetailsInput;
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationUpdateStorageConnectionArgs = {
  input: UpdateStorageConnectionInput;
};


export type MutationUpdateStorageResourceMappingArgs = {
  input: UpdateStorageResourceMappingInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateSupplierDetailsArgs = {
  input: UpdateSupplierDetailsInput;
};


export type MutationUpdateSupplierQuoteArgs = {
  input: UpdateSupplierQuoteInput;
};


export type MutationUpdateSupplierQuoteRequestArgs = {
  input: UpdateSupplierQuoteRequestInput;
};


export type MutationUpdateSupplierReviewersArgs = {
  input: UpdateSupplierReviewersInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateUserDetailsArgs = {
  input: UpdateUserDetailsInput;
};


export type MutationUpdateUserSubscriptionsArgs = {
  input: UpdateUserSubscriptionsInput;
};


export type MutationUpdateWarehouseArgs = {
  input: UpdateWarehouseInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationUpdateWorkflowTypeDetailsArgs = {
  input: UpdateWorkflowTypeDetailsInput;
};


export type MutationWarehouseStockTakeArgs = {
  input: WarehouseStockTakeInput;
};


export type MutationWithdrawWarehouseStockArgs = {
  input: WithdrawWarehouseStockInput;
};

export type NzRegion = {
  __typename?: 'NZRegion';
  id: Scalars['String']['output'];
  jobAggregate: Maybe<JobAggregate>;
  name: Scalars['String']['output'];
};


export type NzRegionJobAggregateArgs = {
  filter?: InputMaybe<JobFilterInput>;
};

export enum NotificationAction {
  Acknowledge = 'ACKNOWLEDGE',
  Clear = 'CLEAR',
  MarkUnread = 'MARK_UNREAD'
}

export type NotificationAttachmentInput = {
  bodyTemplateId?: InputMaybe<Scalars['ID']['input']>;
  filename: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type NotificationInput = {
  attachments: Array<NotificationAttachmentInput>;
  bodyTemplateId?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
};

/**
 * description=A subscription notification channel with its body and attachment templates.
 * displayName=Notification Template
 * module=Admin
 * defaultQuery=notificationTemplates
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=notificationTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Notification_Templates
 */
export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  /**
   * sortable=false
   * groupable=true
   */
  attachmentTemplates: Array<AttachmentTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  bodyTemplateId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  subscription: Maybe<SubscriptionReal>;
  /**
   * sortable=true
   * groupable=true
   */
  type: Scalars['String']['output'];
};


/**
 * description=A subscription notification channel with its body and attachment templates.
 * displayName=Notification Template
 * module=Admin
 * defaultQuery=notificationTemplates
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=notificationTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Notification_Templates
 */
export type NotificationTemplateAttachmentTemplatesArgs = {
  filter?: InputMaybe<AttachmentTemplateFilterInput>;
};


/**
 * description=A subscription notification channel with its body and attachment templates.
 * displayName=Notification Template
 * module=Admin
 * defaultQuery=notificationTemplates
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=notificationTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Notification_Templates
 */
export type NotificationTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A subscription notification channel with its body and attachment templates. */
export type NotificationTemplateAggregate = {
  __typename?: 'NotificationTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A subscription notification channel with its body and attachment templates. */
export type NotificationTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A subscription notification channel with its body and attachment templates. */
export type NotificationTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationTemplateFilterInput = {
  and?: InputMaybe<Array<NotificationTemplateFilterInput>>;
  attachmentTemplates?: InputMaybe<AttachmentTemplateFilterInput>;
  bodyTemplateId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<NotificationTemplateFilterInput>>;
  subscription?: InputMaybe<SubscriptionRealFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type NumberFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type OptionsInput = {
  groupBy?: InputMaybe<StringFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: implement frontend ui support for array inputs */
  sort?: InputMaybe<Array<SortInput>>;
};

export enum OrderCategory {
  Factory = 'FACTORY',
  Job = 'JOB',
  Office = 'OFFICE',
  Stock = 'STOCK',
  Vehicle = 'VEHICLE'
}

export type OrderEmailStatusUpdatedEvent = {
  __typename?: 'OrderEmailStatusUpdatedEvent';
  orderEmail: Scalars['String']['output'];
};

/** PurchaseOrder */
export type OrderOverrideStatusEvent = {
  __typename?: 'OrderOverrideStatusEvent';
  newStatus: Scalars['String']['output'];
  oldStatus: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/** PurchaseOrderReceipt */
export type OrderReceiptCreatedEvent = {
  __typename?: 'OrderReceiptCreatedEvent';
  lineData: Array<Maybe<Scalars['String']['output']>>;
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  receiptId: Scalars['Int']['output'];
  warehouseId: Scalars['Int']['output'];
};

export enum OrderReviewStatus {
  Approved = 'APPROVED',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type OrderRevisionCreatedEvent = {
  __typename?: 'OrderRevisionCreatedEvent';
  orderRevision: Scalars['String']['output'];
};

export enum OrderShippingMethods {
  SeaFreight = 'SeaFreight'
}

export enum OrderShippingTerms {
  Cfr = 'CFR',
  Cif = 'CIF',
  Cip = 'CIP',
  Cpt = 'CPT',
  Dap = 'DAP',
  Dat = 'DAT',
  Ddp = 'DDP',
  Exw = 'EXW',
  Fas = 'FAS',
  Fca = 'FCA',
  Fob = 'FOB'
}

export enum OrderStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Incomplete = 'INCOMPLETE',
  OnHold = 'ON_HOLD',
  Ordered = 'ORDERED',
  PendingReview = 'PENDING_REVIEW',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  Released = 'RELEASED'
}

export type OverrideLeadStatusInput = {
  leadId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type OverridePurchaseOrderStatusInput = {
  purchaseOrderId: Scalars['ID']['input'];
  status: OrderStatus;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PagedJobs = PaginatedResultInterface & {
  __typename?: 'PagedJobs';
  items: Array<Job>;
  pageInfo: PageInfo;
};

export type PaginatedResult = PaginatedResultInterface & {
  __typename?: 'PaginatedResult';
  pageInfo: PageInfo;
};

export type PaginatedResultInterface = {
  pageInfo: PageInfo;
};

/**
 * description=A reusable dashboard panel configuration.
 * displayName=Panel
 * module=Admin
 * defaultQuery=panels
 * iconName=panel
 * colour=#5D35A6
 * aggregateQuery=panelsAggregate
 * grouping=true
 * queryPermission=Query_Panels
 */
export type Panel = {
  __typename?: 'Panel';
  /**
   * sortable=false
   * groupable=false
   */
  compatibleRecordTypes: Maybe<Array<Scalars['String']['output']>>;
  /**
   * sortable=true
   * groupable=false
   */
  config: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  recordTags: Array<RecordTag>;
  /**
   * sortable=true
   * groupable=false
   */
  source: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  type: Scalars['String']['output'];
};


/**
 * description=A reusable dashboard panel configuration.
 * displayName=Panel
 * module=Admin
 * defaultQuery=panels
 * iconName=panel
 * colour=#5D35A6
 * aggregateQuery=panelsAggregate
 * grouping=true
 * queryPermission=Query_Panels
 */
export type PanelCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A reusable dashboard panel configuration.
 * displayName=Panel
 * module=Admin
 * defaultQuery=panels
 * iconName=panel
 * colour=#5D35A6
 * aggregateQuery=panelsAggregate
 * grouping=true
 * queryPermission=Query_Panels
 */
export type PanelRecordTagsArgs = {
  filter?: InputMaybe<RecordTagFilterInput>;
};

/** description=A reusable dashboard panel configuration. */
export type PanelAggregate = {
  __typename?: 'PanelAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable dashboard panel configuration. */
export type PanelAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable dashboard panel configuration. */
export type PanelAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PanelFilterInput = {
  and?: InputMaybe<Array<PanelFilterInput>>;
  config?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PanelFilterInput>>;
  recordTags?: InputMaybe<RecordTagFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

/**
 * description=A sales classification used to group job components and work-order parts.
 * displayName=Part Type
 * module=Sales
 * defaultQuery=partTypes
 * iconName=wrench
 * colour=#A91F54
 * aggregateQuery=partTypesAggregate
 * grouping=true
 * queryPermission=Query_Part_Types
 */
export type PartType = {
  __typename?: 'PartType';
  /**
   * sortable=true
   * groupable=false
   */
  code: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  colour: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modified: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A sales classification used to group job components and work-order parts.
 * displayName=Part Type
 * module=Sales
 * defaultQuery=partTypes
 * iconName=wrench
 * colour=#A91F54
 * aggregateQuery=partTypesAggregate
 * grouping=true
 * queryPermission=Query_Part_Types
 */
export type PartTypeCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A sales classification used to group job components and work-order parts. */
export type PartTypeAggregate = {
  __typename?: 'PartTypeAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A sales classification used to group job components and work-order parts. */
export type PartTypeAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A sales classification used to group job components and work-order parts. */
export type PartTypeAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** PartType */
export type PartTypeCreatedEvent = {
  __typename?: 'PartTypeCreatedEvent';
  partTypeId: Scalars['String']['output'];
  partTypeName: Scalars['String']['output'];
};

/** PartType */
export type PartTypeDeletedEvent = {
  __typename?: 'PartTypeDeletedEvent';
  partTypeId: Scalars['String']['output'];
  partTypeName: Scalars['String']['output'];
};

export type PartTypeFilterInput = {
  and?: InputMaybe<Array<PartTypeFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  colour?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PartTypeFilterInput>>;
};

/** A Part Type identity or a typed nested report dimension. */
export type PartTypeReportDimensionValue = {
  __typename?: 'PartTypeReportDimensionValue';
  created: Maybe<ReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  modified: Maybe<ReportDimensionValue>;
};

/** Select exactly one typed Part Type report dimension. */
export type PartTypeReportGroupByInput =
  { created: DateTimeReportDimensionInput; modified?: never; }
  |  { created?: never; modified: DateTimeReportDimensionInput; };

/** Groups by Part Type identity, or traverses to one of its typed dimensions. */
export type PartTypeReportRelationDimensionInput = {
  filter?: InputMaybe<PartTypeFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<PartTypeReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** PartType */
export type PartTypeRestoredEvent = {
  __typename?: 'PartTypeRestoredEvent';
  partTypeId: Scalars['String']['output'];
  partTypeName: Scalars['String']['output'];
};

/** PartType */
export type PartTypeUpdatedEvent = {
  __typename?: 'PartTypeUpdatedEvent';
  partTypeId: Scalars['String']['output'];
  partTypeName: Scalars['String']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  category: Scalars['String']['output'];
  categoryGroup: Scalars['String']['output'];
  /** The GraphQL input type to use for conditional policies */
  conditionalPolicyInputType: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** sortable=true */
  name: Scalars['String']['output'];
};

export type PermissionCheckInput = {
  conditions?: InputMaybe<Scalars['String']['input']>;
  permission: Scalars['String']['input'];
};

export type PermissionFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
};

export type PermissionInput = {
  conditions?: InputMaybe<Scalars['String']['input']>;
  permissionId: Scalars['String']['input'];
  policy: Policy;
};

export type PermissionPolicy = {
  __typename?: 'PermissionPolicy';
  conditions: Maybe<Scalars['String']['output']>;
  permission: Permission;
  policy: Policy;
  /** The Role this permission came from, if any */
  role: Maybe<Role>;
};

export type PermissionScope = {
  __typename?: 'PermissionScope';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * description=An individual person who can be assigned to work in the system.
 * displayName=Person
 * module=Admin
 * defaultQuery=people
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=peopleAggregate
 * grouping=true
 * queryPermission=Query_People
 */
export type Person = {
  __typename?: 'Person';
  /**
   * description=The number of currently assigned leads attached to this person as a designer.
   * sortable=true
   * groupable=false
   */
  assignedDesignerLeadCount: Scalars['Int']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  assignedWork: Array<PersonAssignedWork>;
  /**
   * sortable=true
   * groupable=true
   */
  branch: Maybe<Branch>;
  /**
   * sortable=true
   * groupable=false
   */
  businessRoleLabels: Scalars['String']['output'];
  /**
   * description=The number of confirmed jobs assigned to this person as a designer.
   * sortable=true
   * groupable=false
   */
  confirmedDesignerJobCount: Scalars['Int']['output'];
  /**
   * description=The system user account connected to this person.
   * sortable=true
   * groupable=true
   */
  connectedUser: Maybe<User>;
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['DateTime']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * description=Confirmed sales for the equivalent completed-month YTD period in the previous year.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  designerPreviousYtdSales: Maybe<Scalars['Float']['output']>;
  /**
   * description=Completed-month YTD confirmed sales for jobs assigned to this person as a designer.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  designerSalesYtd: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * description=The number of issued quotes awaiting a customer outcome for jobs assigned to this person as a designer.
   * sortable=true
   * groupable=false
   */
  outstandingDesignerQuoteCount: Scalars['Int']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  personBusinessRoles: Array<PersonBusinessRole>;
  /**
   * description=Seconds on process timers since midnight in the application database timezone (New Zealand), including running intervals and excluding pauses. Refreshed when queried.
   * sortable=true
   * groupable=false
   */
  processTimeTodaySeconds: Scalars['Int']['output'];
  /**
   * description=The number of unconfirmed jobs assigned to this person as a designer.
   * sortable=true
   * groupable=false
   */
  unconfirmedDesignerJobCount: Scalars['Int']['output'];
};


/**
 * description=An individual person who can be assigned to work in the system.
 * displayName=Person
 * module=Admin
 * defaultQuery=people
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=peopleAggregate
 * grouping=true
 * queryPermission=Query_People
 */
export type PersonAssignedWorkArgs = {
  filter?: InputMaybe<PersonAssignedWorkFilterInput>;
};


/**
 * description=An individual person who can be assigned to work in the system.
 * displayName=Person
 * module=Admin
 * defaultQuery=people
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=peopleAggregate
 * grouping=true
 * queryPermission=Query_People
 */
export type PersonCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An individual person who can be assigned to work in the system.
 * displayName=Person
 * module=Admin
 * defaultQuery=people
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=peopleAggregate
 * grouping=true
 * queryPermission=Query_People
 */
export type PersonPersonBusinessRolesArgs = {
  filter?: InputMaybe<PersonBusinessRoleFilterInput>;
};

/** description=An individual person who can be assigned to work in the system. */
export type PersonAggregate = {
  __typename?: 'PersonAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An individual person who can be assigned to work in the system. */
export type PersonAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An individual person who can be assigned to work in the system. */
export type PersonAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * description=A normalized read model of work assigned to a person across role-specific assignment sources.
 * displayName=Person Assigned Work
 * module=Admin
 * defaultQuery=personAssignedWork
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=personAssignedWorkAggregate
 * grouping=true
 * queryPermission=Query_Person_Assigned_Work
 */
export type PersonAssignedWork = {
  __typename?: 'PersonAssignedWork';
  /**
   * sortable=true
   * groupable=false
   */
  assignmentType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  businessRole: Maybe<BusinessRole>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  person: Person;
  /**
   * sortable=true
   * groupable=true
   */
  personBusinessRole: Maybe<PersonBusinessRole>;
  /**
   * description=Identity metadata for the assigned record, without loading the destination record.
   * sortable=false
   * groupable=false
   */
  record: PersonAssignedWorkRecordReference;
  /**
   * sortable=true
   * groupable=false
   */
  recordId: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordLabel: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  statusLabel: Scalars['String']['output'];
};


/**
 * description=A normalized read model of work assigned to a person across role-specific assignment sources.
 * displayName=Person Assigned Work
 * module=Admin
 * defaultQuery=personAssignedWork
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=personAssignedWorkAggregate
 * grouping=true
 * queryPermission=Query_Person_Assigned_Work
 */
export type PersonAssignedWorkCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A normalized read model of work assigned to a person across role-specific assignment sources. */
export type PersonAssignedWorkAggregate = {
  __typename?: 'PersonAssignedWorkAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A normalized read model of work assigned to a person across role-specific assignment sources. */
export type PersonAssignedWorkAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A normalized read model of work assigned to a person across role-specific assignment sources. */
export type PersonAssignedWorkAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonAssignedWorkFilterInput = {
  and?: InputMaybe<Array<PersonAssignedWorkFilterInput>>;
  assignmentType?: InputMaybe<StringFilterInput>;
  businessRole?: InputMaybe<BusinessRoleFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PersonAssignedWorkFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personBusinessRole?: InputMaybe<PersonBusinessRoleFilterInput>;
  recordId?: InputMaybe<IdFilterInput>;
  recordLabel?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  statusLabel?: InputMaybe<StringFilterInput>;
};

export type PersonAssignedWorkRecordReference = {
  __typename?: 'PersonAssignedWorkRecordReference';
  recordId: Scalars['ID']['output'];
  recordType: Scalars['String']['output'];
};

/**
 * description=A role assignment that makes a person available for a type of business work.
 * displayName=Person Business Role
 * module=Admin
 * defaultQuery=personBusinessRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=personBusinessRolesAggregate
 * grouping=true
 * queryPermission=Query_Person_Business_Roles
 */
export type PersonBusinessRole = {
  __typename?: 'PersonBusinessRole';
  /**
   * sortable=false
   * groupable=true
   */
  assignedWork: Array<PersonAssignedWork>;
  /**
   * sortable=true
   * groupable=true
   */
  businessRole: BusinessRole;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: Scalars['Boolean']['output'];
  /**
   * description=Jobs assigned to this person in this business role through legacy assignment columns.
   * sortable=false
   * groupable=false
   */
  jobs: Array<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  person: Person;
  /**
   * sortable=false
   * groupable=true
   */
  processAssignments: Array<ProcessAssignment>;
};


/**
 * description=A role assignment that makes a person available for a type of business work.
 * displayName=Person Business Role
 * module=Admin
 * defaultQuery=personBusinessRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=personBusinessRolesAggregate
 * grouping=true
 * queryPermission=Query_Person_Business_Roles
 */
export type PersonBusinessRoleAssignedWorkArgs = {
  filter?: InputMaybe<PersonAssignedWorkFilterInput>;
};


/**
 * description=A role assignment that makes a person available for a type of business work.
 * displayName=Person Business Role
 * module=Admin
 * defaultQuery=personBusinessRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=personBusinessRolesAggregate
 * grouping=true
 * queryPermission=Query_Person_Business_Roles
 */
export type PersonBusinessRoleCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A role assignment that makes a person available for a type of business work.
 * displayName=Person Business Role
 * module=Admin
 * defaultQuery=personBusinessRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=personBusinessRolesAggregate
 * grouping=true
 * queryPermission=Query_Person_Business_Roles
 */
export type PersonBusinessRoleJobsArgs = {
  filter?: InputMaybe<JobFilterInput>;
  options?: InputMaybe<OptionsInput>;
};


/**
 * description=A role assignment that makes a person available for a type of business work.
 * displayName=Person Business Role
 * module=Admin
 * defaultQuery=personBusinessRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=personBusinessRolesAggregate
 * grouping=true
 * queryPermission=Query_Person_Business_Roles
 */
export type PersonBusinessRoleProcessAssignmentsArgs = {
  filter?: InputMaybe<ProcessAssignmentFilterInput>;
};

/** description=A role assignment that makes a person available for a type of business work. */
export type PersonBusinessRoleAggregate = {
  __typename?: 'PersonBusinessRoleAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A role assignment that makes a person available for a type of business work. */
export type PersonBusinessRoleAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A role assignment that makes a person available for a type of business work. */
export type PersonBusinessRoleAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonBusinessRoleFilterInput = {
  and?: InputMaybe<Array<PersonBusinessRoleFilterInput>>;
  assignedWork?: InputMaybe<PersonAssignedWorkFilterInput>;
  businessRole?: InputMaybe<BusinessRoleFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PersonBusinessRoleFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  processAssignments?: InputMaybe<ProcessAssignmentFilterInput>;
};

/** A Person Business Role identity or a typed nested report dimension. */
export type PersonBusinessRoleReportDimensionValue = {
  __typename?: 'PersonBusinessRoleReportDimensionValue';
  businessRole: Maybe<BusinessRoleReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  person: Maybe<PersonReportDimensionValue>;
};

/** Select exactly one typed Person Business Role report dimension. */
export type PersonBusinessRoleReportGroupByInput =
  /** Group by Business Role or one of its dimensions. */
  { businessRole: BusinessRoleReportRelationDimensionInput; person?: never; }
  |  /** Group by Person or one of its dimensions. */
  { businessRole?: never; person: PersonReportRelationDimensionInput; };

/** Groups by Person Business Role identity, or traverses to one of its typed dimensions. */
export type PersonBusinessRoleReportRelationDimensionInput = {
  filter?: InputMaybe<PersonBusinessRoleFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<PersonBusinessRoleReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonFilterInput = {
  and?: InputMaybe<Array<PersonFilterInput>>;
  assignedWork?: InputMaybe<PersonAssignedWorkFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  businessRoleLabels?: InputMaybe<StringFilterInput>;
  /** The system user account connected to this person. */
  connectedUser?: InputMaybe<UserFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  /** Filter People by whether they have active system access. */
  hasActiveSystemAccess?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  /** Include inactive people in query results. */
  includeInactive?: InputMaybe<BooleanFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  /** Filter People by whether they are connected to the current user. */
  isCurrentUser?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  personBusinessRoles?: InputMaybe<PersonBusinessRoleFilterInput>;
  /** People assigned as Project Manager to matching jobs. */
  projectManagedJobs?: InputMaybe<JobFilterInput>;
};

/** A Person identity or a typed nested report dimension. */
export type PersonReportDimensionValue = {
  __typename?: 'PersonReportDimensionValue';
  branch: Maybe<BranchReportDimensionValue>;
  connectedUser: Maybe<UserReportDimensionValue>;
  created: Maybe<ReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Select exactly one typed Person report dimension. */
export type PersonReportGroupByInput =
  /** Group by Branch or one of its dimensions. */
  { branch: BranchReportRelationDimensionInput; connectedUser?: never; created?: never; }
  |  /** Group by User or one of its dimensions. */
  { branch?: never; connectedUser: UserReportRelationDimensionInput; created?: never; }
  |  { branch?: never; connectedUser?: never; created: DateTimeReportDimensionInput; };

/** Groups by Person identity, or traverses to one of its typed dimensions. */
export type PersonReportRelationDimensionInput = {
  filter?: InputMaybe<PersonFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<PersonReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonStatus = {
  __typename?: 'PersonStatus';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  peopleAggregate: Maybe<PersonAggregate>;
};


export type PersonStatusPeopleAggregateArgs = {
  filter?: InputMaybe<PersonFilterInput>;
};

export enum Policy {
  Allow = 'Allow',
  Conditional = 'Conditional',
  Deny = 'Deny'
}

/**
 * description=An asset assigned to a process type for a workflow subject.
 * displayName=Process Asset
 * module=Manufacturing
 * defaultQuery=processAssets
 * iconName=cog
 * colour=#A96500
 * aggregateQuery=processAssetsAggregate
 * grouping=true
 * queryPermission=Query_Process_Assets
 */
export type ProcessAsset = {
  __typename?: 'ProcessAsset';
  /**
   * sortable=true
   * groupable=true
   */
  asset: Maybe<Asset>;
  /**
   * sortable=true
   * groupable=false
   */
  assetId: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=true
   */
  processType: Maybe<ProcessType>;
  /**
   * sortable=true
   * groupable=false
   */
  processTypeId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  workflowSubjectId: Scalars['String']['output'];
};


/**
 * description=An asset assigned to a process type for a workflow subject.
 * displayName=Process Asset
 * module=Manufacturing
 * defaultQuery=processAssets
 * iconName=cog
 * colour=#A96500
 * aggregateQuery=processAssetsAggregate
 * grouping=true
 * queryPermission=Query_Process_Assets
 */
export type ProcessAssetCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An asset assigned to a process type for a workflow subject. */
export type ProcessAssetAggregate = {
  __typename?: 'ProcessAssetAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An asset assigned to a process type for a workflow subject. */
export type ProcessAssetAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An asset assigned to a process type for a workflow subject. */
export type ProcessAssetAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessAssetFilterInput = {
  and?: InputMaybe<Array<ProcessAssetFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessAssetFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  processTypeId?: InputMaybe<StringFilterInput>;
  workflowSubjectId?: InputMaybe<StringFilterInput>;
};

/**
 * description=A user role assigned to a process type for a workflow subject.
 * displayName=Process Assignment
 * module=Manufacturing
 * defaultQuery=processAssignments
 * iconName=people
 * colour=#A96500
 * aggregateQuery=processAssignmentsAggregate
 * grouping=true
 * queryPermission=Query_Process_Assignments
 */
export type ProcessAssignment = {
  __typename?: 'ProcessAssignment';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  personBusinessRoleId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
  /**
   * sortable=true
   * groupable=false
   */
  processTypeId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  userRole: Maybe<UserRole>;
  /**
   * sortable=true
   * groupable=false
   */
  userRoleId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  workflowSubject: LineItemMasterWorkflow;
  /**
   * sortable=true
   * groupable=false
   */
  workflowSubjectId: Scalars['String']['output'];
};


/**
 * description=A user role assigned to a process type for a workflow subject.
 * displayName=Process Assignment
 * module=Manufacturing
 * defaultQuery=processAssignments
 * iconName=people
 * colour=#A96500
 * aggregateQuery=processAssignmentsAggregate
 * grouping=true
 * queryPermission=Query_Process_Assignments
 */
export type ProcessAssignmentCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A user role assigned to a process type for a workflow subject. */
export type ProcessAssignmentAggregate = {
  __typename?: 'ProcessAssignmentAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A user role assigned to a process type for a workflow subject. */
export type ProcessAssignmentAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A user role assigned to a process type for a workflow subject. */
export type ProcessAssignmentAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessAssignmentFilterInput = {
  and?: InputMaybe<Array<ProcessAssignmentFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessAssignmentFilterInput>>;
  personBusinessRoleId?: InputMaybe<IdFilterInput>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  processTypeId?: InputMaybe<StringFilterInput>;
  userRole?: InputMaybe<UserRoleFilterInput>;
  userRoleId?: InputMaybe<StringFilterInput>;
  workflowSubject?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  workflowSubjectId?: InputMaybe<StringFilterInput>;
};

/**
 * description=A running manufacturing workflow process for a specific item or job.
 * displayName=Process Instance
 * module=Manufacturing
 * defaultQuery=processInstances
 * colour=#A96500
 * aggregateQuery=processInstancesAggregate
 * grouping=true
 * queryPermission=Query_Process_Instances
 */
export type ProcessInstance = {
  __typename?: 'ProcessInstance';
  /**
   * sortable=false
   * groupable=false
   */
  assignableUserRoles: Array<UserRole>;
  /**
   * sortable=true
   * groupable=false
   */
  assignedHours: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  dueDate: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  elapsedTime: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  leadDays: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=false
   * groupable=false
   */
  processAssets: Array<ProcessAsset>;
  /**
   * sortable=false
   * groupable=false
   */
  processAssignments: Array<ProcessAssignment>;
  /**
   * sortable=true
   * groupable=true
   */
  processType: Maybe<ProcessType>;
  /**
   * sortable=true
   * groupable=true
   */
  scheduled: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  startBy: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  status: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  workflow: Maybe<Workflow>;
};


/**
 * description=A running manufacturing workflow process for a specific item or job.
 * displayName=Process Instance
 * module=Manufacturing
 * defaultQuery=processInstances
 * colour=#A96500
 * aggregateQuery=processInstancesAggregate
 * grouping=true
 * queryPermission=Query_Process_Instances
 */
export type ProcessInstanceCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A running manufacturing workflow process for a specific item or job. */
export type ProcessInstanceAggregate = {
  __typename?: 'ProcessInstanceAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A running manufacturing workflow process for a specific item or job. */
export type ProcessInstanceAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A running manufacturing workflow process for a specific item or job. */
export type ProcessInstanceAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessInstanceFilterInput = {
  and?: InputMaybe<Array<ProcessInstanceFilterInput>>;
  assignedHours?: InputMaybe<StringFilterInput>;
  assignedUsers?: InputMaybe<UserFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  dueDate?: InputMaybe<DateTimeFilterInput>;
  elapsedTime?: InputMaybe<NumberFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  leadDays?: InputMaybe<NumberFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessInstanceFilterInput>>;
  ordered?: InputMaybe<BooleanFilterInput>;
  processAssignments?: InputMaybe<ProcessAssignmentFilterInput>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  scheduled?: InputMaybe<DateTimeFilterInput>;
  startBy?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<IdFilterInput>;
  workflow?: InputMaybe<WorkflowFilterInput>;
};

/**
 * description=A reusable process step inside a workflow template.
 * displayName=Process Template
 * module=Manufacturing
 * defaultQuery=processTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Process_Templates
 */
export type ProcessTemplate = {
  __typename?: 'ProcessTemplate';
  /**
   * sortable=true
   * groupable=false
   */
  assignedHours: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  leadDays: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  processType: Maybe<ProcessType>;
};


/**
 * description=A reusable process step inside a workflow template.
 * displayName=Process Template
 * module=Manufacturing
 * defaultQuery=processTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Process_Templates
 */
export type ProcessTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable process step inside a workflow template. */
export type ProcessTemplateAggregate = {
  __typename?: 'ProcessTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable process step inside a workflow template. */
export type ProcessTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable process step inside a workflow template. */
export type ProcessTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessTemplateFilterInput = {
  and?: InputMaybe<Array<ProcessTemplateFilterInput>>;
  assignedHours?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  leadDays?: InputMaybe<NumberFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTemplateFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
};

/**
 * description=A user timer with process items and elapsed time across its transactions.
 * displayName=Process Timer
 * module=Manufacturing
 * defaultQuery=timers
 * iconName=time
 * colour=#A96500
 * aggregateQuery=timersAggregate
 * grouping=true
 * queryPermission=Query_Process_Timers
 */
export type ProcessTimer = {
  __typename?: 'ProcessTimer';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  elapsedTime: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  itemAggregate: Maybe<ProcessTimerItemAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  items: Array<ProcessTimerItem>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=true
   */
  transactions: Array<TimerTransaction>;
  /**
   * sortable=true
   * groupable=false
   */
  type: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
};


/**
 * description=A user timer with process items and elapsed time across its transactions.
 * displayName=Process Timer
 * module=Manufacturing
 * defaultQuery=timers
 * iconName=time
 * colour=#A96500
 * aggregateQuery=timersAggregate
 * grouping=true
 * queryPermission=Query_Process_Timers
 */
export type ProcessTimerCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A user timer with process items and elapsed time across its transactions.
 * displayName=Process Timer
 * module=Manufacturing
 * defaultQuery=timers
 * iconName=time
 * colour=#A96500
 * aggregateQuery=timersAggregate
 * grouping=true
 * queryPermission=Query_Process_Timers
 */
export type ProcessTimerItemAggregateArgs = {
  filter?: InputMaybe<ProcessTimerItemFilterInput>;
};


/**
 * description=A user timer with process items and elapsed time across its transactions.
 * displayName=Process Timer
 * module=Manufacturing
 * defaultQuery=timers
 * iconName=time
 * colour=#A96500
 * aggregateQuery=timersAggregate
 * grouping=true
 * queryPermission=Query_Process_Timers
 */
export type ProcessTimerItemsArgs = {
  filter?: InputMaybe<ProcessTimerItemFilterInput>;
};


/**
 * description=A user timer with process items and elapsed time across its transactions.
 * displayName=Process Timer
 * module=Manufacturing
 * defaultQuery=timers
 * iconName=time
 * colour=#A96500
 * aggregateQuery=timersAggregate
 * grouping=true
 * queryPermission=Query_Process_Timers
 */
export type ProcessTimerTransactionsArgs = {
  filter?: InputMaybe<TimerTransactionFilterInput>;
};

/** description=A user timer with process items and elapsed time across its transactions. */
export type ProcessTimerAggregate = {
  __typename?: 'ProcessTimerAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A user timer with process items and elapsed time across its transactions. */
export type ProcessTimerAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A user timer with process items and elapsed time across its transactions. */
export type ProcessTimerAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessTimerFilterInput = {
  and?: InputMaybe<Array<ProcessTimerFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  elapsedTime?: InputMaybe<NumberFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  items?: InputMaybe<ProcessTimerItemFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTimerFilterInput>>;
  status?: InputMaybe<StringFilterInput>;
  transactions?: InputMaybe<TimerTransactionFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

/**
 * description=A process type and workflow subject assigned to a process timer.
 * displayName=Process Timer Item
 * module=Manufacturing
 * defaultQuery=processTimerItems
 * iconName=timer
 * colour=#A96500
 * aggregateQuery=processTimerItemsAggregate
 * grouping=true
 * queryPermission=Query_Process_Timer_Items
 */
export type ProcessTimerItem = {
  __typename?: 'ProcessTimerItem';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow: LineItemMasterWorkflow;
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
  /**
   * sortable=true
   * groupable=false
   */
  processTypeId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  timer: ProcessTimer;
  /**
   * sortable=true
   * groupable=false
   */
  timerId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  workflowSubjectId: Scalars['String']['output'];
};


/**
 * description=A process type and workflow subject assigned to a process timer.
 * displayName=Process Timer Item
 * module=Manufacturing
 * defaultQuery=processTimerItems
 * iconName=timer
 * colour=#A96500
 * aggregateQuery=processTimerItemsAggregate
 * grouping=true
 * queryPermission=Query_Process_Timer_Items
 */
export type ProcessTimerItemCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A process type and workflow subject assigned to a process timer. */
export type ProcessTimerItemAggregate = {
  __typename?: 'ProcessTimerItemAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A process type and workflow subject assigned to a process timer. */
export type ProcessTimerItemAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A process type and workflow subject assigned to a process timer. */
export type ProcessTimerItemAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessTimerItemFilterInput = {
  and?: InputMaybe<Array<ProcessTimerItemFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessTimerItemFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  processTypeId?: InputMaybe<StringFilterInput>;
  timer?: InputMaybe<ProcessTimerFilterInput>;
  timerId?: InputMaybe<StringFilterInput>;
  workflowSubjectId?: InputMaybe<StringFilterInput>;
};

/**
 * description=A reusable manufacturing process definition used by workflow types.
 * displayName=Process Type
 * module=Manufacturing
 * defaultQuery=processTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTypesAggregate
 * grouping=true
 * queryPermission=Query_Process_Types
 */
export type ProcessType = {
  __typename?: 'ProcessType';
  /**
   * sortable=false
   * groupable=true
   */
  assignments: Array<ProcessAssignment>;
  /**
   * sortable=true
   * groupable=false
   */
  code: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['DateTime']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modified: Scalars['DateTime']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  roles: Array<ProcessTypeRole>;
};


/**
 * description=A reusable manufacturing process definition used by workflow types.
 * displayName=Process Type
 * module=Manufacturing
 * defaultQuery=processTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTypesAggregate
 * grouping=true
 * queryPermission=Query_Process_Types
 */
export type ProcessTypeAssignmentsArgs = {
  filter?: InputMaybe<ProcessAssignmentFilterInput>;
};


/**
 * description=A reusable manufacturing process definition used by workflow types.
 * displayName=Process Type
 * module=Manufacturing
 * defaultQuery=processTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTypesAggregate
 * grouping=true
 * queryPermission=Query_Process_Types
 */
export type ProcessTypeCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A reusable manufacturing process definition used by workflow types.
 * displayName=Process Type
 * module=Manufacturing
 * defaultQuery=processTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTypesAggregate
 * grouping=true
 * queryPermission=Query_Process_Types
 */
export type ProcessTypeRolesArgs = {
  filter?: InputMaybe<ProcessTypeRoleFilterInput>;
};

/** description=A reusable manufacturing process definition used by workflow types. */
export type ProcessTypeAggregate = {
  __typename?: 'ProcessTypeAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable manufacturing process definition used by workflow types. */
export type ProcessTypeAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable manufacturing process definition used by workflow types. */
export type ProcessTypeAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** ProcessType */
export type ProcessTypeCreatedEvent = {
  __typename?: 'ProcessTypeCreatedEvent';
  processTypeId: Scalars['String']['output'];
  processTypeName: Scalars['String']['output'];
};

/** ProcessType */
export type ProcessTypeDeletedEvent = {
  __typename?: 'ProcessTypeDeletedEvent';
  processTypeId: Scalars['String']['output'];
  processTypeName: Scalars['String']['output'];
};

export type ProcessTypeFilterInput = {
  and?: InputMaybe<Array<ProcessTypeFilterInput>>;
  assignments?: InputMaybe<ProcessAssignmentFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTypeFilterInput>>;
  processInstances?: InputMaybe<ProcessInstanceFilterInput>;
  roles?: InputMaybe<ProcessTypeRoleFilterInput>;
};

/**
 * description=A schedule note assigned to one or more manufacturing process types.
 * displayName=Process Type Note
 * module=Manufacturing
 * defaultQuery=processTypeNotes
 * iconName=message-square-text
 * colour=#A96500
 * aggregateQuery=processTypeNotesAggregate
 * grouping=true
 * queryPermission=Query_Process_Type_Notes
 */
export type ProcessTypeNote = {
  __typename?: 'ProcessTypeNote';
  /**
   * sortable=false
   * groupable=false
   */
  assignedProcessTypes: Array<ProcessType>;
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  date: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  note: Maybe<Scalars['String']['output']>;
};


/**
 * description=A schedule note assigned to one or more manufacturing process types.
 * displayName=Process Type Note
 * module=Manufacturing
 * defaultQuery=processTypeNotes
 * iconName=message-square-text
 * colour=#A96500
 * aggregateQuery=processTypeNotesAggregate
 * grouping=true
 * queryPermission=Query_Process_Type_Notes
 */
export type ProcessTypeNoteCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A schedule note assigned to one or more manufacturing process types. */
export type ProcessTypeNoteAggregate = {
  __typename?: 'ProcessTypeNoteAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A schedule note assigned to one or more manufacturing process types. */
export type ProcessTypeNoteAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A schedule note assigned to one or more manufacturing process types. */
export type ProcessTypeNoteAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessTypeNoteFilterInput = {
  and?: InputMaybe<Array<ProcessTypeNoteFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  note?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTypeNoteFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
};

/** A Process Type identity or a typed nested report dimension. */
export type ProcessTypeReportDimensionValue = {
  __typename?: 'ProcessTypeReportDimensionValue';
  created: Maybe<ReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
  modified: Maybe<ReportDimensionValue>;
};

/** Select exactly one typed Process Type report dimension. */
export type ProcessTypeReportGroupByInput =
  { created: DateTimeReportDimensionInput; modified?: never; }
  |  { created?: never; modified: DateTimeReportDimensionInput; };

/** Groups by Process Type identity, or traverses to one of its typed dimensions. */
export type ProcessTypeReportRelationDimensionInput = {
  filter?: InputMaybe<ProcessTypeFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<ProcessTypeReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ProcessType */
export type ProcessTypeRestoredEvent = {
  __typename?: 'ProcessTypeRestoredEvent';
  processTypeId: Scalars['String']['output'];
  processTypeName: Scalars['String']['output'];
};

/**
 * description=A role type that may be assigned to users working on a manufacturing process type.
 * displayName=Process Type Role
 * module=Manufacturing
 * defaultQuery=processTypeRoles
 * iconName=people
 * colour=#A96500
 * aggregateQuery=processTypeRolesAggregate
 * grouping=true
 * queryPermission=Query_Process_Type_Roles
 */
export type ProcessTypeRole = {
  __typename?: 'ProcessTypeRole';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
  /**
   * sortable=true
   * groupable=false
   */
  roleType: Scalars['String']['output'];
};


/**
 * description=A role type that may be assigned to users working on a manufacturing process type.
 * displayName=Process Type Role
 * module=Manufacturing
 * defaultQuery=processTypeRoles
 * iconName=people
 * colour=#A96500
 * aggregateQuery=processTypeRolesAggregate
 * grouping=true
 * queryPermission=Query_Process_Type_Roles
 */
export type ProcessTypeRoleCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A role type that may be assigned to users working on a manufacturing process type. */
export type ProcessTypeRoleAggregate = {
  __typename?: 'ProcessTypeRoleAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A role type that may be assigned to users working on a manufacturing process type. */
export type ProcessTypeRoleAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A role type that may be assigned to users working on a manufacturing process type. */
export type ProcessTypeRoleAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessTypeRoleFilterInput = {
  and?: InputMaybe<Array<ProcessTypeRoleFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTypeRoleFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  roleType?: InputMaybe<StringFilterInput>;
};

/** ProcessType */
export type ProcessTypeUpdatedEvent = {
  __typename?: 'ProcessTypeUpdatedEvent';
  processTypeId: Scalars['String']['output'];
  processTypeName: Scalars['String']['output'];
};

/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export type Product = {
  __typename?: 'Product';
  /**
   * sortable=true
   * groupable=false
   */
  availableStock: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  category: Maybe<ProductCategory>;
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  currentBuyPrice: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  currentSellPrice: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  daysStockLeft: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  forecastedDemandQty: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  forecastedReorderUrgencyQty: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  forecastedStockRemainingQty: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  image: Maybe<ExternalStorageItem>;
  /**
   * sortable=true
   * groupable=false
   */
  indent: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isStockItem: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  leadTime: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  purchaseOrderLineAggregate: Maybe<PurchaseOrderLineAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  qtyReviewThreshold: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  quoteLineAggregate: Maybe<QuoteLineAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  recordTags: Array<RecordTag>;
  /**
   * sortable=true
   * groupable=false
   */
  reorderLevel: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  safetyStockDays: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  safetyStockQty: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  starred: Scalars['Boolean']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  stock: Maybe<Array<Maybe<Stock>>>;
  /**
   * sortable=false
   * groupable=true
   */
  stockByWarehouse: Array<Stock>;
  /**
   * sortable=true
   * groupable=false
   */
  stockGapDays: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  stockedQty: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  supplier: Maybe<Supplier>;
  /**
   * sortable=true
   * groupable=false
   */
  template: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  type: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  url: Maybe<Scalars['String']['output']>;
};


/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export type ProductCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export type ProductPurchaseOrderLineAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
};


/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export type ProductQuoteLineAggregateArgs = {
  filter?: InputMaybe<QuoteLineFilterInput>;
};


/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export type ProductRecordTagsArgs = {
  filter?: InputMaybe<RecordTagFilterInput>;
};


/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export type ProductStockArgs = {
  filter?: InputMaybe<StockFilterInput>;
};


/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export type ProductStockByWarehouseArgs = {
  filter?: InputMaybe<StockFilterInput>;
};

/** description=An inventory product that can be stocked, purchased, priced, and used on jobs. */
export type ProductAggregate = {
  __typename?: 'ProductAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An inventory product that can be stocked, purchased, priced, and used on jobs. */
export type ProductAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An inventory product that can be stocked, purchased, priced, and used on jobs. */
export type ProductAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * description=An inventory category used to group and filter products.
 * displayName=Product Category
 * module=Inventory
 * defaultQuery=productCategories
 * iconName=group-item
 * colour=#596600
 * aggregateQuery=productCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Product_Categories
 */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  /**
   * sortable=false
   * groupable=false
   */
  childProductCategoriesAggregate: Maybe<ProductCategoryAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  children: Array<ProductCategory>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  group: ProductCategoryGroup;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  parent: Maybe<ProductCategory>;
  /**
   * sortable=false
   * groupable=true
   */
  products: Maybe<Array<Maybe<Product>>>;
};


/**
 * description=An inventory category used to group and filter products.
 * displayName=Product Category
 * module=Inventory
 * defaultQuery=productCategories
 * iconName=group-item
 * colour=#596600
 * aggregateQuery=productCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Product_Categories
 */
export type ProductCategoryChildProductCategoriesAggregateArgs = {
  filter?: InputMaybe<ProductCategoryFilterInput>;
};


/**
 * description=An inventory category used to group and filter products.
 * displayName=Product Category
 * module=Inventory
 * defaultQuery=productCategories
 * iconName=group-item
 * colour=#596600
 * aggregateQuery=productCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Product_Categories
 */
export type ProductCategoryChildrenArgs = {
  filter?: InputMaybe<ProductCategoryFilterInput>;
};


/**
 * description=An inventory category used to group and filter products.
 * displayName=Product Category
 * module=Inventory
 * defaultQuery=productCategories
 * iconName=group-item
 * colour=#596600
 * aggregateQuery=productCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Product_Categories
 */
export type ProductCategoryCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An inventory category used to group and filter products.
 * displayName=Product Category
 * module=Inventory
 * defaultQuery=productCategories
 * iconName=group-item
 * colour=#596600
 * aggregateQuery=productCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Product_Categories
 */
export type ProductCategoryProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
};

/** description=An inventory category used to group and filter products. */
export type ProductCategoryAggregate = {
  __typename?: 'ProductCategoryAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An inventory category used to group and filter products. */
export type ProductCategoryAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An inventory category used to group and filter products. */
export type ProductCategoryAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryFilterInput = {
  and?: InputMaybe<Array<ProductCategoryFilterInput>>;
  children?: InputMaybe<ProductCategoryFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  group?: InputMaybe<ProductCategoryGroupFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  includeSubCategories?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductCategoryFilterInput>>;
  parent?: InputMaybe<ProductCategoryFilterInput>;
  products?: InputMaybe<ProductFilterInput>;
};

/**
 * description=A grouping used to organise related inventory product categories.
 * displayName=Product Category Group
 * module=Inventory
 * defaultQuery=productCategoryGroups
 * colour=#596600
 * aggregateQuery=productCategoryGroupsAggregate
 * grouping=true
 * queryPermission=Query_Product_Category_Groups
 */
export type ProductCategoryGroup = {
  __typename?: 'ProductCategoryGroup';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A grouping used to organise related inventory product categories.
 * displayName=Product Category Group
 * module=Inventory
 * defaultQuery=productCategoryGroups
 * colour=#596600
 * aggregateQuery=productCategoryGroupsAggregate
 * grouping=true
 * queryPermission=Query_Product_Category_Groups
 */
export type ProductCategoryGroupCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A grouping used to organise related inventory product categories. */
export type ProductCategoryGroupAggregate = {
  __typename?: 'ProductCategoryGroupAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A grouping used to organise related inventory product categories. */
export type ProductCategoryGroupAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A grouping used to organise related inventory product categories. */
export type ProductCategoryGroupAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryGroupFilterInput = {
  and?: InputMaybe<Array<ProductCategoryGroupFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductCategoryGroupFilterInput>>;
};

/** Product */
export type ProductCreatedEvent = {
  __typename?: 'ProductCreatedEvent';
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

/** Product */
export type ProductDetailsUpdatedEvent = {
  __typename?: 'ProductDetailsUpdatedEvent';
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

export type ProductFilterInput = {
  and?: InputMaybe<Array<ProductFilterInput>>;
  category?: InputMaybe<ProductCategoryFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  currentBuyPrice?: InputMaybe<NumberFilterInput>;
  currentSellPrice?: InputMaybe<NumberFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  indent?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  isStockItem?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  leadTime?: InputMaybe<NumberFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  qtyReviewThreshold?: InputMaybe<NumberFilterInput>;
  recordTags?: InputMaybe<RecordTagFilterInput>;
  safetyStockDays?: InputMaybe<NumberFilterInput>;
  starred?: InputMaybe<BooleanFilterInput>;
  stock?: InputMaybe<StockFilterInput>;
  stockByWarehouse?: InputMaybe<StockFilterInput>;
  stockedQty?: InputMaybe<NumberFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  template?: InputMaybe<BooleanFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
  unitOfMeasure?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ProductImportInput = {
  buyPrice?: InputMaybe<Scalars['String']['input']>;
  buyPriceEffectiveDate?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  operation: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  supplier: Scalars['String']['input'];
};

export enum ProductImportUpdateField {
  BuyPrice = 'BuyPrice',
  Description = 'Description'
}

/**
 * description=A dated buy or sell price for an inventory product.
 * displayName=Product Price
 * module=Inventory
 * defaultQuery=productPrices
 * iconName=dollar
 * colour=#596600
 * aggregateQuery=productPricesAggregate
 * grouping=true
 * queryPermission=Query_Product_Prices
 */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  effectiveDate: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  product: Product;
  /**
   * sortable=true
   * groupable=false
   */
  type: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitPrice: Maybe<Scalars['Float']['output']>;
};


/**
 * description=A dated buy or sell price for an inventory product.
 * displayName=Product Price
 * module=Inventory
 * defaultQuery=productPrices
 * iconName=dollar
 * colour=#596600
 * aggregateQuery=productPricesAggregate
 * grouping=true
 * queryPermission=Query_Product_Prices
 */
export type ProductPriceCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A dated buy or sell price for an inventory product. */
export type ProductPriceAggregate = {
  __typename?: 'ProductPriceAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A dated buy or sell price for an inventory product. */
export type ProductPriceAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A dated buy or sell price for an inventory product. */
export type ProductPriceAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPriceCreatedEvent = {
  __typename?: 'ProductPriceCreatedEvent';
  entity: Scalars['String']['output'];
};

export type ProductPriceDeletedEvent = {
  __typename?: 'ProductPriceDeletedEvent';
  entity: Scalars['String']['output'];
};

export type ProductPriceFilterInput = {
  and?: InputMaybe<Array<ProductPriceFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  effectiveDate?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductPriceFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
  unitPrice?: InputMaybe<NumberFilterInput>;
};

/**
 * description=A sales project used to group related work.
 * displayName=Project
 * module=Sales
 * defaultQuery=projects
 * iconName=projects
 * colour=#A91F54
 * aggregateQuery=projectsAggregate
 * grouping=true
 * queryPermission=Query_Projects
 */
export type Project = {
  __typename?: 'Project';
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A sales project used to group related work.
 * displayName=Project
 * module=Sales
 * defaultQuery=projects
 * iconName=projects
 * colour=#A91F54
 * aggregateQuery=projectsAggregate
 * grouping=true
 * queryPermission=Query_Projects
 */
export type ProjectCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A sales project used to group related work. */
export type ProjectAggregate = {
  __typename?: 'ProjectAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A sales project used to group related work. */
export type ProjectAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A sales project used to group related work. */
export type ProjectAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectFilterInput = {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
};

export type PromoteSchemaVersionInput = {
  schemaVersionId: Scalars['ID']['input'];
};

/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  /**
   * sortable=true
   * groupable=false
   */
  acknowledgedBy: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  amended: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  approved: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  category: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deliveryAddress: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  deliveryAddressEntity: Maybe<DeliveryAddress>;
  /**
   * sortable=false
   * groupable=false
   */
  documents: Array<Document>;
  /**
   * sortable=false
   * groupable=true
   */
  emails: Array<Email>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  incomplete: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  internalComment: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  invoiceChecked: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<PurchaseOrderLine>;
  /**
   * sortable=true
   * groupable=false
   */
  notificationStatus: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  notifySupplierWhenPlaced: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  placedBy: Maybe<User>;
  /**
   * sortable=true
   * groupable=false
   */
  poNumber: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  purchaseOrderLineAggregate: Maybe<PurchaseOrderLineAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  reference: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  required: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=true
   */
  reviews: Array<PurchaseOrderReview>;
  /**
   * sortable=true
   * groupable=false
   */
  shippingMethod: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  shippingTerms: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  siteVisitRequired: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  ssspCompleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  statusWhenPlaced: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  supplier: Maybe<Supplier>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierComment: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierStatus: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  template: Maybe<DocumentTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  urgent: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  warehouse: Maybe<Warehouse>;
};


/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export type PurchaseOrderCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export type PurchaseOrderDocumentsArgs = {
  filter?: InputMaybe<DocumentTemplateFilterInput>;
};


/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export type PurchaseOrderEmailsArgs = {
  filter?: InputMaybe<EmailFilterInput>;
};


/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export type PurchaseOrderLinesArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
};


/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export type PurchaseOrderPurchaseOrderLineAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
};


/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export type PurchaseOrderReviewsArgs = {
  filter?: InputMaybe<PurchaseOrderReviewFilterInput>;
};

/** description=An order for products or services placed with a supplier. */
export type PurchaseOrderAggregate = {
  __typename?: 'PurchaseOrderAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  incompleteSupplierSssp: Scalars['Boolean']['output'];
};


/** description=An order for products or services placed with a supplier. */
export type PurchaseOrderAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An order for products or services placed with a supplier. */
export type PurchaseOrderAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** PurchaseOrder */
export type PurchaseOrderAmendedEvent = {
  __typename?: 'PurchaseOrderAmendedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/** PurchaseOrder */
export type PurchaseOrderApprovedEvent = {
  __typename?: 'PurchaseOrderApprovedEvent';
  comment: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  placedByUserId: Scalars['String']['output'];
};

/** PurchaseOrder */
export type PurchaseOrderCancelledEvent = {
  __typename?: 'PurchaseOrderCancelledEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

export type PurchaseOrderEvent = {
  __typename?: 'PurchaseOrderEvent';
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload: Maybe<Scalars['String']['output']>;
  purchaseOrder: Maybe<PurchaseOrder>;
  type: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type PurchaseOrderEventFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

export type PurchaseOrderFilterInput = {
  acknowledgedBy?: InputMaybe<StringFilterInput>;
  amended?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<PurchaseOrderFilterInput>>;
  approved?: InputMaybe<BooleanFilterInput>;
  category?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deliveryAddress?: InputMaybe<StringFilterInput>;
  deliveryAddressEntity?: InputMaybe<DeliveryAddressFilterInput>;
  emails?: InputMaybe<EmailFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  incomplete?: InputMaybe<BooleanFilterInput>;
  internalComment?: InputMaybe<StringFilterInput>;
  invoiceChecked?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<PurchaseOrderLineFilterInput>;
  notificationStatus?: InputMaybe<NumberFilterInput>;
  notifySupplierWhenPlaced?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderFilterInput>>;
  placedBy?: InputMaybe<UserFilterInput>;
  poNumber?: InputMaybe<StringFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  required?: InputMaybe<DateTimeFilterInput>;
  reviews?: InputMaybe<PurchaseOrderReviewFilterInput>;
  shippingMethod?: InputMaybe<StringFilterInput>;
  shippingTerms?: InputMaybe<StringFilterInput>;
  siteVisitRequired?: InputMaybe<BooleanFilterInput>;
  ssspCompleted?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<PurchaseOrderStatusFilterInput>;
  statusWhenPlaced?: InputMaybe<StringFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierComment?: InputMaybe<StringFilterInput>;
  supplierStatus?: InputMaybe<NumberFilterInput>;
  template?: InputMaybe<DocumentTemplateFilterInput>;
  urgent?: InputMaybe<BooleanFilterInput>;
  warehouse?: InputMaybe<WarehouseFilterInput>;
};

/** PurchaseOrder */
export type PurchaseOrderIncompleteEvent = {
  __typename?: 'PurchaseOrderIncompleteEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/**
 * description=A product or service line ordered from a supplier on a purchase order.
 * displayName=Purchase Order Line
 * module=Inventory
 * defaultQuery=purchaseOrderLines
 * colour=#596600
 * aggregateQuery=purchaseOrderLinesAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Lines
 */
export type PurchaseOrderLine = {
  __typename?: 'PurchaseOrderLine';
  /**
   * sortable=true
   * groupable=false
   */
  buyPrice: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  line: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  orderedQty: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  product: Maybe<Product>;
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  receivedQty: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  totalPrice: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  unit: Maybe<Scalars['String']['output']>;
};


/**
 * description=A product or service line ordered from a supplier on a purchase order.
 * displayName=Purchase Order Line
 * module=Inventory
 * defaultQuery=purchaseOrderLines
 * colour=#596600
 * aggregateQuery=purchaseOrderLinesAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Lines
 */
export type PurchaseOrderLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A product or service line ordered from a supplier on a purchase order. */
export type PurchaseOrderLineAggregate = {
  __typename?: 'PurchaseOrderLineAggregate';
  /**
   * sortable=true
   * groupable=false
   */
  averageDailyQuantity: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['Float']['output'];
};


/** description=A product or service line ordered from a supplier on a purchase order. */
export type PurchaseOrderLineAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A product or service line ordered from a supplier on a purchase order. */
export type PurchaseOrderLineAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseOrderLineFilterInput = {
  and?: InputMaybe<Array<PurchaseOrderLineFilterInput>>;
  buyPrice?: InputMaybe<NumberFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderLineFilterInput>>;
  orderedQty?: InputMaybe<NumberFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  receivedQty?: InputMaybe<NumberFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
};

export type PurchaseOrderLineInput = {
  buyPrice?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** PurchaseOrder */
export type PurchaseOrderPendingReviewEvent = {
  __typename?: 'PurchaseOrderPendingReviewEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/** PurchaseOrder */
export type PurchaseOrderPlacedEvent = {
  __typename?: 'PurchaseOrderPlacedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

export type PurchaseOrderPreview = {
  __typename?: 'PurchaseOrderPreview';
  html: Scalars['String']['output'];
};

/**
 * description=A receipt recording goods received against a purchase order.
 * displayName=Purchase Order Receipt
 * module=Inventory
 * defaultQuery=purchaseOrderReceipts
 * iconName=receipt
 * colour=#596600
 * aggregateQuery=purchaseOrderReceiptsAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Receipts
 */
export type PurchaseOrderReceipt = {
  __typename?: 'PurchaseOrderReceipt';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<PurchaseOrderReceiptLine>;
  /**
   * sortable=true
   * groupable=false
   */
  notes: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  reference: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
};


/**
 * description=A receipt recording goods received against a purchase order.
 * displayName=Purchase Order Receipt
 * module=Inventory
 * defaultQuery=purchaseOrderReceipts
 * iconName=receipt
 * colour=#596600
 * aggregateQuery=purchaseOrderReceiptsAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Receipts
 */
export type PurchaseOrderReceiptCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A receipt recording goods received against a purchase order.
 * displayName=Purchase Order Receipt
 * module=Inventory
 * defaultQuery=purchaseOrderReceipts
 * iconName=receipt
 * colour=#596600
 * aggregateQuery=purchaseOrderReceiptsAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Receipts
 */
export type PurchaseOrderReceiptLinesArgs = {
  filter?: InputMaybe<PurchaseOrderReceiptLineFilterInput>;
};

/** description=A receipt recording goods received against a purchase order. */
export type PurchaseOrderReceiptAggregate = {
  __typename?: 'PurchaseOrderReceiptAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A receipt recording goods received against a purchase order. */
export type PurchaseOrderReceiptAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A receipt recording goods received against a purchase order. */
export type PurchaseOrderReceiptAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseOrderReceiptFilterInput = {
  and?: InputMaybe<Array<PurchaseOrderReceiptFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<PurchaseOrderReceiptLineFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderReceiptFilterInput>>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

/**
 * description=The quantity received for one purchase order line on a receipt.
 * displayName=Purchase Order Receipt Line
 * module=Inventory
 * defaultQuery=purchaseOrderReceiptLines
 * iconName=list
 * colour=#596600
 * aggregateQuery=purchaseOrderReceiptLinesAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Receipt_Lines
 */
export type PurchaseOrderReceiptLine = {
  __typename?: 'PurchaseOrderReceiptLine';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  line: Maybe<PurchaseOrderLine>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  receipt: Maybe<PurchaseOrderReceipt>;
};


/**
 * description=The quantity received for one purchase order line on a receipt.
 * displayName=Purchase Order Receipt Line
 * module=Inventory
 * defaultQuery=purchaseOrderReceiptLines
 * iconName=list
 * colour=#596600
 * aggregateQuery=purchaseOrderReceiptLinesAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Receipt_Lines
 */
export type PurchaseOrderReceiptLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=The quantity received for one purchase order line on a receipt. */
export type PurchaseOrderReceiptLineAggregate = {
  __typename?: 'PurchaseOrderReceiptLineAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=The quantity received for one purchase order line on a receipt. */
export type PurchaseOrderReceiptLineAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=The quantity received for one purchase order line on a receipt. */
export type PurchaseOrderReceiptLineAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseOrderReceiptLineFilterInput = {
  and?: InputMaybe<Array<PurchaseOrderReceiptLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<PurchaseOrderLineFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderReceiptLineFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  receipt?: InputMaybe<PurchaseOrderReceiptFilterInput>;
};

export type PurchaseOrderReceiptLineInput = {
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
};

/** PurchaseOrder */
export type PurchaseOrderReceivedEvent = {
  __typename?: 'PurchaseOrderReceivedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/** PurchaseOrder */
export type PurchaseOrderRejectedEvent = {
  __typename?: 'PurchaseOrderRejectedEvent';
  comment: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  placedByUserId: Scalars['String']['output'];
};

/** PurchaseOrder */
export type PurchaseOrderReleasedEvent = {
  __typename?: 'PurchaseOrderReleasedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/**
 * description=A reviewer decision on a purchase order.
 * displayName=Purchase Order Review
 * module=Inventory
 * defaultQuery=purchaseOrderReviews
 * iconName=endorsed
 * colour=#596600
 * aggregateQuery=purchaseOrderReviewsAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Reviews
 */
export type PurchaseOrderReview = {
  __typename?: 'PurchaseOrderReview';
  /**
   * sortable=true
   * groupable=false
   */
  comment: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  completedAt: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  status: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
  /**
   * sortable=true
   * groupable=false
   */
  userId: Maybe<Scalars['String']['output']>;
};


/**
 * description=A reviewer decision on a purchase order.
 * displayName=Purchase Order Review
 * module=Inventory
 * defaultQuery=purchaseOrderReviews
 * iconName=endorsed
 * colour=#596600
 * aggregateQuery=purchaseOrderReviewsAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Reviews
 */
export type PurchaseOrderReviewCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reviewer decision on a purchase order. */
export type PurchaseOrderReviewAggregate = {
  __typename?: 'PurchaseOrderReviewAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reviewer decision on a purchase order. */
export type PurchaseOrderReviewAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reviewer decision on a purchase order. */
export type PurchaseOrderReviewAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseOrderReviewFilterInput = {
  and?: InputMaybe<Array<PurchaseOrderReviewFilterInput>>;
  comment?: InputMaybe<StringFilterInput>;
  completedAt?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderReviewFilterInput>>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
};

export type PurchaseOrderSavePayload = {
  __typename?: 'PurchaseOrderSavePayload';
  purchaseOrderId: Scalars['ID']['output'];
  status: OrderStatus;
};

export type PurchaseOrderStatus = {
  __typename?: 'PurchaseOrderStatus';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  purchaseOrderAggregate: Maybe<PurchaseOrderAggregate>;
};


export type PurchaseOrderStatusPurchaseOrderAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
};

export type PurchaseOrderStatusFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  purchaseOrders?: InputMaybe<PurchaseOrderFilterInput>;
};

/** PurchaseOrder */
export type PurchaseOrderSupplierNotificationManuallySentEvent = {
  __typename?: 'PurchaseOrderSupplierNotificationManuallySentEvent';
  orderId: Scalars['Int']['output'];
  orderReference: Maybe<Scalars['String']['output']>;
};

/** PurchaseOrder */
export type PurchaseOrderSupplierNotificationSentEvent = {
  __typename?: 'PurchaseOrderSupplierNotificationSentEvent';
  orderId: Scalars['Int']['output'];
  orderReference: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  actAsUser: Maybe<ActAsUser>;
  actAsUsers: Maybe<Array<ActAsUser>>;
  actAsUsersAggregate: Maybe<ActAsUserAggregate>;
  asset: Maybe<Asset>;
  assets: Maybe<Array<Asset>>;
  assetsAggregate: Maybe<AssetAggregate>;
  assignedPermissions: Maybe<Array<AssignedPermission>>;
  asyncTask: Maybe<AsyncTask>;
  asyncTasks: Maybe<Array<AsyncTask>>;
  asyncTasksAggregate: Maybe<AsyncTaskAggregate>;
  attachmentTemplate: Maybe<AttachmentTemplate>;
  attachmentTemplates: Maybe<Array<AttachmentTemplate>>;
  attachmentTemplatesAggregate: Maybe<AttachmentTemplateAggregate>;
  auditLog: Maybe<AuditLog>;
  auditLogs: Maybe<Array<AuditLog>>;
  auditLogsAggregate: Maybe<ResourceAggregate>;
  batch: Maybe<Batch>;
  batchSchedule: Maybe<BatchSchedule>;
  batchScheduleReport: Maybe<Array<BatchScheduleReportRow>>;
  batchSchedules: Maybe<Array<BatchSchedule>>;
  batchSchedulesAggregate: Maybe<BatchScheduleAggregate>;
  batches: Maybe<Array<Batch>>;
  batchesAggregate: Maybe<BatchAggregate>;
  billOfMaterialsImport: Maybe<BillOfMaterialsImport>;
  branch: Maybe<Branch>;
  branches: Maybe<Array<Branch>>;
  branchesAggregate: Maybe<BranchAggregate>;
  buildType: Maybe<BuildType>;
  buildTypes: Maybe<Array<BuildType>>;
  buildTypesAggregate: Maybe<BuildTypeAggregate>;
  builder: Maybe<Builder>;
  builders: Maybe<Array<Builder>>;
  buildersAggregate: Maybe<BuilderAggregate>;
  businessRole: Maybe<BusinessRole>;
  businessRoles: Maybe<Array<BusinessRole>>;
  businessRolesAggregate: Maybe<BusinessRoleAggregate>;
  calculateQuote: Maybe<Quote>;
  candidate: Maybe<Candidate>;
  candidateIngestionPolicies: Maybe<Array<CandidateIngestionPolicy>>;
  candidateIngestionPoliciesAggregate: Maybe<CandidateIngestionPolicyAggregate>;
  candidateIngestionPolicy: Maybe<CandidateIngestionPolicy>;
  candidates: Maybe<Array<Candidate>>;
  candidatesAggregate: Maybe<CandidateAggregate>;
  client: Maybe<Client>;
  clients: Maybe<Array<Client>>;
  clientsAggregate: Maybe<ClientAggregate>;
  configuredLinkedAction: Maybe<ConfiguredLinkedAction>;
  configuredLinkedActions: Maybe<Array<ConfiguredLinkedAction>>;
  configuredLinkedActionsAggregate: Maybe<ConfiguredLinkedActionAggregate>;
  correspondence: Maybe<Array<Correspondence>>;
  correspondenceAggregate: Maybe<CorrespondenceAggregate>;
  correspondenceRecord: Maybe<Correspondence>;
  costing: Maybe<Costing>;
  costingLine: Maybe<CostingLine>;
  costingLineTemplate: Maybe<CostingLineTemplate>;
  costingLineTemplates: Maybe<Array<CostingLineTemplate>>;
  costingLineTemplatesAggregate: Maybe<CostingLineTemplateAggregate>;
  costingLines: Maybe<Array<CostingLine>>;
  costingLinesAggregate: Maybe<CostingLineAggregate>;
  costingRevision: Maybe<CostingRevision>;
  costingRevisions: Maybe<Array<CostingRevision>>;
  costingRevisionsAggregate: Maybe<CostingRevisionAggregate>;
  costingTemplate: Maybe<CostingTemplate>;
  costingTemplateExpression: Maybe<CostingTemplateExpression>;
  costingTemplateExpressions: Maybe<Array<CostingTemplateExpression>>;
  costingTemplateExpressionsAggregate: Maybe<CostingTemplateExpressionAggregate>;
  costingTemplateRevision: Maybe<CostingTemplateRevision>;
  costingTemplateRevisions: Maybe<Array<CostingTemplateRevision>>;
  costingTemplateRevisionsAggregate: Maybe<CostingTemplateRevisionAggregate>;
  costingTemplates: Maybe<Array<CostingTemplate>>;
  costingTemplatesAggregate: Maybe<CostingTemplateAggregate>;
  costings: Maybe<Array<Costing>>;
  costingsAggregate: Maybe<CostingAggregate>;
  currentUser: Maybe<User>;
  currentUserNotifications: Maybe<Array<UserNotification>>;
  customData: Maybe<Array<CustomData>>;
  customDataAggregate: Maybe<CustomDataAggregate>;
  customDataById: Maybe<CustomData>;
  customTemplate: Maybe<CustomTemplate>;
  customTemplates: Maybe<Array<CustomTemplate>>;
  customTemplatesAggregate: Maybe<CustomTemplateAggregate>;
  days: Maybe<Array<Day>>;
  defaultFolder: Maybe<DefaultFolder>;
  defaultFolders: Maybe<Array<DefaultFolder>>;
  defaultFoldersAggregate: Maybe<DefaultFolderAggregate>;
  deliveryAddress: Maybe<DeliveryAddress>;
  deliveryAddresses: Maybe<Array<DeliveryAddress>>;
  deliveryAddressesAggregate: Maybe<DeliveryAddressAggregate>;
  documentNavigationRecords: Maybe<Array<RecordNavigationRecord>>;
  documentPreview: Maybe<DocumentPreview>;
  documentTemplate: Maybe<DocumentTemplate>;
  documentTemplates: Maybe<Array<DocumentTemplate>>;
  documentTemplatesAggregate: Maybe<DocumentTemplateAggregate>;
  domainEventTypes: Maybe<Array<DomainEventType>>;
  effectiveUserPermissions: Maybe<Array<EffectivePermission>>;
  email: Maybe<Email>;
  emails: Maybe<Array<Email>>;
  emailsAggregate: Maybe<EmailAggregate>;
  eventDescriptionPreview: Maybe<Scalars['String']['output']>;
  externalStorageConnection: Maybe<ExternalStorageConnection>;
  externalStorageConnections: Maybe<Array<ExternalStorageConnection>>;
  externalStorageConnectionsAggregate: Maybe<ExternalStorageConnectionAggregate>;
  externalStorageItem: Maybe<ExternalStorageItem>;
  /**
   * aggregateQuery=externalStorageItemsAggregate
   * grouping=true
   */
  externalStorageItems: Maybe<Array<ExternalStorageItem>>;
  externalStorageItemsAggregate: Maybe<ResourceAggregate>;
  externalStorageResourceMapping: Maybe<ExternalStorageResourceMapping>;
  externalStorageResourceMappings: Maybe<Array<ExternalStorageResourceMapping>>;
  externalStorageResourceMappingsAggregate: Maybe<ExternalStorageResourceMappingAggregate>;
  file: Maybe<File>;
  fileAggregates: Maybe<FileAggregate>;
  /**
   * TODO: Return an operation along with the file info eg "NEW" or "DELETED"
   *  so that our frontend can show pending changes to the user.
   * Would therefore need to return a slightly modified ExternalStorageItem.
   * Returns a list of files in targetPath as if changeset was applied.
   * Only supports native (Google Cloud) storage, no resource mappings.
   * $path must be of format {resourceType}/{resourceId}/{restOfPath...}
   */
  fileChangeset: Maybe<Array<ExternalStorageItem>>;
  files: Maybe<Array<File>>;
  formNavigationRecords: Maybe<Array<RecordNavigationRecord>>;
  googleDownloadFilesRequestUrl: Maybe<Scalars['String']['output']>;
  googleUploadRequestUrl: Maybe<Scalars['String']['output']>;
  graphqlQueryGen: Maybe<Scalars['String']['output']>;
  groupTemplate: Maybe<GroupTemplate>;
  groupTemplates: Maybe<Array<GroupTemplate>>;
  groupTemplatesAggregate: Maybe<GroupTemplateAggregate>;
  housingCompanies: Maybe<Array<HousingCompany>>;
  housingCompaniesAggregate: Maybe<HousingCompanyAggregate>;
  housingCompany: Maybe<HousingCompany>;
  isPermitted: Maybe<Scalars['Boolean']['output']>;
  issue: Maybe<Issue>;
  issueCompletionStatuses: Maybe<Array<IssueCompletionStatus>>;
  issues: Maybe<Array<Issue>>;
  issuesAggregate: Maybe<IssueAggregate>;
  job: Maybe<Job>;
  jobComponent: Maybe<JobComponent>;
  jobComponents: Maybe<Array<JobComponent>>;
  jobComponentsAggregate: Maybe<JobComponentAggregate>;
  jobReport: Maybe<Array<JobReportRow>>;
  jobStatuses: Maybe<Array<JobStatus>>;
  jobs: Maybe<Array<Job>>;
  jobsAggregate: Maybe<JobAggregate>;
  lead: Maybe<Lead>;
  leadCandidateGen: Maybe<Scalars['String']['output']>;
  leadProjectTypes: Maybe<Array<LeadProjectType>>;
  leadReport: Maybe<Array<LeadReportRow>>;
  leadSources: Maybe<Array<LeadSource>>;
  leadStatuses: Maybe<Array<LeadStatus>>;
  leads: Maybe<Array<Lead>>;
  leadsAggregate: Maybe<LeadAggregate>;
  legacyUserRole: Maybe<UserRole>;
  legacyUserRoles: Maybe<Array<UserRole>>;
  legacyUserRolesAggregate: Maybe<UserRoleAggregate>;
  lineItem: Maybe<LineItem>;
  lineItemMasterWorkflow: Maybe<LineItemMasterWorkflow>;
  lineItemMasterWorkflows: Maybe<Array<LineItemMasterWorkflow>>;
  lineItemMasterWorkflowsAggregate: Maybe<LineItemMasterWorkflowAggregate>;
  lineItemReport: Maybe<Array<LineItemReportRow>>;
  lineItems: Maybe<Array<LineItem>>;
  lineItemsAggregate: Maybe<LineItemAggregate>;
  linkedAction: Maybe<LinkedAction>;
  linkedActions: Maybe<Array<LinkedAction>>;
  linkedActionsAggregate: Maybe<LinkedActionAggregate>;
  lostReason: Maybe<LostReason>;
  lostReasons: Maybe<Array<LostReason>>;
  lostReasonsAggregate: Maybe<LostReasonAggregate>;
  months: Maybe<Array<Month>>;
  notificationTemplate: Maybe<NotificationTemplate>;
  notificationTemplates: Maybe<Array<NotificationTemplate>>;
  notificationTemplatesAggregate: Maybe<NotificationTemplateAggregate>;
  nzRegions: Maybe<Array<NzRegion>>;
  panel: Maybe<Panel>;
  panels: Maybe<Array<Panel>>;
  panelsAggregate: Maybe<PanelAggregate>;
  partType: Maybe<PartType>;
  partTypes: Maybe<Array<PartType>>;
  partTypesAggregate: Maybe<PartTypeAggregate>;
  people: Maybe<Array<Person>>;
  peopleAggregate: Maybe<PersonAggregate>;
  permissions: Maybe<Array<Permission>>;
  permitted: Maybe<Scalars['Boolean']['output']>;
  person: Maybe<Person>;
  personAssignedWork: Maybe<Array<PersonAssignedWork>>;
  personAssignedWorkAggregate: Maybe<PersonAssignedWorkAggregate>;
  personAssignedWorkById: Maybe<PersonAssignedWork>;
  personBusinessRole: Maybe<PersonBusinessRole>;
  personBusinessRoles: Maybe<Array<PersonBusinessRole>>;
  personBusinessRolesAggregate: Maybe<PersonBusinessRoleAggregate>;
  personStatuses: Maybe<Array<PersonStatus>>;
  processAsset: Maybe<ProcessAsset>;
  processAssets: Maybe<Array<ProcessAsset>>;
  processAssetsAggregate: Maybe<ProcessAssetAggregate>;
  processAssignment: Maybe<ProcessAssignment>;
  processAssignments: Maybe<Array<ProcessAssignment>>;
  processAssignmentsAggregate: Maybe<ProcessAssignmentAggregate>;
  processInstance: Maybe<ProcessInstance>;
  processInstances: Maybe<Array<ProcessInstance>>;
  processInstancesAggregate: Maybe<ProcessInstanceAggregate>;
  processTemplate: Maybe<ProcessTemplate>;
  processTemplates: Maybe<Array<ProcessTemplate>>;
  processTemplatesAggregate: Maybe<ProcessTemplateAggregate>;
  processTimer: Maybe<ProcessTimer>;
  processTimerItem: Maybe<ProcessTimerItem>;
  processTimerItems: Maybe<Array<ProcessTimerItem>>;
  processTimerItemsAggregate: Maybe<ProcessTimerItemAggregate>;
  processType: Maybe<ProcessType>;
  processTypeNote: Maybe<ProcessTypeNote>;
  processTypeNotes: Maybe<Array<ProcessTypeNote>>;
  processTypeNotesAggregate: Maybe<ProcessTypeNoteAggregate>;
  processTypeRole: Maybe<ProcessTypeRole>;
  processTypeRoles: Maybe<Array<ProcessTypeRole>>;
  processTypeRolesAggregate: Maybe<ProcessTypeRoleAggregate>;
  processTypes: Maybe<Array<ProcessType>>;
  processTypesAggregate: Maybe<ProcessTypeAggregate>;
  product: Maybe<Product>;
  productCategories: Maybe<Array<ProductCategory>>;
  productCategoriesAggregate: Maybe<ProductCategoryAggregate>;
  productCategory: Maybe<ProductCategory>;
  productCategoryGroup: Maybe<ProductCategoryGroup>;
  productCategoryGroups: Maybe<Array<ProductCategoryGroup>>;
  productCategoryGroupsAggregate: Maybe<ProductCategoryGroupAggregate>;
  productPrice: Maybe<ProductPrice>;
  productPrices: Maybe<Array<ProductPrice>>;
  productPricesAggregate: Maybe<ProductPriceAggregate>;
  products: Maybe<Array<Product>>;
  productsAggregate: Maybe<ProductAggregate>;
  project: Maybe<Project>;
  projects: Maybe<Array<Project>>;
  projectsAggregate: Maybe<ProjectAggregate>;
  purchaseOrder: Maybe<PurchaseOrder>;
  purchaseOrderEvents: Maybe<Array<PurchaseOrderEvent>>;
  purchaseOrderLine: Maybe<PurchaseOrderLine>;
  purchaseOrderLines: Maybe<Array<PurchaseOrderLine>>;
  purchaseOrderLinesAggregate: Maybe<PurchaseOrderLineAggregate>;
  purchaseOrderPreview: Maybe<PurchaseOrderPreview>;
  purchaseOrderReceipt: Maybe<PurchaseOrderReceipt>;
  purchaseOrderReceiptLine: Maybe<PurchaseOrderReceiptLine>;
  purchaseOrderReceiptLines: Maybe<Array<PurchaseOrderReceiptLine>>;
  purchaseOrderReceiptLinesAggregate: Maybe<PurchaseOrderReceiptLineAggregate>;
  purchaseOrderReceipts: Maybe<Array<PurchaseOrderReceipt>>;
  purchaseOrderReceiptsAggregate: Maybe<PurchaseOrderReceiptAggregate>;
  purchaseOrderReview: Maybe<PurchaseOrderReview>;
  purchaseOrderReviews: Maybe<Array<PurchaseOrderReview>>;
  purchaseOrderReviewsAggregate: Maybe<PurchaseOrderReviewAggregate>;
  purchaseOrderStatuses: Maybe<Array<PurchaseOrderStatus>>;
  purchaseOrders: Maybe<Array<PurchaseOrder>>;
  purchaseOrdersAggregate: Maybe<PurchaseOrderAggregate>;
  quote: Maybe<Quote>;
  quoteLine: Maybe<QuoteLine>;
  quoteLineTemplate: Maybe<QuoteLineTemplate>;
  quoteLineTemplates: Maybe<Array<QuoteLineTemplate>>;
  quoteLineTemplatesAggregate: Maybe<QuoteLineTemplateAggregate>;
  quoteLines: Maybe<Array<QuoteLine>>;
  quoteLinesAggregate: Maybe<QuoteLineAggregate>;
  quotePreview: Maybe<QuotePreview>;
  quoteRevision: Maybe<QuoteRevision>;
  quoteRevisions: Maybe<Array<QuoteRevision>>;
  quoteRevisionsAggregate: Maybe<QuoteRevisionAggregate>;
  quoteStatuses: Maybe<Array<QuoteStatus>>;
  quoteTemplate: Maybe<QuoteTemplate>;
  quoteTemplateExpression: Maybe<QuoteTemplateExpression>;
  quoteTemplateExpressions: Maybe<Array<QuoteTemplateExpression>>;
  quoteTemplateExpressionsAggregate: Maybe<QuoteTemplateExpressionAggregate>;
  quoteTemplatePreview: Maybe<QuoteTemplatePreview>;
  quoteTemplateRevision: Maybe<QuoteTemplateRevision>;
  quoteTemplateRevisions: Maybe<Array<QuoteTemplateRevision>>;
  quoteTemplateRevisionsAggregate: Maybe<QuoteTemplateRevisionAggregate>;
  quoteTemplates: Maybe<Array<QuoteTemplate>>;
  quoteTemplatesAggregate: Maybe<QuoteTemplateAggregate>;
  quotes: Maybe<Array<Quote>>;
  quotesAggregate: Maybe<QuoteAggregate>;
  recordDocuments: Maybe<Array<Document>>;
  recordFile: Maybe<RecordFile>;
  recordFileAggregates: Maybe<RecordFileAggregate>;
  recordFiles: Maybe<Array<RecordFile>>;
  recordFolder: Maybe<RecordFolder>;
  recordFolders: Maybe<Array<RecordFolder>>;
  recordFoldersAggregate: Maybe<RecordFolderAggregate>;
  recordScreen: Maybe<RecordScreen>;
  recordScreens: Maybe<Array<RecordScreen>>;
  recordScreensAggregate: Maybe<RecordScreenAggregate>;
  recordTag: Maybe<RecordTag>;
  recordTags: Maybe<Array<RecordTag>>;
  recordTagsAggregate: Maybe<RecordTagAggregate>;
  recordTypes: Maybe<Array<RecordType>>;
  region: Maybe<Region>;
  regions: Maybe<Array<Region>>;
  regionsAggregate: Maybe<RegionAggregate>;
  resolvedRecordScreen: Maybe<Screen>;
  role: Maybe<Role>;
  roleInheritance: Maybe<RoleInheritance>;
  roleInheritances: Maybe<Array<RoleInheritance>>;
  roleInheritancesAggregate: Maybe<RoleInheritanceAggregate>;
  rolePermission: Maybe<RolePermission>;
  rolePermissions: Maybe<Array<RolePermission>>;
  rolePermissionsAggregate: Maybe<RolePermissionAggregate>;
  roleUser: Maybe<RoleUser>;
  roleUsers: Maybe<Array<RoleUser>>;
  roleUsersAggregate: Maybe<RoleUserAggregate>;
  roles: Maybe<Array<Role>>;
  rolesAggregate: Maybe<RoleAggregate>;
  saleType: Maybe<SaleType>;
  saleTypes: Maybe<Array<SaleType>>;
  saleTypesAggregate: Maybe<SaleTypeAggregate>;
  salesOrder: Maybe<SalesOrder>;
  salesOrderLine: Maybe<SalesOrderLine>;
  salesOrderLines: Maybe<Array<SalesOrderLine>>;
  salesOrderLinesAggregate: Maybe<ResourceAggregate>;
  salesOrders: Maybe<Array<SalesOrder>>;
  salesOrdersAggregate: Maybe<SalesOrderAggregate>;
  schema: Maybe<Schema>;
  schemaTypes: Maybe<Array<SchemaType>>;
  schemaVersion: Maybe<SchemaVersion>;
  schemaVersions: Maybe<Array<SchemaVersion>>;
  schemaVersionsAggregate: Maybe<SchemaVersionAggregate>;
  schemas: Maybe<Array<Schema>>;
  schemasAggregate: Maybe<SchemaAggregate>;
  screen: Maybe<Screen>;
  screenAssignments: Maybe<Array<RecordScreen>>;
  screens: Maybe<Array<Screen>>;
  screensAggregate: Maybe<ScreenAggregate>;
  specification: Maybe<Specification>;
  specificationLookupOptions: Maybe<Array<SpecificationLookupOption>>;
  stock: Maybe<Array<Stock>>;
  stockAggregate: Maybe<StockAggregate>;
  stockRecord: Maybe<Stock>;
  stockTransaction: Maybe<StockTransaction>;
  stockTransactionLine: Maybe<StockTransactionLine>;
  stockTransactionLines: Maybe<Array<StockTransactionLine>>;
  stockTransactionLinesAggregate: Maybe<StockTransactionLineAggregate>;
  stockTransactions: Maybe<Array<StockTransaction>>;
  stockTransactionsAggregate: Maybe<StockTransactionAggregate>;
  subscriptionReal: Maybe<SubscriptionReal>;
  subscriptions: Maybe<Array<SubscriptionReal>>;
  subscriptionsAggregate: Maybe<SubscriptionRealAggregate>;
  supplier: Maybe<Supplier>;
  supplierCategories: Maybe<Array<SupplierCategory>>;
  supplierCategoriesAggregate: Maybe<SupplierCategoryAggregate>;
  supplierCategory: Maybe<SupplierCategory>;
  supplierQuote: Maybe<SupplierQuote>;
  supplierQuoteLine: Maybe<SupplierQuoteLine>;
  supplierQuoteLines: Maybe<Array<SupplierQuoteLine>>;
  supplierQuoteLinesAggregate: Maybe<ResourceAggregate>;
  supplierQuoteRequest: Maybe<SupplierQuoteRequest>;
  supplierQuoteRequestLine: Maybe<SupplierQuoteRequestLine>;
  supplierQuoteRequestLines: Maybe<Array<SupplierQuoteRequestLine>>;
  supplierQuoteRequestLinesAggregate: Maybe<SupplierQuoteRequestLineAggregate>;
  supplierQuoteRequests: Maybe<Array<SupplierQuoteRequest>>;
  supplierQuoteRequestsAggregate: Maybe<SupplierQuoteRequestAggregate>;
  supplierQuotes: Maybe<Array<SupplierQuote>>;
  supplierQuotesAggregate: Maybe<SupplierQuoteAggregate>;
  suppliers: Maybe<Array<Supplier>>;
  suppliersAggregate: Maybe<SupplierAggregate>;
  systemSettings: Maybe<DataStoreRecord>;
  tag: Maybe<Tag>;
  tags: Maybe<Array<Tag>>;
  tagsAggregate: Maybe<TagAggregate>;
  timerTransaction: Maybe<TimerTransaction>;
  timerTransactions: Maybe<Array<TimerTransaction>>;
  timerTransactionsAggregate: Maybe<TimerTransactionAggregate>;
  timers: Maybe<Array<ProcessTimer>>;
  timersAggregate: Maybe<ProcessTimerAggregate>;
  uploadRequestUrl: Maybe<UploadRequestUrl>;
  user: Maybe<User>;
  userIdentities: Maybe<Array<UserIdentity>>;
  userIdentitiesAggregate: Maybe<UserIdentityAggregate>;
  userIdentity: Maybe<UserIdentity>;
  userPermission: Maybe<UserPermission>;
  userPermissions: Maybe<Array<UserPermission>>;
  userPermissionsAggregate: Maybe<UserPermissionAggregate>;
  users: Maybe<Array<User>>;
  usersAggregate: Maybe<UserAggregate>;
  warehouse: Maybe<Warehouse>;
  warehouses: Maybe<Array<Warehouse>>;
  warehousesAggregate: Maybe<WarehouseAggregate>;
  webhook: Maybe<Webhook>;
  webhooks: Maybe<Array<Webhook>>;
  webhooksAggregate: Maybe<WebhookAggregate>;
  weeks: Maybe<Array<Week>>;
  workflowNote: Maybe<WorkflowNote>;
  workflowNotes: Maybe<Array<WorkflowNote>>;
  workflowNotesAggregate: Maybe<WorkflowNoteAggregate>;
  workflowTemplate: Maybe<WorkflowTemplate>;
  workflowTemplates: Maybe<Array<WorkflowTemplate>>;
  workflowTemplatesAggregate: Maybe<WorkflowTemplateAggregate>;
  workflowType: Maybe<WorkflowType>;
  workflowTypes: Maybe<Array<WorkflowType>>;
  workflowTypesAggregate: Maybe<WorkflowTypeAggregate>;
};


export type QueryActAsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryActAsUsersArgs = {
  filter?: InputMaybe<ActAsUserFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryActAsUsersAggregateArgs = {
  filter?: InputMaybe<ActAsUserFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryAssetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAssetsArgs = {
  filter?: InputMaybe<AssetFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryAssetsAggregateArgs = {
  filter?: InputMaybe<AssetFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryAssignedPermissionsArgs = {
  assignedId: Scalars['ID']['input'];
  assignedType: Scalars['String']['input'];
  filter?: InputMaybe<AssignedPermissionFilterInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryAsyncTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAsyncTasksArgs = {
  filter?: InputMaybe<AsyncTaskFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryAsyncTasksAggregateArgs = {
  filter?: InputMaybe<AsyncTaskFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryAttachmentTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAttachmentTemplatesArgs = {
  filter?: InputMaybe<AttachmentTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryAttachmentTemplatesAggregateArgs = {
  filter?: InputMaybe<AttachmentTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryAuditLogArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAuditLogsArgs = {
  filter?: InputMaybe<AuditLogFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryAuditLogsAggregateArgs = {
  filter?: InputMaybe<AuditLogFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryBatchArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBatchScheduleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBatchScheduleReportArgs = {
  groupBy: Array<BatchScheduleReportGroupByInput>;
};


export type QueryBatchSchedulesArgs = {
  filter?: InputMaybe<BatchScheduleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryBatchSchedulesAggregateArgs = {
  filter?: InputMaybe<BatchScheduleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryBatchesArgs = {
  filter?: InputMaybe<BatchFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryBatchesAggregateArgs = {
  filter?: InputMaybe<BatchFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryBillOfMaterialsImportArgs = {
  jobId: Scalars['ID']['input'];
  loader: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};


export type QueryBranchArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBranchesArgs = {
  filter?: InputMaybe<BranchFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryBranchesAggregateArgs = {
  filter?: InputMaybe<BranchFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryBuildTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBuildTypesArgs = {
  filter?: InputMaybe<BuildTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryBuildTypesAggregateArgs = {
  filter?: InputMaybe<BuildTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryBuilderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBuildersArgs = {
  filter?: InputMaybe<BuilderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryBuildersAggregateArgs = {
  filter?: InputMaybe<BuilderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryBusinessRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBusinessRolesArgs = {
  filter?: InputMaybe<BusinessRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryBusinessRolesAggregateArgs = {
  filter?: InputMaybe<BusinessRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCalculateQuoteArgs = {
  input: CalculateQuoteInput;
};


export type QueryCandidateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCandidateIngestionPoliciesArgs = {
  filter?: InputMaybe<CandidateIngestionPolicyFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCandidateIngestionPoliciesAggregateArgs = {
  filter?: InputMaybe<CandidateIngestionPolicyFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCandidateIngestionPolicyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCandidatesArgs = {
  filter?: InputMaybe<CandidateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCandidatesAggregateArgs = {
  filter?: InputMaybe<CandidateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryClientArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientsArgs = {
  filter?: InputMaybe<ClientFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryClientsAggregateArgs = {
  filter?: InputMaybe<ClientFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryConfiguredLinkedActionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryConfiguredLinkedActionsArgs = {
  filter?: InputMaybe<ConfiguredLinkedActionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryConfiguredLinkedActionsAggregateArgs = {
  filter?: InputMaybe<ConfiguredLinkedActionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCorrespondenceArgs = {
  filter?: InputMaybe<CorrespondenceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCorrespondenceAggregateArgs = {
  filter?: InputMaybe<CorrespondenceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCorrespondenceRecordArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingLineTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingLineTemplatesArgs = {
  filter?: InputMaybe<CostingLineTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCostingLineTemplatesAggregateArgs = {
  filter?: InputMaybe<CostingLineTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCostingLinesArgs = {
  filter?: InputMaybe<CostingLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCostingLinesAggregateArgs = {
  filter?: InputMaybe<CostingLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCostingRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingRevisionsArgs = {
  filter?: InputMaybe<CostingRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCostingRevisionsAggregateArgs = {
  filter?: InputMaybe<CostingRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCostingTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingTemplateExpressionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingTemplateExpressionsArgs = {
  filter?: InputMaybe<CostingTemplateExpressionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCostingTemplateExpressionsAggregateArgs = {
  filter?: InputMaybe<CostingTemplateExpressionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCostingTemplateRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCostingTemplateRevisionsArgs = {
  filter?: InputMaybe<CostingTemplateRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCostingTemplateRevisionsAggregateArgs = {
  filter?: InputMaybe<CostingTemplateRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCostingTemplatesArgs = {
  filter?: InputMaybe<CostingTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCostingTemplatesAggregateArgs = {
  filter?: InputMaybe<CostingTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCostingsArgs = {
  filter?: InputMaybe<CostingFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCostingsAggregateArgs = {
  filter?: InputMaybe<CostingFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryCustomDataByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomTemplatesArgs = {
  filter?: InputMaybe<CustomTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryCustomTemplatesAggregateArgs = {
  filter?: InputMaybe<CustomTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryDaysArgs = {
  filter?: InputMaybe<DateTimeFilterInput>;
};


export type QueryDefaultFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDefaultFoldersArgs = {
  filter?: InputMaybe<DefaultFolderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryDefaultFoldersAggregateArgs = {
  filter?: InputMaybe<DefaultFolderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryDeliveryAddressArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeliveryAddressesArgs = {
  filter?: InputMaybe<DeliveryAddressFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryDeliveryAddressesAggregateArgs = {
  filter?: InputMaybe<DeliveryAddressFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryDocumentNavigationRecordsArgs = {
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};


export type QueryDocumentPreviewArgs = {
  input: GetDocumentPreviewInput;
};


export type QueryDocumentTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDocumentTemplatesArgs = {
  filter?: InputMaybe<DocumentTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryDocumentTemplatesAggregateArgs = {
  filter?: InputMaybe<DocumentTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryEffectiveUserPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryEmailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailsArgs = {
  filter?: InputMaybe<EmailFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryEmailsAggregateArgs = {
  filter?: InputMaybe<EmailFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryEventDescriptionPreviewArgs = {
  eventName: Scalars['String']['input'];
};


export type QueryExternalStorageConnectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExternalStorageConnectionsArgs = {
  filter?: InputMaybe<ExternalStorageConnectionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryExternalStorageConnectionsAggregateArgs = {
  filter?: InputMaybe<ExternalStorageConnectionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryExternalStorageItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryExternalStorageItemsArgs = {
  filter?: InputMaybe<ExternalStorageItemFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryExternalStorageItemsAggregateArgs = {
  filter?: InputMaybe<ExternalStorageItemFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalStorageResourceMappingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExternalStorageResourceMappingsArgs = {
  filter?: InputMaybe<ExternalStorageResourceMappingFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryExternalStorageResourceMappingsAggregateArgs = {
  filter?: InputMaybe<ExternalStorageResourceMappingFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFileAggregatesArgs = {
  filter?: InputMaybe<FileFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryFileChangesetArgs = {
  filter?: InputMaybe<ExternalStorageItemFilterInput>;
  id: Scalars['ID']['input'];
  targetPath: Scalars['String']['input'];
};


export type QueryFilesArgs = {
  filter?: InputMaybe<FileFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryFormNavigationRecordsArgs = {
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};


export type QueryGoogleDownloadFilesRequestUrlArgs = {
  fileHashes: Array<Scalars['String']['input']>;
  firebaseTenantId: Scalars['String']['input'];
  firebaseUserId: Scalars['String']['input'];
};


export type QueryGoogleUploadRequestUrlArgs = {
  object: Scalars['String']['input'];
};


export type QueryGraphqlQueryGenArgs = {
  input: AiGenInput;
};


export type QueryGroupTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGroupTemplatesArgs = {
  filter?: InputMaybe<GroupTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryGroupTemplatesAggregateArgs = {
  filter?: InputMaybe<GroupTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryHousingCompaniesArgs = {
  filter?: InputMaybe<HousingCompanyFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryHousingCompaniesAggregateArgs = {
  filter?: InputMaybe<HousingCompanyFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryHousingCompanyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIsPermittedArgs = {
  permissions: Array<PermissionCheckInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIssueArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIssueCompletionStatusesArgs = {
  filter?: InputMaybe<IssueFilterInput>;
};


export type QueryIssuesArgs = {
  filter?: InputMaybe<IssueFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryIssuesAggregateArgs = {
  filter?: InputMaybe<IssueFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJobComponentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJobComponentsArgs = {
  filter?: InputMaybe<JobComponentFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryJobComponentsAggregateArgs = {
  filter?: InputMaybe<JobComponentFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryJobReportArgs = {
  groupBy: Array<JobReportGroupByInput>;
};


export type QueryJobStatusesArgs = {
  filter?: InputMaybe<JobStatusFilterInput>;
};


export type QueryJobsArgs = {
  filter?: InputMaybe<JobFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryJobsAggregateArgs = {
  filter?: InputMaybe<JobFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryLeadArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLeadCandidateGenArgs = {
  input: AiGenInput;
};


export type QueryLeadProjectTypesArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};


export type QueryLeadReportArgs = {
  groupBy: Array<LeadReportGroupByInput>;
};


export type QueryLeadSourcesArgs = {
  filter?: InputMaybe<LeadSourceFilterInput>;
};


export type QueryLeadStatusesArgs = {
  filter?: InputMaybe<LeadStatusFilterInput>;
};


export type QueryLeadsArgs = {
  filter?: InputMaybe<LeadFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryLegacyUserRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLegacyUserRolesArgs = {
  filter?: InputMaybe<UserRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryLegacyUserRolesAggregateArgs = {
  filter?: InputMaybe<UserRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryLineItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLineItemMasterWorkflowArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLineItemMasterWorkflowsArgs = {
  filter?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryLineItemMasterWorkflowsAggregateArgs = {
  filter?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryLineItemReportArgs = {
  groupBy: Array<LineItemReportGroupByInput>;
};


export type QueryLineItemsArgs = {
  filter?: InputMaybe<LineItemFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryLineItemsAggregateArgs = {
  filter?: InputMaybe<LineItemFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryLinkedActionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLinkedActionsArgs = {
  filter?: InputMaybe<LinkedActionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryLinkedActionsAggregateArgs = {
  filter?: InputMaybe<LinkedActionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryLostReasonArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLostReasonsArgs = {
  filter?: InputMaybe<LostReasonFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryLostReasonsAggregateArgs = {
  filter?: InputMaybe<LostReasonFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryMonthsArgs = {
  filter?: InputMaybe<DateTimeFilterInput>;
};


export type QueryNotificationTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNotificationTemplatesArgs = {
  filter?: InputMaybe<NotificationTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryNotificationTemplatesAggregateArgs = {
  filter?: InputMaybe<NotificationTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryNzRegionsArgs = {
  filter?: InputMaybe<DateTimeFilterInput>;
};


export type QueryPanelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPanelsArgs = {
  filter?: InputMaybe<PanelFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPanelsAggregateArgs = {
  filter?: InputMaybe<PanelFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPartTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPartTypesArgs = {
  filter?: InputMaybe<PartTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPartTypesAggregateArgs = {
  filter?: InputMaybe<PartTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPeopleArgs = {
  filter?: InputMaybe<PersonFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPeopleAggregateArgs = {
  filter?: InputMaybe<PersonFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPermissionsArgs = {
  filter?: InputMaybe<PermissionFilterInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPermittedArgs = {
  permission: Scalars['String']['input'];
};


export type QueryPersonArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonAssignedWorkArgs = {
  filter?: InputMaybe<PersonAssignedWorkFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPersonAssignedWorkAggregateArgs = {
  filter?: InputMaybe<PersonAssignedWorkFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPersonAssignedWorkByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonBusinessRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonBusinessRolesArgs = {
  filter?: InputMaybe<PersonBusinessRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPersonBusinessRolesAggregateArgs = {
  filter?: InputMaybe<PersonBusinessRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessAssetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessAssetsArgs = {
  filter?: InputMaybe<ProcessAssetFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessAssetsAggregateArgs = {
  filter?: InputMaybe<ProcessAssetFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessAssignmentsArgs = {
  filter?: InputMaybe<ProcessAssignmentFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessAssignmentsAggregateArgs = {
  filter?: InputMaybe<ProcessAssignmentFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessInstanceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessInstancesArgs = {
  filter?: InputMaybe<ProcessInstanceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessInstancesAggregateArgs = {
  filter?: InputMaybe<ProcessInstanceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessTemplatesArgs = {
  filter?: InputMaybe<ProcessTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessTemplatesAggregateArgs = {
  filter?: InputMaybe<ProcessTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessTimerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessTimerItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessTimerItemsArgs = {
  filter?: InputMaybe<ProcessTimerItemFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessTimerItemsAggregateArgs = {
  filter?: InputMaybe<ProcessTimerItemFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessTypeNoteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessTypeNotesArgs = {
  filter?: InputMaybe<ProcessTypeNoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessTypeNotesAggregateArgs = {
  filter?: InputMaybe<ProcessTypeNoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessTypeRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProcessTypeRolesArgs = {
  filter?: InputMaybe<ProcessTypeRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessTypeRolesAggregateArgs = {
  filter?: InputMaybe<ProcessTypeRoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProcessTypesArgs = {
  filter?: InputMaybe<ProcessTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProcessTypesAggregateArgs = {
  filter?: InputMaybe<ProcessTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProductCategoriesAggregateArgs = {
  filter?: InputMaybe<ProductCategoryFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProductCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductCategoryGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductCategoryGroupsArgs = {
  filter?: InputMaybe<ProductCategoryGroupFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProductCategoryGroupsAggregateArgs = {
  filter?: InputMaybe<ProductCategoryGroupFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProductPriceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductPricesArgs = {
  filter?: InputMaybe<ProductPriceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProductPricesAggregateArgs = {
  filter?: InputMaybe<ProductPriceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProductsAggregateArgs = {
  filter?: InputMaybe<ProductFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectsArgs = {
  filter?: InputMaybe<ProjectFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryProjectsAggregateArgs = {
  filter?: InputMaybe<ProjectFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPurchaseOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPurchaseOrderEventsArgs = {
  filter?: InputMaybe<PurchaseOrderEventFilterInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPurchaseOrderLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPurchaseOrderLinesArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPurchaseOrderLinesAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPurchaseOrderPreviewArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type QueryPurchaseOrderReceiptArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPurchaseOrderReceiptLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPurchaseOrderReceiptLinesArgs = {
  filter?: InputMaybe<PurchaseOrderReceiptLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPurchaseOrderReceiptLinesAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderReceiptLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPurchaseOrderReceiptsArgs = {
  filter?: InputMaybe<PurchaseOrderReceiptFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPurchaseOrderReceiptsAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderReceiptFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPurchaseOrderReviewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPurchaseOrderReviewsArgs = {
  filter?: InputMaybe<PurchaseOrderReviewFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPurchaseOrderReviewsAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderReviewFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryPurchaseOrderStatusesArgs = {
  filter?: InputMaybe<PurchaseOrderStatusFilterInput>;
};


export type QueryPurchaseOrdersArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryPurchaseOrdersAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryQuoteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuoteLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuoteLineTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuoteLineTemplatesArgs = {
  filter?: InputMaybe<QuoteLineTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryQuoteLineTemplatesAggregateArgs = {
  filter?: InputMaybe<QuoteLineTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryQuoteLinesArgs = {
  filter?: InputMaybe<QuoteLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryQuoteLinesAggregateArgs = {
  filter?: InputMaybe<QuoteLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryQuotePreviewArgs = {
  quote: CreateQuoteInput;
};


export type QueryQuoteRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuoteRevisionsArgs = {
  filter?: InputMaybe<QuoteRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryQuoteRevisionsAggregateArgs = {
  filter?: InputMaybe<QuoteRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryQuoteStatusesArgs = {
  filter?: InputMaybe<QuoteFilterInput>;
};


export type QueryQuoteTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuoteTemplateExpressionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuoteTemplateExpressionsArgs = {
  filter?: InputMaybe<QuoteTemplateExpressionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryQuoteTemplateExpressionsAggregateArgs = {
  filter?: InputMaybe<QuoteTemplateExpressionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryQuoteTemplatePreviewArgs = {
  costings: Scalars['String']['input'];
  twigTemplate: Scalars['String']['input'];
};


export type QueryQuoteTemplateRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuoteTemplateRevisionsArgs = {
  filter?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryQuoteTemplateRevisionsAggregateArgs = {
  filter?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryQuoteTemplatesArgs = {
  filter?: InputMaybe<QuoteTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryQuoteTemplatesAggregateArgs = {
  filter?: InputMaybe<QuoteTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryQuotesArgs = {
  filter?: InputMaybe<QuoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryQuotesAggregateArgs = {
  filter?: InputMaybe<QuoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRecordDocumentsArgs = {
  documentTemplateId?: InputMaybe<Scalars['ID']['input']>;
  recordId: Scalars['ID']['input'];
  recordType: Scalars['String']['input'];
};


export type QueryRecordFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecordFileAggregatesArgs = {
  filter?: InputMaybe<RecordFileFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRecordFilesArgs = {
  filter?: InputMaybe<RecordFileFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRecordFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecordFoldersArgs = {
  filter?: InputMaybe<RecordFolderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRecordFoldersAggregateArgs = {
  filter?: InputMaybe<RecordFolderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRecordScreenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecordScreensArgs = {
  filter?: InputMaybe<RecordScreenFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRecordScreensAggregateArgs = {
  filter?: InputMaybe<RecordScreenFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRecordTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecordTagsArgs = {
  filter?: InputMaybe<RecordTagFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRecordTagsAggregateArgs = {
  filter?: InputMaybe<RecordTagFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRegionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRegionsArgs = {
  filter?: InputMaybe<RegionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRegionsAggregateArgs = {
  filter?: InputMaybe<RegionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryResolvedRecordScreenArgs = {
  recordType: Scalars['String']['input'];
};


export type QueryRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRoleInheritanceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRoleInheritancesArgs = {
  filter?: InputMaybe<RoleInheritanceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRoleInheritancesAggregateArgs = {
  filter?: InputMaybe<RoleInheritanceFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRolePermissionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRolePermissionsArgs = {
  filter?: InputMaybe<RolePermissionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRolePermissionsAggregateArgs = {
  filter?: InputMaybe<RolePermissionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRoleUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRoleUsersArgs = {
  filter?: InputMaybe<RoleUserFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRoleUsersAggregateArgs = {
  filter?: InputMaybe<RoleUserFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryRolesArgs = {
  filter?: InputMaybe<RoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryRolesAggregateArgs = {
  filter?: InputMaybe<RoleFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySaleTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySaleTypesArgs = {
  filter?: InputMaybe<SaleTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySaleTypesAggregateArgs = {
  filter?: InputMaybe<SaleTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySalesOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySalesOrderLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySalesOrderLinesArgs = {
  filter?: InputMaybe<SalesOrderLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySalesOrderLinesAggregateArgs = {
  filter?: InputMaybe<SalesOrderLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySalesOrdersArgs = {
  filter?: InputMaybe<SalesOrderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySalesOrdersAggregateArgs = {
  filter?: InputMaybe<SalesOrderFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySchemaArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySchemaTypesArgs = {
  filter?: InputMaybe<SchemaTypeFilterInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySchemaVersionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySchemaVersionsArgs = {
  filter?: InputMaybe<SchemaVersionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySchemaVersionsAggregateArgs = {
  filter?: InputMaybe<SchemaVersionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySchemasArgs = {
  filter?: InputMaybe<SchemaFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySchemasAggregateArgs = {
  filter?: InputMaybe<SchemaFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryScreenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScreenAssignmentsArgs = {
  filter?: InputMaybe<RecordScreenFilterInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryScreensArgs = {
  filter?: InputMaybe<ScreenFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryScreensAggregateArgs = {
  filter?: InputMaybe<ScreenFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySpecificationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpecificationLookupOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type QueryStockArgs = {
  filter?: InputMaybe<StockFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryStockAggregateArgs = {
  filter?: InputMaybe<StockFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryStockRecordArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStockTransactionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStockTransactionLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStockTransactionLinesArgs = {
  filter?: InputMaybe<StockTransactionLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryStockTransactionLinesAggregateArgs = {
  filter?: InputMaybe<StockTransactionLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryStockTransactionsArgs = {
  filter?: InputMaybe<StockTransactionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryStockTransactionsAggregateArgs = {
  filter?: InputMaybe<StockTransactionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySubscriptionRealArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubscriptionsArgs = {
  filter?: InputMaybe<SubscriptionRealFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySubscriptionsAggregateArgs = {
  filter?: InputMaybe<SubscriptionRealFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySupplierArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierCategoriesArgs = {
  filter?: InputMaybe<SupplierCategoryFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySupplierCategoriesAggregateArgs = {
  filter?: InputMaybe<SupplierCategoryFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySupplierCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierQuoteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierQuoteLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierQuoteLinesArgs = {
  filter?: InputMaybe<SupplierQuoteLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySupplierQuoteLinesAggregateArgs = {
  filter?: InputMaybe<SupplierQuoteLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySupplierQuoteRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierQuoteRequestLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierQuoteRequestLinesArgs = {
  filter?: InputMaybe<SupplierQuoteRequestLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySupplierQuoteRequestLinesAggregateArgs = {
  filter?: InputMaybe<SupplierQuoteRequestLineFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySupplierQuoteRequestsArgs = {
  filter?: InputMaybe<SupplierQuoteRequestFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySupplierQuoteRequestsAggregateArgs = {
  filter?: InputMaybe<SupplierQuoteRequestFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySupplierQuotesArgs = {
  filter?: InputMaybe<SupplierQuoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySupplierQuotesAggregateArgs = {
  filter?: InputMaybe<SupplierQuoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QuerySuppliersArgs = {
  filter?: InputMaybe<SupplierFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QuerySuppliersAggregateArgs = {
  filter?: InputMaybe<SupplierFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryTagsAggregateArgs = {
  filter?: InputMaybe<TagFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryTimerTransactionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTimerTransactionsArgs = {
  filter?: InputMaybe<TimerTransactionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryTimerTransactionsAggregateArgs = {
  filter?: InputMaybe<TimerTransactionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryTimersArgs = {
  filter?: InputMaybe<ProcessTimerFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryTimersAggregateArgs = {
  filter?: InputMaybe<ProcessTimerFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryUploadRequestUrlArgs = {
  area: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  jobNumber: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserIdentitiesArgs = {
  filter?: InputMaybe<UserIdentityFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryUserIdentitiesAggregateArgs = {
  filter?: InputMaybe<UserIdentityFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryUserIdentityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserPermissionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserPermissionsArgs = {
  filter?: InputMaybe<UserPermissionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryUserPermissionsAggregateArgs = {
  filter?: InputMaybe<UserPermissionFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryUsersAggregateArgs = {
  filter?: InputMaybe<UserFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryWarehouseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWarehousesArgs = {
  filter?: InputMaybe<WarehouseFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryWarehousesAggregateArgs = {
  filter?: InputMaybe<WarehouseFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryWebhookArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWebhooksArgs = {
  filter?: InputMaybe<WebhookFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryWebhooksAggregateArgs = {
  filter?: InputMaybe<WebhookFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryWeeksArgs = {
  filter?: InputMaybe<WeekFilterInput>;
};


export type QueryWorkflowNoteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkflowNotesArgs = {
  filter?: InputMaybe<WorkflowNoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryWorkflowNotesAggregateArgs = {
  filter?: InputMaybe<WorkflowNoteFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryWorkflowTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkflowTemplatesArgs = {
  filter?: InputMaybe<WorkflowTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryWorkflowTemplatesAggregateArgs = {
  filter?: InputMaybe<WorkflowTemplateFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};


export type QueryWorkflowTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkflowTypesArgs = {
  filter?: InputMaybe<WorkflowTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
  options?: InputMaybe<OptionsInput>;
};


export type QueryWorkflowTypesAggregateArgs = {
  filter?: InputMaybe<WorkflowTypeFilterInput>;
  group?: InputMaybe<ResourceGroupInput>;
};

/**
 * description=A sales quote containing priced work offered to a client.
 * displayName=Quote
 * module=Sales
 * defaultQuery=quotes
 * iconName=th
 * colour=#A91F54
 * aggregateQuery=quotesAggregate
 * grouping=true
 * queryPermission=Query_Quotes
 */
export type Quote = {
  __typename?: 'Quote';
  /**
   * sortable=true
   * groupable=true
   */
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  clientAddress: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  clientName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  contactName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision: Maybe<QuoteRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  lineItem: Maybe<LineItem>;
  /**
   * sortable=false
   * groupable=false
   */
  lines: Array<QuoteLine>;
  /**
   * sortable=true
   * groupable=false
   */
  quoteNumber: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  reference: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  version: Scalars['Int']['output'];
};


/**
 * description=A sales quote containing priced work offered to a client.
 * displayName=Quote
 * module=Sales
 * defaultQuery=quotes
 * iconName=th
 * colour=#A91F54
 * aggregateQuery=quotesAggregate
 * grouping=true
 * queryPermission=Query_Quotes
 */
export type QuoteCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A sales quote containing priced work offered to a client. */
export type QuoteAggregate = {
  __typename?: 'QuoteAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['Float']['output'];
};


/** description=A sales quote containing priced work offered to a client. */
export type QuoteAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A sales quote containing priced work offered to a client. */
export type QuoteAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuoteApprovalRequestedEvent = {
  __typename?: 'QuoteApprovalRequestedEvent';
  quote: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type QuoteFilterInput = {
  acceptedAt?: InputMaybe<DateTimeFilterInput>;
  and?: InputMaybe<Array<QuoteFilterInput>>;
  clientAddress?: InputMaybe<StringFilterInput>;
  clientName?: InputMaybe<StringFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<QuoteRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  issuedAt?: InputMaybe<DateTimeFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteFilterInput>>;
  quoteNumber?: InputMaybe<StringFilterInput>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
};

/**
 * description=A costed line item within a sales quote.
 * displayName=Quote Line
 * module=Sales
 * defaultQuery=quoteLines
 * colour=#A91F54
 * aggregateQuery=quoteLinesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Lines
 */
export type QuoteLine = {
  __typename?: 'QuoteLine';
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  costingRevision: Maybe<CostingRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  costingRevisionId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  jobComponent: Maybe<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  line: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  lineTemplateId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  lines: Array<QuoteLine>;
  /**
   * sortable=true
   * groupable=false
   */
  markupAmount: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  parentLine: Maybe<QuoteLine>;
  /**
   * sortable=true
   * groupable=true
   */
  product: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  productId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  quote: Maybe<Quote>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteRevision: Maybe<QuoteRevision>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  type: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitSellPrice: Scalars['String']['output'];
};


/**
 * description=A costed line item within a sales quote.
 * displayName=Quote Line
 * module=Sales
 * defaultQuery=quoteLines
 * colour=#A91F54
 * aggregateQuery=quoteLinesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Lines
 */
export type QuoteLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A costed line item within a sales quote. */
export type QuoteLineAggregate = {
  __typename?: 'QuoteLineAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['Float']['output'];
};


/** description=A costed line item within a sales quote. */
export type QuoteLineAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A costed line item within a sales quote. */
export type QuoteLineAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuoteLineFilterInput = {
  and?: InputMaybe<Array<QuoteLineFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  costingRevision?: InputMaybe<CostingRevisionFilterInput>;
  costingRevisionId?: InputMaybe<IdFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobComponent?: InputMaybe<JobComponentFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  lineTemplateId?: InputMaybe<StringFilterInput>;
  markupAmount?: InputMaybe<StringFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteLineFilterInput>>;
  parentLine?: InputMaybe<QuoteLineFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<StringFilterInput>;
  quantity?: InputMaybe<StringFilterInput>;
  quote?: InputMaybe<QuoteFilterInput>;
  quoteRevision?: InputMaybe<QuoteRevisionFilterInput>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitSellPrice?: InputMaybe<StringFilterInput>;
};

export type QuoteLineInput = {
  costPrice?: InputMaybe<Scalars['String']['input']>;
  costing?: InputMaybe<Scalars['String']['input']>;
  costingRevisionId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jobComponentId?: InputMaybe<Scalars['ID']['input']>;
  lineTemplateId?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<QuoteLineInput>>;
  markupExpression?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  type?: QuoteLineType;
};

/**
 * description=A reusable quote line definition used when building quote templates.
 * displayName=Quote Line Template
 * module=Sales
 * defaultQuery=quoteLineTemplates
 * colour=#A91F54
 * aggregateQuery=quoteLineTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Line_Templates
 */
export type QuoteLineTemplate = {
  __typename?: 'QuoteLineTemplate';
  /**
   * sortable=true
   * groupable=false
   */
  category: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  descriptionEditable: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  markupEditable: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  quantityEditable: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPriceEditable: Scalars['Boolean']['output'];
};


/**
 * description=A reusable quote line definition used when building quote templates.
 * displayName=Quote Line Template
 * module=Sales
 * defaultQuery=quoteLineTemplates
 * colour=#A91F54
 * aggregateQuery=quoteLineTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Line_Templates
 */
export type QuoteLineTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable quote line definition used when building quote templates. */
export type QuoteLineTemplateAggregate = {
  __typename?: 'QuoteLineTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable quote line definition used when building quote templates. */
export type QuoteLineTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable quote line definition used when building quote templates. */
export type QuoteLineTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuoteLineTemplateFilterInput = {
  and?: InputMaybe<Array<QuoteLineTemplateFilterInput>>;
  category?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  descriptionEditable?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  markupEditable?: InputMaybe<BooleanFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteLineTemplateFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  quantityEditable?: InputMaybe<BooleanFilterInput>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitCostPriceEditable?: InputMaybe<BooleanFilterInput>;
};

export type QuoteLineTemplateInput = {
  category?: Scalars['String']['input'];
  costPriceEditable?: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  descriptionEditable?: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  markupEditable?: Scalars['Boolean']['input'];
  markupExpression?: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  quantityEditable?: Scalars['Boolean']['input'];
  type?: QuoteLineType;
  unitCostPrice?: Scalars['String']['input'];
  unitCostPriceEditable?: Scalars['Boolean']['input'];
};

export enum QuoteLineType {
  Composite = 'COMPOSITE',
  Normal = 'NORMAL'
}

export type QuotePreview = {
  __typename?: 'QuotePreview';
  html: Scalars['String']['output'];
};

export type QuoteRequestAcceptedEvent = {
  __typename?: 'QuoteRequestAcceptedEvent';
  quoteRequest: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type QuoteRequestPlacedEvent = {
  __typename?: 'QuoteRequestPlacedEvent';
  quoteRequest: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type QuoteRequestQuotedEvent = {
  __typename?: 'QuoteRequestQuotedEvent';
  quoteRequest: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

/**
 * description=A saved revision of a quote at a particular point in its lifecycle.
 * displayName=Quote Revision
 * module=Sales
 * defaultQuery=quoteRevisions
 * colour=#A91F54
 * aggregateQuery=quoteRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Revisions
 */
export type QuoteRevision = {
  __typename?: 'QuoteRevision';
  /**
   * sortable=true
   * groupable=false
   */
  clientAddress: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  clientName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  contactName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<QuoteLine>;
  /**
   * sortable=true
   * groupable=true
   */
  quote: Quote;
  /**
   * sortable=true
   * groupable=false
   */
  reference: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  version: Scalars['Int']['output'];
};


/**
 * description=A saved revision of a quote at a particular point in its lifecycle.
 * displayName=Quote Revision
 * module=Sales
 * defaultQuery=quoteRevisions
 * colour=#A91F54
 * aggregateQuery=quoteRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Revisions
 */
export type QuoteRevisionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A saved revision of a quote at a particular point in its lifecycle.
 * displayName=Quote Revision
 * module=Sales
 * defaultQuery=quoteRevisions
 * colour=#A91F54
 * aggregateQuery=quoteRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Revisions
 */
export type QuoteRevisionLinesArgs = {
  filter?: InputMaybe<QuoteLineFilterInput>;
};

/** description=A saved revision of a quote at a particular point in its lifecycle. */
export type QuoteRevisionAggregate = {
  __typename?: 'QuoteRevisionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A saved revision of a quote at a particular point in its lifecycle. */
export type QuoteRevisionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A saved revision of a quote at a particular point in its lifecycle. */
export type QuoteRevisionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuoteRevisionFilterInput = {
  and?: InputMaybe<Array<QuoteRevisionFilterInput>>;
  clientAddress?: InputMaybe<StringFilterInput>;
  clientName?: InputMaybe<StringFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<QuoteLineFilterInput>;
  or?: InputMaybe<Array<QuoteRevisionFilterInput>>;
  quote?: InputMaybe<QuoteFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
};

export type QuoteStatus = {
  __typename?: 'QuoteStatus';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quoteAggregate: Maybe<QuoteAggregate>;
};


export type QuoteStatusQuoteAggregateArgs = {
  filter?: InputMaybe<QuoteFilterInput>;
};

/**
 * description=A reusable sales quoting template for generating quote lines and pricing.
 * displayName=Quote Template
 * module=Sales
 * defaultQuery=quoteTemplates
 * iconName=document
 * colour=#A91F54
 * aggregateQuery=quoteTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Templates
 */
export type QuoteTemplate = {
  __typename?: 'QuoteTemplate';
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  draftRevision: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isDefault: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  version: Scalars['Int']['output'];
};


/**
 * description=A reusable sales quoting template for generating quote lines and pricing.
 * displayName=Quote Template
 * module=Sales
 * defaultQuery=quoteTemplates
 * iconName=document
 * colour=#A91F54
 * aggregateQuery=quoteTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Templates
 */
export type QuoteTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable sales quoting template for generating quote lines and pricing. */
export type QuoteTemplateAggregate = {
  __typename?: 'QuoteTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable sales quoting template for generating quote lines and pricing. */
export type QuoteTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable sales quoting template for generating quote lines and pricing. */
export type QuoteTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * description=A formula or expression used by quote templates to calculate quote content.
 * displayName=Quote Template Expression
 * module=Sales
 * defaultQuery=quoteTemplateExpressions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateExpressionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Expressions
 */
export type QuoteTemplateExpression = {
  __typename?: 'QuoteTemplateExpression';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  quoteTemplateRevisionId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  value: Scalars['String']['output'];
};


/**
 * description=A formula or expression used by quote templates to calculate quote content.
 * displayName=Quote Template Expression
 * module=Sales
 * defaultQuery=quoteTemplateExpressions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateExpressionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Expressions
 */
export type QuoteTemplateExpressionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A formula or expression used by quote templates to calculate quote content. */
export type QuoteTemplateExpressionAggregate = {
  __typename?: 'QuoteTemplateExpressionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A formula or expression used by quote templates to calculate quote content. */
export type QuoteTemplateExpressionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A formula or expression used by quote templates to calculate quote content. */
export type QuoteTemplateExpressionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuoteTemplateExpressionFilterInput = {
  and?: InputMaybe<Array<QuoteTemplateExpressionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteTemplateExpressionFilterInput>>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  quoteTemplateRevisionId?: InputMaybe<StringFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type QuoteTemplateFilterInput = {
  and?: InputMaybe<Array<QuoteTemplateFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isDefault?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteTemplateFilterInput>>;
  version?: InputMaybe<NumberFilterInput>;
};

export type QuoteTemplatePreview = {
  __typename?: 'QuoteTemplatePreview';
  html: Scalars['String']['output'];
};

/**
 * description=A saved revision of a quote template used to preserve template history.
 * displayName=Quote Template Revision
 * module=Sales
 * defaultQuery=quoteTemplateRevisions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Revisions
 */
export type QuoteTemplateRevision = {
  __typename?: 'QuoteTemplateRevision';
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  defaultLines: Array<QuoteLine>;
  /**
   * sortable=false
   * groupable=true
   */
  expressions: Array<QuoteTemplateExpression>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lineTemplates: Array<QuoteLineTemplate>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplate: QuoteTemplate;
  /**
   * sortable=true
   * groupable=false
   */
  status: QuoteTemplateRevisionStatus;
  /**
   * sortable=true
   * groupable=false
   */
  version: Scalars['Int']['output'];
};


/**
 * description=A saved revision of a quote template used to preserve template history.
 * displayName=Quote Template Revision
 * module=Sales
 * defaultQuery=quoteTemplateRevisions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Revisions
 */
export type QuoteTemplateRevisionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A saved revision of a quote template used to preserve template history.
 * displayName=Quote Template Revision
 * module=Sales
 * defaultQuery=quoteTemplateRevisions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Revisions
 */
export type QuoteTemplateRevisionExpressionsArgs = {
  filter?: InputMaybe<QuoteTemplateExpressionFilterInput>;
};


/**
 * description=A saved revision of a quote template used to preserve template history.
 * displayName=Quote Template Revision
 * module=Sales
 * defaultQuery=quoteTemplateRevisions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Revisions
 */
export type QuoteTemplateRevisionLineTemplatesArgs = {
  filter?: InputMaybe<QuoteLineTemplateFilterInput>;
};

/** description=A saved revision of a quote template used to preserve template history. */
export type QuoteTemplateRevisionAggregate = {
  __typename?: 'QuoteTemplateRevisionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A saved revision of a quote template used to preserve template history. */
export type QuoteTemplateRevisionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A saved revision of a quote template used to preserve template history. */
export type QuoteTemplateRevisionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuoteTemplateRevisionFilterInput = {
  and?: InputMaybe<Array<QuoteTemplateRevisionFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  expressions?: InputMaybe<QuoteTemplateExpressionFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineTemplates?: InputMaybe<QuoteLineTemplateFilterInput>;
  or?: InputMaybe<Array<QuoteTemplateRevisionFilterInput>>;
  quoteTemplate?: InputMaybe<QuoteTemplateFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
};

/** Quote template revision status. */
export enum QuoteTemplateRevisionStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ReceiveWarehouseStockInput = {
  stock: Array<WarehouseStockInput>;
  warehouseId: Scalars['ID']['input'];
};

/**
 * description=A file attached to a record, including its folder and metadata.
 * displayName=Record File
 * module=Admin
 * defaultQuery=recordFiles
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=recordFileAggregates
 * grouping=true
 * queryPermission=Query_Record_Files
 */
export type RecordFile = {
  __typename?: 'RecordFile';
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  file: Maybe<File>;
  /**
   * sortable=true
   * groupable=false
   */
  fileId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  folder: Maybe<RecordFolder>;
  /**
   * sortable=true
   * groupable=false
   */
  folderId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isPrimaryImage: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  metadata: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  path: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  resourceId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
};


/**
 * description=A file attached to a record, including its folder and metadata.
 * displayName=Record File
 * module=Admin
 * defaultQuery=recordFiles
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=recordFileAggregates
 * grouping=true
 * queryPermission=Query_Record_Files
 */
export type RecordFileCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A file attached to a record, including its folder and metadata. */
export type RecordFileAggregate = {
  __typename?: 'RecordFileAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A file attached to a record, including its folder and metadata. */
export type RecordFileAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A file attached to a record, including its folder and metadata. */
export type RecordFileAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordFileDeletedEvent = {
  __typename?: 'RecordFileDeletedEvent';
  fileId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type RecordFileFilterInput = {
  and?: InputMaybe<Array<RecordFileFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  file?: InputMaybe<FileFilterInput>;
  fileId?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<RecordFolderFilterInput>;
  folderId?: InputMaybe<IdFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  isPrimaryImage?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  or?: InputMaybe<Array<RecordFileFilterInput>>;
  path?: InputMaybe<StringFilterInput>;
  primaryImage?: InputMaybe<BooleanFilterInput>;
  resourceId?: InputMaybe<IdFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

/** RecordFile */
export type RecordFilesUploadedEvent = {
  __typename?: 'RecordFilesUploadedEvent';
  fileCount: Scalars['Int']['output'];
  folderId: Maybe<Scalars['String']['output']>;
  folderName: Maybe<Scalars['String']['output']>;
  recordFileIds: Array<Maybe<Scalars['String']['output']>>;
  recordId: Scalars['String']['output'];
  recordType: Scalars['String']['output'];
};

/**
 * description=A native folder belonging to a record; file contents remain in UUID-based storage.
 * displayName=Record Folder
 * defaultQuery=recordFolders
 * iconName=folder-close
 * aggregateQuery=recordFoldersAggregate
 * grouping=true
 * queryPermission=Query_Record_Folders
 */
export type RecordFolder = {
  __typename?: 'RecordFolder';
  /**
   * sortable=false
   * groupable=true
   */
  children: Array<RecordFolder>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  defaultFolderId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  parentFolder: Maybe<RecordFolder>;
  /**
   * sortable=true
   * groupable=false
   */
  parentFolderId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceId: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  resourceType: Scalars['String']['output'];
};


/**
 * description=A native folder belonging to a record; file contents remain in UUID-based storage.
 * displayName=Record Folder
 * defaultQuery=recordFolders
 * iconName=folder-close
 * aggregateQuery=recordFoldersAggregate
 * grouping=true
 * queryPermission=Query_Record_Folders
 */
export type RecordFolderChildrenArgs = {
  filter?: InputMaybe<RecordFolderFilterInput>;
};


/**
 * description=A native folder belonging to a record; file contents remain in UUID-based storage.
 * displayName=Record Folder
 * defaultQuery=recordFolders
 * iconName=folder-close
 * aggregateQuery=recordFoldersAggregate
 * grouping=true
 * queryPermission=Query_Record_Folders
 */
export type RecordFolderCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A native folder belonging to a record; file contents remain in UUID-based storage. */
export type RecordFolderAggregate = {
  __typename?: 'RecordFolderAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A native folder belonging to a record; file contents remain in UUID-based storage. */
export type RecordFolderAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A native folder belonging to a record; file contents remain in UUID-based storage. */
export type RecordFolderAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordFolderFilterInput = {
  and?: InputMaybe<Array<RecordFolderFilterInput>>;
  children?: InputMaybe<RecordFolderFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  defaultFolderId?: InputMaybe<IdFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RecordFolderFilterInput>>;
  parentFolder?: InputMaybe<RecordFolderFilterInput>;
  parentFolderId?: InputMaybe<IdFilterInput>;
  resourceId?: InputMaybe<IdFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
};

export type RecordNavigationRecord = {
  __typename?: 'RecordNavigationRecord';
  groupLabel: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
  recordType: RecordType;
  relation: Maybe<Scalars['String']['output']>;
};

/**
 * description=An application screen assigned directly to a user or role.
 * displayName=Record Screen
 * module=Admin
 * defaultQuery=recordScreens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=recordScreensAggregate
 * grouping=true
 * queryPermission=Query_Record_Screens
 */
export type RecordScreen = {
  __typename?: 'RecordScreen';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  inheritedFrom: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * description=Identity of the user or role assigned to this screen, without loading the destination record.
   * sortable=false
   * groupable=false
   */
  record: RecordScreenRecordReference;
  /**
   * sortable=true
   * groupable=false
   */
  recordId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: RecordScreenType;
  /**
   * sortable=true
   * groupable=true
   */
  role: Maybe<Role>;
  /**
   * sortable=true
   * groupable=true
   */
  screen: Screen;
  /**
   * sortable=true
   * groupable=false
   */
  source: Maybe<RecordSource>;
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
};


/**
 * description=An application screen assigned directly to a user or role.
 * displayName=Record Screen
 * module=Admin
 * defaultQuery=recordScreens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=recordScreensAggregate
 * grouping=true
 * queryPermission=Query_Record_Screens
 */
export type RecordScreenCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An application screen assigned directly to a user or role. */
export type RecordScreenAggregate = {
  __typename?: 'RecordScreenAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An application screen assigned directly to a user or role. */
export type RecordScreenAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An application screen assigned directly to a user or role. */
export type RecordScreenAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordScreenFilterInput = {
  and?: InputMaybe<Array<RecordScreenFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RecordScreenFilterInput>>;
  recordId?: InputMaybe<IdFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  screen?: InputMaybe<ScreenFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

export type RecordScreenRecordReference = {
  __typename?: 'RecordScreenRecordReference';
  recordId: Scalars['ID']['output'];
  recordType: Scalars['String']['output'];
};

export enum RecordScreenType {
  Role = 'ROLE',
  User = 'USER'
}

export enum RecordSource {
  System = 'SYSTEM',
  User = 'USER'
}

/**
 * description=A tag assignment linking a reusable tag to another record.
 * displayName=Record Tag
 * module=Admin
 * defaultQuery=recordTags
 * iconName=tag
 * colour=#5D35A6
 * aggregateQuery=recordTagsAggregate
 * grouping=true
 * queryPermission=Query_Record_Tags
 */
export type RecordTag = {
  __typename?: 'RecordTag';
  /**
   * sortable=true
   * groupable=false
   */
  colour: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  resourceType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  tag: Tag;
};


/**
 * description=A tag assignment linking a reusable tag to another record.
 * displayName=Record Tag
 * module=Admin
 * defaultQuery=recordTags
 * iconName=tag
 * colour=#5D35A6
 * aggregateQuery=recordTagsAggregate
 * grouping=true
 * queryPermission=Query_Record_Tags
 */
export type RecordTagCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A tag assignment linking a reusable tag to another record. */
export type RecordTagAggregate = {
  __typename?: 'RecordTagAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A tag assignment linking a reusable tag to another record. */
export type RecordTagAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A tag assignment linking a reusable tag to another record. */
export type RecordTagAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordTagFilterInput = {
  and?: InputMaybe<Array<RecordTagFilterInput>>;
  colour?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RecordTagFilterInput>>;
  recordId?: InputMaybe<IdFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<TagFilterInput>;
};

/** All discoverable record type names. */
export enum RecordType {
  ActAsUser = 'ActAsUser',
  Asset = 'Asset',
  AssignedPermission = 'AssignedPermission',
  AsyncTask = 'AsyncTask',
  AttachmentTemplate = 'AttachmentTemplate',
  AuditLog = 'AuditLog',
  Batch = 'Batch',
  BatchSchedule = 'BatchSchedule',
  BillOfMaterialsImport = 'BillOfMaterialsImport',
  BillOfMaterialsLine = 'BillOfMaterialsLine',
  Branch = 'Branch',
  BuildType = 'BuildType',
  Builder = 'Builder',
  BusinessRole = 'BusinessRole',
  Candidate = 'Candidate',
  CandidateIngestionPolicy = 'CandidateIngestionPolicy',
  Client = 'Client',
  ComponentAction = 'ComponentAction',
  ComponentGridColumn = 'ComponentGridColumn',
  ConfiguredLinkedAction = 'ConfiguredLinkedAction',
  Correspondence = 'Correspondence',
  Costing = 'Costing',
  CostingLine = 'CostingLine',
  CostingLineTemplate = 'CostingLineTemplate',
  CostingRevision = 'CostingRevision',
  CostingTemplate = 'CostingTemplate',
  CostingTemplateExpression = 'CostingTemplateExpression',
  CostingTemplateRevision = 'CostingTemplateRevision',
  CustomData = 'CustomData',
  CustomTemplate = 'CustomTemplate',
  DataStore = 'DataStore',
  DataStoreRecord = 'DataStoreRecord',
  Day = 'Day',
  DefaultFolder = 'DefaultFolder',
  DeliveryAddress = 'DeliveryAddress',
  Designer = 'Designer',
  Document = 'Document',
  DocumentPreview = 'DocumentPreview',
  DocumentTemplate = 'DocumentTemplate',
  EffectivePermission = 'EffectivePermission',
  Email = 'Email',
  ExternalStorageConnection = 'ExternalStorageConnection',
  ExternalStorageItem = 'ExternalStorageItem',
  ExternalStorageResourceMapping = 'ExternalStorageResourceMapping',
  File = 'File',
  GroupInstance = 'GroupInstance',
  GroupTemplate = 'GroupTemplate',
  HousingCompany = 'HousingCompany',
  Issue = 'Issue',
  IssueCompletionStatus = 'IssueCompletionStatus',
  Job = 'Job',
  JobComponent = 'JobComponent',
  JobStatus = 'JobStatus',
  JobStatusEnum = 'JobStatusEnum',
  Lead = 'Lead',
  LeadProjectType = 'LeadProjectType',
  LeadProjectTypeEnum = 'LeadProjectTypeEnum',
  LeadSource = 'LeadSource',
  LeadStatus = 'LeadStatus',
  LeadStatusEnum = 'LeadStatusEnum',
  LineItem = 'LineItem',
  LineItemMasterWorkflow = 'LineItemMasterWorkflow',
  LinkedAction = 'LinkedAction',
  LostReason = 'LostReason',
  Machine = 'Machine',
  MachineType = 'MachineType',
  Money = 'Money',
  Month = 'Month',
  NzRegion = 'NZRegion',
  NotificationAction = 'NotificationAction',
  NotificationTemplate = 'NotificationTemplate',
  PageInfo = 'PageInfo',
  PagedJobs = 'PagedJobs',
  PaginatedResult = 'PaginatedResult',
  Panel = 'Panel',
  PartType = 'PartType',
  Permission = 'Permission',
  PermissionPolicy = 'PermissionPolicy',
  PermissionScope = 'PermissionScope',
  Person = 'Person',
  PersonAssignedWork = 'PersonAssignedWork',
  PersonBusinessRole = 'PersonBusinessRole',
  PersonStatus = 'PersonStatus',
  ProcessAsset = 'ProcessAsset',
  ProcessAssignment = 'ProcessAssignment',
  ProcessInstance = 'ProcessInstance',
  ProcessTemplate = 'ProcessTemplate',
  ProcessTimer = 'ProcessTimer',
  ProcessTimerItem = 'ProcessTimerItem',
  ProcessType = 'ProcessType',
  ProcessTypeNote = 'ProcessTypeNote',
  ProcessTypeRole = 'ProcessTypeRole',
  Product = 'Product',
  ProductCategory = 'ProductCategory',
  ProductCategoryGroup = 'ProductCategoryGroup',
  ProductImportUpdateField = 'ProductImportUpdateField',
  ProductPrice = 'ProductPrice',
  Project = 'Project',
  ProjectManager = 'ProjectManager',
  PurchaseOrder = 'PurchaseOrder',
  PurchaseOrderEvent = 'PurchaseOrderEvent',
  PurchaseOrderLine = 'PurchaseOrderLine',
  PurchaseOrderPreview = 'PurchaseOrderPreview',
  PurchaseOrderReceipt = 'PurchaseOrderReceipt',
  PurchaseOrderReceiptLine = 'PurchaseOrderReceiptLine',
  PurchaseOrderReview = 'PurchaseOrderReview',
  PurchaseOrderSavePayload = 'PurchaseOrderSavePayload',
  PurchaseOrderStatus = 'PurchaseOrderStatus',
  Quote = 'Quote',
  QuoteLine = 'QuoteLine',
  QuoteLineTemplate = 'QuoteLineTemplate',
  QuotePreview = 'QuotePreview',
  QuoteRevision = 'QuoteRevision',
  QuoteStatus = 'QuoteStatus',
  QuoteTemplate = 'QuoteTemplate',
  QuoteTemplateExpression = 'QuoteTemplateExpression',
  QuoteTemplatePreview = 'QuoteTemplatePreview',
  QuoteTemplateRevision = 'QuoteTemplateRevision',
  RecordFile = 'RecordFile',
  RecordFolder = 'RecordFolder',
  RecordNavigationRecord = 'RecordNavigationRecord',
  RecordScreen = 'RecordScreen',
  RecordTag = 'RecordTag',
  Region = 'Region',
  Role = 'Role',
  RoleInheritance = 'RoleInheritance',
  RolePermission = 'RolePermission',
  RoleUser = 'RoleUser',
  SaleType = 'SaleType',
  SalesOrder = 'SalesOrder',
  SalesOrderLine = 'SalesOrderLine',
  Schema = 'Schema',
  SchemaType = 'SchemaType',
  SchemaVersion = 'SchemaVersion',
  Screen = 'Screen',
  SignedUploadUrlPayload = 'SignedUploadUrlPayload',
  Specification = 'Specification',
  SpecificationLookupOption = 'SpecificationLookupOption',
  Stock = 'Stock',
  StockTransaction = 'StockTransaction',
  StockTransactionLine = 'StockTransactionLine',
  SubscriptionReal = 'SubscriptionReal',
  Supplier = 'Supplier',
  SupplierCategory = 'SupplierCategory',
  SupplierQuote = 'SupplierQuote',
  SupplierQuoteLine = 'SupplierQuoteLine',
  SupplierQuoteRequest = 'SupplierQuoteRequest',
  SupplierQuoteRequestLine = 'SupplierQuoteRequestLine',
  Tag = 'Tag',
  TimerTransaction = 'TimerTransaction',
  Unknown = 'Unknown',
  UploadRequestUrl = 'UploadRequestUrl',
  User = 'User',
  UserIdentity = 'UserIdentity',
  UserNotification = 'UserNotification',
  UserPermission = 'UserPermission',
  UserRole = 'UserRole',
  Warehouse = 'Warehouse',
  Webhook = 'Webhook',
  Week = 'Week',
  Workflow = 'Workflow',
  WorkflowNode = 'WorkflowNode',
  WorkflowNote = 'WorkflowNote',
  WorkflowTemplate = 'WorkflowTemplate',
  WorkflowType = 'WorkflowType'
}

/**
 * description=A geographic region used for grouping sales and operational records.
 * displayName=Region
 * module=Admin
 * defaultQuery=regions
 * iconName=map
 * colour=#5D35A6
 * aggregateQuery=regionsAggregate
 * grouping=true
 * queryPermission=Query_Regions
 */
export type Region = {
  __typename?: 'Region';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  nzRegion: Scalars['String']['output'];
};


/**
 * description=A geographic region used for grouping sales and operational records.
 * displayName=Region
 * module=Admin
 * defaultQuery=regions
 * iconName=map
 * colour=#5D35A6
 * aggregateQuery=regionsAggregate
 * grouping=true
 * queryPermission=Query_Regions
 */
export type RegionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A geographic region used for grouping sales and operational records. */
export type RegionAggregate = {
  __typename?: 'RegionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A geographic region used for grouping sales and operational records. */
export type RegionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A geographic region used for grouping sales and operational records. */
export type RegionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RegionFilterInput = {
  and?: InputMaybe<Array<RegionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nzRegion?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RegionFilterInput>>;
};

/** A Region identity or a typed nested report dimension. */
export type RegionReportDimensionValue = {
  __typename?: 'RegionReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Region identity, or traverses to one of its typed dimensions. */
export type RegionReportRelationDimensionInput = {
  filter?: InputMaybe<RegionFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReleasePurchaseOrdersInput = {
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};

/** Calendar interval used by a DateTime report dimension. */
export enum ReportDateInterval {
  /** One row per calendar day. */
  Day = 'DAY',
  /** One row per calendar month. */
  Month = 'MONTH',
  /** One row per calendar quarter. */
  Quarter = 'QUARTER',
  /** One row per ISO week, starting on Monday. */
  Week = 'WEEK',
  /** One row per calendar year. */
  Year = 'YEAR'
}

/** A stable machine-readable dimension key and its display label. */
export type ReportDimensionValue = {
  __typename?: 'ReportDimensionValue';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type RescheduleBatchesInput = {
  batchScheduleIds: Array<Scalars['ID']['input']>;
  ignoreRestrictions: Scalars['Boolean']['input'];
  scheduled: Scalars['String']['input'];
};

export type ResetUserPasswordInput = {
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ResourceAggregate = {
  __typename?: 'ResourceAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


export type ResourceAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


export type ResourceAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceGroup = {
  __typename?: 'ResourceGroup';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ResourceGroupByInput = {
  dir?: InputMaybe<ResourceGroupDirection>;
  field: Scalars['String']['input'];
};

export enum ResourceGroupDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ResourceGroupInput = {
  field: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ResourceGroupPage = {
  __typename?: 'ResourceGroupPage';
  items: Array<ResourceGroup>;
  totalCount: Scalars['Int']['output'];
};

export type RestorePartTypesInput = {
  partTypeIds: Array<Scalars['ID']['input']>;
};

export type RestoreProcessTypesInput = {
  processTypeIds: Array<Scalars['ID']['input']>;
};

export type RestoreWorkflowTypesInput = {
  workflowTypeIds: Array<Scalars['ID']['input']>;
};

export type ReviseQuoteInput = {
  clientAddress?: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['ID']['input']>>;
  lines: Array<QuoteLineInput>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  reference: Scalars['String']['input'];
};

/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type Role = {
  __typename?: 'Role';
  /**
   * sortable=false
   * groupable=false
   */
  allPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  allScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=true
   */
  assignedUsers: Array<RoleUser>;
  /**
   * sortable=false
   * groupable=false
   */
  childRoles: Array<Role>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  inheritFrom: Array<Role>;
  /**
   * sortable=false
   * groupable=true
   */
  inheritances: Array<RoleInheritance>;
  /**
   * sortable=false
   * groupable=true
   */
  inheritedBy: Array<RoleInheritance>;
  /**
   * sortable=true
   * groupable=false
   */
  inheritedFromName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedScreens: Array<Screen>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  ownPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  ownScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=false
   */
  parentRoles: Array<Role>;
  /**
   * sortable=false
   * groupable=false
   */
  screenAggregate: Maybe<RecordScreenAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  source: RecordSource;
  /**
   * description=The number of users directly assigned to this role.
   * sortable=false
   * groupable=false
   */
  userAggregate: Maybe<RoleUserAggregate>;
  /**
   * description=Users directly assigned to this role or to a child role that inherits it.
   * sortable=false
   * groupable=false
   */
  users: Array<User>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleAllPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleAssignedUsersArgs = {
  filter?: InputMaybe<RoleUserFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleInheritancesArgs = {
  filter?: InputMaybe<RoleInheritanceFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleInheritedByArgs = {
  filter?: InputMaybe<RoleInheritanceFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleInheritedPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleOwnPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleScreenAggregateArgs = {
  filter?: InputMaybe<RecordScreenFilterInput>;
};


/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export type RoleUserAggregateArgs = {
  filter?: InputMaybe<RoleUserFilterInput>;
};

/** description=An application authorization role assigned to users and inherited by other roles. */
export type RoleAggregate = {
  __typename?: 'RoleAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An application authorization role assigned to users and inherited by other roles. */
export type RoleAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An application authorization role assigned to users and inherited by other roles. */
export type RoleAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Role */
export type RoleCreatedEvent = {
  __typename?: 'RoleCreatedEvent';
  description: Scalars['String']['output'];
  inheritedFrom: Array<Maybe<Scalars['String']['output']>>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
};

/** Role */
export type RoleDeletedEvent = {
  __typename?: 'RoleDeletedEvent';
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
};

/** Role */
export type RoleDetailsUpdatedEvent = {
  __typename?: 'RoleDetailsUpdatedEvent';
  description: Maybe<Scalars['String']['output']>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
};

export type RoleFilterInput = {
  and?: InputMaybe<Array<RoleFilterInput>>;
  assignedUsers?: InputMaybe<RoleUserFilterInput>;
  childRoles?: InputMaybe<RoleInheritanceFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  inheritances?: InputMaybe<RoleInheritanceFilterInput>;
  inheritedBy?: InputMaybe<RoleInheritanceFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RoleFilterInput>>;
  parentRoles?: InputMaybe<RoleInheritanceFilterInput>;
  roleScreens?: InputMaybe<RecordScreenFilterInput>;
  roleUsers?: InputMaybe<RoleUserFilterInput>;
  source?: InputMaybe<SourceFilterInput>;
};

/**
 * description=An inheritance edge from a child application role to a parent role.
 * displayName=Role Inheritance
 * module=Admin
 * defaultQuery=roleInheritances
 * iconName=diagram-tree
 * colour=#5D35A6
 * aggregateQuery=roleInheritancesAggregate
 * grouping=true
 * queryPermission=Query_Role_Inheritances
 */
export type RoleInheritance = {
  __typename?: 'RoleInheritance';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  parentId: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  parentRole: Role;
  /**
   * sortable=true
   * groupable=true
   */
  role: Role;
  /**
   * sortable=true
   * groupable=false
   */
  roleId: Scalars['String']['output'];
};


/**
 * description=An inheritance edge from a child application role to a parent role.
 * displayName=Role Inheritance
 * module=Admin
 * defaultQuery=roleInheritances
 * iconName=diagram-tree
 * colour=#5D35A6
 * aggregateQuery=roleInheritancesAggregate
 * grouping=true
 * queryPermission=Query_Role_Inheritances
 */
export type RoleInheritanceCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An inheritance edge from a child application role to a parent role. */
export type RoleInheritanceAggregate = {
  __typename?: 'RoleInheritanceAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An inheritance edge from a child application role to a parent role. */
export type RoleInheritanceAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An inheritance edge from a child application role to a parent role. */
export type RoleInheritanceAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Role */
export type RoleInheritanceAssignmentUpdatedEvent = {
  __typename?: 'RoleInheritanceAssignmentUpdatedEvent';
  assignedInheritance: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
  unassignedInheritance: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RoleInheritanceFilterInput = {
  and?: InputMaybe<Array<RoleInheritanceFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RoleInheritanceFilterInput>>;
  parent?: InputMaybe<RoleFilterInput>;
  parentId?: InputMaybe<StringFilterInput>;
  parentRole?: InputMaybe<RoleFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<StringFilterInput>;
};

/**
 * description=A permission assigned directly to an application role.
 * displayName=Role Permission
 * module=Admin
 * defaultQuery=rolePermissions
 * iconName=key
 * colour=#5D35A6
 * aggregateQuery=rolePermissionsAggregate
 * grouping=true
 * queryPermission=Query_Role_Permissions
 */
export type RolePermission = {
  __typename?: 'RolePermission';
  /**
   * sortable=true
   * groupable=false
   */
  conditions: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  permission: Permission;
  /**
   * sortable=true
   * groupable=false
   */
  policy: Policy;
  /**
   * sortable=true
   * groupable=true
   */
  role: Role;
};


/**
 * description=A permission assigned directly to an application role.
 * displayName=Role Permission
 * module=Admin
 * defaultQuery=rolePermissions
 * iconName=key
 * colour=#5D35A6
 * aggregateQuery=rolePermissionsAggregate
 * grouping=true
 * queryPermission=Query_Role_Permissions
 */
export type RolePermissionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A permission assigned directly to an application role. */
export type RolePermissionAggregate = {
  __typename?: 'RolePermissionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A permission assigned directly to an application role. */
export type RolePermissionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A permission assigned directly to an application role. */
export type RolePermissionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RolePermissionFilterInput = {
  and?: InputMaybe<Array<RolePermissionFilterInput>>;
  conditions?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RolePermissionFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
};

/** Role */
export type RolePermissionsAssignmentUpdatedEvent = {
  __typename?: 'RolePermissionsAssignmentUpdatedEvent';
  assignedPermissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
  unassignedPermissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Role */
export type RoleScreensAssignmentUpdatedEvent = {
  __typename?: 'RoleScreensAssignmentUpdatedEvent';
  assignedScreens: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
  unassignedScreens: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * description=A direct assignment of an application role to a user.
 * displayName=Role User
 * module=Admin
 * defaultQuery=roleUsers
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=roleUsersAggregate
 * grouping=true
 * queryPermission=Query_Role_Users
 */
export type RoleUser = {
  __typename?: 'RoleUser';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  role: Role;
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
};


/**
 * description=A direct assignment of an application role to a user.
 * displayName=Role User
 * module=Admin
 * defaultQuery=roleUsers
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=roleUsersAggregate
 * grouping=true
 * queryPermission=Query_Role_Users
 */
export type RoleUserCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A direct assignment of an application role to a user. */
export type RoleUserAggregate = {
  __typename?: 'RoleUserAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A direct assignment of an application role to a user. */
export type RoleUserAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A direct assignment of an application role to a user. */
export type RoleUserAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleUserFilterInput = {
  and?: InputMaybe<Array<RoleUserFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RoleUserFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

/** Role */
export type RoleUsersAssignmentUpdatedEvent = {
  __typename?: 'RoleUsersAssignmentUpdatedEvent';
  assignedUserIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
  unassignedUserIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * description=A sales classification describing how a job or quote was sold.
 * displayName=Sale Type
 * module=Sales
 * defaultQuery=saleTypes
 * colour=#A91F54
 * aggregateQuery=saleTypesAggregate
 * grouping=true
 * queryPermission=Query_Sale_Types
 */
export type SaleType = {
  __typename?: 'SaleType';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A sales classification describing how a job or quote was sold.
 * displayName=Sale Type
 * module=Sales
 * defaultQuery=saleTypes
 * colour=#A91F54
 * aggregateQuery=saleTypesAggregate
 * grouping=true
 * queryPermission=Query_Sale_Types
 */
export type SaleTypeCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A sales classification describing how a job or quote was sold. */
export type SaleTypeAggregate = {
  __typename?: 'SaleTypeAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A sales classification describing how a job or quote was sold. */
export type SaleTypeAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A sales classification describing how a job or quote was sold. */
export type SaleTypeAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleTypeFilterInput = {
  and?: InputMaybe<Array<SaleTypeFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SaleTypeFilterInput>>;
};

/** A Sale Type identity or a typed nested report dimension. */
export type SaleTypeReportDimensionValue = {
  __typename?: 'SaleTypeReportDimensionValue';
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Groups by Sale Type identity, or traverses to one of its typed dimensions. */
export type SaleTypeReportRelationDimensionInput = {
  filter?: InputMaybe<SaleTypeFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * description=A sales order accepted for client work.
 * displayName=Sales Order
 * module=Sales
 * defaultQuery=salesOrders
 * iconName=shopping-cart
 * colour=#A91F54
 * aggregateQuery=salesOrdersAggregate
 * grouping=true
 * queryPermission=Query_Sales_Orders
 */
export type SalesOrder = {
  __typename?: 'SalesOrder';
  /**
   * sortable=true
   * groupable=true
   */
  client: Maybe<Client>;
  /**
   * sortable=true
   * groupable=false
   */
  clientAddress: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  clientName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  confirmedAt: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  contactName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  currency: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<SalesOrderLine>;
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  reference: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  salesOrderNumber: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['String']['output'];
};


/**
 * description=A sales order accepted for client work.
 * displayName=Sales Order
 * module=Sales
 * defaultQuery=salesOrders
 * iconName=shopping-cart
 * colour=#A91F54
 * aggregateQuery=salesOrdersAggregate
 * grouping=true
 * queryPermission=Query_Sales_Orders
 */
export type SalesOrderCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A sales order accepted for client work.
 * displayName=Sales Order
 * module=Sales
 * defaultQuery=salesOrders
 * iconName=shopping-cart
 * colour=#A91F54
 * aggregateQuery=salesOrdersAggregate
 * grouping=true
 * queryPermission=Query_Sales_Orders
 */
export type SalesOrderLinesArgs = {
  filter?: InputMaybe<SalesOrderLineFilterInput>;
};

/** description=A sales order accepted for client work. */
export type SalesOrderAggregate = {
  __typename?: 'SalesOrderAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A sales order accepted for client work. */
export type SalesOrderAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A sales order accepted for client work. */
export type SalesOrderAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SalesOrderFilterInput = {
  and?: InputMaybe<Array<SalesOrderFilterInput>>;
  client?: InputMaybe<ClientFilterInput>;
  clientAddress?: InputMaybe<StringFilterInput>;
  clientName?: InputMaybe<StringFilterInput>;
  confirmedAt?: InputMaybe<StringFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<SalesOrderLineFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SalesOrderFilterInput>>;
  reference?: InputMaybe<StringFilterInput>;
  salesOrderNumber?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
};

/**
 * description=A product or service line on a sales order.
 * displayName=Sales Order Line
 * module=Sales
 * defaultQuery=salesOrderLines
 * colour=#A91F54
 * aggregateQuery=salesOrderLinesAggregate
 * grouping=true
 * queryPermission=Query_Sales_Order_Lines
 */
export type SalesOrderLine = {
  __typename?: 'SalesOrderLine';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  jobComponent: Maybe<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  line: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  lineTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  salesOrder: SalesOrder;
  /**
   * sortable=true
   * groupable=true
   */
  sourceQuote: Maybe<Quote>;
  /**
   * sortable=true
   * groupable=true
   */
  sourceQuoteLine: Maybe<QuoteLine>;
  /**
   * sortable=true
   * groupable=true
   */
  sourceQuoteRevision: Maybe<QuoteRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  unit: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  unitSellPrice: Scalars['String']['output'];
};


/**
 * description=A product or service line on a sales order.
 * displayName=Sales Order Line
 * module=Sales
 * defaultQuery=salesOrderLines
 * colour=#A91F54
 * aggregateQuery=salesOrderLinesAggregate
 * grouping=true
 * queryPermission=Query_Sales_Order_Lines
 */
export type SalesOrderLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type SalesOrderLineFilterInput = {
  and?: InputMaybe<Array<SalesOrderLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobComponent?: InputMaybe<JobComponentFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  lineTotal?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SalesOrderLineFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  salesOrder?: InputMaybe<SalesOrderFilterInput>;
  sourceQuote?: InputMaybe<QuoteFilterInput>;
  sourceQuoteLine?: InputMaybe<QuoteLineFilterInput>;
  sourceQuoteRevision?: InputMaybe<QuoteRevisionFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
  unitSellPrice?: InputMaybe<StringFilterInput>;
};

export type SalesOrderLineInput = {
  description: Scalars['String']['input'];
  jobComponentId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['String']['input'];
  sourceQuoteId?: InputMaybe<Scalars['ID']['input']>;
  sourceQuoteLineId?: InputMaybe<Scalars['ID']['input']>;
  sourceQuoteRevisionId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitSellPrice: Scalars['String']['input'];
};

/**
 * description=A custom form schema and its published and draft versions.
 * displayName=Schema
 * module=Admin
 * defaultQuery=schemas
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=schemasAggregate
 * grouping=true
 * queryPermission=Query_Schemas
 */
export type Schema = {
  __typename?: 'Schema';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  latestVersion: Maybe<SchemaVersion>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  recordType: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  versions: Array<SchemaVersion>;
};


/**
 * description=A custom form schema and its published and draft versions.
 * displayName=Schema
 * module=Admin
 * defaultQuery=schemas
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=schemasAggregate
 * grouping=true
 * queryPermission=Query_Schemas
 */
export type SchemaCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A custom form schema and its published and draft versions.
 * displayName=Schema
 * module=Admin
 * defaultQuery=schemas
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=schemasAggregate
 * grouping=true
 * queryPermission=Query_Schemas
 */
export type SchemaVersionsArgs = {
  filter?: InputMaybe<SchemaVersionFilterInput>;
};

/** description=A custom form schema and its published and draft versions. */
export type SchemaAggregate = {
  __typename?: 'SchemaAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A custom form schema and its published and draft versions. */
export type SchemaAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A custom form schema and its published and draft versions. */
export type SchemaAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SchemaCreatedEvent = {
  __typename?: 'SchemaCreatedEvent';
  schema: Scalars['String']['output'];
};

export type SchemaDeletedEvent = {
  __typename?: 'SchemaDeletedEvent';
  schema: Scalars['String']['output'];
};

export type SchemaFilterInput = {
  and?: InputMaybe<Array<SchemaFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  latestVersion?: InputMaybe<SchemaVersionFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SchemaFilterInput>>;
  recordType?: InputMaybe<StringFilterInput>;
  versions?: InputMaybe<SchemaVersionFilterInput>;
};

export type SchemaType = {
  __typename?: 'SchemaType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SchemaTypeFilterInput = {
  id?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
};

export type SchemaUpdatedEvent = {
  __typename?: 'SchemaUpdatedEvent';
  schema: Scalars['String']['output'];
};

/**
 * description=A version of a custom form and its data definition.
 * displayName=Schema Version
 * module=Admin
 * defaultQuery=schemaVersions
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=schemaVersionsAggregate
 * grouping=true
 * queryPermission=Query_Schema_Versions
 */
export type SchemaVersion = {
  __typename?: 'SchemaVersion';
  /**
   * sortable=true
   * groupable=false
   */
  created: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  dataDefinition: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  extra: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  formDefinition: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  latestActive: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  schema: Maybe<Schema>;
  /**
   * sortable=true
   * groupable=false
   */
  schemaId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  status: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  version: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  versionNo: Maybe<Scalars['String']['output']>;
};


/**
 * description=A version of a custom form and its data definition.
 * displayName=Schema Version
 * module=Admin
 * defaultQuery=schemaVersions
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=schemaVersionsAggregate
 * grouping=true
 * queryPermission=Query_Schema_Versions
 */
export type SchemaVersionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type SchemaVersionActiveEvent = {
  __typename?: 'SchemaVersionActiveEvent';
  schemaVersion: Scalars['String']['output'];
};

/** description=A version of a custom form and its data definition. */
export type SchemaVersionAggregate = {
  __typename?: 'SchemaVersionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A version of a custom form and its data definition. */
export type SchemaVersionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A version of a custom form and its data definition. */
export type SchemaVersionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SchemaVersionCreatedEvent = {
  __typename?: 'SchemaVersionCreatedEvent';
  schemaVersion: Scalars['String']['output'];
};

export type SchemaVersionDeletedEvent = {
  __typename?: 'SchemaVersionDeletedEvent';
  schemaVersion: Scalars['String']['output'];
};

export type SchemaVersionFilterInput = {
  and?: InputMaybe<Array<SchemaVersionFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  dataDefinition?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  extra?: InputMaybe<StringFilterInput>;
  formDefinition?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  latestActive?: InputMaybe<BooleanFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SchemaVersionFilterInput>>;
  schema?: InputMaybe<SchemaFilterInput>;
  schemaId?: InputMaybe<IdFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  version?: InputMaybe<StringFilterInput>;
  versionNo?: InputMaybe<StringFilterInput>;
};

export type SchemaVersionInput = {
  dataSchema: Scalars['String']['input'];
  formSchema: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  schemaId: Scalars['ID']['input'];
};

export type SchemaVersionUpdatedEvent = {
  __typename?: 'SchemaVersionUpdatedEvent';
  schemaVersion: Scalars['String']['output'];
};

/**
 * description=An application screen definition made from one or more panels.
 * displayName=Screen
 * module=Admin
 * defaultQuery=screens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=screensAggregate
 * grouping=true
 * queryPermission=Query_Screens
 */
export type Screen = {
  __typename?: 'Screen';
  /**
   * sortable=false
   * groupable=false
   */
  assignmentAggregate: Maybe<RecordScreenAggregate>;
  /**
   * sortable=true
   * groupable=true
   */
  created: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  group: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  icon: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  resolvedScreenCfg: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  roles: Maybe<Array<Role>>;
  /**
   * sortable=true
   * groupable=false
   */
  screenCfg: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  source: Scalars['String']['output'];
};


/**
 * description=An application screen definition made from one or more panels.
 * displayName=Screen
 * module=Admin
 * defaultQuery=screens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=screensAggregate
 * grouping=true
 * queryPermission=Query_Screens
 */
export type ScreenAssignmentAggregateArgs = {
  filter?: InputMaybe<RecordScreenFilterInput>;
};


/**
 * description=An application screen definition made from one or more panels.
 * displayName=Screen
 * module=Admin
 * defaultQuery=screens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=screensAggregate
 * grouping=true
 * queryPermission=Query_Screens
 */
export type ScreenCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An application screen definition made from one or more panels.
 * displayName=Screen
 * module=Admin
 * defaultQuery=screens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=screensAggregate
 * grouping=true
 * queryPermission=Query_Screens
 */
export type ScreenResolvedScreenCfgArgs = {
  recordId?: InputMaybe<Scalars['ID']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
};

/** description=An application screen definition made from one or more panels. */
export type ScreenAggregate = {
  __typename?: 'ScreenAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An application screen definition made from one or more panels. */
export type ScreenAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An application screen definition made from one or more panels. */
export type ScreenAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScreenAssignmentInput = {
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  screenId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Screen */
export type ScreenCreatedEvent = {
  __typename?: 'ScreenCreatedEvent';
  screenCfg: Scalars['String']['output'];
  screenId: Scalars['String']['output'];
  screenName: Scalars['String']['output'];
};

/** Screen */
export type ScreenDeletedEvent = {
  __typename?: 'ScreenDeletedEvent';
  screenId: Scalars['String']['output'];
  screenName: Scalars['String']['output'];
};

export type ScreenFilterInput = {
  and?: InputMaybe<Array<ScreenFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  icon?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ScreenFilterInput>>;
  recordType?: InputMaybe<StringFilterInput>;
  screenCfg?: InputMaybe<StringFilterInput>;
};

export enum ScreenGroup {
  Accounts = 'ACCOUNTS',
  Admin = 'ADMIN',
  Installation = 'INSTALLATION',
  Inventory = 'INVENTORY',
  Maintenance = 'MAINTENANCE',
  Manufacturing = 'MANUFACTURING',
  Sales = 'SALES'
}

export type ScreenUnassignmentInput = {
  recordScreenIds: Array<Scalars['String']['input']>;
  screenId: Scalars['ID']['input'];
};

/** Screen */
export type ScreenUpdatedEvent = {
  __typename?: 'ScreenUpdatedEvent';
  screenCfg: Maybe<Scalars['String']['output']>;
  screenGroup: Maybe<Scalars['String']['output']>;
  screenId: Scalars['String']['output'];
  screenName: Scalars['String']['output'];
};

export type SetCandidateIngestionPolicyInput = {
  candidateType: Scalars['String']['input'];
  emailAddresses: Array<Scalars['String']['input']>;
  mode: CandidateIngestionMode;
  senderRecordId: Scalars['ID']['input'];
  senderRecordType: Scalars['String']['input'];
};

export type SetConfiguredLinkedActionInput = {
  actionId: Scalars['String']['input'];
  bindings: Scalars['String']['input'];
  displayOrder: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  recordPath: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  roleIds: Array<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};

export type SetCustomDataInput = {
  data: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
  schemaId: Scalars['String']['input'];
  upgradeSchema?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetDefaultFolderInput = {
  allowedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};

export type SetFavouriteLinkedActionInput = {
  actionId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  recordPath: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};

export type SetLinkedActionRecipientInput = {
  assigned: Scalars['Boolean']['input'];
  linkedActionId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetUserPinInput = {
  pin: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type SignedUploadUrlPayload = {
  __typename?: 'SignedUploadUrlPayload';
  fileId: Scalars['String']['output'];
  uploadToken: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type SortInput = {
  dir?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type SourceFilterInput = {
  eq?: InputMaybe<RecordSource>;
  notEq?: InputMaybe<RecordSource>;
};

export type Specification = {
  __typename?: 'Specification';
  id: Scalars['ID']['output'];
};

export type SpecificationLookupOption = {
  __typename?: 'SpecificationLookupOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** PurchaseOrderReview */
export type StatusChangedEvent = {
  __typename?: 'StatusChangedEvent';
  comment: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  orderReviewId: Scalars['String']['output'];
  review: Scalars['String']['output'];
  reviewerUserName: Scalars['String']['output'];
};

export type StatusUpdatedEvent = {
  __typename?: 'StatusUpdatedEvent';
  quoteRequestEmail: Scalars['String']['output'];
};

/**
 * description=Current inventory quantities and values for products in warehouses.
 * displayName=Stock
 * module=Inventory
 * defaultQuery=stock
 * iconName=package
 * colour=#596600
 * aggregateQuery=stockAggregate
 * grouping=true
 * queryPermission=Query_Stock
 */
export type Stock = {
  __typename?: 'Stock';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  product: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  totalCostPrice: Maybe<Money>;
  /**
   * sortable=true
   * groupable=true
   */
  warehouse: Maybe<Warehouse>;
};


/**
 * description=Current inventory quantities and values for products in warehouses.
 * displayName=Stock
 * module=Inventory
 * defaultQuery=stock
 * iconName=package
 * colour=#596600
 * aggregateQuery=stockAggregate
 * grouping=true
 * queryPermission=Query_Stock
 */
export type StockCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=Current inventory quantities and values for products in warehouses. */
export type StockAggregate = {
  __typename?: 'StockAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=false
   * groupable=false
   */
  totalCostPrice: Money;
  /**
   * sortable=true
   * groupable=false
   */
  totalQuantity: Scalars['Float']['output'];
};


/** description=Current inventory quantities and values for products in warehouses. */
export type StockAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=Current inventory quantities and values for products in warehouses. */
export type StockAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StockFilterInput = {
  and?: InputMaybe<Array<StockFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<StockFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<NumberFilterInput>;
  warehouse?: InputMaybe<WarehouseFilterInput>;
};

export type StockTakeCreatedEvent = {
  __typename?: 'StockTakeCreatedEvent';
  stockTakeId: Scalars['String']['output'];
};

/**
 * description=An inventory movement that receives, transfers, adjusts, or withdraws stock.
 * displayName=Stock Transaction
 * module=Inventory
 * defaultQuery=stockTransactions
 * colour=#596600
 * aggregateQuery=stockTransactionsAggregate
 * grouping=true
 * queryPermission=Query_Stock_Transactions
 */
export type StockTransaction = {
  __typename?: 'StockTransaction';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<StockTransactionLine>;
  /**
   * sortable=true
   * groupable=false
   */
  type: StockTransactionType;
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
  /**
   * sortable=true
   * groupable=true
   */
  warehouse: Warehouse;
};


/**
 * description=An inventory movement that receives, transfers, adjusts, or withdraws stock.
 * displayName=Stock Transaction
 * module=Inventory
 * defaultQuery=stockTransactions
 * colour=#596600
 * aggregateQuery=stockTransactionsAggregate
 * grouping=true
 * queryPermission=Query_Stock_Transactions
 */
export type StockTransactionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An inventory movement that receives, transfers, adjusts, or withdraws stock.
 * displayName=Stock Transaction
 * module=Inventory
 * defaultQuery=stockTransactions
 * colour=#596600
 * aggregateQuery=stockTransactionsAggregate
 * grouping=true
 * queryPermission=Query_Stock_Transactions
 */
export type StockTransactionLinesArgs = {
  filter?: InputMaybe<StockTransactionLineFilterInput>;
};

/** description=An inventory movement that receives, transfers, adjusts, or withdraws stock. */
export type StockTransactionAggregate = {
  __typename?: 'StockTransactionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  totalCostPrice: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  totalQuantity: Scalars['Float']['output'];
};


/** description=An inventory movement that receives, transfers, adjusts, or withdraws stock. */
export type StockTransactionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An inventory movement that receives, transfers, adjusts, or withdraws stock. */
export type StockTransactionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StockTransactionCreatedEvent = {
  __typename?: 'StockTransactionCreatedEvent';
  stockTransactionId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type StockTransactionFilterInput = {
  and?: InputMaybe<Array<StockTransactionFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<StockTransactionLineFilterInput>;
  or?: InputMaybe<Array<StockTransactionFilterInput>>;
  type?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  warehouse?: InputMaybe<WarehouseFilterInput>;
};

/**
 * description=A product quantity movement within an inventory stock transaction.
 * displayName=Stock Transaction Line
 * module=Inventory
 * defaultQuery=stockTransactionLines
 * colour=#596600
 * aggregateQuery=stockTransactionLinesAggregate
 * grouping=true
 * queryPermission=Query_Stock_Transaction_Lines
 */
export type StockTransactionLine = {
  __typename?: 'StockTransactionLine';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  product: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['Float']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  stockTransaction: StockTransaction;
};


/**
 * description=A product quantity movement within an inventory stock transaction.
 * displayName=Stock Transaction Line
 * module=Inventory
 * defaultQuery=stockTransactionLines
 * colour=#596600
 * aggregateQuery=stockTransactionLinesAggregate
 * grouping=true
 * queryPermission=Query_Stock_Transaction_Lines
 */
export type StockTransactionLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A product quantity movement within an inventory stock transaction. */
export type StockTransactionLineAggregate = {
  __typename?: 'StockTransactionLineAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A product quantity movement within an inventory stock transaction. */
export type StockTransactionLineAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A product quantity movement within an inventory stock transaction. */
export type StockTransactionLineAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StockTransactionLineFilterInput = {
  and?: InputMaybe<Array<StockTransactionLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<StockTransactionLineFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<NumberFilterInput>;
  stockTransaction?: InputMaybe<StockTransactionFilterInput>;
};

/** Inventory stock transaction type. */
export enum StockTransactionType {
  Receive = 'Receive',
  StockTake = 'StockTake',
  Transfer = 'Transfer',
  Withdraw = 'Withdraw'
}

export type StringFilterInput = {
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  likeAll?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitPurchaseOrderReviewInput = {
  comment: Scalars['String']['input'];
  purchaseOrderId: Scalars['ID']['input'];
  review: OrderReviewStatus;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** A placeholder query used by thecodingmachine/graphqlite when there are no declared subscriptions. */
  dummySubscription: Maybe<Scalars['String']['output']>;
};

/**
 * description=An event subscription defining notification recipients and templates.
 * displayName=Subscription
 * module=Admin
 * defaultQuery=subscriptions
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=subscriptionsAggregate
 * grouping=true
 * queryPermission=Query_Subscriptions
 */
export type SubscriptionReal = {
  __typename?: 'SubscriptionReal';
  /**
   * sortable=true
   * groupable=true
   */
  channels: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  event: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  maxRecipients: Maybe<Scalars['Int']['output']>;
  /**
   * sortable=false
   * groupable=true
   */
  notificationTemplates: Array<NotificationTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  sourceFilter: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  targetFilter: Maybe<Scalars['String']['output']>;
};


/**
 * description=An event subscription defining notification recipients and templates.
 * displayName=Subscription
 * module=Admin
 * defaultQuery=subscriptions
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=subscriptionsAggregate
 * grouping=true
 * queryPermission=Query_Subscriptions
 */
export type SubscriptionRealCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=An event subscription defining notification recipients and templates.
 * displayName=Subscription
 * module=Admin
 * defaultQuery=subscriptions
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=subscriptionsAggregate
 * grouping=true
 * queryPermission=Query_Subscriptions
 */
export type SubscriptionRealNotificationTemplatesArgs = {
  filter?: InputMaybe<NotificationTemplateFilterInput>;
};

/** description=An event subscription defining notification recipients and templates. */
export type SubscriptionRealAggregate = {
  __typename?: 'SubscriptionRealAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An event subscription defining notification recipients and templates. */
export type SubscriptionRealAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An event subscription defining notification recipients and templates. */
export type SubscriptionRealAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionRealFilterInput = {
  and?: InputMaybe<Array<SubscriptionRealFilterInput>>;
  channels?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  event?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  maxRecipients?: InputMaybe<NumberFilterInput>;
  notificationTemplates?: InputMaybe<NotificationTemplateFilterInput>;
  or?: InputMaybe<Array<SubscriptionRealFilterInput>>;
  sourceFilter?: InputMaybe<StringFilterInput>;
  targetFilter?: InputMaybe<StringFilterInput>;
};

/**
 * description=A supplier that provides products or services for purchasing and inventory.
 * displayName=Supplier
 * module=Inventory
 * defaultQuery=suppliers
 * iconName=shop
 * colour=#596600
 * aggregateQuery=suppliersAggregate
 * grouping=true
 * queryPermission=Query_Suppliers
 */
export type Supplier = {
  __typename?: 'Supplier';
  /**
   * sortable=true
   * groupable=false
   */
  address: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  category: Maybe<SupplierCategory>;
  /**
   * sortable=true
   * groupable=false
   */
  cell: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  currency: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  email: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  image: Maybe<File>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  numberOfReviews: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  orderEmails: Array<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  productAggregate: Maybe<ProductAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  products: Maybe<Array<Maybe<Product>>>;
  /**
   * sortable=true
   * groupable=false
   */
  quantityThreshold: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  quoteEmails: Array<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  reviewType: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  reviewers: Array<User>;
  /**
   * sortable=true
   * groupable=false
   */
  url: Maybe<Scalars['String']['output']>;
};


/**
 * description=A supplier that provides products or services for purchasing and inventory.
 * displayName=Supplier
 * module=Inventory
 * defaultQuery=suppliers
 * iconName=shop
 * colour=#596600
 * aggregateQuery=suppliersAggregate
 * grouping=true
 * queryPermission=Query_Suppliers
 */
export type SupplierCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A supplier that provides products or services for purchasing and inventory.
 * displayName=Supplier
 * module=Inventory
 * defaultQuery=suppliers
 * iconName=shop
 * colour=#596600
 * aggregateQuery=suppliersAggregate
 * grouping=true
 * queryPermission=Query_Suppliers
 */
export type SupplierProductAggregateArgs = {
  filter?: InputMaybe<ProductFilterInput>;
};


/**
 * description=A supplier that provides products or services for purchasing and inventory.
 * displayName=Supplier
 * module=Inventory
 * defaultQuery=suppliers
 * iconName=shop
 * colour=#596600
 * aggregateQuery=suppliersAggregate
 * grouping=true
 * queryPermission=Query_Suppliers
 */
export type SupplierProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
};

/** description=A supplier that provides products or services for purchasing and inventory. */
export type SupplierAggregate = {
  __typename?: 'SupplierAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A supplier that provides products or services for purchasing and inventory. */
export type SupplierAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A supplier that provides products or services for purchasing and inventory. */
export type SupplierAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * description=An inventory category used to group suppliers.
 * displayName=Supplier Category
 * module=Inventory
 * defaultQuery=supplierCategories
 * iconName=tag
 * colour=#596600
 * aggregateQuery=supplierCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Categories
 */
export type SupplierCategory = {
  __typename?: 'SupplierCategory';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=An inventory category used to group suppliers.
 * displayName=Supplier Category
 * module=Inventory
 * defaultQuery=supplierCategories
 * iconName=tag
 * colour=#596600
 * aggregateQuery=supplierCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Categories
 */
export type SupplierCategoryCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An inventory category used to group suppliers. */
export type SupplierCategoryAggregate = {
  __typename?: 'SupplierCategoryAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An inventory category used to group suppliers. */
export type SupplierCategoryAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An inventory category used to group suppliers. */
export type SupplierCategoryAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierCategoryFilterInput = {
  and?: InputMaybe<Array<SupplierCategoryFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierCategoryFilterInput>>;
};

/** Supplier */
export type SupplierCreatedEvent = {
  __typename?: 'SupplierCreatedEvent';
  supplierId: Scalars['Int']['output'];
  supplierName: Scalars['String']['output'];
};

/** Supplier */
export type SupplierDeletedEvent = {
  __typename?: 'SupplierDeletedEvent';
  supplierId: Scalars['Int']['output'];
  supplierName: Scalars['String']['output'];
};

/** Supplier */
export type SupplierDetailsUpdatedEvent = {
  __typename?: 'SupplierDetailsUpdatedEvent';
  address: Scalars['String']['output'];
  category: Maybe<Scalars['String']['output']>;
  cell: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  email: Scalars['String']['output'];
  orderEmails: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quoteEmails: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  supplierId: Scalars['Int']['output'];
  supplierName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SupplierFilterInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<SupplierFilterInput>>;
  category?: InputMaybe<SupplierCategoryFilterInput>;
  cell?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  image?: InputMaybe<FileFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  numberOfReviews?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierFilterInput>>;
  products?: InputMaybe<ProductFilterInput>;
  quantityThreshold?: InputMaybe<StringFilterInput>;
  reviewType?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

/**
 * description=A priced offer received from a supplier.
 * displayName=Supplier Quote
 * module=Inventory
 * defaultQuery=supplierQuotes
 * iconName=document
 * colour=#596600
 * aggregateQuery=supplierQuotesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quotes
 */
export type SupplierQuote = {
  __typename?: 'SupplierQuote';
  /**
   * sortable=false
   * groupable=true
   */
  costingLines: Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  currency: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<SupplierQuoteLine>;
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  quoteRequest: Maybe<SupplierQuoteRequest>;
  /**
   * sortable=true
   * groupable=false
   */
  reference: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  supplier: Maybe<Supplier>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierAddress: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  supplierName: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  supplierQuoteNumber: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['String']['output'];
};


/**
 * description=A priced offer received from a supplier.
 * displayName=Supplier Quote
 * module=Inventory
 * defaultQuery=supplierQuotes
 * iconName=document
 * colour=#596600
 * aggregateQuery=supplierQuotesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quotes
 */
export type SupplierQuoteCostingLinesArgs = {
  filter?: InputMaybe<CostingLineFilterInput>;
};


/**
 * description=A priced offer received from a supplier.
 * displayName=Supplier Quote
 * module=Inventory
 * defaultQuery=supplierQuotes
 * iconName=document
 * colour=#596600
 * aggregateQuery=supplierQuotesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quotes
 */
export type SupplierQuoteCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A priced offer received from a supplier.
 * displayName=Supplier Quote
 * module=Inventory
 * defaultQuery=supplierQuotes
 * iconName=document
 * colour=#596600
 * aggregateQuery=supplierQuotesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quotes
 */
export type SupplierQuoteLinesArgs = {
  filter?: InputMaybe<SupplierQuoteLineFilterInput>;
};

/** description=A priced offer received from a supplier. */
export type SupplierQuoteAggregate = {
  __typename?: 'SupplierQuoteAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A priced offer received from a supplier. */
export type SupplierQuoteAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A priced offer received from a supplier. */
export type SupplierQuoteAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierQuoteFilterInput = {
  and?: InputMaybe<Array<SupplierQuoteFilterInput>>;
  costingLines?: InputMaybe<CostingLineFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<SupplierQuoteLineFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteFilterInput>>;
  quoteRequest?: InputMaybe<SupplierQuoteRequestFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierAddress?: InputMaybe<StringFilterInput>;
  supplierName?: InputMaybe<StringFilterInput>;
  supplierQuoteNumber?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
};

/**
 * description=A product or service line offered on a supplier quote.
 * displayName=Supplier Quote Line
 * module=Inventory
 * defaultQuery=supplierQuoteLines
 * colour=#596600
 * aggregateQuery=supplierQuoteLinesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quote_Lines
 */
export type SupplierQuoteLine = {
  __typename?: 'SupplierQuoteLine';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  line: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  product: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  supplierQuote: Maybe<SupplierQuote>;
  /**
   * sortable=true
   * groupable=false
   */
  total: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  unitPrice: Scalars['String']['output'];
};


/**
 * description=A product or service line offered on a supplier quote.
 * displayName=Supplier Quote Line
 * module=Inventory
 * defaultQuery=supplierQuoteLines
 * colour=#596600
 * aggregateQuery=supplierQuoteLinesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quote_Lines
 */
export type SupplierQuoteLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type SupplierQuoteLineFilterInput = {
  and?: InputMaybe<Array<SupplierQuoteLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteLineFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<StringFilterInput>;
  supplierQuote?: InputMaybe<SupplierQuoteFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  unitPrice?: InputMaybe<StringFilterInput>;
};

export type SupplierQuoteLineInput = {
  description: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['String']['input'];
  unitPrice: Scalars['String']['input'];
};

/**
 * description=A request sent to a supplier for pricing on products or services.
 * displayName=Supplier Quote Request
 * module=Inventory
 * defaultQuery=supplierQuoteRequests
 * iconName=send-message
 * colour=#596600
 * aggregateQuery=supplierQuoteRequestsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Requests
 */
export type SupplierQuoteRequest = {
  __typename?: 'SupplierQuoteRequest';
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  job: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  lines: Array<SupplierQuoteRequestLine>;
  /**
   * sortable=true
   * groupable=false
   */
  noteForSupplier: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  reference: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  supplier: Maybe<Supplier>;
};


/**
 * description=A request sent to a supplier for pricing on products or services.
 * displayName=Supplier Quote Request
 * module=Inventory
 * defaultQuery=supplierQuoteRequests
 * iconName=send-message
 * colour=#596600
 * aggregateQuery=supplierQuoteRequestsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Requests
 */
export type SupplierQuoteRequestCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A request sent to a supplier for pricing on products or services.
 * displayName=Supplier Quote Request
 * module=Inventory
 * defaultQuery=supplierQuoteRequests
 * iconName=send-message
 * colour=#596600
 * aggregateQuery=supplierQuoteRequestsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Requests
 */
export type SupplierQuoteRequestLinesArgs = {
  filter?: InputMaybe<SupplierQuoteRequestLineFilterInput>;
};

/** description=A request sent to a supplier for pricing on products or services. */
export type SupplierQuoteRequestAggregate = {
  __typename?: 'SupplierQuoteRequestAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A request sent to a supplier for pricing on products or services. */
export type SupplierQuoteRequestAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A request sent to a supplier for pricing on products or services. */
export type SupplierQuoteRequestAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierQuoteRequestFilterInput = {
  and?: InputMaybe<Array<SupplierQuoteRequestFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<SupplierQuoteRequestLineFilterInput>;
  noteForSupplier?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteRequestFilterInput>>;
  reference?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
};

/**
 * description=A product or service line included in a supplier quote request.
 * displayName=Supplier Quote Request Line
 * module=Inventory
 * defaultQuery=supplierQuoteRequestLines
 * colour=#596600
 * aggregateQuery=supplierQuoteRequestLinesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Request_Lines
 */
export type SupplierQuoteRequestLine = {
  __typename?: 'SupplierQuoteRequestLine';
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  line: Scalars['Int']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  product: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: Maybe<Scalars['Float']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteRequest: SupplierQuoteRequest;
  /**
   * sortable=true
   * groupable=false
   */
  unit: Maybe<Scalars['String']['output']>;
};


/**
 * description=A product or service line included in a supplier quote request.
 * displayName=Supplier Quote Request Line
 * module=Inventory
 * defaultQuery=supplierQuoteRequestLines
 * colour=#596600
 * aggregateQuery=supplierQuoteRequestLinesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Request_Lines
 */
export type SupplierQuoteRequestLineCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A product or service line included in a supplier quote request. */
export type SupplierQuoteRequestLineAggregate = {
  __typename?: 'SupplierQuoteRequestLineAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A product or service line included in a supplier quote request. */
export type SupplierQuoteRequestLineAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A product or service line included in a supplier quote request. */
export type SupplierQuoteRequestLineAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierQuoteRequestLineFilterInput = {
  and?: InputMaybe<Array<SupplierQuoteRequestLineFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteRequestLineFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<NumberFilterInput>;
  quoteRequest?: InputMaybe<SupplierQuoteRequestFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
};

export type SupplierQuoteRequestLineInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  line: Scalars['Int']['input'];
  quantity: Scalars['String']['input'];
};

/** Supplier */
export type SupplierReviewersUpdatedEvent = {
  __typename?: 'SupplierReviewersUpdatedEvent';
  numberOfReviews: Scalars['Int']['output'];
  quantityThreshold: Maybe<Scalars['Int']['output']>;
  reviewType: Scalars['String']['output'];
  supplierId: Scalars['Int']['output'];
  supplierName: Scalars['String']['output'];
};

/** PurchaseOrder */
export type SupplierStatusUpdatedEvent = {
  __typename?: 'SupplierStatusUpdatedEvent';
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
};

/**
 * description=A reusable label that can be attached to supported records.
 * displayName=Tag
 * module=Admin
 * defaultQuery=tags
 * iconName=tag
 * colour=#5D35A6
 * aggregateQuery=tagsAggregate
 * grouping=true
 * queryPermission=Query_Tags
 */
export type Tag = {
  __typename?: 'Tag';
  /**
   * sortable=true
   * groupable=false
   */
  colour: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  resourceType: Maybe<Scalars['String']['output']>;
};


/**
 * description=A reusable label that can be attached to supported records.
 * displayName=Tag
 * module=Admin
 * defaultQuery=tags
 * iconName=tag
 * colour=#5D35A6
 * aggregateQuery=tagsAggregate
 * grouping=true
 * queryPermission=Query_Tags
 */
export type TagCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable label that can be attached to supported records. */
export type TagAggregate = {
  __typename?: 'TagAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable label that can be attached to supported records. */
export type TagAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable label that can be attached to supported records. */
export type TagAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TagFilterInput = {
  and?: InputMaybe<Array<TagFilterInput>>;
  colour?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<TagFilterInput>>;
  resourceType?: InputMaybe<StringFilterInput>;
};

/** DocumentTemplate */
export type TemplateCreatedEvent = {
  __typename?: 'TemplateCreatedEvent';
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

/** DocumentTemplate */
export type TemplateDeletedEvent = {
  __typename?: 'TemplateDeletedEvent';
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

/** DocumentTemplate */
export type TemplateUpdatedEvent = {
  __typename?: 'TemplateUpdatedEvent';
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

/**
 * description=A start and stop interval recorded against a process timer.
 * displayName=Timer Transaction
 * module=Manufacturing
 * defaultQuery=timerTransactions
 * iconName=timer
 * colour=#A96500
 * aggregateQuery=timerTransactionsAggregate
 * grouping=true
 * queryPermission=Query_Timer_Transactions
 */
export type TimerTransaction = {
  __typename?: 'TimerTransaction';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  start: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  stop: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  timer: Maybe<ProcessTimer>;
};


/**
 * description=A start and stop interval recorded against a process timer.
 * displayName=Timer Transaction
 * module=Manufacturing
 * defaultQuery=timerTransactions
 * iconName=timer
 * colour=#A96500
 * aggregateQuery=timerTransactionsAggregate
 * grouping=true
 * queryPermission=Query_Timer_Transactions
 */
export type TimerTransactionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A start and stop interval recorded against a process timer. */
export type TimerTransactionAggregate = {
  __typename?: 'TimerTransactionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A start and stop interval recorded against a process timer. */
export type TimerTransactionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A start and stop interval recorded against a process timer. */
export type TimerTransactionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TimerTransactionFilterInput = {
  and?: InputMaybe<Array<TimerTransactionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<TimerTransactionFilterInput>>;
  start?: InputMaybe<DateTimeFilterInput>;
  stop?: InputMaybe<DateTimeFilterInput>;
  timer?: InputMaybe<ProcessTimerFilterInput>;
};

export type TransferWarehouseStockInput = {
  destinationWarehouseId: Scalars['ID']['input'];
  sourceWarehouseId: Scalars['ID']['input'];
  stock: Array<WarehouseStockInput>;
};

export type TriggerWebhookInput = {
  recordId?: InputMaybe<Scalars['String']['input']>;
  webhookId: Scalars['String']['input'];
};

export type UnassignBusinessRolesFromPersonInput = {
  personBusinessRoleIds: Array<Scalars['ID']['input']>;
};

export type UnassignInheritanceFromRoleInput = {
  roleId: Scalars['ID']['input'];
  roleInheritanceIds: Array<Scalars['String']['input']>;
};

export type UnassignLeadsFromSalespersonInput = {
  leadIds: Array<Scalars['ID']['input']>;
};

export type UnassignPermissionsFromRoleInput = {
  roleId: Scalars['ID']['input'];
  rolePermissionIds: Array<Scalars['String']['input']>;
};

export type UnassignPermissionsFromUserInput = {
  userId: Scalars['ID']['input'];
  userPermissionIds: Array<Scalars['String']['input']>;
};

export type UnassignRolesFromUserInput = {
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type UnassignScreensFromRoleInput = {
  recordScreenIds: Array<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
};

export type UnassignScreensFromUserInput = {
  recordScreenIds: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type UnassignUsersFromRoleInput = {
  roleId: Scalars['ID']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type UnmarkJobLostInput = {
  jobId: Scalars['ID']['input'];
};

export type UnmarkLeadLostInput = {
  leadId: Scalars['ID']['input'];
};

export type UpdateBatchDetailsInput = {
  batchId: Scalars['ID']['input'];
  cubicMetres?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sheets?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBranchInput = {
  branchId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  colour: Scalars['String']['input'];
  darkColour: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateBuilderInput = {
  address: Scalars['String']['input'];
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateBusinessRoleInput = {
  businessRoleId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateClientInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxHome?: InputMaybe<Scalars['String']['input']>;
  faxWork?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneCell?: InputMaybe<Scalars['String']['input']>;
  phoneHome?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCorrespondenceInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  type: Scalars['Int']['input'];
};

export type UpdateCostingInput = {
  costingId: Scalars['ID']['input'];
  jobComponentId?: InputMaybe<Scalars['ID']['input']>;
  lines?: Array<CostingLineInput>;
  name: Scalars['String']['input'];
};

export type UpdateDocumentTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  query: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  sampleDataOverride: Scalars['String']['input'];
  template: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};

export type UpdateDraftPurchaseOrderInput = {
  category?: InputMaybe<OrderCategory>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressId?: InputMaybe<Scalars['ID']['input']>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines?: InputMaybe<Array<PurchaseOrderLineInput>>;
  notifySupplierWhenPlaced?: Scalars['Boolean']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<OrderShippingMethods>;
  shippingTerms?: InputMaybe<OrderShippingTerms>;
  siteVisitRequired?: Scalars['Boolean']['input'];
  statusWhenPlaced?: InputMaybe<OrderStatus>;
  supplierComment?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  urgent?: Scalars['Boolean']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDraftSchemaVersionInput = {
  dataSchema: Scalars['String']['input'];
  formSchema: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateHousingCompanyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateIssueInput = {
  completed?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  requiredDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateJobBuilderInput = {
  builderId?: InputMaybe<Scalars['ID']['input']>;
  builderPhone?: InputMaybe<Scalars['String']['input']>;
  hcJobNumber?: InputMaybe<Scalars['String']['input']>;
  hcPmPhone?: InputMaybe<Scalars['String']['input']>;
  hcProjectManager?: InputMaybe<Scalars['String']['input']>;
  housingCompanyId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateJobClientInput = {
  client: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateJobComponentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  jobComponentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  partTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateJobDetailsInput = {
  benchtopOnly: Scalars['Boolean']['input'];
  branch: Scalars['ID']['input'];
  buildType: Scalars['ID']['input'];
  designer?: InputMaybe<Scalars['ID']['input']>;
  estimatedDueDate: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  jobName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectManager?: InputMaybe<Scalars['ID']['input']>;
  saleType: Scalars['ID']['input'];
  showHome: Scalars['Boolean']['input'];
  sssp: Scalars['Boolean']['input'];
  tristoneJoin: Scalars['Boolean']['input'];
  tristoneSpecified: Scalars['Boolean']['input'];
};

export type UpdateJobNoteInput = {
  jobId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateJobSiteInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  difficultAccess: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  region?: InputMaybe<Scalars['ID']['input']>;
  siteNotes?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['Boolean']['input'];
};

export type UpdateLeadInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  builderName?: InputMaybe<Scalars['String']['input']>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  joineryTypes?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priceRangeBottom?: InputMaybe<Scalars['Float']['input']>;
  priceRangeTop?: InputMaybe<Scalars['Float']['input']>;
  priority?: Scalars['Int']['input'];
  projectType: Scalars['String']['input'];
  requiredBy?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLineItemInput = {
  lineItemId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateLineItemWorkflowInput = {
  lineItemId: Scalars['ID']['input'];
  placeholders?: Array<LineItemWorkflowPlaceholderInput>;
  workflowTemplateId: Scalars['ID']['input'];
};

export type UpdateLostReasonInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  lostReasonId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdatePanelConfigInput = {
  config: Scalars['String']['input'];
  name: Scalars['String']['input'];
  panelId: Scalars['ID']['input'];
};

export type UpdatePanelDetailsInput = {
  name: Scalars['String']['input'];
  panelId: Scalars['ID']['input'];
  tags: Array<Scalars['ID']['input']>;
};

export type UpdatePartTypeInput = {
  code: Scalars['String']['input'];
  colour: Scalars['String']['input'];
  name: Scalars['String']['input'];
  partTypeId: Scalars['ID']['input'];
};

export type UpdatePermissionForRoleInput = {
  permission: PermissionInput;
  roleId: Scalars['ID']['input'];
  rolePermissionId: Scalars['ID']['input'];
};

export type UpdatePermissionForUserInput = {
  permission: PermissionInput;
  userId: Scalars['ID']['input'];
  userPermissionId: Scalars['ID']['input'];
};

export type UpdatePersonInput = {
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
};

export type UpdateProcessInstanceDetailsInput = {
  assignedHours: Scalars['Float']['input'];
  leadDays: Scalars['Int']['input'];
  processInstanceId: Scalars['ID']['input'];
};

export type UpdateProcessInstanceStatusInput = {
  processInstanceId: Scalars['ID']['input'];
  status: Scalars['Int']['input'];
};

export type UpdateProcessTypeDetailsInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  processTypeId: Scalars['ID']['input'];
};

export type UpdateProcessTypeNoteInput = {
  assignedProcessIds: Array<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processTypeNoteId: Scalars['ID']['input'];
};

export type UpdateProcessTypeRoleInput = {
  processTypeId: Scalars['ID']['input'];
  processTypeRoleId: Scalars['ID']['input'];
  roleType: Scalars['String']['input'];
};

export type UpdateProductCategoryInput = {
  group: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProductDetailsInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  indent?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  qtyReviewThreshold?: InputMaybe<Scalars['Int']['input']>;
  safetyStockDays?: InputMaybe<Scalars['Int']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  stockItem?: InputMaybe<Scalars['Boolean']['input']>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePurchaseOrderInternalCommentInput = {
  internalComment: Scalars['String']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};

export type UpdateQuoteInput = {
  clientAddress?: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<QuoteLineInput>;
  quoteId: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
};

export type UpdateRoleDetailsInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roleId: Scalars['ID']['input'];
};

export type UpdateSalesOrderInput = {
  clientAddress?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientName: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  currency?: Scalars['String']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SalesOrderLineInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  salesOrderId: Scalars['ID']['input'];
};

export type UpdateSchemaDetailsInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};

export type UpdateScreenConfigInput = {
  name: Scalars['String']['input'];
  screenCfg: Scalars['String']['input'];
  screenId: Scalars['ID']['input'];
};

export type UpdateScreenDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recordType?: InputMaybe<Scalars['String']['input']>;
  screenGroup?: InputMaybe<ScreenGroup>;
  screenId: Scalars['ID']['input'];
};

export type UpdateSettingsInput = {
  settings: Scalars['String']['input'];
};

export type UpdateStorageConnectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  deviceAccessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dropboxAuthToken?: InputMaybe<Scalars['String']['input']>;
  dropboxNamespaceId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  localRoot?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  root: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateStorageResourceMappingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  externalStorageConnectionId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  resourceFilter?: InputMaybe<Scalars['String']['input']>;
  resourceMappingId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
};

export type UpdateSubscriptionInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event: Scalars['String']['input'];
  maxRecipients?: InputMaybe<Scalars['Int']['input']>;
  notifications?: Array<NotificationInput>;
  sourceFilter?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
  targetFilter?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierDetailsInput = {
  address: Scalars['String']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  cell: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  quoteEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type UpdateSupplierQuoteInput = {
  files?: Array<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  lines?: Array<SupplierQuoteLineInput>;
  quoteRequestId?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  salesTax?: Scalars['String']['input'];
  saveAsDraft?: Scalars['Boolean']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierQuoteId: Scalars['ID']['input'];
  supplierQuoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierQuoteRequestInput = {
  files?: Array<Scalars['ID']['input']>;
  lines: Array<SupplierQuoteRequestLineInput>;
  noteForSupplier: Scalars['String']['input'];
  place?: Scalars['Boolean']['input'];
  reference: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierQuoteRequestId: Scalars['ID']['input'];
};

export type UpdateSupplierReviewersInput = {
  id: Scalars['ID']['input'];
  numberOfReviews: Scalars['Int']['input'];
  quantityThreshold: Scalars['Int']['input'];
  reviewType: Scalars['Int']['input'];
  reviewers: Array<Scalars['String']['input']>;
};

export type UpdateTagInput = {
  colour: Scalars['String']['input'];
  context: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUserDetailsInput = {
  authProvider: AuthProviderType;
  branchId?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type UpdateUserSubscriptionsInput = {
  subscriptions: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateWarehouseInput = {
  address: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateWebhookInput = {
  authType?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  event: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sourceFilter?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateWorkflowTypeDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  master: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  workflowTypeId: Scalars['ID']['input'];
};

export type UploadRequestUrl = {
  __typename?: 'UploadRequestUrl';
  headers: Scalars['String']['output'];
  method: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type User = {
  __typename?: 'User';
  /**
   * sortable=false
   * groupable=false
   */
  allPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  allScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=true
   */
  assignedRoles: Array<RoleUser>;
  /**
   * sortable=true
   * groupable=false
   */
  authProvider: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  authProviderUid: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  branch: Maybe<Branch>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  email: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  firebaseAuthId: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  fullName: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  hasPin: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  identities: Array<UserIdentity>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedScreens: Array<Screen>;
  /**
   * sortable=true
   * groupable=false
   */
  initials: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  ownPermissions: Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  ownScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=false
   */
  roles: Array<Role>;
  /**
   * sortable=false
   * groupable=true
   */
  timers: Array<ProcessTimer>;
  /**
   * sortable=true
   * groupable=false
   */
  username: Maybe<Scalars['String']['output']>;
};


/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type UserAllPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type UserAssignedRolesArgs = {
  filter?: InputMaybe<RoleUserFilterInput>;
};


/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type UserCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type UserIdentitiesArgs = {
  filter?: InputMaybe<UserIdentityFilterInput>;
};


/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type UserInheritedPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type UserOwnPermissionsArgs = {
  filter?: InputMaybe<AssignedPermissionFilterInput>;
};


/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export type UserTimersArgs = {
  filter?: InputMaybe<ProcessTimerFilterInput>;
};

/** description=A system user account with application roles, identities, permissions, and screen access. */
export type UserAggregate = {
  __typename?: 'UserAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A system user account with application roles, identities, permissions, and screen access. */
export type UserAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A system user account with application roles, identities, permissions, and screen access. */
export type UserAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** User */
export type UserCreatedEvent = {
  __typename?: 'UserCreatedEvent';
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/** User */
export type UserDeletedEvent = {
  __typename?: 'UserDeletedEvent';
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/** User */
export type UserDisabledEvent = {
  __typename?: 'UserDisabledEvent';
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/** User */
export type UserEnabledEvent = {
  __typename?: 'UserEnabledEvent';
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  assignedRoles?: InputMaybe<RoleUserFilterInput>;
  authProvider?: InputMaybe<StringFilterInput>;
  authProviderUid?: InputMaybe<StringFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  fullName?: InputMaybe<StringFilterInput>;
  hasPersonIdentity?: InputMaybe<BooleanFilterInput>;
  hasPin?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  identities?: InputMaybe<UserIdentityFilterInput>;
  includeSystem?: InputMaybe<BooleanFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isCurrent?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  oldRoles?: InputMaybe<UserRoleFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  reviewedSuppliers?: InputMaybe<SupplierFilterInput>;
  timers?: InputMaybe<ProcessTimerFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

/**
 * description=A link between a system user and the domain record that user represents.
 * displayName=User Identity
 * module=Admin
 * defaultQuery=userIdentities
 * iconName=id-number
 * colour=#5D35A6
 * aggregateQuery=userIdentitiesAggregate
 * grouping=true
 * queryPermission=Query_User_Identities
 */
export type UserIdentity = {
  __typename?: 'UserIdentity';
  /**
   * sortable=true
   * groupable=false
   */
  created: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * description=The schema type of the represented record.
   * sortable=true
   * groupable=false
   */
  entity: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * description=The person represented by a Person identity.
   * sortable=true
   * groupable=true
   */
  person: Maybe<Person>;
  /**
   * sortable=true
   * groupable=false
   */
  recordId: Maybe<Scalars['ID']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  recordLabel: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
  /**
   * sortable=true
   * groupable=false
   */
  userId: Maybe<Scalars['String']['output']>;
};


/**
 * description=A link between a system user and the domain record that user represents.
 * displayName=User Identity
 * module=Admin
 * defaultQuery=userIdentities
 * iconName=id-number
 * colour=#5D35A6
 * aggregateQuery=userIdentitiesAggregate
 * grouping=true
 * queryPermission=Query_User_Identities
 */
export type UserIdentityCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A link between a system user and the domain record that user represents. */
export type UserIdentityAggregate = {
  __typename?: 'UserIdentityAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A link between a system user and the domain record that user represents. */
export type UserIdentityAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A link between a system user and the domain record that user represents. */
export type UserIdentityAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserIdentityFilterInput = {
  and?: InputMaybe<Array<UserIdentityFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  /** The schema type of the represented record. */
  entity?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<UserIdentityFilterInput>>;
  /** The person represented by a Person identity. */
  person?: InputMaybe<PersonFilterInput>;
  recordId?: InputMaybe<IdFilterInput>;
  recordLabel?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  id: Scalars['ID']['output'];
  initialPath: Array<Scalars['String']['output']>;
  initialTab: Maybe<Scalars['String']['output']>;
  recordId: Maybe<Scalars['ID']['output']>;
  recordType: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  unread: Scalars['Boolean']['output'];
};

/**
 * description=A permission assigned directly to an application user.
 * displayName=User Permission
 * module=Admin
 * defaultQuery=userPermissions
 * iconName=key
 * colour=#5D35A6
 * aggregateQuery=userPermissionsAggregate
 * grouping=true
 * queryPermission=Query_User_Permissions
 */
export type UserPermission = {
  __typename?: 'UserPermission';
  /**
   * sortable=true
   * groupable=false
   */
  conditions: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  permission: Permission;
  /**
   * sortable=true
   * groupable=false
   */
  policy: Policy;
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
};


/**
 * description=A permission assigned directly to an application user.
 * displayName=User Permission
 * module=Admin
 * defaultQuery=userPermissions
 * iconName=key
 * colour=#5D35A6
 * aggregateQuery=userPermissionsAggregate
 * grouping=true
 * queryPermission=Query_User_Permissions
 */
export type UserPermissionCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A permission assigned directly to an application user. */
export type UserPermissionAggregate = {
  __typename?: 'UserPermissionAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A permission assigned directly to an application user. */
export type UserPermissionAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A permission assigned directly to an application user. */
export type UserPermissionAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPermissionFilterInput = {
  and?: InputMaybe<Array<UserPermissionFilterInput>>;
  conditions?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<UserPermissionFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
};

/** User */
export type UserPermissionsUpdatedEvent = {
  __typename?: 'UserPermissionsUpdatedEvent';
  assignedPermissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unassignedPermissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/** A User identity or a typed nested report dimension. */
export type UserReportDimensionValue = {
  __typename?: 'UserReportDimensionValue';
  branch: Maybe<BranchReportDimensionValue>;
  /** Stable machine-readable Resource identity. */
  key: Maybe<Scalars['String']['output']>;
  /** Display label for the Resource identity. */
  label: Maybe<Scalars['String']['output']>;
};

/** Select exactly one typed User report dimension. */
export type UserReportGroupByInput =
  /** Group by Branch or one of its dimensions. */
  { branch: BranchReportRelationDimensionInput; };

/** Groups by User identity, or traverses to one of its typed dimensions. */
export type UserReportRelationDimensionInput = {
  filter?: InputMaybe<UserFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<UserReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** User */
export type UserRestoredEvent = {
  __typename?: 'UserRestoredEvent';
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/**
 * description=A legacy operational role type attached to a user for workflow assignments.
 * displayName=Legacy User Role
 * module=Admin
 * defaultQuery=legacyUserRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=legacyUserRolesAggregate
 * grouping=true
 * queryPermission=Query_Legacy_User_Roles
 */
export type UserRole = {
  __typename?: 'UserRole';
  /**
   * sortable=true
   * groupable=true
   */
  businessRole: Maybe<BusinessRole>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  processAssignments: Array<ProcessAssignment>;
  /**
   * sortable=true
   * groupable=false
   */
  type: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=true
   */
  user: Maybe<User>;
};


/**
 * description=A legacy operational role type attached to a user for workflow assignments.
 * displayName=Legacy User Role
 * module=Admin
 * defaultQuery=legacyUserRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=legacyUserRolesAggregate
 * grouping=true
 * queryPermission=Query_Legacy_User_Roles
 */
export type UserRoleCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A legacy operational role type attached to a user for workflow assignments.
 * displayName=Legacy User Role
 * module=Admin
 * defaultQuery=legacyUserRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=legacyUserRolesAggregate
 * grouping=true
 * queryPermission=Query_Legacy_User_Roles
 */
export type UserRoleProcessAssignmentsArgs = {
  filter?: InputMaybe<ProcessAssignmentFilterInput>;
};

/** description=A legacy operational role type attached to a user for workflow assignments. */
export type UserRoleAggregate = {
  __typename?: 'UserRoleAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A legacy operational role type attached to a user for workflow assignments. */
export type UserRoleAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A legacy operational role type attached to a user for workflow assignments. */
export type UserRoleAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserRoleFilterInput = {
  and?: InputMaybe<Array<UserRoleFilterInput>>;
  businessRole?: InputMaybe<BusinessRoleFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<UserRoleFilterInput>>;
  processAssignments?: InputMaybe<ProcessAssignmentFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

/** User */
export type UserRolesUpdatedEvent = {
  __typename?: 'UserRolesUpdatedEvent';
  assignedRoles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unassignedRoles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/** User */
export type UserScreensUpdatedEvent = {
  __typename?: 'UserScreensUpdatedEvent';
  assignedScreens: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unassignedScreens: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/** User */
export type UserUpdatedEvent = {
  __typename?: 'UserUpdatedEvent';
  authProvider: Scalars['String']['output'];
  branch: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/**
 * description=A warehouse or stock location used to hold inventory products.
 * displayName=Warehouse
 * module=Inventory
 * defaultQuery=warehouses
 * iconName=office
 * colour=#596600
 * aggregateQuery=warehousesAggregate
 * grouping=true
 * queryPermission=Query_Warehouses
 */
export type Warehouse = {
  __typename?: 'Warehouse';
  /**
   * sortable=true
   * groupable=false
   */
  address: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  color: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=true
   */
  stock: Array<Stock>;
  /**
   * sortable=false
   * groupable=false
   */
  stockAggregate: Maybe<StockAggregate>;
};


/**
 * description=A warehouse or stock location used to hold inventory products.
 * displayName=Warehouse
 * module=Inventory
 * defaultQuery=warehouses
 * iconName=office
 * colour=#596600
 * aggregateQuery=warehousesAggregate
 * grouping=true
 * queryPermission=Query_Warehouses
 */
export type WarehouseCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/**
 * description=A warehouse or stock location used to hold inventory products.
 * displayName=Warehouse
 * module=Inventory
 * defaultQuery=warehouses
 * iconName=office
 * colour=#596600
 * aggregateQuery=warehousesAggregate
 * grouping=true
 * queryPermission=Query_Warehouses
 */
export type WarehouseStockArgs = {
  filter?: InputMaybe<StockFilterInput>;
};


/**
 * description=A warehouse or stock location used to hold inventory products.
 * displayName=Warehouse
 * module=Inventory
 * defaultQuery=warehouses
 * iconName=office
 * colour=#596600
 * aggregateQuery=warehousesAggregate
 * grouping=true
 * queryPermission=Query_Warehouses
 */
export type WarehouseStockAggregateArgs = {
  filter?: InputMaybe<StockFilterInput>;
};

/** description=A warehouse or stock location used to hold inventory products. */
export type WarehouseAggregate = {
  __typename?: 'WarehouseAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A warehouse or stock location used to hold inventory products. */
export type WarehouseAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A warehouse or stock location used to hold inventory products. */
export type WarehouseAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Warehouse */
export type WarehouseCreatedEvent = {
  __typename?: 'WarehouseCreatedEvent';
  warehouseId: Scalars['Int']['output'];
  warehouseName: Scalars['String']['output'];
};

/** Warehouse */
export type WarehouseDeletedEvent = {
  __typename?: 'WarehouseDeletedEvent';
  warehouseId: Scalars['Int']['output'];
  warehouseName: Scalars['String']['output'];
};

export type WarehouseFilterInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<WarehouseFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WarehouseFilterInput>>;
  stock?: InputMaybe<StockFilterInput>;
};

export type WarehouseStockInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['String']['input'];
};

/** Warehouse */
export type WarehouseStockReceivedEvent = {
  __typename?: 'WarehouseStockReceivedEvent';
  stock: Array<Maybe<Scalars['String']['output']>>;
  warehouseId: Scalars['Int']['output'];
  warehouseName: Scalars['String']['output'];
};

/** Warehouse */
export type WarehouseStockTakeEvent = {
  __typename?: 'WarehouseStockTakeEvent';
  countedStock: Array<Maybe<Scalars['String']['output']>>;
  stockDelta: Array<Maybe<Scalars['String']['output']>>;
  warehouseId: Scalars['Int']['output'];
  warehouseName: Scalars['String']['output'];
};

export type WarehouseStockTakeInput = {
  stock: Array<WarehouseStockInput>;
  warehouseId: Scalars['ID']['input'];
};

/** Warehouse */
export type WarehouseStockTransferReceivedEvent = {
  __typename?: 'WarehouseStockTransferReceivedEvent';
  receivedWarehouseId: Scalars['Int']['output'];
  receivedWarehouseName: Scalars['String']['output'];
  stock: Array<Maybe<Scalars['String']['output']>>;
  withdrawnWarehouseId: Scalars['Int']['output'];
  withdrawnWarehouseName: Scalars['String']['output'];
};

/** Warehouse */
export type WarehouseStockTransferWithdrawnEvent = {
  __typename?: 'WarehouseStockTransferWithdrawnEvent';
  receivedWarehouseId: Scalars['Int']['output'];
  receivedWarehouseName: Scalars['String']['output'];
  stock: Array<Maybe<Scalars['String']['output']>>;
  withdrawnWarehouseId: Scalars['Int']['output'];
  withdrawnWarehouseName: Scalars['String']['output'];
};

/** Warehouse */
export type WarehouseStockWithdrawnEvent = {
  __typename?: 'WarehouseStockWithdrawnEvent';
  stock: Array<Maybe<Scalars['String']['output']>>;
  warehouseId: Scalars['Int']['output'];
  warehouseName: Scalars['String']['output'];
};

/** Warehouse */
export type WarehouseUpdatedEvent = {
  __typename?: 'WarehouseUpdatedEvent';
  warehouseId: Scalars['Int']['output'];
  warehouseName: Scalars['String']['output'];
};

/**
 * description=An outbound webhook configured for an event and source filter.
 * displayName=Webhook
 * module=Admin
 * defaultQuery=webhooks
 * iconName=data-connection
 * colour=#5D35A6
 * aggregateQuery=webhooksAggregate
 * grouping=true
 * queryPermission=Query_Webhooks
 */
export type Webhook = {
  __typename?: 'Webhook';
  /**
   * sortable=true
   * groupable=false
   */
  authType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  created: Scalars['String']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  event: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  sourceFilter: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  url: Scalars['String']['output'];
};


/**
 * description=An outbound webhook configured for an event and source filter.
 * displayName=Webhook
 * module=Admin
 * defaultQuery=webhooks
 * iconName=data-connection
 * colour=#5D35A6
 * aggregateQuery=webhooksAggregate
 * grouping=true
 * queryPermission=Query_Webhooks
 */
export type WebhookCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=An outbound webhook configured for an event and source filter. */
export type WebhookAggregate = {
  __typename?: 'WebhookAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=An outbound webhook configured for an event and source filter. */
export type WebhookAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=An outbound webhook configured for an event and source filter. */
export type WebhookAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Webhook */
export type WebhookCallFailedEvent = {
  __typename?: 'WebhookCallFailedEvent';
  error: Scalars['String']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  webhookId: Scalars['String']['output'];
};

/** Webhook */
export type WebhookCalledEvent = {
  __typename?: 'WebhookCalledEvent';
  response: Scalars['String']['output'];
  url: Scalars['String']['output'];
  webhookId: Scalars['String']['output'];
};

export type WebhookCreatedEvent = {
  __typename?: 'WebhookCreatedEvent';
  webhook: Scalars['String']['output'];
};

export type WebhookDeletedEvent = {
  __typename?: 'WebhookDeletedEvent';
  webhook: Scalars['String']['output'];
};

export type WebhookFilterInput = {
  and?: InputMaybe<Array<WebhookFilterInput>>;
  authType?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  event?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WebhookFilterInput>>;
  sourceFilter?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type WebhookUpdatedEvent = {
  __typename?: 'WebhookUpdatedEvent';
  webhook: Scalars['String']['output'];
};

export type Week = {
  __typename?: 'Week';
  createdLeadAggregate: Maybe<LeadAggregate>;
  createdPurchaseOrderAggregate: Maybe<PurchaseOrderAggregate>;
  createdPurchaseOrderLineAggregate: Maybe<PurchaseOrderLineAggregate>;
  stockTransactionAggregate: Maybe<StockTransactionAggregate>;
  weekNumber: Scalars['String']['output'];
  weekNumberAndYear: Scalars['String']['output'];
  year: Scalars['String']['output'];
};


export type WeekCreatedLeadAggregateArgs = {
  filter?: InputMaybe<LeadFilterInput>;
};


export type WeekCreatedPurchaseOrderAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderFilterInput>;
};


export type WeekCreatedPurchaseOrderLineAggregateArgs = {
  filter?: InputMaybe<PurchaseOrderLineFilterInput>;
};


export type WeekStockTransactionAggregateArgs = {
  filter?: InputMaybe<StockTransactionFilterInput>;
};

export type WeekFilterInput = {
  date?: InputMaybe<DateTimeFilterInput>;
};

export type WithdrawWarehouseStockInput = {
  stock: Array<WarehouseStockInput>;
  warehouseId: Scalars['ID']['input'];
};

/**
 * description=A workflow containing the process and group nodes for manufacturing work.
 * displayName=Workflow
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type Workflow = {
  __typename?: 'Workflow';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  type: Maybe<WorkflowType>;
};


/**
 * description=A workflow containing the process and group nodes for manufacturing work.
 * displayName=Workflow
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type WorkflowCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type WorkflowFilterInput = {
  and?: InputMaybe<Array<WorkflowFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowFilterInput>>;
  type?: InputMaybe<WorkflowTypeFilterInput>;
};

/**
 * description=A process, group, or workflow node and its dependencies.
 * displayName=Workflow Node
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type WorkflowNode = {
  __typename?: 'WorkflowNode';
  /**
   * sortable=false
   * groupable=false
   */
  children: Array<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  nodeType: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  owner: Maybe<Scalars['String']['output']>;
  /**
   * sortable=false
   * groupable=false
   */
  parents: Array<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  status: Scalars['Int']['output'];
};


/**
 * description=A process, group, or workflow node and its dependencies.
 * displayName=Workflow Node
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export type WorkflowNodeCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

export type WorkflowNodeFilterInput = {
  and?: InputMaybe<Array<WorkflowNodeFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nodeType?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowNodeFilterInput>>;
  owner?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
};

/**
 * description=A note assigned directly to a workflow node.
 * displayName=Workflow Note
 * module=Manufacturing
 * defaultQuery=workflowNotes
 * iconName=message-square-text
 * colour=#A96500
 * aggregateQuery=workflowNotesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Notes
 */
export type WorkflowNote = {
  __typename?: 'WorkflowNote';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  createdBy: Maybe<User>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modified: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  nodeId: Scalars['ID']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  processInstance: Maybe<ProcessInstance>;
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
};


/**
 * description=A note assigned directly to a workflow node.
 * displayName=Workflow Note
 * module=Manufacturing
 * defaultQuery=workflowNotes
 * iconName=message-square-text
 * colour=#A96500
 * aggregateQuery=workflowNotesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Notes
 */
export type WorkflowNoteCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A note assigned directly to a workflow node. */
export type WorkflowNoteAggregate = {
  __typename?: 'WorkflowNoteAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A note assigned directly to a workflow node. */
export type WorkflowNoteAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A note assigned directly to a workflow node. */
export type WorkflowNoteAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowNoteFilterInput = {
  and?: InputMaybe<Array<WorkflowNoteFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  nodeId?: InputMaybe<IdFilterInput>;
  or?: InputMaybe<Array<WorkflowNoteFilterInput>>;
  processInstance?: InputMaybe<ProcessInstanceFilterInput>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
};

/**
 * description=A reusable workflow definition that can be assigned to workflow subjects.
 * displayName=Workflow Template
 * module=Manufacturing
 * defaultQuery=workflowTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=workflowTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Templates
 */
export type WorkflowTemplate = {
  __typename?: 'WorkflowTemplate';
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  display: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  placeHolder: Scalars['Boolean']['output'];
  /**
   * description=Placeholder workflow selections required by this template.
   * sortable=false
   * groupable=false
   */
  placeholders: Array<WorkflowTemplatePlaceholder>;
  /**
   * description=Workflow diagram group label data for previewing this template.
   * sortable=false
   * groupable=false
   */
  previewGroupInstances: Array<WorkflowTemplatePreviewGroupInstance>;
  /**
   * description=Workflow diagram item data for previewing this template.
   * sortable=false
   * groupable=false
   */
  previewItems: Array<WorkflowTemplatePreviewItem>;
  /**
   * sortable=true
   * groupable=false
   */
  valid: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  workflowType: Maybe<WorkflowType>;
};


/**
 * description=A reusable workflow definition that can be assigned to workflow subjects.
 * displayName=Workflow Template
 * module=Manufacturing
 * defaultQuery=workflowTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=workflowTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Templates
 */
export type WorkflowTemplateCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A reusable workflow definition that can be assigned to workflow subjects. */
export type WorkflowTemplateAggregate = {
  __typename?: 'WorkflowTemplateAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A reusable workflow definition that can be assigned to workflow subjects. */
export type WorkflowTemplateAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A reusable workflow definition that can be assigned to workflow subjects. */
export type WorkflowTemplateAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowTemplateFilterInput = {
  and?: InputMaybe<Array<WorkflowTemplateFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  display?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowTemplateFilterInput>>;
  placeHolder?: InputMaybe<BooleanFilterInput>;
  valid?: InputMaybe<BooleanFilterInput>;
  workflowType?: InputMaybe<WorkflowTypeFilterInput>;
};

export type WorkflowTemplatePlaceholder = {
  __typename?: 'WorkflowTemplatePlaceholder';
  description: Maybe<Scalars['String']['output']>;
  display: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  options: Array<WorkflowTemplatePlaceholderOption>;
};

export type WorkflowTemplatePlaceholderOption = {
  __typename?: 'WorkflowTemplatePlaceholderOption';
  description: Maybe<Scalars['String']['output']>;
  display: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  placeholders: Array<WorkflowTemplatePlaceholder>;
  previewGroupInstances: Array<WorkflowTemplatePreviewGroupInstance>;
  previewItems: Array<WorkflowTemplatePreviewItem>;
};

export type WorkflowTemplatePreviewGroupInstance = {
  __typename?: 'WorkflowTemplatePreviewGroupInstance';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  workflow: WorkflowTemplatePreviewGroupWorkflow;
};

export type WorkflowTemplatePreviewGroupWorkflow = {
  __typename?: 'WorkflowTemplatePreviewGroupWorkflow';
  id: Scalars['ID']['output'];
  type: Maybe<WorkflowTemplatePreviewWorkflowType>;
};

export type WorkflowTemplatePreviewItem = {
  __typename?: 'WorkflowTemplatePreviewItem';
  children: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nodeType: Scalars['String']['output'];
  owner: Maybe<Scalars['String']['output']>;
  parents: Array<Scalars['String']['output']>;
  processTypeId: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
};

export type WorkflowTemplatePreviewWorkflowType = {
  __typename?: 'WorkflowTemplatePreviewWorkflowType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/**
 * description=A manufacturing workflow definition made up of ordered process steps.
 * displayName=Workflow Type
 * module=Manufacturing
 * defaultQuery=workflowTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=workflowTypesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Types
 */
export type WorkflowType = {
  __typename?: 'WorkflowType';
  /**
   * sortable=true
   * groupable=true
   */
  created: Scalars['DateTime']['output'];
  /**
   * sortable=false
   * groupable=false
   */
  customData: Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * sortable=true
   * groupable=false
   */
  id: Scalars['ID']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  label: Scalars['String']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  master: Scalars['Boolean']['output'];
  /**
   * sortable=true
   * groupable=true
   */
  modified: Scalars['DateTime']['output'];
  /**
   * sortable=true
   * groupable=false
   */
  name: Scalars['String']['output'];
};


/**
 * description=A manufacturing workflow definition made up of ordered process steps.
 * displayName=Workflow Type
 * module=Manufacturing
 * defaultQuery=workflowTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=workflowTypesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Types
 */
export type WorkflowTypeCustomDataArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};

/** description=A manufacturing workflow definition made up of ordered process steps. */
export type WorkflowTypeAggregate = {
  __typename?: 'WorkflowTypeAggregate';
  count: Scalars['Int']['output'];
  customDataAggregate: Maybe<CustomDataAggregate>;
  groups: ResourceGroupPage;
};


/** description=A manufacturing workflow definition made up of ordered process steps. */
export type WorkflowTypeAggregateCustomDataAggregateArgs = {
  filter?: InputMaybe<CustomDataFilterInput>;
};


/** description=A manufacturing workflow definition made up of ordered process steps. */
export type WorkflowTypeAggregateGroupsArgs = {
  by: ResourceGroupByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** WorkflowType */
export type WorkflowTypeCreatedEvent = {
  __typename?: 'WorkflowTypeCreatedEvent';
  workflowTypeId: Scalars['String']['output'];
  workflowTypeName: Scalars['String']['output'];
};

/** WorkflowType */
export type WorkflowTypeDeletedEvent = {
  __typename?: 'WorkflowTypeDeletedEvent';
  workflowTypeId: Scalars['String']['output'];
  workflowTypeName: Scalars['String']['output'];
};

export type WorkflowTypeFilterInput = {
  and?: InputMaybe<Array<WorkflowTypeFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  master?: InputMaybe<BooleanFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowTypeFilterInput>>;
};

/** WorkflowType */
export type WorkflowTypeRestoredEvent = {
  __typename?: 'WorkflowTypeRestoredEvent';
  workflowTypeId: Scalars['String']['output'];
  workflowTypeName: Scalars['String']['output'];
};

/** WorkflowType */
export type WorkflowTypeUpdatedEvent = {
  __typename?: 'WorkflowTypeUpdatedEvent';
  workflowTypeId: Scalars['String']['output'];
  workflowTypeName: Scalars['String']['output'];
};

export type IsPermittedQueryVariables = Exact<{
  permissions: Array<PermissionCheckInput> | PermissionCheckInput;
}>;


export type IsPermittedQuery = { __typename?: 'Query', isPermitted: boolean | null };

export type CurrentUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserNotificationsQuery = { __typename?: 'Query', currentUserNotifications: Array<{ __typename?: 'UserNotification', id: string, title: string, text: string, unread: boolean, timestamp: number, recordType: string | null, recordId: string | null, initialTab: string | null, initialPath: Array<string> }> | null };

export type UpdateCurrentUserNotificationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  action: NotificationAction;
}>;


export type UpdateCurrentUserNotificationsMutation = { __typename?: 'Mutation', updateCurrentUserNotifications: boolean };

export type PrepareActAsUserSessionQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type PrepareActAsUserSessionQuery = { __typename?: 'Query', actAsUsers: Array<{ __typename?: 'ActAsUser', id: string, fullName: string | null, isActive: boolean, deleted: boolean, permissions: Array<{ __typename?: 'AssignedPermission', policy: Policy, permission: { __typename?: 'Permission', id: string } }>, screens: Array<{ __typename?: 'Screen', id: string, name: string, icon: string | null, group: string | null }> }> | null };

export type CurrentUserSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserSessionQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, fullName: string | null, isActive: boolean, deleted: boolean, permissions: Array<{ __typename?: 'AssignedPermission', policy: Policy, permission: { __typename?: 'Permission', id: string } }>, screens: Array<{ __typename?: 'Screen', id: string, name: string, icon: string | null, group: string | null }> } | null };

export type UserSwitcherPermissionsQueryVariables = Exact<{
  admin: Scalars['String']['input'];
  regular: Scalars['String']['input'];
}>;


export type UserSwitcherPermissionsQuery = { __typename?: 'Query', admin: boolean | null, regular: boolean | null };

export type GetSystemSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemSettingsQuery = { __typename?: 'Query', systemSettings: { __typename?: 'DataStoreRecord', data: string | null } | null };

export type UpdateSystemSettingsMutationVariables = Exact<{
  input: UpdateSettingsInput;
}>;


export type UpdateSystemSettingsMutation = { __typename?: 'Mutation', updateSettings: string };

export type CreateHousingCompanyMutationVariables = Exact<{
  input: CreateHousingCompanyInput;
}>;


export type CreateHousingCompanyMutation = { __typename?: 'Mutation', createHousingCompany: string | null };

export type CreateJobEmailMutationVariables = Exact<{
  input: CreateJobEmailInput;
}>;


export type CreateJobEmailMutation = { __typename?: 'Mutation', createJobEmail: string };

export type GetUploadRequestUrlQueryVariables = Exact<{
  jobNumber: Scalars['String']['input'];
  area: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type GetUploadRequestUrlQuery = { __typename?: 'Query', uploadRequestUrl: { __typename?: 'UploadRequestUrl', url: string, method: string, headers: string } | null };

export type GetJobDetailsQueryVariables = Exact<{
  jobNumber: Scalars['String']['input'];
}>;


export type GetJobDetailsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'Job', siteAddress: string | null, client: { __typename?: 'Client', fullName: string } | null }> | null };

export type NotifyJobPhotoRecipientsMutationVariables = Exact<{
  jobNumber: Scalars['String']['input'];
  area: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotifyJobPhotoRecipientsMutation = { __typename?: 'Mutation', notifyJobPhotoRecipients: boolean };

export type AssignUsersToProcessInstanceMutationVariables = Exact<{
  userRoles: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  processInstanceId: Scalars['ID']['input'];
}>;


export type AssignUsersToProcessInstanceMutation = { __typename?: 'Mutation', assignUsersToProcessInstance: string };

export type ListProductsAndCategoriesQueryDocumentQueryVariables = Exact<{
  productsOptions?: InputMaybe<OptionsInput>;
  productsFilter?: InputMaybe<ProductFilterInput>;
  categoriesOptions?: InputMaybe<OptionsInput>;
  categoriesFilter?: InputMaybe<ProductCategoryFilterInput>;
}>;


export type ListProductsAndCategoriesQueryDocumentQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name: string, code: string | null, currentBuyPrice: number | null, currentSellPrice: number | null, category: { __typename?: 'ProductCategory', id: string } | null }> | null, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, parent: { __typename?: 'ProductCategory', id: string, name: string, parent: { __typename?: 'ProductCategory', id: string, name: string, parent: { __typename?: 'ProductCategory', id: string, name: string } | null } | null } | null }> | null };

export type MatchProductsQueryVariables = Exact<{
  codes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  supplier: Scalars['ID']['input'];
}>;


export type MatchProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, code: string | null, name: string, currentBuyPrice: number | null }> | null };

export type BulkImportProductMutationVariables = Exact<{
  productsToImport: Array<ProductImportInput> | ProductImportInput;
  updateFields: Array<ProductImportUpdateField> | ProductImportUpdateField;
}>;


export type BulkImportProductMutation = { __typename?: 'Mutation', bulkProductImport: string | null };

export type AvailableTagsQueryVariables = Exact<{
  resourceType: Scalars['String']['input'];
}>;


export type AvailableTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string, description: string | null, colour: string | null }> | null };

export type ProcessTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessTypesQueryQuery = { __typename?: 'Query', processTypes: Array<{ __typename?: 'ProcessType', id: string, name: string }> | null };

export type GetUserTimerTransactionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type GetUserTimerTransactionsQuery = { __typename?: 'Query', timerTransactions: Array<{ __typename?: 'TimerTransaction', start: string | null, stop: string | null, timer: { __typename?: 'ProcessTimer', status: string | null, items: Array<{ __typename?: 'ProcessTimerItem', processType: { __typename?: 'ProcessType', name: string }, lineItemMasterWorkflow: { __typename?: 'LineItemMasterWorkflow', lineItem: { __typename?: 'LineItem', partNumber: string | null } | null } }> } | null }> | null };

export type CreateQuoteApprovalRequestMutationVariables = Exact<{
  input: CreateQuoteApprovalRequestInput;
}>;


export type CreateQuoteApprovalRequestMutation = { __typename?: 'Mutation', createQuoteApprovalRequest: string };

export type SubmitQuoteForApprovalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubmitQuoteForApprovalMutation = { __typename?: 'Mutation', submitQuoteForApproval: string };

export type GetSupplierQuoteRequestQueryVariables = Exact<{
  supplierQuoteRequestId: Scalars['ID']['input'];
}>;


export type GetSupplierQuoteRequestQuery = { __typename?: 'Query', supplierQuoteRequests: Array<{ __typename?: 'SupplierQuoteRequest', id: string, status: number, reference: string, supplier: { __typename?: 'Supplier', name: string } | null, job: { __typename?: 'Job', jobNumber: string | null } | null }> | null };

export type PromoteSchemaVersionMutationVariables = Exact<{
  input: PromoteSchemaVersionInput;
}>;


export type PromoteSchemaVersionMutation = { __typename?: 'Mutation', promoteSchemaVersion: string | null };

export type UpdateUserSubscriptionsMutationVariables = Exact<{
  input: UpdateUserSubscriptionsInput;
}>;


export type UpdateUserSubscriptionsMutation = { __typename?: 'Mutation', updateUserSubscriptions: boolean };

export type ListUserTimersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserTimersQueryQuery = { __typename?: 'Query', timers: Array<{ __typename?: 'ProcessTimer', id: string, status: string | null, elapsedTime: number | null, transactions: Array<{ __typename?: 'TimerTransaction', id: string }>, items: Array<{ __typename?: 'ProcessTimerItem', processType: { __typename?: 'ProcessType', id: string, name: string }, lineItemMasterWorkflow: { __typename?: 'LineItemMasterWorkflow', lineItem: { __typename?: 'LineItem', id: string, partNumber: string | null } | null } }> }> | null };

export type CreateProcessTimerMutationVariables = Exact<{
  input: CreateProcessTimerInput;
}>;


export type CreateProcessTimerMutation = { __typename?: 'Mutation', createProcessTimer: string | null };

export type PauseTimersMutationVariables = Exact<{
  timerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PauseTimersMutation = { __typename?: 'Mutation', pauseTimers: string | null };

export type ResumeTimersMutationVariables = Exact<{
  timerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ResumeTimersMutation = { __typename?: 'Mutation', resumeTimers: string | null };

export type CompleteTimersMutationVariables = Exact<{
  timerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CompleteTimersMutation = { __typename?: 'Mutation', completeTimers: string | null };

export type BranchesFilterQueryVariables = Exact<{
  input?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BranchesFilterQuery = { __typename?: 'Query', branches: Array<{ __typename?: 'Branch', id: string, name: string }> | null };

export type GetSuppliersQueryVariables = Exact<{
  options?: InputMaybe<OptionsInput>;
  filter?: InputMaybe<SupplierFilterInput>;
}>;


export type GetSuppliersQuery = { __typename?: 'Query', suppliers: Array<{ __typename?: 'Supplier', id: string, deleted: boolean, name: string, cell: string | null, email: string | null, url: string | null, currency: string | null, category: { __typename?: 'SupplierCategory', id: string, name: string } | null, image: { __typename?: 'File', hash: string | null } | null }> | null };

export type GetSuppliersFilterQueryVariables = Exact<{
  input?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetSuppliersFilterQuery = { __typename?: 'Query', suppliers: Array<{ __typename?: 'Supplier', id: string, name: string }> | null };

export type DesignersFilterQueryVariables = Exact<{
  input?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DesignersFilterQuery = { __typename?: 'Query', personBusinessRoles: Array<{ __typename?: 'PersonBusinessRole', id: string, label: string }> | null };

export type GetHousingCompaniesFilterQueryVariables = Exact<{
  input?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetHousingCompaniesFilterQuery = { __typename?: 'Query', housingCompanies: Array<{ __typename?: 'HousingCompany', id: string, name: string | null, deleted: boolean }> | null };

export type ProjectManagersFilterQueryVariables = Exact<{
  input?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProjectManagersFilterQuery = { __typename?: 'Query', personBusinessRoles: Array<{ __typename?: 'PersonBusinessRole', id: string, label: string }> | null };

export type RegionsFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsFilterQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string }> | null };

export type GetClientCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientCardQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, fullName: string, phoneWork: string | null, phoneHome: string | null, phoneCell: string | null, email: string | null, address: string | null, notes: string | null } | null };

export type GetClientDialogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientDialogQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, firstName: string | null, lastName: string | null, phoneWork: string | null, phoneHome: string | null, phoneCell: string | null, email: string | null, address: string | null, faxHome: string | null, notes: string | null } | null };

export type GetBuildersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuildersQuery = { __typename?: 'Query', builders: Array<{ __typename?: 'Builder', id: string, name: string }> | null };

export type SupplierQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierQuery = { __typename?: 'Query', supplier: { __typename?: 'Supplier', cell: string | null, id: string, currency: string | null, email: string | null, name: string, address: string | null, numberOfReviews: string, orderEmails: Array<string>, quantityThreshold: string, quoteEmails: Array<string>, reviewType: string, url: string | null, image: { __typename?: 'File', hash: string | null } | null, reviewers: Array<{ __typename?: 'User', fullName: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }>, category: { __typename?: 'SupplierCategory', id: string, name: string } | null } | null };


export const IsPermittedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isPermitted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PermissionCheckInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPermitted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"permissions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}}}]}]}}]} as unknown as DocumentNode<IsPermittedQuery, IsPermittedQueryVariables>;
export const CurrentUserNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"initialTab"}},{"kind":"Field","name":{"kind":"Name","value":"initialPath"}}]}}]}}]} as unknown as DocumentNode<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>;
export const UpdateCurrentUserNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCurrentUserNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationAction"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentUserNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}}]}]}}]} as unknown as DocumentNode<UpdateCurrentUserNotificationsMutation, UpdateCurrentUserNotificationsMutationVariables>;
export const PrepareActAsUserSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrepareActAsUserSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actAsUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","alias":{"kind":"Name","value":"permissions"},"name":{"kind":"Name","value":"allPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"screens"},"name":{"kind":"Name","value":"allScreens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareActAsUserSessionQuery, PrepareActAsUserSessionQueryVariables>;
export const CurrentUserSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","alias":{"kind":"Name","value":"permissions"},"name":{"kind":"Name","value":"allPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"screens"},"name":{"kind":"Name","value":"allScreens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserSessionQuery, CurrentUserSessionQueryVariables>;
export const UserSwitcherPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSwitcherPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"admin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regular"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"admin"},"name":{"kind":"Name","value":"isPermitted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"permissions"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"permission"},"value":{"kind":"Variable","name":{"kind":"Name","value":"admin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"conditions"},"value":{"kind":"StringValue","value":"{}","block":false}}]}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"regular"},"name":{"kind":"Name","value":"isPermitted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"permissions"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"permission"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regular"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"conditions"},"value":{"kind":"StringValue","value":"{}","block":false}}]}]}}]}]}}]} as unknown as DocumentNode<UserSwitcherPermissionsQuery, UserSwitcherPermissionsQueryVariables>;
export const GetSystemSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSystemSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>;
export const UpdateSystemSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSystemSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>;
export const CreateHousingCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createHousingCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateHousingCompanyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createHousingCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateHousingCompanyMutation, CreateHousingCompanyMutationVariables>;
export const CreateJobEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createJobEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateJobEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJobEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateJobEmailMutation, CreateJobEmailMutationVariables>;
export const GetUploadRequestUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUploadRequestUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadRequestUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"area"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"headers"}}]}}]}}]} as unknown as DocumentNode<GetUploadRequestUrlQuery, GetUploadRequestUrlQueryVariables>;
export const GetJobDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siteAddress"}}]}}]}}]} as unknown as DocumentNode<GetJobDetailsQuery, GetJobDetailsQueryVariables>;
export const NotifyJobPhotoRecipientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notifyJobPhotoRecipients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifyJobPhotoRecipients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"area"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}]}]}}]} as unknown as DocumentNode<NotifyJobPhotoRecipientsMutation, NotifyJobPhotoRecipientsMutationVariables>;
export const AssignUsersToProcessInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignUsersToProcessInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processInstanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignUsersToProcessInstance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userRoles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}}},{"kind":"Argument","name":{"kind":"Name","value":"processInstanceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processInstanceId"}}}]}]}}]} as unknown as DocumentNode<AssignUsersToProcessInstanceMutation, AssignUsersToProcessInstanceMutationVariables>;
export const ListProductsAndCategoriesQueryDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProductsAndCategoriesQueryDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productsOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OptionsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoriesOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OptionsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoriesFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategoryFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productsOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"currentBuyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"currentSellPrice"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoriesOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoriesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListProductsAndCategoriesQueryDocumentQuery, ListProductsAndCategoriesQueryDocumentQueryVariables>;
export const MatchProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"matchProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codes"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"supplier"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentBuyPrice"}}]}}]}}]} as unknown as DocumentNode<MatchProductsQuery, MatchProductsQueryVariables>;
export const BulkImportProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkImportProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productsToImport"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImportInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImportUpdateField"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkProductImport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productsToImport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productsToImport"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}}}]}]}}]} as unknown as DocumentNode<BulkImportProductMutation, BulkImportProductMutationVariables>;
export const AvailableTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"availableTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}}]}}]}}]} as unknown as DocumentNode<AvailableTagsQuery, AvailableTagsQueryVariables>;
export const ProcessTypesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"processTypesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProcessTypesQueryQuery, ProcessTypesQueryQueryVariables>;
export const GetUserTimerTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserTimerTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timerTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timer"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"start","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"DESC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"stop"}},{"kind":"Field","name":{"kind":"Name","value":"timer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemMasterWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partNumber"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserTimerTransactionsQuery, GetUserTimerTransactionsQueryVariables>;
export const CreateQuoteApprovalRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createQuoteApprovalRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateQuoteApprovalRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createQuoteApprovalRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateQuoteApprovalRequestMutation, CreateQuoteApprovalRequestMutationVariables>;
export const SubmitQuoteForApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitQuoteForApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitQuoteForApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<SubmitQuoteForApprovalMutation, SubmitQuoteForApprovalMutationVariables>;
export const GetSupplierQuoteRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSupplierQuoteRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierQuoteRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierQuoteRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierQuoteRequestId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]} as unknown as DocumentNode<GetSupplierQuoteRequestQuery, GetSupplierQuoteRequestQueryVariables>;
export const PromoteSchemaVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"promoteSchemaVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PromoteSchemaVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoteSchemaVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<PromoteSchemaVersionMutation, PromoteSchemaVersionMutationVariables>;
export const UpdateUserSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserSubscriptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateUserSubscriptionsMutation, UpdateUserSubscriptionsMutationVariables>;
export const ListUserTimersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listUserTimersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"StringValue","value":"20","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"elapsedTime"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemMasterWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListUserTimersQueryQuery, ListUserTimersQueryQueryVariables>;
export const CreateProcessTimerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProcessTimer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProcessTimerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProcessTimer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateProcessTimerMutation, CreateProcessTimerMutationVariables>;
export const PauseTimersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pauseTimers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pauseTimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timerIds"}}}]}]}}]} as unknown as DocumentNode<PauseTimersMutation, PauseTimersMutationVariables>;
export const ResumeTimersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resumeTimers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resumeTimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timerIds"}}}]}]}}]} as unknown as DocumentNode<ResumeTimersMutation, ResumeTimersMutationVariables>;
export const CompleteTimersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"completeTimers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeTimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timerIds"}}}]}]}}]} as unknown as DocumentNode<CompleteTimersMutation, CompleteTimersMutationVariables>;
export const BranchesFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"branchesFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"branches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"likeAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<BranchesFilterQuery, BranchesFilterQueryVariables>;
export const GetSuppliersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSuppliers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OptionsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cell"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]}}]}}]} as unknown as DocumentNode<GetSuppliersQuery, GetSuppliersQueryVariables>;
export const GetSuppliersFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSuppliersFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"likeAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSuppliersFilterQuery, GetSuppliersFilterQueryVariables>;
export const DesignersFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"designersFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personBusinessRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"person"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"likeAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessRole"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"StringValue","value":"Designer","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"label","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<DesignersFilterQuery, DesignersFilterQueryVariables>;
export const GetHousingCompaniesFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHousingCompaniesFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"housingCompanies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"likeAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"deleted","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<GetHousingCompaniesFilterQuery, GetHousingCompaniesFilterQueryVariables>;
export const ProjectManagersFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectManagersFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personBusinessRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"person"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"likeAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessRole"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"StringValue","value":"Project Manager","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"label","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<ProjectManagersFilterQuery, ProjectManagersFilterQueryVariables>;
export const RegionsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"regionsFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RegionsFilterQuery, RegionsFilterQueryVariables>;
export const GetClientCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneWork"}},{"kind":"Field","name":{"kind":"Name","value":"phoneHome"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCell"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<GetClientCardQuery, GetClientCardQueryVariables>;
export const GetClientDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneWork"}},{"kind":"Field","name":{"kind":"Name","value":"phoneHome"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCell"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"faxHome"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<GetClientDialogQuery, GetClientDialogQueryVariables>;
export const GetBuildersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBuilders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"StringValue","value":"ASC","block":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetBuildersQuery, GetBuildersQueryVariables>;
export const SupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"supplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cell"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfReviews"}},{"kind":"Field","name":{"kind":"Name","value":"orderEmails"}},{"kind":"Field","name":{"kind":"Name","value":"quantityThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"quoteEmails"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<SupplierQuery, SupplierQueryVariables>;

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIsPermittedQuery(
 *   ({ query, variables }) => {
 *     const { permissions } = variables;
 *     return HttpResponse.json({
 *       data: { isPermitted }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockIsPermittedQuery = (resolver: GraphQLResponseResolver<IsPermittedQuery, IsPermittedQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<IsPermittedQuery, IsPermittedQueryVariables>(
    'isPermitted',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCurrentUserNotificationsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { currentUserNotifications }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCurrentUserNotificationsQuery = (resolver: GraphQLResponseResolver<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>(
    'CurrentUserNotifications',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCurrentUserNotificationsMutation(
 *   ({ query, variables }) => {
 *     const { ids, action } = variables;
 *     return HttpResponse.json({
 *       data: { updateCurrentUserNotifications }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCurrentUserNotificationsMutation = (resolver: GraphQLResponseResolver<UpdateCurrentUserNotificationsMutation, UpdateCurrentUserNotificationsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCurrentUserNotificationsMutation, UpdateCurrentUserNotificationsMutationVariables>(
    'UpdateCurrentUserNotifications',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPrepareActAsUserSessionQuery(
 *   ({ query, variables }) => {
 *     const { userId } = variables;
 *     return HttpResponse.json({
 *       data: { actAsUsers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPrepareActAsUserSessionQuery = (resolver: GraphQLResponseResolver<PrepareActAsUserSessionQuery, PrepareActAsUserSessionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PrepareActAsUserSessionQuery, PrepareActAsUserSessionQueryVariables>(
    'PrepareActAsUserSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCurrentUserSessionQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { currentUser }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCurrentUserSessionQuery = (resolver: GraphQLResponseResolver<CurrentUserSessionQuery, CurrentUserSessionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CurrentUserSessionQuery, CurrentUserSessionQueryVariables>(
    'CurrentUserSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserSwitcherPermissionsQuery(
 *   ({ query, variables }) => {
 *     const { admin, regular } = variables;
 *     return HttpResponse.json({
 *       data: { isPermitted, isPermitted }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserSwitcherPermissionsQuery = (resolver: GraphQLResponseResolver<UserSwitcherPermissionsQuery, UserSwitcherPermissionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserSwitcherPermissionsQuery, UserSwitcherPermissionsQueryVariables>(
    'UserSwitcherPermissions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSystemSettingsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { systemSettings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSystemSettingsQuery = (resolver: GraphQLResponseResolver<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
    'getSystemSettings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSystemSettingsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { updateSettings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateSystemSettingsMutation = (resolver: GraphQLResponseResolver<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>(
    'updateSystemSettings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateHousingCompanyMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { createHousingCompany }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateHousingCompanyMutation = (resolver: GraphQLResponseResolver<CreateHousingCompanyMutation, CreateHousingCompanyMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateHousingCompanyMutation, CreateHousingCompanyMutationVariables>(
    'createHousingCompany',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateJobEmailMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { createJobEmail }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateJobEmailMutation = (resolver: GraphQLResponseResolver<CreateJobEmailMutation, CreateJobEmailMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateJobEmailMutation, CreateJobEmailMutationVariables>(
    'createJobEmail',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetUploadRequestUrlQuery(
 *   ({ query, variables }) => {
 *     const { jobNumber, area, notes, fileName } = variables;
 *     return HttpResponse.json({
 *       data: { uploadRequestUrl }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetUploadRequestUrlQuery = (resolver: GraphQLResponseResolver<GetUploadRequestUrlQuery, GetUploadRequestUrlQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetUploadRequestUrlQuery, GetUploadRequestUrlQueryVariables>(
    'getUploadRequestUrl',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetJobDetailsQuery(
 *   ({ query, variables }) => {
 *     const { jobNumber } = variables;
 *     return HttpResponse.json({
 *       data: { jobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetJobDetailsQuery = (resolver: GraphQLResponseResolver<GetJobDetailsQuery, GetJobDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetJobDetailsQuery, GetJobDetailsQueryVariables>(
    'getJobDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockNotifyJobPhotoRecipientsMutation(
 *   ({ query, variables }) => {
 *     const { jobNumber, area, notes } = variables;
 *     return HttpResponse.json({
 *       data: { notifyJobPhotoRecipients }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockNotifyJobPhotoRecipientsMutation = (resolver: GraphQLResponseResolver<NotifyJobPhotoRecipientsMutation, NotifyJobPhotoRecipientsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<NotifyJobPhotoRecipientsMutation, NotifyJobPhotoRecipientsMutationVariables>(
    'notifyJobPhotoRecipients',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssignUsersToProcessInstanceMutation(
 *   ({ query, variables }) => {
 *     const { userRoles, processInstanceId } = variables;
 *     return HttpResponse.json({
 *       data: { assignUsersToProcessInstance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssignUsersToProcessInstanceMutation = (resolver: GraphQLResponseResolver<AssignUsersToProcessInstanceMutation, AssignUsersToProcessInstanceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AssignUsersToProcessInstanceMutation, AssignUsersToProcessInstanceMutationVariables>(
    'assignUsersToProcessInstance',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListProductsAndCategoriesQueryDocumentQuery(
 *   ({ query, variables }) => {
 *     const { productsOptions, productsFilter, categoriesOptions, categoriesFilter } = variables;
 *     return HttpResponse.json({
 *       data: { products, productCategories }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockListProductsAndCategoriesQueryDocumentQuery = (resolver: GraphQLResponseResolver<ListProductsAndCategoriesQueryDocumentQuery, ListProductsAndCategoriesQueryDocumentQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ListProductsAndCategoriesQueryDocumentQuery, ListProductsAndCategoriesQueryDocumentQueryVariables>(
    'listProductsAndCategoriesQueryDocument',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMatchProductsQuery(
 *   ({ query, variables }) => {
 *     const { codes, supplier } = variables;
 *     return HttpResponse.json({
 *       data: { products }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMatchProductsQuery = (resolver: GraphQLResponseResolver<MatchProductsQuery, MatchProductsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MatchProductsQuery, MatchProductsQueryVariables>(
    'matchProducts',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkImportProductMutation(
 *   ({ query, variables }) => {
 *     const { productsToImport, updateFields } = variables;
 *     return HttpResponse.json({
 *       data: { bulkProductImport }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkImportProductMutation = (resolver: GraphQLResponseResolver<BulkImportProductMutation, BulkImportProductMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BulkImportProductMutation, BulkImportProductMutationVariables>(
    'bulkImportProduct',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAvailableTagsQuery(
 *   ({ query, variables }) => {
 *     const { resourceType } = variables;
 *     return HttpResponse.json({
 *       data: { tags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAvailableTagsQuery = (resolver: GraphQLResponseResolver<AvailableTagsQuery, AvailableTagsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AvailableTagsQuery, AvailableTagsQueryVariables>(
    'availableTags',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcessTypesQueryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { processTypes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcessTypesQueryQuery = (resolver: GraphQLResponseResolver<ProcessTypesQueryQuery, ProcessTypesQueryQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProcessTypesQueryQuery, ProcessTypesQueryQueryVariables>(
    'processTypesQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetUserTimerTransactionsQuery(
 *   ({ query, variables }) => {
 *     const { userId, from, to } = variables;
 *     return HttpResponse.json({
 *       data: { timerTransactions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetUserTimerTransactionsQuery = (resolver: GraphQLResponseResolver<GetUserTimerTransactionsQuery, GetUserTimerTransactionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetUserTimerTransactionsQuery, GetUserTimerTransactionsQueryVariables>(
    'getUserTimerTransactions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateQuoteApprovalRequestMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { createQuoteApprovalRequest }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateQuoteApprovalRequestMutation = (resolver: GraphQLResponseResolver<CreateQuoteApprovalRequestMutation, CreateQuoteApprovalRequestMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateQuoteApprovalRequestMutation, CreateQuoteApprovalRequestMutationVariables>(
    'createQuoteApprovalRequest',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitQuoteForApprovalMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { submitQuoteForApproval }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitQuoteForApprovalMutation = (resolver: GraphQLResponseResolver<SubmitQuoteForApprovalMutation, SubmitQuoteForApprovalMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitQuoteForApprovalMutation, SubmitQuoteForApprovalMutationVariables>(
    'submitQuoteForApproval',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSupplierQuoteRequestQuery(
 *   ({ query, variables }) => {
 *     const { supplierQuoteRequestId } = variables;
 *     return HttpResponse.json({
 *       data: { supplierQuoteRequests }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSupplierQuoteRequestQuery = (resolver: GraphQLResponseResolver<GetSupplierQuoteRequestQuery, GetSupplierQuoteRequestQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSupplierQuoteRequestQuery, GetSupplierQuoteRequestQueryVariables>(
    'getSupplierQuoteRequest',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPromoteSchemaVersionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { promoteSchemaVersion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPromoteSchemaVersionMutation = (resolver: GraphQLResponseResolver<PromoteSchemaVersionMutation, PromoteSchemaVersionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<PromoteSchemaVersionMutation, PromoteSchemaVersionMutationVariables>(
    'promoteSchemaVersion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateUserSubscriptionsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { updateUserSubscriptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateUserSubscriptionsMutation = (resolver: GraphQLResponseResolver<UpdateUserSubscriptionsMutation, UpdateUserSubscriptionsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateUserSubscriptionsMutation, UpdateUserSubscriptionsMutationVariables>(
    'updateUserSubscriptions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListUserTimersQueryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { timers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockListUserTimersQueryQuery = (resolver: GraphQLResponseResolver<ListUserTimersQueryQuery, ListUserTimersQueryQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ListUserTimersQueryQuery, ListUserTimersQueryQueryVariables>(
    'listUserTimersQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateProcessTimerMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { createProcessTimer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateProcessTimerMutation = (resolver: GraphQLResponseResolver<CreateProcessTimerMutation, CreateProcessTimerMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateProcessTimerMutation, CreateProcessTimerMutationVariables>(
    'createProcessTimer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPauseTimersMutation(
 *   ({ query, variables }) => {
 *     const { timerIds } = variables;
 *     return HttpResponse.json({
 *       data: { pauseTimers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPauseTimersMutation = (resolver: GraphQLResponseResolver<PauseTimersMutation, PauseTimersMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<PauseTimersMutation, PauseTimersMutationVariables>(
    'pauseTimers',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockResumeTimersMutation(
 *   ({ query, variables }) => {
 *     const { timerIds } = variables;
 *     return HttpResponse.json({
 *       data: { resumeTimers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockResumeTimersMutation = (resolver: GraphQLResponseResolver<ResumeTimersMutation, ResumeTimersMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ResumeTimersMutation, ResumeTimersMutationVariables>(
    'resumeTimers',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCompleteTimersMutation(
 *   ({ query, variables }) => {
 *     const { timerIds } = variables;
 *     return HttpResponse.json({
 *       data: { completeTimers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCompleteTimersMutation = (resolver: GraphQLResponseResolver<CompleteTimersMutation, CompleteTimersMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CompleteTimersMutation, CompleteTimersMutationVariables>(
    'completeTimers',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBranchesFilterQuery(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { branches }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBranchesFilterQuery = (resolver: GraphQLResponseResolver<BranchesFilterQuery, BranchesFilterQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BranchesFilterQuery, BranchesFilterQueryVariables>(
    'branchesFilter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSuppliersQuery(
 *   ({ query, variables }) => {
 *     const { options, filter } = variables;
 *     return HttpResponse.json({
 *       data: { suppliers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSuppliersQuery = (resolver: GraphQLResponseResolver<GetSuppliersQuery, GetSuppliersQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSuppliersQuery, GetSuppliersQueryVariables>(
    'getSuppliers',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSuppliersFilterQuery(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { suppliers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSuppliersFilterQuery = (resolver: GraphQLResponseResolver<GetSuppliersFilterQuery, GetSuppliersFilterQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSuppliersFilterQuery, GetSuppliersFilterQueryVariables>(
    'getSuppliersFilter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDesignersFilterQuery(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { personBusinessRoles }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDesignersFilterQuery = (resolver: GraphQLResponseResolver<DesignersFilterQuery, DesignersFilterQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<DesignersFilterQuery, DesignersFilterQueryVariables>(
    'designersFilter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetHousingCompaniesFilterQuery(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { housingCompanies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetHousingCompaniesFilterQuery = (resolver: GraphQLResponseResolver<GetHousingCompaniesFilterQuery, GetHousingCompaniesFilterQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetHousingCompaniesFilterQuery, GetHousingCompaniesFilterQueryVariables>(
    'getHousingCompaniesFilter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProjectManagersFilterQuery(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { personBusinessRoles }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProjectManagersFilterQuery = (resolver: GraphQLResponseResolver<ProjectManagersFilterQuery, ProjectManagersFilterQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProjectManagersFilterQuery, ProjectManagersFilterQueryVariables>(
    'projectManagersFilter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRegionsFilterQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { regions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRegionsFilterQuery = (resolver: GraphQLResponseResolver<RegionsFilterQuery, RegionsFilterQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RegionsFilterQuery, RegionsFilterQueryVariables>(
    'regionsFilter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetClientCardQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { client }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetClientCardQuery = (resolver: GraphQLResponseResolver<GetClientCardQuery, GetClientCardQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetClientCardQuery, GetClientCardQueryVariables>(
    'getClientCard',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetClientDialogQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { client }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetClientDialogQuery = (resolver: GraphQLResponseResolver<GetClientDialogQuery, GetClientDialogQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetClientDialogQuery, GetClientDialogQueryVariables>(
    'getClientDialog',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetBuildersQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { builders }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetBuildersQuery = (resolver: GraphQLResponseResolver<GetBuildersQuery, GetBuildersQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetBuildersQuery, GetBuildersQueryVariables>(
    'getBuilders',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSupplierQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { supplier }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSupplierQuery = (resolver: GraphQLResponseResolver<SupplierQuery, SupplierQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SupplierQuery, SupplierQueryVariables>(
    'supplier',
    resolver,
    options
  )
